import { Dexie, liveQuery } from 'dexie';
import { from } from 'rxjs';
import { request } from 'graphql-request';
import anylogger from 'anylogger';

const graphqlUrl = "https://squid.subsquid.io/chaindata/v/v4/graphql";

/**
 * Helper function to add our onfinality api key to any public onfinality RPC urls in an array of chains.
 */
const addCustomChainRpcs = (chains, onfinalityApiKey) => chains.map(chain => {
  // only add our custom rpcs when the chain is healthy
  // the extension won't bother to connect to unhealthy chains
  if (!chain.isHealthy) return chain;

  // copy chain instead of mutating
  const chainWithCustomRpcs = {
    ...chain
  };
  if (typeof onfinalityApiKey !== "string" || !onfinalityApiKey) return chainWithCustomRpcs;

  // add rpcs
  chainWithCustomRpcs.rpcs = (chainWithCustomRpcs.rpcs || []
  // convert public onfinality rpc endpoints to private onfinality rpc endpoints
  ).map(rpc => {
    rpc.url = rpc.url.replace(/^wss:\/\/([A-z-]+)\.api\.onfinality\.io\/public-ws\/?$/, `wss://$1.api.onfinality.io/ws?apikey=${onfinalityApiKey}`);
    return rpc;
  })
  // prioritise onfinality rpcs
  .sort((a, b) => {
    if (a.url.includes("api.onfinality.io")) return -1;
    if (b.url.includes("api.onfinality.io")) return 1;
    return 0;
  });

  // return copy
  return chainWithCustomRpcs;
});

/* eslint-disable */

/** All built-in and custom scalars, mapped to their actual values */

const ChainFragmentDoc = {
  kind: "Document",
  definitions: [{
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "Chain"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "Chain"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "isTestnet"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "sortIndex"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "genesisHash"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "prefix"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "name"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "themeColor"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "logo"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "chainName"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "implName"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "specName"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "specVersion"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "nativeToken"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "tokens"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "orderBy"
          },
          value: {
            kind: "EnumValue",
            value: "id_ASC"
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "account"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "subscanUrl"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "chainspecQrUrl"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "latestMetadataQrUrl"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "isUnknownFeeToken"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "rpcs"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "url"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "isHealthy"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "isHealthy"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "evmNetworks"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "orderBy"
          },
          value: {
            kind: "EnumValue",
            value: "name_ASC"
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "parathreads"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "orderBy"
          },
          value: {
            kind: "EnumValue",
            value: "paraId_ASC"
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "paraId"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "name"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "paraId"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "relay"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "balanceMetadata"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "moduleType"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "metadata"
            }
          }]
        }
      }]
    }
  }]
};
const EvmNetworkFragmentDoc = {
  kind: "Document",
  definitions: [{
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "EvmNetwork"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "EvmNetwork"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "isTestnet"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "sortIndex"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "name"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "themeColor"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "logo"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "nativeToken"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "tokens"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "orderBy"
          },
          value: {
            kind: "EnumValue",
            value: "id_ASC"
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "explorerUrl"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "rpcs"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "url"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "isHealthy"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "isHealthy"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "substrateChain"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }]
        }
      }]
    }
  }]
};
const TokenFragmentDoc = {
  kind: "Document",
  definitions: [{
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "Token"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "Token"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "data"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "squidImplementationDetailNativeToChains"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "orderBy"
          },
          value: {
            kind: "EnumValue",
            value: "sortIndex_ASC"
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "squidImplementationDetailNativeToEvmNetworks"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "orderBy"
          },
          value: {
            kind: "EnumValue",
            value: "name_ASC"
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }]
        }
      }]
    }
  }]
};
const ChainsDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "chains"
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "chains"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "orderBy"
          },
          value: {
            kind: "EnumValue",
            value: "sortIndex_ASC"
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "Chain"
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "Chain"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "Chain"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "isTestnet"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "sortIndex"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "genesisHash"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "prefix"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "name"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "themeColor"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "logo"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "chainName"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "implName"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "specName"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "specVersion"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "nativeToken"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "tokens"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "orderBy"
          },
          value: {
            kind: "EnumValue",
            value: "id_ASC"
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "account"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "subscanUrl"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "chainspecQrUrl"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "latestMetadataQrUrl"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "isUnknownFeeToken"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "rpcs"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "url"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "isHealthy"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "isHealthy"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "evmNetworks"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "orderBy"
          },
          value: {
            kind: "EnumValue",
            value: "name_ASC"
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "parathreads"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "orderBy"
          },
          value: {
            kind: "EnumValue",
            value: "paraId_ASC"
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "paraId"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "name"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "paraId"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "relay"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "balanceMetadata"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "moduleType"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "metadata"
            }
          }]
        }
      }]
    }
  }]
};
const EvmNetworksDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "evmNetworks"
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "evmNetworks"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "orderBy"
          },
          value: {
            kind: "EnumValue",
            value: "sortIndex_ASC"
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "EvmNetwork"
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "EvmNetwork"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "EvmNetwork"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "isTestnet"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "sortIndex"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "name"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "themeColor"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "logo"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "nativeToken"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "tokens"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "orderBy"
          },
          value: {
            kind: "EnumValue",
            value: "id_ASC"
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "explorerUrl"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "rpcs"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "url"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "isHealthy"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "isHealthy"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "substrateChain"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }]
        }
      }]
    }
  }]
};
const EvmNetworkByIdDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "evmNetworkById"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "evmNetworkId"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "evmNetworkById"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "id"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "evmNetworkId"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "EvmNetwork"
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "EvmNetwork"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "EvmNetwork"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "isTestnet"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "sortIndex"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "name"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "themeColor"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "logo"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "nativeToken"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "tokens"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "orderBy"
          },
          value: {
            kind: "EnumValue",
            value: "id_ASC"
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "explorerUrl"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "rpcs"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "url"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "isHealthy"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "isHealthy"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "substrateChain"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }]
        }
      }]
    }
  }]
};
const TokensDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "tokens"
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "tokens"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "orderBy"
          },
          value: {
            kind: "EnumValue",
            value: "id_ASC"
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "Token"
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "Token"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "Token"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "data"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "squidImplementationDetailNativeToChains"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "orderBy"
          },
          value: {
            kind: "EnumValue",
            value: "sortIndex_ASC"
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "squidImplementationDetailNativeToEvmNetworks"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "orderBy"
          },
          value: {
            kind: "EnumValue",
            value: "name_ASC"
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }]
        }
      }]
    }
  }]
};
const TokenByIdDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "tokenById"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "tokenId"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "tokenById"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "id"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "tokenId"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "Token"
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "Token"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "Token"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "data"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "squidImplementationDetailNativeToChains"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "orderBy"
          },
          value: {
            kind: "EnumValue",
            value: "sortIndex_ASC"
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "squidImplementationDetailNativeToEvmNetworks"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "orderBy"
          },
          value: {
            kind: "EnumValue",
            value: "name_ASC"
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }]
        }
      }]
    }
  }]
};

/* eslint-disable */

/**
 * Map of all GraphQL operations in the project.
 *
 * This map has several performance disadvantages:
 * 1. It is not tree-shakeable, so it will include all operations in the project.
 * 2. It is not minifiable, so the string of a GraphQL query will be multiple times inside the bundle.
 * 3. It does not support dead code elimination, so it will add unused operations.
 *
 * Therefore it is highly recommended to use the babel or swc plugin for production.
 */
const documents = {
  "\n  fragment Chain on Chain {\n    id\n    isTestnet\n    sortIndex\n    genesisHash\n    prefix\n    name\n    themeColor\n    logo\n    chainName\n    implName\n    specName\n    specVersion\n    nativeToken {\n      id\n    }\n    tokens(orderBy: id_ASC) {\n      id\n    }\n    account\n    subscanUrl\n    chainspecQrUrl\n    latestMetadataQrUrl\n    isUnknownFeeToken\n    rpcs {\n      url\n      isHealthy\n    }\n    isHealthy\n    evmNetworks(orderBy: name_ASC) {\n      id\n    }\n    parathreads(orderBy: paraId_ASC) {\n      id\n      paraId\n      name\n    }\n    paraId\n    relay {\n      id\n    }\n    balanceMetadata {\n      moduleType\n      metadata\n    }\n  }\n": ChainFragmentDoc,
  "\n  fragment EvmNetwork on EvmNetwork {\n    id\n    isTestnet\n    sortIndex\n    name\n    themeColor\n    logo\n    nativeToken {\n      id\n    }\n    tokens(orderBy: id_ASC) {\n      id\n    }\n    explorerUrl\n    rpcs {\n      url\n      isHealthy\n    }\n    isHealthy\n    substrateChain {\n      id\n    }\n  }\n": EvmNetworkFragmentDoc,
  "\n  fragment Token on Token {\n    id\n    data\n\n    # TODO: Fix (add variants and their relations) when https://github.com/subsquid/squid/issues/41 is merged\n\n    squidImplementationDetailNativeToChains(orderBy: sortIndex_ASC) {\n      id\n    }\n    squidImplementationDetailNativeToEvmNetworks(orderBy: name_ASC) {\n      id\n    }\n  }\n": TokenFragmentDoc,
  "\n  query chains {\n    chains(orderBy: sortIndex_ASC) {\n      ...Chain\n    }\n  }\n": ChainsDocument,
  "\n  query evmNetworks {\n    evmNetworks(orderBy: sortIndex_ASC) {\n      ...EvmNetwork\n    }\n  }\n": EvmNetworksDocument,
  "\n  query evmNetworkById($evmNetworkId: String!) {\n    evmNetworkById(id: $evmNetworkId) {\n      ...EvmNetwork\n    }\n  }\n": EvmNetworkByIdDocument,
  "\n  query tokens {\n    tokens(orderBy: id_ASC) {\n      ...Token\n    }\n  }\n": TokensDocument,
  "\n  query tokenById($tokenId: String!) {\n    tokenById(id: $tokenId) {\n      ...Token\n    }\n  }\n": TokenByIdDocument
};

/**
 * The graphql function is used to parse GraphQL queries into a document that can be used by GraphQL clients.
 *
 *
 * @example
 * ```ts
 * const query = graphql(`query GetUser($id: ID!) { user(id: $id) { name } }`);
 * ```
 *
 * The query argument is unknown!
 * Please regenerate the types.
 */

/**
 * The graphql function is used to parse GraphQL queries into a document that can be used by GraphQL clients.
 */

/**
 * The graphql function is used to parse GraphQL queries into a document that can be used by GraphQL clients.
 */

/**
 * The graphql function is used to parse GraphQL queries into a document that can be used by GraphQL clients.
 */

/**
 * The graphql function is used to parse GraphQL queries into a document that can be used by GraphQL clients.
 */

/**
 * The graphql function is used to parse GraphQL queries into a document that can be used by GraphQL clients.
 */

/**
 * The graphql function is used to parse GraphQL queries into a document that can be used by GraphQL clients.
 */

/**
 * The graphql function is used to parse GraphQL queries into a document that can be used by GraphQL clients.
 */

/**
 * The graphql function is used to parse GraphQL queries into a document that can be used by GraphQL clients.
 */

function graphql(source) {
  return documents[source] ?? {};
}

//
// Queries
//

const chainsQuery = graphql(`
  query chains {
    chains(orderBy: sortIndex_ASC) {
      ...Chain
    }
  }
`);
const evmNetworksQuery = graphql(`
  query evmNetworks {
    evmNetworks(orderBy: sortIndex_ASC) {
      ...EvmNetwork
    }
  }
`);
const evmNetworkByIdQuery = graphql(`
  query evmNetworkById($evmNetworkId: String!) {
    evmNetworkById(id: $evmNetworkId) {
      ...EvmNetwork
    }
  }
`);
const tokensQuery = graphql(`
  query tokens {
    tokens(orderBy: id_ASC) {
      ...Token
    }
  }
`);
const tokenByIdQuery = graphql(`
  query tokenById($tokenId: String!) {
    tokenById(id: $tokenId) {
      ...Token
    }
  }
`);

//
// Fetchers
//

const fetchChains = async () => (await request(graphqlUrl, chainsQuery)).chains;
const fetchEvmNetworks = async () => (await request(graphqlUrl, evmNetworksQuery)).evmNetworks;
const fetchEvmNetwork = async evmNetworkId => (await request(graphqlUrl, evmNetworkByIdQuery, {
  evmNetworkId
})).evmNetworkById;
const fetchTokens = async () => (await request(graphqlUrl, tokensQuery)).tokens;
const fetchToken = async tokenId => (await request(graphqlUrl, tokenByIdQuery, {
  tokenId
})).tokenById?.data;

var initChainsResponse = [
	{
		id: "polkadot",
		isTestnet: false,
		sortIndex: 1,
		genesisHash: "0x91b171bb158e2d3848fa23a9f1c25182fb8e20313b2c1eb49219da7a70ce90c3",
		prefix: 0,
		name: "Polkadot",
		themeColor: "#e6007a",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/polkadot.svg",
		chainName: "Polkadot",
		implName: "parity-polkadot",
		specName: "polkadot",
		specVersion: "9430",
		nativeToken: {
			id: "polkadot-substrate-native-dot"
		},
		tokens: [
			{
				id: "polkadot-substrate-native-dot"
			}
		],
		account: "*25519",
		subscanUrl: "https://polkadot.subscan.io/",
		chainspecQrUrl: "https://metadata.parity.io/qr/polkadot_specs.png",
		latestMetadataQrUrl: "https://metadata.parity.io/qr/polkadot_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://polkadot.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://1rpc.io/dot",
				isHealthy: true
			},
			{
				url: "wss://polkadot-public-rpc.blockops.network/ws",
				isHealthy: true
			},
			{
				url: "wss://polkadot-rpc.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://polkadot-rpc-tn.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://rpc.ibp.network/polkadot",
				isHealthy: true
			},
			{
				url: "wss://rpc.dotters.network/polkadot",
				isHealthy: true
			},
			{
				url: "wss://rpc-polkadot.luckyfriday.io",
				isHealthy: true
			},
			{
				url: "wss://rpc.polkadot.io",
				isHealthy: true
			},
			{
				url: "wss://polkadot.public.curie.radiumblock.co/ws",
				isHealthy: true
			},
			{
				url: "wss://dot-rpc.stakeworld.io",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
			{
				id: "polkadot-asset-hub",
				paraId: 1000,
				name: "AssetHub"
			},
			{
				id: "statemint",
				paraId: 1000,
				name: "Statemint"
			},
			{
				id: "polkadot-collectives",
				paraId: 1001,
				name: "Collectives"
			},
			{
				id: "polkadot-bridge-hub",
				paraId: 1002,
				name: "BridgeHub"
			},
			{
				id: "acala",
				paraId: 2000,
				name: "Acala"
			},
			{
				id: "clover",
				paraId: 2002,
				name: "Clover"
			},
			{
				id: "moonbeam",
				paraId: 2004,
				name: "Moonbeam"
			},
			{
				id: "astar",
				paraId: 2006,
				name: "Astar"
			},
			{
				id: "kapex",
				paraId: 2007,
				name: "Kapex"
			},
			{
				id: "crust-parachain",
				paraId: 2008,
				name: "Crust"
			},
			{
				id: "equilibrium-polkadot",
				paraId: 2011,
				name: "Equilibrium"
			},
			{
				id: "parallel",
				paraId: 2012,
				name: "Parallel"
			},
			{
				id: "litentry",
				paraId: 2013,
				name: "Litentry"
			},
			{
				id: "subgame-polkadot",
				paraId: 2017,
				name: "SubGame Gamma Polkadot"
			},
			{
				id: "subdao",
				paraId: 2018,
				name: "SubDAO"
			},
			{
				id: "composable-finance",
				paraId: 2019,
				name: "Composable Finance"
			},
			{
				id: "efinity-polkadot",
				paraId: 2021,
				name: "Efinity"
			},
			{
				id: "sora-polkadot",
				paraId: 2025,
				name: "Sora"
			},
			{
				id: "nodle-polkadot",
				paraId: 2026,
				name: "Nodle"
			},
			{
				id: "coinversation",
				paraId: 2027,
				name: "Coinversation"
			},
			{
				id: "odyssey",
				paraId: 2028,
				name: "Ares Odyssey"
			},
			{
				id: "bifrost-polkadot",
				paraId: 2030,
				name: "Bifrost Polkadot"
			},
			{
				id: "centrifuge-polkadot",
				paraId: 2031,
				name: "Centrifuge"
			},
			{
				id: "interlay",
				paraId: 2032,
				name: "Interlay"
			},
			{
				id: "hydradx",
				paraId: 2034,
				name: "HydraDX"
			},
			{
				id: "phala",
				paraId: 2035,
				name: "Phala"
			},
			{
				id: "unique",
				paraId: 2037,
				name: "Unique"
			},
			{
				id: "geminis",
				paraId: 2038,
				name: "Geminis"
			},
			{
				id: "integritee-polkadot",
				paraId: 2039,
				name: "Integritee Shell"
			},
			{
				id: "polkadex-polkadot",
				paraId: 2040,
				name: "Polkadex"
			},
			{
				id: "origintrail-parachain",
				paraId: 2043,
				name: "OriginTrail"
			},
			{
				id: "darwinia",
				paraId: 2046,
				name: "Darwinia"
			},
			{
				id: "bitgreen",
				paraId: 2048,
				name: "Bitgreen"
			},
			{
				id: "ajuna",
				paraId: 2051,
				name: "Ajuna"
			},
			{
				id: "kylin",
				paraId: 2052,
				name: "Kylin"
			},
			{
				id: "omnibtc",
				paraId: 2053,
				name: "OmniBTC"
			},
			{
				id: "aventus",
				paraId: 2056,
				name: "Aventus"
			},
			{
				id: "watr",
				paraId: 2058,
				name: "Watr"
			},
			{
				id: "kilt-spiritnet",
				paraId: 2086,
				name: "KILT Spiritnet"
			},
			{
				id: "oak",
				paraId: 2090,
				name: "Oak"
			},
			{
				id: "frequency",
				paraId: 2091,
				name: "Frequency"
			},
			{
				id: "zeitgeist",
				paraId: 2092,
				name: "Zeitgeist"
			},
			{
				id: "hashed",
				paraId: 2093,
				name: "Hashed"
			},
			{
				id: "pendulum",
				paraId: 2094,
				name: "Pendulum"
			},
			{
				id: "subsocial-polkadot",
				paraId: 2101,
				name: "Subsocial"
			},
			{
				id: "manta",
				paraId: 2104,
				name: "Manta"
			},
			{
				id: "t-3-rn",
				paraId: 3333,
				name: "t3rn"
			},
			{
				id: "peaq",
				paraId: 3338,
				name: "Peaq"
			},
			{
				id: "invarch",
				paraId: 3340,
				name: "InvArch"
			}
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000f10c0400210d",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "DOT",
					decimals: 10,
					metadata: "0x6d6574610ecc000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e74446174610000100000050500140c3c70616c6c65745f62616c616e6365731474797065732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e6365000114666c6167731c01284578747261466c61677300001800000507001c0c3c70616c6c65745f62616c616e636573147479706573284578747261466c61677300000400180110753132380000340000020800a40c3473705f61726974686d65746963287065725f7468696e67731c50657262696c6c0000040010010c7533320000d40c1c73705f636f72651c65643235353139185075626c6963000004000401205b75383b2033325d0000e00c1c73705f636f72651c73723235353139185075626c6963000004000401205b75383b2033325d0000f000000618006d010000061000b5010000021000350204184f7074696f6e04045401100108104e6f6e6500000010536f6d650400100000010000410204184f7074696f6e04045401000108104e6f6e6500000010536f6d65040000000001000089020c48706f6c6b61646f745f70617261636861696e287072696d6974697665730849640000040010010c75333200001903000003080000000800a904085c70616c6c65745f6e6f6d696e6174696f6e5f706f6f6c7324506f6f6c537461746500010c104f70656e0000001c426c6f636b65640001002844657374726f79696e6700020000c10404184f7074696f6e04045401c5040108104e6f6e6500000010536f6d650400c5040000010000c50400000408a40000c904085c70616c6c65745f6e6f6d696e6174696f6e5f706f6f6c7350436f6d6d697373696f6e4368616e676552617465042c426c6f636b4e756d6265720110000801306d61785f696e637265617365a4011c50657262696c6c0001246d696e5f64656c617910012c426c6f636b4e756d6265720000b90504184f7074696f6e04045401bd050108104e6f6e6500000010536f6d650400bd050000010000bd05082873705f72756e74696d652c4d756c74695369676e657200010c1c456432353531390400d4013c656432353531393a3a5075626c69630000001c537232353531390400e0013c737232353531393a3a5075626c69630001001445636473610400c105013465636473613a3a5075626c696300020000c1050c1c73705f636f7265146563647361185075626c696300000400c50501205b75383b2033335d0000c5050000032100000008002d080c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e646564566563080454013108045300000400390801185665633c543e000031080c3c70616c6c65745f62616c616e6365731474797065732c42616c616e63654c6f636b041c42616c616e63650118000c01086964190301384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e733508011c526561736f6e73000035080c3c70616c6c65745f62616c616e6365731474797065731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000390800000231080059080c3473705f61726974686d657469632c66697865645f706f696e7424466978656455313238000004001801107531323800006108083870616c6c65745f7374616b696e67345374616b696e674c656467657204045400001401147374617368000130543a3a4163636f756e744964000114746f74616cf0013042616c616e63654f663c543e000118616374697665f0013042616c616e63654f663c543e000124756e6c6f636b696e67650801f0426f756e6465645665633c556e6c6f636b4368756e6b3c42616c616e63654f663c543e3e2c20543a3a4d6178556e6c6f636b696e674368756e6b733e00013c636c61696d65645f7265776172647371080194426f756e6465645665633c457261496e6465782c20543a3a486973746f727944657074683e000065080c4c626f756e6465645f636f6c6c656374696f6e732c626f756e6465645f76656328426f756e6465645665630804540169080453000004006d0801185665633c543e00006908083870616c6c65745f7374616b696e672c556e6c6f636b4368756e6b041c42616c616e636501180008011476616c7565f0011c42616c616e636500010c6572616d010120457261496e64657800006d0800000269080071080c4c626f756e6465645f636f6c6c656374696f6e732c626f756e6465645f76656328426f756e6465645665630804540110045300000400b50101185665633c543e0000e50900000408101800e909000002e50900e50a085c70616c6c65745f6e6f6d696e6174696f6e5f706f6f6c7328506f6f6c4d656d626572040454000010011c706f6f6c5f6964100118506f6f6c4964000118706f696e747318013042616c616e63654f663c543e0001706c6173745f7265636f726465645f7265776172645f636f756e74657259080140543a3a526577617264436f756e746572000138756e626f6e64696e675f65726173e90a01e0426f756e64656442547265654d61703c457261496e6465782c2042616c616e63654f663c543e2c20543a3a4d6178556e626f6e64696e673e0000e90a0c4c626f756e6465645f636f6c6c656374696f6e7344626f756e6465645f62747265655f6d61703c426f756e64656442547265654d61700c044b011004560118045300000400ed0a013842547265654d61703c4b2c20563e0000ed0a042042547265654d617008044b011004560118000400e909000000f10a085c70616c6c65745f6e6f6d696e6174696f6e5f706f6f6c733c426f6e646564506f6f6c496e6e65720404540000140128636f6d6d697373696f6ef50a0134436f6d6d697373696f6e3c543e0001386d656d6265725f636f756e74657210010c753332000118706f696e747318013042616c616e63654f663c543e000114726f6c6573010b015c506f6f6c526f6c65733c543a3a4163636f756e7449643e0001147374617465a9040124506f6f6c53746174650000f50a085c70616c6c65745f6e6f6d696e6174696f6e5f706f6f6c7328436f6d6d697373696f6e040454000010011c63757272656e74c104017c4f7074696f6e3c2850657262696c6c2c20543a3a4163636f756e744964293e00010c6d6178f90a013c4f7074696f6e3c50657262696c6c3e00012c6368616e67655f72617465fd0a01b04f7074696f6e3c436f6d6d697373696f6e4368616e6765526174653c543a3a426c6f636b4e756d6265723e3e0001347468726f74746c655f66726f6d350201584f7074696f6e3c543a3a426c6f636b4e756d6265723e0000f90a04184f7074696f6e04045401a40108104e6f6e6500000010536f6d650400a40000010000fd0a04184f7074696f6e04045401c9040108104e6f6e6500000010536f6d650400c9040000010000010b085c70616c6c65745f6e6f6d696e6174696f6e5f706f6f6c7324506f6f6c526f6c657304244163636f756e7449640100001001246465706f7369746f720001244163636f756e744964000110726f6f74410201444f7074696f6e3c4163636f756e7449643e0001246e6f6d696e61746f72410201444f7074696f6e3c4163636f756e7449643e00011c626f756e636572410201444f7074696f6e3c4163636f756e7449643e0000210b0c4c626f756e6465645f636f6c6c656374696f6e732c626f756e6465645f76656328426f756e64656456656308045401080453000004003401185665633c543e00009d0b000002890200710c0c5c706f6c6b61646f745f72756e74696d655f636f6d6d6f6e2463726f77646c6f616e2046756e64496e666f10244163636f756e74496401001c42616c616e636501182c426c6f636b4e756d62657201102c4c65617365506572696f640110002801246465706f7369746f720001244163636f756e7449640001207665726966696572b905014c4f7074696f6e3c4d756c74695369676e65723e00011c6465706f73697418011c42616c616e636500011872616973656418011c42616c616e636500010c656e6410012c426c6f636b4e756d62657200010c63617018011c42616c616e63650001446c6173745f636f6e747269627574696f6e750c01744c617374436f6e747269627574696f6e3c426c6f636b4e756d6265723e00013066697273745f706572696f6410012c4c65617365506572696f6400012c6c6173745f706572696f6410012c4c65617365506572696f6400012866756e645f696e64657810012446756e64496e6465780000750c0c5c706f6c6b61646f745f72756e74696d655f636f6d6d6f6e2463726f77646c6f616e404c617374436f6e747269627574696f6e042c426c6f636b4e756d6265720110010c144e6576657200000024507265456e64696e67040010010c75333200010018456e64696e67040010012c426c6f636b4e756d62657200020000181853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000008004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402002d08040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e00000000051c5374616b696e67011c5374616b696e6704184c6564676572000104020061080400044501204d61702066726f6d20616c6c2028756e6c6f636b6564292022636f6e74726f6c6c657222206163636f756e747320746f2074686520696e666f20726567617264696e6720746865207374616b696e672e00000000073c4e6f6d696e6174696f6e506f6f6c73013c4e6f6d696e6174696f6e506f6f6c730c2c506f6f6c4d656d626572730001040500e50a04000c4020416374697665206d656d626572732e00d02054574f582d4e4f54453a20534146452073696e636520604163636f756e7449646020697320612073656375726520686173682e2c426f6e646564506f6f6c730001040510f10a040004682053746f7261676520666f7220626f6e64656420706f6f6c732e204d657461646174610101040510210b0400045c204d6574616461746120666f722074686520706f6f6c2e000000002714506172617301145061726173042850617261636861696e7301009d0b04000c350120416c6c2070617261636861696e732e204f72646572656420617363656e64696e672062792060506172614964602e20506172617468726561647320617265206e6f7420696e636c756465642e00e820436f6e7369646572207573696e6720746865205b6050617261636861696e734361636865605d2074797065206f66206d6f64696679696e672e00000000382443726f77646c6f616e012443726f77646c6f616e041446756e6473000104058902710c0400046820496e666f206f6e20616c6c206f66207468652066756e64732e0000000049f10c0400210d",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: "70792f6366756e64",
					existentialDeposit: "10000000000",
					nominationPoolsPalletId: "70792f6e6f706c73"
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000f10c0400210d",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "kusama",
		isTestnet: false,
		sortIndex: 2,
		genesisHash: "0xb0a8d493285c2df73290dfb7e61f870f17b41801197a149ca93654499ea3dafe",
		prefix: 2,
		name: "Kusama",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/kusama.svg",
		chainName: "Kusama",
		implName: "parity-kusama",
		specName: "kusama",
		specVersion: "9430",
		nativeToken: {
			id: "kusama-substrate-native-ksm"
		},
		tokens: [
			{
				id: "kusama-substrate-native-ksm"
			}
		],
		account: "*25519",
		subscanUrl: "https://kusama.subscan.io/",
		chainspecQrUrl: "https://metadata.parity.io/qr/kusama_specs.png",
		latestMetadataQrUrl: "https://metadata.parity.io/qr/kusama_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://kusama.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://1rpc.io/ksm",
				isHealthy: true
			},
			{
				url: "wss://kusama-public-rpc.blockops.network/ws",
				isHealthy: true
			},
			{
				url: "wss://kusama-rpc.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://kusama-rpc-tn.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://rpc.ibp.network/kusama",
				isHealthy: true
			},
			{
				url: "wss://rpc.dotters.network/kusama",
				isHealthy: true
			},
			{
				url: "wss://rpc-kusama.luckyfriday.io",
				isHealthy: true
			},
			{
				url: "wss://kusama-rpc.polkadot.io",
				isHealthy: true
			},
			{
				url: "wss://kusama.public.curie.radiumblock.co/ws",
				isHealthy: true
			},
			{
				url: "wss://ksm-rpc.stakeworld.io",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
			{
				id: "statemine",
				paraId: 1000,
				name: "Statemine"
			},
			{
				id: "kusama-asset-hub",
				paraId: 1000,
				name: "AssetHub"
			},
			{
				id: "encointer",
				paraId: 1001,
				name: "Encointer"
			},
			{
				id: "kusama-bridge-hub",
				paraId: 1002,
				name: "BridgeHub"
			},
			{
				id: "karura",
				paraId: 2000,
				name: "Karura"
			},
			{
				id: "bifrost-kusama",
				paraId: 2001,
				name: "Bifrost Kusama"
			},
			{
				id: "khala",
				paraId: 2004,
				name: "Khala"
			},
			{
				id: "shiden-kusama",
				paraId: 2007,
				name: "Shiden"
			},
			{
				id: "mars",
				paraId: 2008,
				name: "Mars"
			},
			{
				id: "polkasmith",
				paraId: 2009,
				name: "PolkaSmith"
			},
			{
				id: "sora-kusama",
				paraId: 2011,
				name: "Sora"
			},
			{
				id: "shadow-kusama",
				paraId: 2012,
				name: "Crust Shadow"
			},
			{
				id: "integritee-kusama",
				paraId: 2015,
				name: "Integritee"
			},
			{
				id: "sakura",
				paraId: 2016,
				name: "Sakura"
			},
			{
				id: "subgame-kusama",
				paraId: 2018,
				name: "SubGame Gamma Kusama"
			},
			{
				id: "kpron",
				paraId: 2019,
				name: "Kpron"
			},
			{
				id: "moonriver",
				paraId: 2023,
				name: "Moonriver"
			},
			{
				id: "genshiro-kusama",
				paraId: 2024,
				name: "Genshiro"
			},
			{
				id: "robonomics-kusama",
				paraId: 2048,
				name: "Robonomics"
			},
			{
				id: "trustbase",
				paraId: 2078,
				name: "TrustBase"
			},
			{
				id: "loom-network",
				paraId: 2080,
				name: "Loom"
			},
			{
				id: "calamari",
				paraId: 2084,
				name: "Calamari"
			},
			{
				id: "heiko-kusama",
				paraId: 2085,
				name: "Parallel Heiko"
			},
			{
				id: "picasso",
				paraId: 2087,
				name: "Picasso"
			},
			{
				id: "altair",
				paraId: 2088,
				name: "Altair"
			},
			{
				id: "basilisk",
				paraId: 2090,
				name: "Basilisk"
			},
			{
				id: "kintsugi",
				paraId: 2092,
				name: "Kintsugi"
			},
			{
				id: "unorthodox",
				paraId: 2094,
				name: "Unorthodox"
			},
			{
				id: "quartz",
				paraId: 2095,
				name: "Quartz"
			},
			{
				id: "bitcountry-pioneer",
				paraId: 2096,
				name: "Bit.Country Pioneer"
			},
			{
				id: "subsocial-x",
				paraId: 2100,
				name: "SubsocialX"
			},
			{
				id: "pichiu",
				paraId: 2102,
				name: "Pichiu"
			},
			{
				id: "crab",
				paraId: 2105,
				name: "Darwinia Crab"
			},
			{
				id: "litmus",
				paraId: 2106,
				name: "Litmus"
			},
			{
				id: "kico",
				paraId: 2107,
				name: "Kico"
			},
			{
				id: "mangata",
				paraId: 2110,
				name: "MangataX"
			},
			{
				id: "kabocha",
				paraId: 2113,
				name: "Kabocha"
			},
			{
				id: "turing",
				paraId: 2114,
				name: "Turing"
			},
			{
				id: "dorafactory",
				paraId: 2115,
				name: "Dora Factory"
			},
			{
				id: "tanganika",
				paraId: 2116,
				name: "Tanganika"
			},
			{
				id: "listen",
				paraId: 2118,
				name: "Listen"
			},
			{
				id: "bajun",
				paraId: 2119,
				name: "Bajun"
			},
			{
				id: "imbue",
				paraId: 2121,
				name: "Imbue"
			},
			{
				id: "gm",
				paraId: 2123,
				name: "GM"
			},
			{
				id: "amplitude",
				paraId: 2124,
				name: "Amplitude"
			},
			{
				id: "tinker",
				paraId: 2125,
				name: "InvArch Tinkernet"
			},
			{
				id: "snow",
				paraId: 2129,
				name: "Snow"
			},
			{
				id: "ipci",
				paraId: 2222,
				name: "DAO IPCI"
			},
			{
				id: "riodefi",
				paraId: 2227,
				name: "RioDeFi"
			},
			{
				id: "zero",
				paraId: 2236,
				name: "Subzero"
			},
			{
				id: "krest",
				paraId: 2241,
				name: "Krest"
			},
			{
				id: "aband",
				paraId: 2257,
				name: "Aband"
			}
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000650d0400910d",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "KSM",
					decimals: 12,
					metadata: "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",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: "70792f6366756e64",
					existentialDeposit: "333333333",
					nominationPoolsPalletId: "70792f6e6f706c73"
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000650d0400910d",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "3-dpass",
		isTestnet: false,
		sortIndex: 3,
		genesisHash: "0x6c5894837ad89b6d92b114a2fb3eafa8fe3d26a54848e3447015442cd6ef4e66",
		prefix: 71,
		name: "3DPass",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "3dpass - The Ledger of Things",
		implName: "poscan-runtime",
		specName: "poscan-runtime",
		specVersion: "112",
		nativeToken: {
			id: "3-dpass-substrate-native-p3d"
		},
		tokens: [
			{
				id: "3-dpass-substrate-native-p3d"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://rpc2.3dpass.org",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e38000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503001000000505001800000507002800000208007c0000040000e000000500000501102873705f72756e74696d651c626f756e6465642c626f756e6465645f76656328426f756e64656456656308045401080453000004002801185665633c543e0000f5050c3470616c6c65745f61737365747314747970657330417373657444657461696c730c1c42616c616e63650118244163636f756e7449640100384465706f73697442616c616e63650118003001146f776e65720001244163636f756e7449640001186973737565720001244163636f756e74496400011461646d696e0001244163636f756e74496400011c667265657a65720001244163636f756e744964000118737570706c7918011c42616c616e636500011c6465706f7369741801384465706f73697442616c616e636500012c6d696e5f62616c616e636518011c42616c616e636500013469735f73756666696369656e74e00110626f6f6c0001206163636f756e747310010c75333200012c73756666696369656e747310010c753332000124617070726f76616c7310010c75333200012469735f66726f7a656ee00110626f6f6c0000f90500000408100000fd050c3470616c6c65745f6173736574731474797065733041737365744163636f756e740c1c42616c616e63650118384465706f73697442616c616e63650118144578747261017c0010011c62616c616e636518011c42616c616e636500012469735f66726f7a656ee00110626f6f6c000118726561736f6e0106017c4578697374656e6365526561736f6e3c4465706f73697442616c616e63653e00011465787472617c01144578747261000001060c3470616c6c65745f6173736574731474797065733c4578697374656e6365526561736f6e041c42616c616e63650118011020436f6e73756d65720000002853756666696369656e740001002c4465706f73697448656c64040018011c42616c616e63650002003c4465706f736974526566756e646564000300000d060c3470616c6c65745f6173736574731474797065733441737365744d6574616461746108384465706f73697442616c616e6365011834426f756e646564537472696e670105010014011c6465706f7369741801384465706f73697442616c616e63650001106e616d6505010134426f756e646564537472696e6700011873796d626f6c05010134426f756e646564537472696e67000120646563696d616c73080108753800012469735f66726f7a656ee00110626f6f6c0000041841737365747301184173736574730c1441737365740001040210f505040004542044657461696c73206f6620616e2061737365742e1c4163636f756e740001080202f905fd05040004e42054686520686f6c64696e6773206f662061207370656369666963206163636f756e7420666f7220612073706563696669632061737365742e204d6574616461746101010402100d065000000000000000000000000000000000000000000458204d65746164617461206f6620616e2061737365742e0000000018450704007d07",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "P3D",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700fd010000030800000008006904102873705f72756e74696d651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e646564566563080454016d04045300000400750401185665633c543e00006d04083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964fd0101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e737104011c526561736f6e7300007104083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c0002000075040000026d0400081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402006904040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e0000000007450704007d07",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000450704007d07",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "aband",
		isTestnet: false,
		sortIndex: 4,
		genesisHash: null,
		prefix: null,
		name: "Aband",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2257,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
		]
	},
	{
		id: "acala",
		isTestnet: false,
		sortIndex: 5,
		genesisHash: "0xfc41b9bd8ef8fe53d58c7ea67c794c7ec9a73daf05e6d54b14ff6342c99ba64c",
		prefix: 10,
		name: "Acala",
		themeColor: "#e61059",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/acala.svg",
		chainName: "Acala",
		implName: "acala",
		specName: "acala",
		specVersion: "2180",
		nativeToken: {
			id: "acala-substrate-native-aca"
		},
		tokens: [
			{
				id: "acala-substrate-native-aca"
			},
			{
				id: "acala-substrate-tokens-ape"
			},
			{
				id: "acala-substrate-tokens-astr"
			},
			{
				id: "acala-substrate-tokens-ausd"
			},
			{
				id: "acala-substrate-tokens-dai"
			},
			{
				id: "acala-substrate-tokens-dot"
			},
			{
				id: "acala-substrate-tokens-eq"
			},
			{
				id: "acala-substrate-tokens-eqd"
			},
			{
				id: "acala-substrate-tokens-glmr"
			},
			{
				id: "acala-substrate-tokens-ibtc"
			},
			{
				id: "acala-substrate-tokens-intr"
			},
			{
				id: "acala-substrate-tokens-lcdot"
			},
			{
				id: "acala-substrate-tokens-ldot"
			},
			{
				id: "acala-substrate-tokens-lp-aca-ausd"
			},
			{
				id: "acala-substrate-tokens-lp-ausd-ibtc"
			},
			{
				id: "acala-substrate-tokens-lp-ausd-intr"
			},
			{
				id: "acala-substrate-tokens-lp-ausd-lcdot"
			},
			{
				id: "acala-substrate-tokens-lp-ausd-ldot"
			},
			{
				id: "acala-substrate-tokens-lp-dot-lcdot"
			},
			{
				id: "acala-substrate-tokens-para"
			},
			{
				id: "acala-substrate-tokens-pha"
			},
			{
				id: "acala-substrate-tokens-tap"
			},
			{
				id: "acala-substrate-tokens-tdot"
			},
			{
				id: "acala-substrate-tokens-usdcet"
			},
			{
				id: "acala-substrate-tokens-wbtc"
			},
			{
				id: "acala-substrate-tokens-weth"
			}
		],
		account: "*25519",
		subscanUrl: "https://acala.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/acala_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/acala_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://acala-polkadot.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://acala-rpc-0.aca-api.network",
				isHealthy: true
			},
			{
				url: "wss://acala-rpc-1.aca-api.network",
				isHealthy: true
			},
			{
				url: "wss://acala-rpc-3.aca-api.network/ws",
				isHealthy: true
			},
			{
				url: "wss://acala-rpc.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://acala.polkawallet.io",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
			{
				id: "787"
			}
		],
		parathreads: [
		],
		paraId: 2000,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e00006d090400b8",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "ACA",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700d800000308000000080015060c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e646564566563080454011906045300000400210601185665633c543e00001906083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964d801384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e731d06011c526561736f6e7300001d06083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200002106000002190600081853797374656d011853797374656d041c4163636f756e7401010402000c410100000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000002042616c616e636573012042616c616e63657304144c6f636b7301010402001506040000000000000a6d090400b8",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "100000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e34000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503001000000505001800000507009c0000050400a4083c7072696d69746976655f7479706573104831363000000400a801205b75383b2032305d0000a8000003140000000800cc0c406163616c615f7072696d6974697665732063757272656e63792843757272656e6379496400011814546f6b656e0400d0012c546f6b656e53796d626f6c0000002044657853686172650800d4012044657853686172650000d4012044657853686172650001001445726332300400a4012845766d4164647265737300020050537461626c654173736574506f6f6c546f6b656e0400100144537461626c654173736574506f6f6c49640003003c4c697175696443726f77646c6f616e04001001144c6561736500040030466f726569676e417373657404009c0138466f726569676e4173736574496400050000d00c406163616c615f7072696d6974697665732063757272656e63792c546f6b656e53796d626f6c00013c0c41434100000010415553440001000c444f54000200104c444f540003000c5441500004000c4b4152008000104b5553440081000c4b534d008200104c4b534d0083000c5441490084000c424e4300a8001456534b534d00a9000c50484100aa00104b494e5400ab00104b42544300ac0000d40c406163616c615f7072696d6974697665732063757272656e637920446578536861726500011414546f6b656e0400d0012c546f6b656e53796d626f6c0000001445726332300400a4012845766d416464726573730001003c4c697175696443726f77646c6f616e04001001144c6561736500020030466f726569676e417373657404009c0138466f726569676e4173736574496400030050537461626c654173736574506f6f6c546f6b656e0400100144537461626c654173736574506f6f6c49640004000039060000040800cc004906082c6f726d6c5f746f6b656e732c4163636f756e7444617461041c42616c616e63650118000c01106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e636500000418546f6b656e730118546f6b656e7304204163636f756e7473010108020539064906c000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000b6d090400b8",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "ajuna",
		isTestnet: false,
		sortIndex: 7,
		genesisHash: "0xe358eb1d11b31255a286c12e44fe6780b7edb171d657905a97e39f71d9c6c3ee",
		prefix: 1328,
		name: "Ajuna",
		themeColor: "#5785c4",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/ajuna.svg",
		chainName: "Ajuna Polkadot",
		implName: "ajuna",
		specName: "ajuna",
		specVersion: "119",
		nativeToken: {
			id: "ajuna-substrate-native-ajun"
		},
		tokens: [
			{
				id: "ajuna-substrate-native-ajun"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://rpc-parachain.ajuna.network",
				isHealthy: true
			},
			{
				url: "wss://ajuna.public.curie.radiumblock.co/ws",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2051,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000fd0504004106",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "AJUN",
					decimals: 12,
					metadata: "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",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000fd0504004106",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "aleph-zero",
		isTestnet: false,
		sortIndex: 8,
		genesisHash: "0x70255b4d28de0fc4e1a193d7e175ad1ccef431598211c55538f1018651a0344e",
		prefix: 42,
		name: "Aleph Zero",
		themeColor: "#91979c",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/aleph-zero.svg",
		chainName: "Aleph Zero",
		implName: "aleph-node",
		specName: "aleph-node",
		specVersion: "61",
		nativeToken: {
			id: "aleph-zero-substrate-native-azero"
		},
		tokens: [
			{
				id: "aleph-zero-substrate-native-azero"
			}
		],
		account: "*25519",
		subscanUrl: "https://alephzero.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/aleph-node_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/aleph-node_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://ws.azero.dev",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000a9040400e904",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "AZERO",
					decimals: 12,
					metadata: "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",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "500",
					nominationPoolsPalletId: "70792f6e6f706c73"
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000a9040400e904",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "altair",
		isTestnet: false,
		sortIndex: 9,
		genesisHash: "0xaa3876c1dc8a1afcc2e9a685a49ff7704cfd36ad8c90bf2702b9d1b00cc40011",
		prefix: 136,
		name: "Altair",
		themeColor: "#bb8b49",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/altair.svg",
		chainName: "Altair",
		implName: "altair",
		specName: "altair",
		specVersion: "1027",
		nativeToken: {
			id: "altair-substrate-native-air"
		},
		tokens: [
			{
				id: "altair-substrate-native-air"
			}
		],
		account: "*25519",
		subscanUrl: "https://altair.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/altair_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/altair_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://altair.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://fullnode.altair.centrifuge.io",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2088,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000d50a0400050b",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "AIR",
					decimals: 18,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700cd020000030800000008004104101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e6465645665630804540145040453000004004d0401185665633c543e00004504083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964cd0201384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e734904011c526561736f6e7300004904083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200004d04000002450400081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402004104040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e0000000014d50a0400050b",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e000418546f6b656e73000141060145010001e90861d50a0400050b",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "amplitude",
		isTestnet: false,
		sortIndex: 10,
		genesisHash: "0xcceae7f3b9947cdb67369c026ef78efa5f34a08fe5808d373c04421ecf4f1aaf",
		prefix: 57,
		name: "Amplitude",
		themeColor: "#5defa7",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/amplitude.svg",
		chainName: "Amplitude",
		implName: "amplitude",
		specName: "amplitude",
		specVersion: "9",
		nativeToken: {
			id: "amplitude-substrate-native-ampe"
		},
		tokens: [
			{
				id: "amplitude-substrate-native-ampe"
			},
			{
				id: "amplitude-substrate-tokens-ksm"
			},
			{
				id: "amplitude-substrate-tokens-usdt"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: "https://metadata.novasama.io/qr/amplitude_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/amplitude_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://amplitude-rpc.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://rpc-amplitude.pendulumchain.tech",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2124,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000490804008d08",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "AMPE",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507003d010000030800000008000903101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e646564566563080454010d03045300000400150301185665633c543e00000d03083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c010869643d0101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e731103011c526561736f6e7300001103083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c0002000015030000020d0300081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402000903040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000a490804008d08",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e28000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503001800000507004000000304000000080099010850737061636577616c6b5f7072696d6974697665732843757272656e6379496400010c184e61746976650000000c58434d040008010875380001001c5374656c6c617204009d0101144173736574000200009d010850737061636577616c6b5f7072696d69746976657314417373657400010c345374656c6c61724e617469766500000024416c7068614e756d34080110636f646540011842797465733400011869737375657204012c417373657449737375657200010028416c7068614e756d3132080110636f6465a101011c4279746573313200011869737375657204012c417373657449737375657200020000a1010000030c0000000800090700000408009901001907082c6f726d6c5f746f6b656e732c4163636f756e7444617461041c42616c616e63650118000c01106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e636500000418546f6b656e730118546f6b656e7304204163636f756e7473010108020509071907c000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000018b8205468652062616c616e6365206f66206120746f6b656e207479706520756e64657220616e206163636f756e742e00fc204e4f54453a2049662074686520746f74616c2069732065766572207a65726f2c206465637265617365206163636f756e7420726566206163636f756e742e001901204e4f54453a2054686973206973206f6e6c79207573656420696e20746865206361736520746861742074686973206d6f64756c65206973207573656420746f2073746f7265282062616c616e6365732e0000000035490804008d08",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "odyssey",
		isTestnet: false,
		sortIndex: 12,
		genesisHash: null,
		prefix: null,
		name: "Ares Odyssey",
		themeColor: "#2b9ff3",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/odyssey.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2028,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
		]
	},
	{
		id: "ares-odyssey",
		isTestnet: false,
		sortIndex: 13,
		genesisHash: "0x0f3665e2e57fb38fd638145b69e567fb05bbadfd457624f90f15e5dbb31320bb",
		prefix: 34,
		name: "Ares Odyssey Standalone",
		themeColor: "#2b9ff3",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/ares-odyssey.svg",
		chainName: "Ares Odyssey",
		implName: "ares-odyssey",
		specName: "ares-odyssey",
		specVersion: "174",
		nativeToken: {
			id: "ares-odyssey-substrate-native-ares"
		},
		tokens: [
			{
				id: "ares-odyssey-substrate-native-ares"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://odyssey.aresprotocol.io",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000c1090400ed09",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "ARES",
					decimals: 12,
					metadata: "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",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "500",
					nominationPoolsPalletId: "70792f6e6f706c73"
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000c1090400ed09",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "kusama-asset-hub",
		isTestnet: false,
		sortIndex: 14,
		genesisHash: "0x48239ef607d7928874027a43a67689209727dfb3d3dc5e5b03a39bdc2eda771a",
		prefix: 2,
		name: "AssetHub",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Statemine",
		implName: "statemine",
		specName: "statemine",
		specVersion: "9430",
		nativeToken: {
			id: "kusama-asset-hub-substrate-native-ksm"
		},
		tokens: [
			{
				id: "kusama-asset-hub-substrate-native-ksm"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://statemine.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://statemine-rpc.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://statemine-rpc-tn.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://sys.ibp.network/statemine",
				isHealthy: true
			},
			{
				url: "wss://sys.dotters.network/statemine",
				isHealthy: true
			},
			{
				url: "wss://rpc-statemine.luckyfriday.io",
				isHealthy: true
			},
			{
				url: "wss://kusama-asset-hub-rpc.polkadot.io",
				isHealthy: true
			},
			{
				url: "wss://statemine.public.curie.radiumblock.co/ws",
				isHealthy: true
			},
			{
				url: "wss://ksm-rpc.stakeworld.io/statemine",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 1000,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "KSM",
					decimals: 12,
					metadata: "0x6d6574610e34000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e74446174610000100000050500140c3c70616c6c65745f62616c616e6365731474797065732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e6365000114666c6167731c01284578747261466c61677300001800000507001c0c3c70616c6c65745f62616c616e636573147479706573284578747261466c616773000004001801107531323800000101000003080000000800c5020c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401c902045300000400d10201185665633c543e0000c9020c3c70616c6c65745f62616c616e6365731474797065732c42616c616e63654c6f636b041c42616c616e63650118000c01086964010101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73cd02011c526561736f6e730000cd020c3c70616c6c65745f62616c616e6365731474797065731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000d102000002c90200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000008004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200c502040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000aed0504001906",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "33333333",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000ed0504001906",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "polkadot-asset-hub",
		isTestnet: false,
		sortIndex: 15,
		genesisHash: "0x68d56f15f85d3136970ec16946040bc1752654e906147f7e43e9d539d7c3de2f",
		prefix: 0,
		name: "AssetHub",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Statemint",
		implName: "statemint",
		specName: "statemint",
		specVersion: "9430",
		nativeToken: {
			id: "polkadot-asset-hub-substrate-native-dot"
		},
		tokens: [
			{
				id: "polkadot-asset-hub-substrate-native-dot"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://statemint.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://statemint-rpc.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://statemint-rpc-tn.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://sys.ibp.network/statemint",
				isHealthy: true
			},
			{
				url: "wss://sys.dotters.network/statemint",
				isHealthy: true
			},
			{
				url: "wss://polkadot-asset-hub-rpc.polkadot.io",
				isHealthy: true
			},
			{
				url: "wss://statemint.public.curie.radiumblock.co/ws",
				isHealthy: true
			},
			{
				url: "wss://dot-rpc.stakeworld.io/statemint",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 1000,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "DOT",
					decimals: 10,
					metadata: "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",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000ed0504001906",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "astar",
		isTestnet: false,
		sortIndex: 16,
		genesisHash: "0x9eb76c5184c4ab8679d2d5d819fdf90b9c001403e9e17da2e14b6d8aec4029c6",
		prefix: 5,
		name: "Astar",
		themeColor: "#03b0fb",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/astar.svg",
		chainName: "Astar",
		implName: "astar",
		specName: "astar",
		specVersion: "61",
		nativeToken: {
			id: "astar-substrate-native-astr"
		},
		tokens: [
			{
				id: "astar-substrate-assets-18446744073709551616-aca"
			},
			{
				id: "astar-substrate-assets-18446744073709551617-ausd"
			},
			{
				id: "astar-substrate-assets-18446744073709551618-ldot"
			},
			{
				id: "astar-substrate-assets-18446744073709551619-glmr"
			},
			{
				id: "astar-substrate-assets-18446744073709551620-ibtc"
			},
			{
				id: "astar-substrate-assets-18446744073709551621-intr"
			},
			{
				id: "astar-substrate-assets-18446744073709551622-pha"
			},
			{
				id: "astar-substrate-assets-18446744073709551623-bnc"
			},
			{
				id: "astar-substrate-assets-18446744073709551624-vdot"
			},
			{
				id: "astar-substrate-assets-18446744073709551625-clv"
			},
			{
				id: "astar-substrate-assets-18446744073709551626-vsdot"
			},
			{
				id: "astar-substrate-assets-18446744073709551627-ring"
			},
			{
				id: "astar-substrate-assets-18446744073709551628-eq"
			},
			{
				id: "astar-substrate-assets-18446744073709551629-eqd"
			},
			{
				id: "astar-substrate-assets-340282366920938463463374607431768211455-dot"
			},
			{
				id: "astar-substrate-assets-4294969280-usdt"
			},
			{
				id: "astar-substrate-native-astr"
			}
		],
		account: "*25519",
		subscanUrl: "https://astar.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/astar_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/astar_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://astar.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://rpc.astar.network",
				isHealthy: true
			},
			{
				url: "wss://1rpc.io/astr",
				isHealthy: true
			},
			{
				url: "wss://astar-rpc.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://astar.public.curie.radiumblock.co/ws",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
			{
				id: "592"
			}
		],
		parathreads: [
		],
		paraId: 2006,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "ASTR",
					decimals: 18,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e6365000018000005070045010000030800000008004d050c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e646564566563080454015105045300000400590501185665633c543e00005105083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964450101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e735505011c526561736f6e7300005505083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200005905000002510500081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e000000000a2042616c616e636573012042616c616e63657304144c6f636b7301010402004d05040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000001f490704008d07",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000490704008d07",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "automata",
		isTestnet: false,
		sortIndex: 18,
		genesisHash: "0xc8eda34601b5a48c73f47ee39a3a86a858c34f044185b17dc7d5ad155813dc63",
		prefix: 2349,
		name: "Automata",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Automata Network",
		implName: "automata",
		specName: "automata",
		specVersion: "1000",
		nativeToken: {
			id: "automata-substrate-native-ata"
		},
		tokens: [
			{
				id: "automata-substrate-native-ata"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://automata.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://api.ata.network",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 13
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "ATA",
					decimals: 18,
					metadata: null,
					isTestnet: false,
					accountInfoType: null,
					metadataVersion: 13,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 13
				}
			}
		]
	},
	{
		id: "aventus",
		isTestnet: false,
		sortIndex: 19,
		genesisHash: "0x8b5c955b5c8fd7112562327e3859473df4e3dff49bd72a113dbb668d2cfa20d7",
		prefix: 42,
		name: "Aventus",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "AvN Polkadot",
		implName: "avn-parachain",
		specName: "avn-parachain",
		specVersion: "31",
		nativeToken: {
			id: "aventus-substrate-native-avt"
		},
		tokens: [
			{
				id: "aventus-substrate-native-avt"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://public-rpc.mainnet.aventus.io",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2056,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e3c000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503001000000505001800000507003000000208008c00000500007d010000040000950300000408100000e9040c3470616c6c65745f61737365747314747970657330417373657444657461696c730c1c42616c616e63650118244163636f756e7449640100384465706f73697442616c616e63650118003001146f776e65720001244163636f756e7449640001186973737565720001244163636f756e74496400011461646d696e0001244163636f756e74496400011c667265657a65720001244163636f756e744964000118737570706c7918011c42616c616e636500011c6465706f7369741801384465706f73697442616c616e636500012c6d696e5f62616c616e636518011c42616c616e636500013469735f73756666696369656e748c0110626f6f6c0001206163636f756e747310010c75333200012c73756666696369656e747310010c753332000124617070726f76616c7310010c753332000118737461747573ed04012c41737365745374617475730000ed040c3470616c6c65745f6173736574731474797065732c417373657453746174757300010c104c6976650000001846726f7a656e0001002844657374726f79696e6700020000f1040c3470616c6c65745f6173736574731474797065733041737365744163636f756e740c1c42616c616e63650118384465706f73697442616c616e63650118144578747261017d010010011c62616c616e636518011c42616c616e636500012469735f66726f7a656e8c0110626f6f6c000118726561736f6ef504017c4578697374656e6365526561736f6e3c4465706f73697442616c616e63653e00011465787472617d01011445787472610000f5040c3470616c6c65745f6173736574731474797065733c4578697374656e6365526561736f6e041c42616c616e63650118011020436f6e73756d65720000002853756666696369656e740001002c4465706f73697448656c64040018011c42616c616e63650002003c4465706f736974526566756e6465640003000001050c3470616c6c65745f6173736574731474797065733441737365744d6574616461746108384465706f73697442616c616e6365011834426f756e646564537472696e670105050014011c6465706f7369741801384465706f73697442616c616e63650001106e616d6505050134426f756e646564537472696e6700011873796d626f6c05050134426f756e646564537472696e67000120646563696d616c73080108753800012469735f66726f7a656e8c0110626f6f6c00000505101c73705f636f72651c626f756e6465642c626f756e6465645f76656328426f756e64656456656308045401080453000004003001185665633c543e0000041841737365747301184173736574730c1441737365740001040210e904040004542044657461696c73206f6620616e2061737365742e1c4163636f756e7400010802029503f104040004e42054686520686f6c64696e6773206f662061207370656369666963206163636f756e7420666f7220612073706563696669632061737365742e204d65746164617461010104021001055000000000000000000000000000000000000000000458204d65746164617461206f6620616e2061737365742e000000003c89060400b506",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "AVT",
					decimals: 18,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507002101000003080000000800d102101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401d502045300000400dd0201185665633c543e0000d502083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964210101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73d902011c526561736f6e730000d902083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000dd02000002d50200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200d102040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000a89060400b506",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "0",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e000089060400b506",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "bajun",
		isTestnet: false,
		sortIndex: 20,
		genesisHash: "0x35a06bfec2edf0ff4be89a6428ccd9ff5bd0167d618c5a0d4341f9600a458d14",
		prefix: 1337,
		name: "Bajun",
		themeColor: "#f36468",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/bajun.svg",
		chainName: "Bajun Kusama",
		implName: "bajun",
		specName: "bajun",
		specVersion: "117",
		nativeToken: {
			id: "bajun-substrate-native-baju"
		},
		tokens: [
			{
				id: "bajun-substrate-native-baju"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: "https://metadata.novasama.io/qr/bajun_specs.png",
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://bajun.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://rpc-parachain.bajun.network",
				isHealthy: true
			},
			{
				url: "wss://bajun.public.curie.radiumblock.co/ws",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2119,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000f90604003d07",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "BAJU",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e6365000018000005070031010000030800000008005505101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e646564566563080454015905045300000400610501185665633c543e00005905083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964310101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e735d05011c526561736f6e7300005d05083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200006105000002590500081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402005505040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000ff90604003d07",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000f90604003d07",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "basilisk",
		isTestnet: false,
		sortIndex: 21,
		genesisHash: "0xa85cfb9b9fd4d622a5b28289a02347af987d8f73fa3108450e2b4a11c1ce5755",
		prefix: 10041,
		name: "Basilisk",
		themeColor: "#4cffaf",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/basilisk.svg",
		chainName: "Basilisk",
		implName: "basilisk",
		specName: "basilisk",
		specVersion: "101",
		nativeToken: {
			id: "basilisk-substrate-native-bsx"
		},
		tokens: [
			{
				id: "basilisk-substrate-native-bsx"
			},
			{
				id: "basilisk-substrate-tokens-ausd"
			},
			{
				id: "basilisk-substrate-tokens-dai"
			},
			{
				id: "basilisk-substrate-tokens-ksm"
			},
			{
				id: "basilisk-substrate-tokens-tnkr"
			},
			{
				id: "basilisk-substrate-tokens-usdcet"
			},
			{
				id: "basilisk-substrate-tokens-usdt"
			},
			{
				id: "basilisk-substrate-tokens-wbtc"
			},
			{
				id: "basilisk-substrate-tokens-weth"
			},
			{
				id: "basilisk-substrate-tokens-wusdt"
			}
		],
		account: "*25519",
		subscanUrl: "https://basilisk.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/basilisk_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/basilisk_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://rpc.basilisk.cloud",
				isHealthy: true
			},
			{
				url: "wss://basilisk-rpc.dwellir.com",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2090,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e000071080400b108",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "BSX",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507007101000003080000000800d902101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401dd02045300000400e50201185665633c543e0000dd02083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964710101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73e102011c526561736f6e730000e102083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000e502000002dd0200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200d902040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000271080400b108",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e1c000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d000004000003200000000800080000050300100000050500180000050700a107000004080010004908082c6f726d6c5f746f6b656e732c4163636f756e7444617461041c42616c616e63650118000c01106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e636500000418546f6b656e730118546f6b656e7304204163636f756e74730101080205a1074908c000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000018b8205468652062616c616e6365206f66206120746f6b656e207479706520756e64657220616e206163636f756e742e00fc204e4f54453a2049662074686520746f74616c2069732065766572207a65726f2c206465637265617365206163636f756e7420726566206163636f756e742e001901204e4f54453a2054686973206973206f6e6c79207573656420696e20746865206361736520746861742074686973206d6f64756c65206973207573656420746f2073746f7265282062616c616e6365732e000000009771080400b108",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "bifrost-kusama",
		isTestnet: false,
		sortIndex: 22,
		genesisHash: "0x9f28c6a68e0fc9646eff64935684f6eeeece527e37bbe1f213d22caa1d9d6bed",
		prefix: 6,
		name: "Bifrost Kusama",
		themeColor: "#68baf9",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/bifrost-kusama.svg",
		chainName: "Bifrost",
		implName: "bifrost",
		specName: "bifrost",
		specVersion: "978",
		nativeToken: {
			id: "bifrost-kusama-substrate-native-bnc"
		},
		tokens: [
			{
				id: "bifrost-kusama-substrate-native-bnc"
			},
			{
				id: "bifrost-kusama-substrate-orml-bnc"
			},
			{
				id: "bifrost-kusama-substrate-orml-dot"
			},
			{
				id: "bifrost-kusama-substrate-orml-kar"
			},
			{
				id: "bifrost-kusama-substrate-orml-ksm"
			},
			{
				id: "bifrost-kusama-substrate-orml-kusd"
			},
			{
				id: "bifrost-kusama-substrate-orml-movr"
			},
			{
				id: "bifrost-kusama-substrate-orml-pha"
			},
			{
				id: "bifrost-kusama-substrate-orml-rmrk"
			},
			{
				id: "bifrost-kusama-substrate-orml-zlk"
			},
			{
				id: "bifrost-kusama-substrate-tokens-ausd"
			},
			{
				id: "bifrost-kusama-substrate-tokens-usdt"
			},
			{
				id: "bifrost-kusama-substrate-tokens-vbnc"
			},
			{
				id: "bifrost-kusama-substrate-tokens-vksm"
			},
			{
				id: "bifrost-kusama-substrate-tokens-vsksm"
			}
		],
		account: "*25519",
		subscanUrl: "https://bifrost-kusama.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/bifrost_specs.png",
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://bifrost-parachain.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://bifrost-rpc.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://bifrost-rpc.liebi.com/ws",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2001,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000110c0400550c",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "BNC",
					decimals: 12,
					metadata: "0x6d6574610e34000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e74446174610000100000050500140c3c70616c6c65745f62616c616e6365731474797065732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e6365000114666c6167731c01284578747261466c61677300001800000507001c0c3c70616c6c65745f62616c616e636573147479706573284578747261466c61677300000400180110753132380000590200000308000000080055070c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e646564566563080454015907045300000400610701185665633c543e000059070c3c70616c6c65745f62616c616e6365731474797065732c42616c616e63654c6f636b041c42616c616e63650118000c01086964590201384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e735d07011c526561736f6e7300005d070c3c70616c6c65745f62616c616e6365731474797065731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200006107000002590700081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000008004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402005507040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000a110c0400550c",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "10000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
						"BNC",
						"KUSD",
						"DOT",
						"KSM",
						"KAR",
						"ZLK",
						"PHA",
						"RMRK",
						"MOVR"
					],
					decimals: [
						12,
						12,
						10,
						12,
						12,
						18,
						12,
						10,
						18
					],
					isTestnet: false,
					stateKeys: {
						ASG: "0x283537e217dff4590200",
						BNC: "0x4a6fdeede9332ffc0201",
						DOT: "0x40c8bff02912d7a00203",
						ETH: "0x6eea53e67b8cc2660205",
						KAR: "0xca82739c8129d4d20206",
						KSM: "0x1dab0d33717892710204",
						PHA: "0xc3413250cf88fd430208",
						ZLK: "0xb682815e8b9cd45d0207",
						KUSD: "0xfb747b895a9033f80202",
						MOVR: "0xac435ba151a0ded6020a",
						RMRK: "0x3aabf5b1eec116df0209"
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "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",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "bifrost-polkadot",
		isTestnet: false,
		sortIndex: 23,
		genesisHash: "0x262e1b2ad728475fd6fe88e62d34c200abe6fd693931ddad144059b1eb884e5b",
		prefix: 6,
		name: "Bifrost Polkadot",
		themeColor: "#68baf9",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/bifrost-polkadot.svg",
		chainName: "Bifrost Polkadot",
		implName: "bifrost_polkadot",
		specName: "bifrost_polkadot",
		specVersion: "976",
		nativeToken: {
			id: "bifrost-polkadot-substrate-native-bnc"
		},
		tokens: [
			{
				id: "bifrost-polkadot-substrate-native-bnc"
			},
			{
				id: "bifrost-polkadot-substrate-orml-bnc"
			},
			{
				id: "bifrost-polkadot-substrate-tokens-astr"
			},
			{
				id: "bifrost-polkadot-substrate-tokens-dot"
			},
			{
				id: "bifrost-polkadot-substrate-tokens-glmr"
			},
			{
				id: "bifrost-polkadot-substrate-tokens-vdot"
			},
			{
				id: "bifrost-polkadot-substrate-tokens-vsdot"
			}
		],
		account: "*25519",
		subscanUrl: "https://bifrost.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/bifrost_polkadot_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/bifrost_polkadot_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://bifrost-polkadot.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://hk.p.bifrost-rpc.liebi.com/ws",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2030,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e00006d0a0400b10a",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "BNC",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e6365000018000005070031010000030800000008006d04101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e646564566563080454017104045300000400790401185665633c543e00007104083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964310101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e737504011c526561736f6e7300007504083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200007904000002710400081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402006d04040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000a6d0a0400b10a",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "10000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
						"BNC"
					],
					decimals: [
						12
					],
					isTestnet: false,
					stateKeys: {
						ASG: "0x283537e217dff4590200",
						BNC: "0x4a6fdeede9332ffc0201",
						DOT: "0x40c8bff02912d7a00203",
						ETH: "0x6eea53e67b8cc2660205",
						KAR: "0xca82739c8129d4d20206",
						KSM: "0x1dab0d33717892710204",
						PHA: "0xc3413250cf88fd430208",
						ZLK: "0xb682815e8b9cd45d0207",
						KUSD: "0xfb747b895a9033f80202",
						MOVR: "0xac435ba151a0ded6020a",
						RMRK: "0x3aabf5b1eec116df0209"
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "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",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "bitcountry-pioneer",
		isTestnet: false,
		sortIndex: 25,
		genesisHash: "0xf22b7850cdd5a7657bbfd90ac86441275bbc57ace3d2698a740c7b0ec4de5ec3",
		prefix: 268,
		name: "Bit.Country Pioneer",
		themeColor: "#f8fcfc",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/bitcountry-pioneer.svg",
		chainName: "Pioneer Network",
		implName: "pioneer-runtime",
		specName: "pioneer-runtime",
		specVersion: "19",
		nativeToken: {
			id: "bitcountry-pioneer-substrate-native-neer"
		},
		tokens: [
			{
				id: "bitcountry-pioneer-substrate-native-neer"
			},
			{
				id: "bitcountry-pioneer-substrate-tokens-ausd"
			},
			{
				id: "bitcountry-pioneer-substrate-tokens-bit"
			},
			{
				id: "bitcountry-pioneer-substrate-tokens-kar"
			},
			{
				id: "bitcountry-pioneer-substrate-tokens-ksm"
			}
		],
		account: "*25519",
		subscanUrl: "https://pioneer.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/pioneer-runtime_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/pioneer-runtime_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://pioneer.api.onfinality.io/public-ws",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2096,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000510704009107",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "NEER",
					decimals: 18,
					metadata: "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",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "100000000000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e20000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d000004000003200000000800080000050300180000050700200000050600b008586269745f636f756e7472795f7072696d6974697665733c46756e6769626c65546f6b656e49640001142c4e6174697665546f6b656e040020011c546f6b656e49640000003446756e6769626c65546f6b656e040020011c546f6b656e4964000100204445585368617265080020011c546f6b656e4964000020011c546f6b656e4964000200384d696e696e675265736f75726365040020011c546f6b656e496400030018537461626c65040020011c546f6b656e49640004000001050000040800b0001105082c6f726d6c5f746f6b656e732c4163636f756e7444617461041c42616c616e63650118000c01106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e636500000418546f6b656e730118546f6b656e7304204163636f756e7473010108020501051105c000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000018b8205468652062616c616e6365206f66206120746f6b656e207479706520756e64657220616e206163636f756e742e00fc204e4f54453a2049662074686520746f74616c2069732065766572207a65726f2c206465637265617365206163636f756e7420726566206163636f756e742e001901204e4f54453a2054686973206973206f6e6c79207573656420696e20746865206361736520746861742074686973206d6f64756c65206973207573656420746f2073746f7265282062616c616e6365732e000000000e510704009107",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "bitgreen",
		isTestnet: false,
		sortIndex: 26,
		genesisHash: "0xc14597baeccb232d662770d2d50ae832ca8c3192693d2b0814e6433f2888ddd6",
		prefix: 42,
		name: "Bitgreen",
		themeColor: "#c0ff00",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/bitgreen.svg",
		chainName: "Bitgreen",
		implName: "bitgreen-parachain",
		specName: "bitgreen-parachain",
		specVersion: "1201",
		nativeToken: {
			id: "bitgreen-substrate-native-bbb"
		},
		tokens: [
			{
				id: "bitgreen-substrate-native-bbb"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://mainnet.bitgreen.org",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2048,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "BBB",
					decimals: 18,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507000d01000003080000000800f902101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401fd02045300000400050301185665633c543e0000fd02083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c010869640d0101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e730103011c526561736f6e7300000103083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200000503000002fd0200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200f902040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000add0704002508",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e1c000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503001800000507006101084c626974677265656e5f7072696d6974697665732843757272656e6379496400010c0c444f540000001055534454000100105553444300020000790400000408006101008904082c6f726d6c5f746f6b656e732c4163636f756e7444617461041c42616c616e63650118000c01106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e636500000418546f6b656e730118546f6b656e7304204163636f756e7473010108020579048904c000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000018b8205468652062616c616e6365206f66206120746f6b656e207479706520756e64657220616e206163636f756e742e00fc204e4f54453a2049662074686520746f74616c2069732065766572207a65726f2c206465637265617365206163636f756e7420726566206163636f756e742e001901204e4f54453a2054686973206973206f6e6c79207573656420696e20746865206361736520746861742074686973206d6f64756c65206973207573656420746f2073746f7265282062616c616e6365732e0000000029dd0704002508",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "bittensor",
		isTestnet: false,
		sortIndex: 27,
		genesisHash: "0x2f0555cc76fc2840a25a6ea3b9637146806f1f44b090c175ffde2a7e5ab36c03",
		prefix: 42,
		name: "Bittensor",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/bittensor.svg",
		chainName: "Bittensor",
		implName: "node-subtensor",
		specName: "node-subtensor",
		specVersion: "127",
		nativeToken: {
			id: "bittensor-substrate-native-tao"
		},
		tokens: [
			{
				id: "bittensor-substrate-native-tao"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://entrypoint-finney.opentensor.ai",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e00007d020400bd02",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "TAO",
					decimals: 9,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e6365000018000005060021010000030800000008008d010c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e646564566563080454019101045300000400990101185665633c543e00009101083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964210101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e739501011c526561736f6e7300009501083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200009901000002910100081853797374656d011853797374656d041c4163636f756e7401010402000cc000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402008d01040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e00000000057d020400bd02",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "500",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e00007d020400bd02",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "kusama-bridge-hub",
		isTestnet: false,
		sortIndex: 28,
		genesisHash: "0x00dcb981df86429de8bbacf9803401f09485366c44efbf53af9ecfab03adc7e5",
		prefix: 2,
		name: "BridgeHub",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Kusama BridgeHub",
		implName: "bridge-hub-kusama",
		specName: "bridge-hub-kusama",
		specVersion: "9430",
		nativeToken: {
			id: "kusama-bridge-hub-substrate-native-ksm"
		},
		tokens: [
			{
				id: "kusama-bridge-hub-substrate-native-ksm"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://sys.ibp.network/bridgehub-kusama",
				isHealthy: true
			},
			{
				url: "wss://sys.dotters.network/bridgehub-kusama",
				isHealthy: true
			},
			{
				url: "wss://kusama-bridge-hub-rpc.polkadot.io",
				isHealthy: true
			},
			{
				url: "wss://ksm-rpc.stakeworld.io/bridgehub",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 1002,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000f10304003504",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "KSM",
					decimals: 12,
					metadata: "0x6d6574610e34000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e74446174610000100000050500140c3c70616c6c65745f62616c616e6365731474797065732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e6365000114666c6167731c01284578747261466c61677300001800000507001c0c3c70616c6c65745f62616c616e636573147479706573284578747261466c61677300000400180110753132380000f800000308000000080079020c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e646564566563080454017d02045300000400850201185665633c543e00007d020c3c70616c6c65745f62616c616e6365731474797065732c42616c616e63654c6f636b041c42616c616e63650118000c01086964f801384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e738102011c526561736f6e73000081020c3c70616c6c65745f62616c616e6365731474797065731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c0002000085020000027d0200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000008004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402007902040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000af10304003504",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "33333333",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000f10304003504",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "polkadot-bridge-hub",
		isTestnet: false,
		sortIndex: 29,
		genesisHash: "0xdcf691b5a3fbe24adc99ddc959c0561b973e329b1aef4c4b22e7bb2ddecb4464",
		prefix: 0,
		name: "BridgeHub",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Polkadot BridgeHub",
		implName: "bridge-hub-polkadot",
		specName: "bridge-hub-polkadot",
		specVersion: "9430",
		nativeToken: {
			id: "polkadot-bridge-hub-substrate-native-dot"
		},
		tokens: [
			{
				id: "polkadot-bridge-hub-substrate-native-dot"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://polkadot-bridge-hub-rpc.polkadot.io",
				isHealthy: true
			},
			{
				url: "wss://dot-rpc.stakeworld.io/bridgehub",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 1002,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000f10304003504",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "DOT",
					decimals: 10,
					metadata: "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",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000f10304003504",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "calamari",
		isTestnet: false,
		sortIndex: 30,
		genesisHash: "0x4ac80c99289841dd946ef92765bf659a307d39189b3ce374a92b5f0415ee17a1",
		prefix: 78,
		name: "Calamari",
		themeColor: "#ff991f",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/calamari.svg",
		chainName: "Calamari Parachain",
		implName: "calamari",
		specName: "calamari",
		specVersion: "4300",
		nativeToken: {
			id: "calamari-substrate-native-kma"
		},
		tokens: [
			{
				id: "calamari-substrate-native-kma"
			}
		],
		account: "*25519",
		subscanUrl: "https://calamari.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/calamari_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/calamari_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://calamari.systems",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2084,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "KMA",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507005101000003080000000800f902101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401fd02045300000400050301185665633c543e0000fd02083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964510101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e730103011c526561736f6e7300000103083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200000503000002fd0200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200f902040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000ae90704001108",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "100000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000e90704001108",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "centrifuge-polkadot",
		isTestnet: false,
		sortIndex: 31,
		genesisHash: "0xb3db41421702df9a7fcac62b53ffeac85f7853cc4e689e0b93aeb3db18c09d82",
		prefix: 36,
		name: "Centrifuge",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/centrifuge-polkadot.svg",
		chainName: "Centrifuge",
		implName: "centrifuge",
		specName: "centrifuge",
		specVersion: "1019",
		nativeToken: {
			id: "centrifuge-polkadot-substrate-native-cfg"
		},
		tokens: [
			{
				id: "centrifuge-polkadot-substrate-native-cfg"
			}
		],
		account: "*25519",
		subscanUrl: "https://centrifuge.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/centrifuge_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/centrifuge_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://centrifuge-parachain.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://fullnode.centrifuge.io",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2031,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000350b0400650b",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "CFG",
					decimals: 18,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700a9010000030800000008005104101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e6465645665630804540155040453000004005d0401185665633c543e00005504083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964a90101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e735904011c526561736f6e7300005904083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200005d04000002550400081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402005104040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e0000000014350b0400650b",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e000418546f6b656e73000175060115010001cd0862350b0400650b",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "cere",
		isTestnet: false,
		sortIndex: 32,
		genesisHash: "0x81443836a9a24caaa23f1241897d1235717535711d1d3fe24eae4fdc942c092c",
		prefix: 54,
		name: "Cere",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Cere Mainnet Beta",
		implName: "substrate-node",
		specName: "node",
		specVersion: "47000",
		nativeToken: {
			id: "cere-substrate-native-cere"
		},
		tokens: [
			{
				id: "cere-substrate-native-cere"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://archive.mainnet.cere.network/ws",
				isHealthy: true
			},
			{
				url: "wss://mainnet.cere-archive.republiccrypto-runtime.com:444",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e00006d080400a508",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "CERE",
					decimals: 10,
					metadata: "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",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "10000000000",
					nominationPoolsPalletId: "70792f6e6f706c73"
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e00006d080400a508",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "chainx",
		isTestnet: false,
		sortIndex: 33,
		genesisHash: "0x6ac13efb5b368b97b4934cef6edfdd99c2af51ba5109bfb8dacc116f9c584c10",
		prefix: 44,
		name: "ChainX",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "ChainX",
		implName: "chainx-net",
		specName: "chainx",
		specVersion: "32",
		nativeToken: {
			id: "chainx-substrate-native-pcx"
		},
		tokens: [
			{
				id: "chainx-substrate-native-pcx"
			}
		],
		account: "*25519",
		subscanUrl: "https://chainx.subscan.io/",
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://mainnet.chainx.org/ws",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000d50704001108",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "PCX",
					decimals: 8,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507004902000003080000000800ed0410346672616d655f737570706f72741c73746f72616765407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401f104045300000400f90401185665633c543e0000f104083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964490201384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73f504011c526561736f6e730000f504083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000f904000002f10400081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200ed04040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e0000000006d50704001108",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "0",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000d50704001108",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "clover",
		isTestnet: false,
		sortIndex: 34,
		genesisHash: "0x5c7bd13edf349b33eb175ffae85210299e324d852916336027391536e686f267",
		prefix: 128,
		name: "Clover",
		themeColor: "#0aa777",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/clover.svg",
		chainName: "Clover",
		implName: "clover-mainnet",
		specName: "clover-mainnet",
		specVersion: "25",
		nativeToken: {
			id: "clover-substrate-native-clv"
		},
		tokens: [
			{
				id: "clover-substrate-native-clv"
			}
		],
		account: "*25519",
		subscanUrl: "https://clover.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/clover-mainnet_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/clover-mainnet_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://clover.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://rpc-para.clover.finance",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2002,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "CLV",
					decimals: 18,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700b5010000030800000008008d02102873705f72756e74696d651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e646564566563080454019102045300000400990201185665633c543e00009102083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964b50101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e739502011c526561736f6e7300009502083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200009902000002910200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402008d02040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e0000000004f10704002d08",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "0",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000f10704002d08",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "coinversation",
		isTestnet: false,
		sortIndex: 35,
		genesisHash: null,
		prefix: null,
		name: "Coinversation",
		themeColor: "#2cb4e4",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/coinversation.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2027,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
		]
	},
	{
		id: "polkadot-collectives",
		isTestnet: false,
		sortIndex: 36,
		genesisHash: "0x46ee89aa2eedd13e988962630ec9fb7565964cf5023bb351f2b6b25c1b68b0b2",
		prefix: 0,
		name: "Collectives",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Collectives",
		implName: "collectives",
		specName: "collectives",
		specVersion: "9430",
		nativeToken: {
			id: "polkadot-collectives-substrate-native-dot"
		},
		tokens: [
			{
				id: "polkadot-collectives-substrate-native-dot"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://collectives.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://sys.ibp.network/collectives-polkadot",
				isHealthy: true
			},
			{
				url: "wss://sys.dotters.network/collectives-polkadot",
				isHealthy: true
			},
			{
				url: "wss://polkadot-collectives-rpc.polkadot.io",
				isHealthy: true
			},
			{
				url: "wss://collectives.public.curie.radiumblock.co/ws",
				isHealthy: true
			},
			{
				url: "wss://dot-rpc.stakeworld.io/collectives",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 1001,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e00009d050400dd05",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "DOT",
					decimals: 10,
					metadata: "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",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e00009d050400dd05",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "competitors-club",
		isTestnet: false,
		sortIndex: 37,
		genesisHash: null,
		prefix: null,
		name: "Competitors Club",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "composable-finance",
		isTestnet: false,
		sortIndex: 38,
		genesisHash: "0xdaab8df776eb52ec604a5df5d388bb62a050a0aaec4556a64265b9d42755552d",
		prefix: 50,
		name: "Composable Finance",
		themeColor: "#9f3da2",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/composable-finance.svg",
		chainName: "Composable Finance",
		implName: "composable",
		specName: "composable",
		specVersion: "10032",
		nativeToken: {
			id: "composable-finance-substrate-native-layr"
		},
		tokens: [
			{
				id: "composable-finance-substrate-native-layr"
			},
			{
				id: "composable-finance-substrate-tokens-ausd"
			},
			{
				id: "composable-finance-substrate-tokens-bnc"
			},
			{
				id: "composable-finance-substrate-tokens-dot"
			},
			{
				id: "composable-finance-substrate-tokens-kar"
			},
			{
				id: "composable-finance-substrate-tokens-ksm"
			},
			{
				id: "composable-finance-substrate-tokens-movr"
			},
			{
				id: "composable-finance-substrate-tokens-usdc"
			},
			{
				id: "composable-finance-substrate-tokens-usdt"
			},
			{
				id: "composable-finance-substrate-tokens-vksm"
			},
			{
				id: "composable-finance-substrate-tokens-wbtc"
			},
			{
				id: "composable-finance-substrate-tokens-weth"
			}
		],
		account: "*25519",
		subscanUrl: "https://composable.subscan.io/",
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://composable.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://rpc.composable.finance",
				isHealthy: true
			},
			{
				url: "wss://composable-rpc.dwellir.com",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2019,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0004184173736574730001b1040004344e617469766541737365744964fd01400200000000000000000000000100000000015d07399d070400c907",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "LAYR",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700610100000308000000080005050c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e646564566563080454010905045300000400110501185665633c543e00000905083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964610101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e730d05011c526561736f6e7300000d05083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200001105000002090500081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402000505040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e00000000069d070400c907",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "100000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e1c000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d000004000003200000000800080000050300180000050700fd010c287072696d6974697665732063757272656e63792843757272656e637949640000040018011075313238000021070000040800fd01003107082c6f726d6c5f746f6b656e732c4163636f756e7444617461041c42616c616e63650118000c01106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e636500000418546f6b656e730118546f6b656e7304204163636f756e7473010108020521073107c000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000018b8205468652062616c616e6365206f66206120746f6b656e207479706520756e64657220616e206163636f756e742e00fc204e4f54453a2049662074686520746f74616c2069732065766572207a65726f2c206465637265617365206163636f756e7420726566206163636f756e742e001901204e4f54453a2054686973206973206f6e6c79207573656420696e20746865206361736520746861742074686973206d6f64756c65206973207573656420746f2073746f7265282062616c616e6365732e00000000349d070400c907",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "creditcoin",
		isTestnet: false,
		sortIndex: 39,
		genesisHash: "0xdd954cbf4000542ef1a15bca509cd89684330bee5e23766c527cdb0d7275e9c2",
		prefix: 42,
		name: "Creditcoin",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Creditcoin",
		implName: "creditcoin-node",
		specName: "creditcoin-node",
		specVersion: "210",
		nativeToken: {
			id: "creditcoin-substrate-native-ctc"
		},
		tokens: [
			{
				id: "creditcoin-substrate-native-ctc"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://rpc.mainnet.creditcoin.network/ws",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e000095020400bd02",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "CTC",
					decimals: 18,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507008101000003080000000800950110346672616d655f737570706f72741c73746f72616765407765616b5f626f756e6465645f766563385765616b426f756e646564566563080454019901045300000400a10101185665633c543e00009901083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964810101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e739d01011c526561736f6e7300009d01083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000a101000002990100081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402009501040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000295020400bd02",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "500",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e000095020400bd02",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "crown-sterling",
		isTestnet: false,
		sortIndex: 40,
		genesisHash: "0xce24ecf534daea9cd46e425659ef4950a57dd29d07272b423220129c323a64b7",
		prefix: 0,
		name: "Crown Sterling",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Crown Sterling",
		implName: "cs-crown-sterling",
		specName: "crown-sterling",
		specVersion: "5004",
		nativeToken: {
			id: "crown-sterling-substrate-native-csov"
		},
		tokens: [
			{
				id: "crown-sterling-substrate-native-csov"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://blockchain.crownsterling.io",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 12
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "CSOV",
					decimals: 12,
					metadata: null,
					isTestnet: false,
					accountInfoType: null,
					metadataVersion: 12,
					crowdloanPalletId: null,
					existentialDeposit: "1",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 12
				}
			}
		]
	},
	{
		id: "crust-parachain",
		isTestnet: false,
		sortIndex: 41,
		genesisHash: "0x4319cc49ee79495b57a1fec4d2bd43f59052dcc690276de566c2691d6df4f7b8",
		prefix: 88,
		name: "Crust",
		themeColor: "#f08727",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/crust-parachain.svg",
		chainName: "Crust",
		implName: "polkadot-crust-parachain",
		specName: "polkadot-crust-parachain",
		specVersion: "4",
		nativeToken: {
			id: "crust-parachain-substrate-native-cru"
		},
		tokens: [
			{
				id: "crust-parachain-substrate-native-cru"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://crust-parachain.crustapps.net",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2008,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "CRU",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507000d010000030800000008004d02102873705f72756e74696d651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e646564566563080454015102045300000400590201185665633c543e00005102083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c010869640d0101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e735502011c526561736f6e7300005502083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200005902000002510200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402004d02040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e0000000002210704005907",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "100000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000210704005907",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "shadow-kusama",
		isTestnet: false,
		sortIndex: 42,
		genesisHash: "0xd4c0c08ca49dc7c680c3dac71a7c0703e5b222f4b6c03fe4c5219bb8f22c18dc",
		prefix: 66,
		name: "Crust Shadow",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/shadow-kusama.svg",
		chainName: "Crust Shadow",
		implName: "crust-collator",
		specName: "crust-collator",
		specVersion: "16",
		nativeToken: {
			id: "shadow-kusama-substrate-native-csm"
		},
		tokens: [
			{
				id: "shadow-kusama-substrate-native-csm"
			}
		],
		account: "*25519",
		subscanUrl: "https://shadow.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/crust-collator_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/crust-collator_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://rpc-shadow.crust.network/",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2012,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "CSM",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507000d010000030800000008004d02102873705f72756e74696d651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e646564566563080454015102045300000400590201185665633c543e00005102083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c010869640d0101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e735502011c526561736f6e7300005502083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200005902000002510200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402004d02040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e0000000002210704005907",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "100000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000210704005907",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "crust",
		isTestnet: false,
		sortIndex: 43,
		genesisHash: "0x8b404e7ed8789d813982b9cb4c8b664c05b3fbf433309f603af014ec9ce56a8c",
		prefix: 66,
		name: "Crust Standalone",
		themeColor: "#f08727",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/crust.svg",
		chainName: "Crust",
		implName: "crustio-crust",
		specName: "crust",
		specVersion: "21",
		nativeToken: {
			id: "crust-substrate-native-cru"
		},
		tokens: [
			{
				id: "crust-substrate-native-cru"
			}
		],
		account: "*25519",
		subscanUrl: "https://crust.subscan.io/",
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://crust.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://rpc.crust.network",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 12
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "CRU",
					decimals: 12,
					metadata: null,
					isTestnet: false,
					accountInfoType: null,
					metadataVersion: 12,
					crowdloanPalletId: null,
					existentialDeposit: "100000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 12
				}
			}
		]
	},
	{
		id: "ipci",
		isTestnet: false,
		sortIndex: 44,
		genesisHash: "0x6f0f071506de39058fe9a95bbca983ac0e9c5da3443909574e95d52eb078d348",
		prefix: 32,
		name: "DAO IPCI",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Ipci",
		implName: "ipci-airalab",
		specName: "ipci",
		specVersion: "5",
		nativeToken: {
			id: "ipci-substrate-native-mito"
		},
		tokens: [
			{
				id: "ipci-substrate-native-mito"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: "https://metadata.novasama.io/qr/ipci_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/ipci_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://kusama.rpc.ipci.io",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2222,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "MITO",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e6365000018000005070049010000030800000008004104102873705f72756e74696d651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e6465645665630804540145040453000004004d0401185665633c543e00004504083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964490101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e734904011c526561736f6e7300004904083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200004d04000002450400081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402004104040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e0000000008e5050400a104",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000e5050400a104",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "darwinia",
		isTestnet: false,
		sortIndex: 45,
		genesisHash: "0xf0b8924b12e8108550d28870bc03f7b45a947e1b2b9abf81bfb0b89ecb60570e",
		prefix: 18,
		name: "Darwinia",
		themeColor: "#db378a",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/darwinia.svg",
		chainName: "Darwinia2",
		implName: "DarwiniaOfficialRust",
		specName: "Darwinia2",
		specVersion: "6340",
		nativeToken: {
			id: "darwinia-substrate-native-ring"
		},
		tokens: [
			{
				id: "darwinia-substrate-native-ring"
			}
		],
		account: "secp256k1",
		subscanUrl: "https://darwinia.subscan.io/",
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://rpc.darwinia.network",
				isHealthy: true
			},
			{
				url: "wss://darwinia-rpc.darwiniacommunitydao.xyz",
				isHealthy: true
			},
			{
				url: "wss://darwinia-rpc.dwellir.com",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
			{
				id: "46"
			}
		],
		parathreads: [
		],
		paraId: 2046,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "RING",
					decimals: 18,
					metadata: "0x6d6574610e3000082866705f6163636f756e742c4163636f756e7449643230000004000401205b75383b2032305d0000040000031400000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507009d0100000308000000080089030c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e646564566563080454018d03045300000400950301185665633c543e00008d03083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c010869649d0101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e739103011c526561736f6e7300009103083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c0002000095030000028d0300081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402008903040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000589090400bd09",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "0",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e000089090400bd09",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "crab",
		isTestnet: false,
		sortIndex: 47,
		genesisHash: "0x86e49c195aeae7c5c4a86ced251f1a28c67b3c35d8289c387ede1776cdd88b24",
		prefix: 42,
		name: "Darwinia Crab",
		themeColor: "#512dbc",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/crab.svg",
		chainName: "Crab2",
		implName: "DarwiniaOfficialRust",
		specName: "Crab2",
		specVersion: "6340",
		nativeToken: {
			id: "crab-substrate-native-crab"
		},
		tokens: [
			{
				id: "crab-substrate-native-crab"
			}
		],
		account: "secp256k1",
		subscanUrl: "https://crab.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/crab2_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/crab2_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://crab.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://crab-rpc.darwinia.network/",
				isHealthy: true
			},
			{
				url: "wss://crab-rpc.darwiniacommunitydao.xyz",
				isHealthy: true
			},
			{
				url: "wss://darwiniacrab-rpc.dwellir.com",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2105,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "CRAB",
					decimals: 18,
					metadata: "0x6d6574610e3000082866705f6163636f756e742c4163636f756e7449643230000004000401205b75383b2032305d0000040000031400000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507009d0100000308000000080089030c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e646564566563080454018d03045300000400950301185665633c543e00008d03083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c010869649d0101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e739103011c526561736f6e7300009103083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c0002000095030000028d0300081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402008903040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e0000000005610904009509",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "0",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000610904009509",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "debio",
		isTestnet: false,
		sortIndex: 48,
		genesisHash: "0x996800af345b3109acdada9913e36d1efa98b89e7dcd0b61b70fdbfc13b2fa50",
		prefix: 42,
		name: "DeBio",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "DeBio",
		implName: "debio",
		specName: "appchain",
		specVersion: "2040",
		nativeToken: {
			id: "debio-substrate-native-dbio"
		},
		tokens: [
			{
				id: "debio-substrate-native-dbio"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://ws-rpc.debio.network",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000e90604001507",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "DBIO",
					decimals: 18,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507004d03000003080000000800bd03101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401c103045300000400c90301185665633c543e0000c103083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c010869644d0301384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73c503011c526561736f6e730000c503083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000c903000002c10300081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200bd03040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e0000000003e90604001507",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "10000000000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000e90604001507",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "dock-pos-mainnet",
		isTestnet: false,
		sortIndex: 49,
		genesisHash: "0x6bfe24dca2a3be10f22212678ac13a6446ec764103c0f3471c71609eac384aae",
		prefix: 22,
		name: "Dock",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Dock PoS Mainnet",
		implName: "Dock",
		specName: "dock-pos-main-runtime",
		specVersion: "44",
		nativeToken: {
			id: "dock-pos-mainnet-substrate-native-dock"
		},
		tokens: [
			{
				id: "dock-pos-mainnet-substrate-native-dock"
			}
		],
		account: "*25519",
		subscanUrl: "https://dock.subscan.io/",
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://mainnet-node.dock.io",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000050a0400410a",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "DOCK",
					decimals: 6,
					metadata: "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",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "500",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000050a0400410a",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "dorafactory",
		isTestnet: false,
		sortIndex: 50,
		genesisHash: "0x577d331ca43646f547cdaa07ad0aa387a383a93416764480665103081f3eaf14",
		prefix: 128,
		name: "Dora Factory",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Dorafactory Network",
		implName: "DORA KSM Parachain",
		specName: "DORA KSM Parachain",
		specVersion: "33",
		nativeToken: {
			id: "dorafactory-substrate-native-dora"
		},
		tokens: [
			{
				id: "dorafactory-substrate-native-dora"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: "https://metadata.novasama.io/qr/dora%20ksm%20parachain_metadata_latest.apng",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/dora%20ksm%20parachain_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://kusama.dorafactory.org",
				isHealthy: false
			}
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2115,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e000099050400dd05",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "DORA",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507001901000003080000000800d903102873705f72756e74696d651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401dd03045300000400e50301185665633c543e0000dd03083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964190101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73e103011c526561736f6e730000e103083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000e503000002dd0300081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200d903040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000a99050400dd05",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e1c000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d00000400000320000000080008000005030018000005070071011060646f7261666163746f72795f6e6f64655f72756e74696d6524636f6e7374616e74732063757272656e63792843757272656e637949640001080c4b534d00000010444f524100010000d1040000040800710100e104082c6f726d6c5f746f6b656e732c4163636f756e7444617461041c42616c616e63650118000c01106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e636500000418546f6b656e730118546f6b656e7304204163636f756e74730101080205d104e104c000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000018b8205468652062616c616e6365206f66206120746f6b656e207479706520756e64657220616e206163636f756e742e00fc204e4f54453a2049662074686520746f74616c2069732065766572207a65726f2c206465637265617365206163636f756e7420726566206163636f756e742e001901204e4f54453a2054686973206973206f6e6c79207573656420696e20746865206361736520746861742074686973206d6f64756c65206973207573656420746f2073746f7265282062616c616e6365732e000000002999050400dd05",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "edgeware",
		isTestnet: false,
		sortIndex: 51,
		genesisHash: "0x742a2ca70c2fda6cee4f8df98d64c4c670a052d9568058982dad9d5a7a135c5b",
		prefix: 7,
		name: "Edgeware",
		themeColor: "#ff3b80",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/edgeware.svg",
		chainName: "Edgeware",
		implName: "edgeware-node",
		specName: "edgeware",
		specVersion: "53",
		nativeToken: {
			id: "edgeware-substrate-native-edg"
		},
		tokens: [
			{
				id: "edgeware-substrate-native-edg"
			}
		],
		account: "*25519",
		subscanUrl: "https://edgeware.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/edgeware_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/edgeware_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://edgeware.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://mainnet2.edgewa.re",
				isHealthy: true
			},
			{
				url: "wss://edgeware.jelliedowl.net",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
			{
				id: "2021"
			}
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "EDG",
					decimals: 18,
					metadata: "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",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "10000000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e00000d0804004d08",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "efinity-polkadot",
		isTestnet: false,
		sortIndex: 53,
		genesisHash: "0x99ded175d436bee7d751fa3f2f8c7a257ddc063a541f8daa5e6152604f66b2a0",
		prefix: 1110,
		name: "Efinity",
		themeColor: "#496ddb",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/efinity-polkadot.svg",
		chainName: "Efinity",
		implName: "efinity",
		specName: "efinity",
		specVersion: "3014",
		nativeToken: {
			id: "efinity-polkadot-substrate-native-efi"
		},
		tokens: [
			{
				id: "efinity-polkadot-substrate-native-efi"
			}
		],
		account: "Sr25519",
		subscanUrl: "https://efinity.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/efinity_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/efinity_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://efinity.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://efinity-rpc.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://rpc.efinity.io",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2021,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000ed0904004903",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "EFI",
					decimals: 18,
					metadata: "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",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000ed0904004903",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "efinity-standalone",
		isTestnet: false,
		sortIndex: 54,
		genesisHash: null,
		prefix: null,
		name: "Efinity Standalone",
		themeColor: "#496ddb",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/efinity-standalone.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "encointer",
		isTestnet: false,
		sortIndex: 55,
		genesisHash: "0x7dd99936c1e9e6d1ce7d90eb6f33bea8393b4bf87677d675aa63c9cb3e8c5b5b",
		prefix: 2,
		name: "Encointer",
		themeColor: "#8a8888",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/encointer.svg",
		chainName: "Encointer on Kusama",
		implName: "encointer-parachain",
		specName: "encointer-parachain",
		specVersion: "12",
		nativeToken: {
			id: "encointer-substrate-native-ksm"
		},
		tokens: [
			{
				id: "encointer-substrate-native-ksm"
			}
		],
		account: "*25519",
		subscanUrl: "https://encointer.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/encointer-parachain_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/encointer-parachain_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://encointer.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://kusama.api.encointer.org",
				isHealthy: true
			},
			{
				url: "wss://sys.ibp.network/encointer-kusama",
				isHealthy: true
			},
			{
				url: "wss://sys.dotters.network/encointer-kusama",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 1001,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000290504005505",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "KSM",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700f4000003080000000800a502102873705f72756e74696d651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401a902045300000400b10201185665633c543e0000a902083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964f401384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73ad02011c526561736f6e730000ad02083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000b102000002a90200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200a502040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000a290504005505",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "3333333",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000290504005505",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "equilibrium-polkadot",
		isTestnet: false,
		sortIndex: 56,
		genesisHash: "0x89d3ec46d2fb43ef5a9713833373d5ea666b092fa8fd68fbc34596036571b907",
		prefix: 68,
		name: "Equilibrium",
		themeColor: "#1792ff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/equilibrium-polkadot.svg",
		chainName: "Equilibrium parachain",
		implName: "Equilibrium-parachain",
		specName: "Equilibrium-parachain",
		specVersion: "28",
		nativeToken: {
			id: "equilibrium-polkadot-substrate-equilibrium-eq"
		},
		tokens: [
			{
				id: "equilibrium-polkadot-substrate-equilibrium-aca"
			},
			{
				id: "equilibrium-polkadot-substrate-equilibrium-astr"
			},
			{
				id: "equilibrium-polkadot-substrate-equilibrium-bnb"
			},
			{
				id: "equilibrium-polkadot-substrate-equilibrium-bnc"
			},
			{
				id: "equilibrium-polkadot-substrate-equilibrium-busd"
			},
			{
				id: "equilibrium-polkadot-substrate-equilibrium-cd613"
			},
			{
				id: "equilibrium-polkadot-substrate-equilibrium-cd714"
			},
			{
				id: "equilibrium-polkadot-substrate-equilibrium-cd815"
			},
			{
				id: "equilibrium-polkadot-substrate-equilibrium-cru"
			},
			{
				id: "equilibrium-polkadot-substrate-equilibrium-dot"
			},
			{
				id: "equilibrium-polkadot-substrate-equilibrium-eq"
			},
			{
				id: "equilibrium-polkadot-substrate-equilibrium-eqd"
			},
			{
				id: "equilibrium-polkadot-substrate-equilibrium-eqdot"
			},
			{
				id: "equilibrium-polkadot-substrate-equilibrium-glmr"
			},
			{
				id: "equilibrium-polkadot-substrate-equilibrium-ibtc"
			},
			{
				id: "equilibrium-polkadot-substrate-equilibrium-intr"
			},
			{
				id: "equilibrium-polkadot-substrate-equilibrium-lit"
			},
			{
				id: "equilibrium-polkadot-substrate-equilibrium-lpt0"
			},
			{
				id: "equilibrium-polkadot-substrate-equilibrium-lpt1"
			},
			{
				id: "equilibrium-polkadot-substrate-equilibrium-mxeth"
			},
			{
				id: "equilibrium-polkadot-substrate-equilibrium-mxusdc"
			},
			{
				id: "equilibrium-polkadot-substrate-equilibrium-mxwbtc"
			},
			{
				id: "equilibrium-polkadot-substrate-equilibrium-para"
			},
			{
				id: "equilibrium-polkadot-substrate-equilibrium-pha"
			},
			{
				id: "equilibrium-polkadot-substrate-equilibrium-usdt"
			},
			{
				id: "equilibrium-polkadot-substrate-equilibrium-xdot"
			},
			{
				id: "equilibrium-polkadot-substrate-equilibrium-xdot2"
			},
			{
				id: "equilibrium-polkadot-substrate-equilibrium-xdot3"
			}
		],
		account: "*25519",
		subscanUrl: "https://equilibrium.subscan.io/",
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://equilibrium-rpc.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://node.pol.equilibrium.io/",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2011,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e00008d080400b908",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: "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",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "",
					decimals: 0,
					metadata: null,
					isTestnet: false,
					accountInfoType: null,
					metadataVersion: 0,
					crowdloanPalletId: null,
					existentialDeposit: null,
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
						"TOKEN"
					],
					decimals: [
						9
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e00008d080400b908",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "fragnova",
		isTestnet: false,
		sortIndex: 58,
		genesisHash: "0x3219b65b821c54e1dc6518a8444568da0b98267170d67c2f698aec40bf8e65c7",
		prefix: 93,
		name: "Fragnova",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Fragnova",
		implName: "fragnova-hstn",
		specName: "fragnova",
		specVersion: "1",
		nativeToken: {
			id: "fragnova-substrate-native-nova"
		},
		tokens: [
			{
				id: "fragnova-substrate-native-nova"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://ws.fragnova.network",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "NOVA",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507006901000003080000000800d5010c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401d901045300000400e10101185665633c543e0000d901083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964690101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73dd01011c526561736f6e730000dd01083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000e101000002d90100081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200d501040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e00000000058d050400b505",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "500",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e00008d050400b505",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "frequency",
		isTestnet: false,
		sortIndex: 59,
		genesisHash: "0x4a587bf17a404e3572747add7aab7bbe56e805a5479c6c436f07f36fcc8d3ae1",
		prefix: 90,
		name: "Frequency",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Frequency",
		implName: "frequency",
		specName: "frequency",
		specVersion: "30",
		nativeToken: {
			id: "frequency-substrate-native-frqcy"
		},
		tokens: [
			{
				id: "frequency-substrate-native-frqcy"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://frequency-rpc.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://0.rpc.frequency.xyz",
				isHealthy: true
			},
			{
				url: "wss://1.rpc.frequency.xyz",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2091,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000b9040400ed04",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "FRQCY",
					decimals: 8,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507005d010000030800000008007103101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e6465645665630804540175030453000004007d0301185665633c543e00007503083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c010869645d0101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e737903011c526561736f6e7300007903083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200007d03000002750300081853797374656d011853797374656d041c4163636f756e7401010402000c410100000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000002042616c616e636573012042616c616e63657304144c6f636b7301010402007103040000000000000ab9040400ed04",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000b9040400ed04",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "geminis",
		isTestnet: false,
		sortIndex: 60,
		genesisHash: null,
		prefix: null,
		name: "Geminis",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://rpc.geminis.network",
				isHealthy: false
			}
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2038,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
		]
	},
	{
		id: "genshiro-kusama",
		isTestnet: false,
		sortIndex: 61,
		genesisHash: "0x9de765698374eb576968c8a764168893fb277e65ad3ddafcfe2c49593fc6d663",
		prefix: 67,
		name: "Genshiro",
		themeColor: "#e8662d",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/genshiro-kusama.svg",
		chainName: "Genshiro",
		implName: "Gens-parachain",
		specName: "Gens-parachain",
		specVersion: "17",
		nativeToken: null,
		tokens: [
			{
				id: "genshiro-kusama-substrate-equilibrium-bnb"
			},
			{
				id: "genshiro-kusama-substrate-equilibrium-busd"
			},
			{
				id: "genshiro-kusama-substrate-equilibrium-crv"
			},
			{
				id: "genshiro-kusama-substrate-equilibrium-dai"
			},
			{
				id: "genshiro-kusama-substrate-equilibrium-dot"
			},
			{
				id: "genshiro-kusama-substrate-equilibrium-eqd"
			},
			{
				id: "genshiro-kusama-substrate-equilibrium-eth"
			},
			{
				id: "genshiro-kusama-substrate-equilibrium-gens"
			},
			{
				id: "genshiro-kusama-substrate-equilibrium-hdot"
			},
			{
				id: "genshiro-kusama-substrate-equilibrium-hko"
			},
			{
				id: "genshiro-kusama-substrate-equilibrium-kar"
			},
			{
				id: "genshiro-kusama-substrate-equilibrium-ksm"
			},
			{
				id: "genshiro-kusama-substrate-equilibrium-lpt0"
			},
			{
				id: "genshiro-kusama-substrate-equilibrium-usdc"
			},
			{
				id: "genshiro-kusama-substrate-equilibrium-usdt"
			},
			{
				id: "genshiro-kusama-substrate-equilibrium-wbtc"
			},
			{
				id: "genshiro-kusama-substrate-equilibrium-xdot"
			},
			{
				id: "genshiro-kusama-substrate-equilibrium-xdot2"
			},
			{
				id: "genshiro-kusama-substrate-equilibrium-xdot3"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://node.ksm.genshiro.io",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2024,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000a5060400d106",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: "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",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "",
					decimals: 0,
					metadata: null,
					isTestnet: false,
					accountInfoType: null,
					metadataVersion: 0,
					crowdloanPalletId: null,
					existentialDeposit: null,
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
						"Unknown",
						"EQD",
						"GENS",
						"ETH",
						"BTC",
						"KSM",
						"CRV"
					],
					decimals: [
						9
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000a5060400d106",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "gm",
		isTestnet: false,
		sortIndex: 62,
		genesisHash: "0x19a3733beb9cb8a970a308d835599e9005e02dc007a35440e461a451466776f8",
		prefix: 7013,
		name: "GM",
		themeColor: "#e07445",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/gm.svg",
		chainName: "GM Parachain",
		implName: "gm_parachain",
		specName: "gm_parachain",
		specVersion: "8",
		nativeToken: {
			id: "gm-substrate-native-fren"
		},
		tokens: [
			{
				id: "gm-substrate-native-fren"
			},
			{
				id: "gm-substrate-tokens-gm"
			},
			{
				id: "gm-substrate-tokens-gn"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: "https://metadata.novasama.io/qr/gm_parachain_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/gm_parachain_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://leemo.gmordie.com",
				isHealthy: false
			},
			{
				url: "wss://ws.gm.bldnodes.org",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2123,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000e50504002906",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "FREN",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700a00000030800000008006904102873705f72756e74696d651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e646564566563080454016d04045300000400750401185665633c543e00006d04083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964a001384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e737104011c526561736f6e7300007104083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c0002000075040000026d0400081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402006904040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000ae50504002906",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
						"FREN",
						"GM",
						"GN"
					],
					decimals: [
						12,
						0,
						0
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e1c000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503001800000507009c0840676d5f636861696e5f72756e74696d6524436f6f6f6f6f696e7300010c104652454e00000008474d00010008474e00020000950400000408009c00a504082c6f726d6c5f746f6b656e732c4163636f756e7444617461041c42616c616e63650118000c01106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e636500000418546f6b656e730118546f6b656e7304204163636f756e747301010802059504a504c000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000018b8205468652062616c616e6365206f66206120746f6b656e207479706520756e64657220616e206163636f756e742e00fc204e4f54453a2049662074686520746f74616c2069732065766572207a65726f2c206465637265617365206163636f756e7420726566206163636f756e742e001901204e4f54453a2054686973206973206f6e6c79207573656420696e20746865206361736520746861742074686973206d6f64756c65206973207573656420746f2073746f7265282062616c616e6365732e000000000ce50504002906",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "hanonycash",
		isTestnet: false,
		sortIndex: 64,
		genesisHash: null,
		prefix: null,
		name: "Hanonycash",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "hashed",
		isTestnet: false,
		sortIndex: 65,
		genesisHash: "0xdce5477cfca571c2cb652f38bbb70429004be3cf9649dd2b4ad9455b2251fe43",
		prefix: 42,
		name: "Hashed",
		themeColor: "#22b6b4",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/hashed.svg",
		chainName: "Hashed Network",
		implName: "luhn",
		specName: "luhn",
		specVersion: "2",
		nativeToken: {
			id: "hashed-substrate-native-hash"
		},
		tokens: [
			{
				id: "hashed-substrate-native-hash"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://c1.hashed.live",
				isHealthy: true
			},
			{
				url: "wss://c3.hashed.live",
				isHealthy: true
			},
			{
				url: "wss://c2.hashed.network",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2093,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "HASH",
					decimals: 18,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700f0000003080000000800c902102873705f72756e74696d651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401cd02045300000400d50201185665633c543e0000cd02083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964f001384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73d102011c526561736f6e730000d102083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000d502000002cd0200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200c902040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000afd0704002908",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000fd0704002908",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "humanode",
		isTestnet: false,
		sortIndex: 66,
		genesisHash: "0xc56fa32442b2dad76f214b3ae07998e4ca09736e4813724bfb0717caae2c8bee",
		prefix: 5234,
		name: "Humanode",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Humanode Mainnet",
		implName: "humanode",
		specName: "humanode",
		specVersion: "105",
		nativeToken: {
			id: "humanode-substrate-native-hmnd"
		},
		tokens: [
			{
				id: "humanode-substrate-native-hmnd"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://explorer-rpc-ws.mainnet.stages.humanode.io",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e00001d0404005904",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "HMND",
					decimals: 18,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700a5010000030800000008004502101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e646564566563080454014902045300000400510201185665633c543e00004902083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964a50101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e734d02011c526561736f6e7300004d02083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200005102000002490200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402004502040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e00000000081d0404005904",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "500",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e00001d0404005904",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "hydradx",
		isTestnet: false,
		sortIndex: 67,
		genesisHash: "0xafdc188f45c71dacbaa0b62e16a91f726c7b8699a9748cdf715459de6b7f366d",
		prefix: 63,
		name: "HydraDX",
		themeColor: "#52b2ed",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/hydradx.svg",
		chainName: "HydraDX",
		implName: "hydradx",
		specName: "hydradx",
		specVersion: "160",
		nativeToken: {
			id: "hydradx-substrate-native-hdx"
		},
		tokens: [
			{
				id: "hydradx-substrate-native-hdx"
			},
			{
				id: "hydradx-substrate-tokens-ape"
			},
			{
				id: "hydradx-substrate-tokens-astr"
			},
			{
				id: "hydradx-substrate-tokens-bnc"
			},
			{
				id: "hydradx-substrate-tokens-cfg"
			},
			{
				id: "hydradx-substrate-tokens-dai"
			},
			{
				id: "hydradx-substrate-tokens-dot"
			},
			{
				id: "hydradx-substrate-tokens-ibtc"
			},
			{
				id: "hydradx-substrate-tokens-lrna"
			},
			{
				id: "hydradx-substrate-tokens-pha"
			},
			{
				id: "hydradx-substrate-tokens-usdc"
			},
			{
				id: "hydradx-substrate-tokens-usdt"
			},
			{
				id: "hydradx-substrate-tokens-vdot"
			},
			{
				id: "hydradx-substrate-tokens-wbtc"
			},
			{
				id: "hydradx-substrate-tokens-weth"
			},
			{
				id: "hydradx-substrate-tokens-ztg"
			}
		],
		account: "*25519",
		subscanUrl: "https://hydradx.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/hydradx_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/hydradx_metadata_latest.apng",
		isUnknownFeeToken: true,
		rpcs: [
			{
				url: "wss://hydradx.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://hydradx-rpc.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://rpc.hydradx.cloud",
				isHealthy: true
			},
			{
				url: "wss://rpc-lb.data6.zp-labs.net:8443/hydradx/ws/?token=2ZGuGivPJJAxXiT1hR1Yg2MXGjMrhEBYFjgbdPi",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2034,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000a9080400e908",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "HDX",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507007d01000003080000000800d902101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401dd02045300000400e50201185665633c543e0000dd02083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c010869647d0101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73e102011c526561736f6e730000e102083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000e502000002dd0200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000012042616c616e636573012042616c616e63657304144c6f636b730101040200d902040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e0000000007a9080400e908",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e1c000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503001000000505001800000507000507000004080010001507082c6f726d6c5f746f6b656e732c4163636f756e7444617461041c42616c616e63650118000c01106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e636500000418546f6b656e730118546f6b656e7304204163636f756e7473010108020505071507c000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000018b8205468652062616c616e6365206f66206120746f6b656e207479706520756e64657220616e206163636f756e742e00fc204e4f54453a2049662074686520746f74616c2069732065766572207a65726f2c206465637265617365206163636f756e7420726566206163636f756e742e001901204e4f54453a2054686973206973206f6e6c79207573656420696e20746865206361736520746861742074686973206d6f64756c65206973207573656420746f2073746f7265282062616c616e6365732e000000004da9080400e908",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "imbue",
		isTestnet: false,
		sortIndex: 68,
		genesisHash: "0xca93a37c913a25fa8fdb33c7f738afc39379cb71d37874a16d4c091a5aef9f89",
		prefix: 42,
		name: "Imbue",
		themeColor: "#97ff00",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/imbue.svg",
		chainName: "imbue kusama",
		implName: "imbue",
		specName: "imbue",
		specVersion: "1038",
		nativeToken: {
			id: "imbue-substrate-native-imbu"
		},
		tokens: [
			{
				id: "imbue-substrate-native-imbu"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: "https://metadata.novasama.io/qr/imbue_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/imbue_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://collator.production.imbue.network",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2121,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000450704008107",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "IMBU",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507005101000003080000000800c9050c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401cd05045300000400d50501185665633c543e0000cd05083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964510101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73d105011c526561736f6e730000d105083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000d505000002cd0500081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000012042616c616e636573012042616c616e63657304144c6f636b730101040200c905040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e0000000013450704008107",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "100000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000450704008107",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "integritee-kusama",
		isTestnet: false,
		sortIndex: 69,
		genesisHash: "0xcdedc8eadbfa209d3f207bba541e57c3c58a667b05a2e1d1e86353c9000758da",
		prefix: 13,
		name: "Integritee",
		themeColor: "#777aac",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/integritee-kusama.svg",
		chainName: "Integritee Network (Kusama)",
		implName: "integritee-full",
		specName: "integritee-parachain",
		specVersion: "35",
		nativeToken: {
			id: "integritee-kusama-substrate-native-teer"
		},
		tokens: [
			{
				id: "integritee-kusama-substrate-native-teer"
			}
		],
		account: "*25519",
		subscanUrl: "https://integritee.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/integritee-parachain_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/integritee-parachain_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://integritee-kusama.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://kusama.api.integritee.network",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2015,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e000065060400a506",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "TEER",
					decimals: 12,
					metadata: "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",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e000065060400a506",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "integritee-polkadot",
		isTestnet: false,
		sortIndex: 70,
		genesisHash: "0xe13e7af377c64e83f95e0d70d5e5c3c01d697a84538776c5b9bbe0e7d7b6034c",
		prefix: 13,
		name: "Integritee Shell",
		themeColor: "#777aac",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/integritee-polkadot.svg",
		chainName: "Integritee Shell",
		implName: "integritee-shell",
		specName: "integritee-parachain",
		specVersion: "4",
		nativeToken: {
			id: "integritee-polkadot-substrate-native-teer"
		},
		tokens: [
			{
				id: "integritee-polkadot-substrate-native-teer"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://integritee-rpc.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://polkadot.api.integritee.network",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2039,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000ed0104002d02",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "TEER",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e6365000018000005070090000003080000000800ad0110346672616d655f737570706f72741c73746f72616765407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401b101045300000400b90101185665633c543e0000b101083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c010869649001384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73b501011c526561736f6e730000b501083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000b901000002b10100081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200ad01040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000aed0104002d02",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000ed0104002d02",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "interlay",
		isTestnet: false,
		sortIndex: 71,
		genesisHash: "0xbf88efe70e9e0e916416e8bed61f2b45717f517d7f3523e33c7b001e5ffcbc72",
		prefix: 2032,
		name: "Interlay",
		themeColor: "#948d9d",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/interlay.svg",
		chainName: "Interlay",
		implName: "interlay-parachain",
		specName: "interlay-parachain",
		specVersion: "1024004",
		nativeToken: {
			id: "interlay-substrate-orml-intr"
		},
		tokens: [
			{
				id: "interlay-substrate-native-intr"
			},
			{
				id: "interlay-substrate-orml-dot"
			},
			{
				id: "interlay-substrate-orml-ibtc"
			},
			{
				id: "interlay-substrate-orml-intr"
			},
			{
				id: "interlay-substrate-orml-kbtc"
			},
			{
				id: "interlay-substrate-orml-kint"
			},
			{
				id: "interlay-substrate-orml-ksm"
			},
			{
				id: "interlay-substrate-tokens-ldot"
			},
			{
				id: "interlay-substrate-tokens-lp-dot-intr"
			},
			{
				id: "interlay-substrate-tokens-lp-ibtc-dot"
			},
			{
				id: "interlay-substrate-tokens-lp-ibtc-usdt"
			},
			{
				id: "interlay-substrate-tokens-qdot"
			},
			{
				id: "interlay-substrate-tokens-qibtc"
			},
			{
				id: "interlay-substrate-tokens-qusdt"
			},
			{
				id: "interlay-substrate-tokens-usdt"
			}
		],
		account: "*25519",
		subscanUrl: "https://interlay.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/interlay-parachain_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/interlay-parachain_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://interlay.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://interlay-rpc.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://api.interlay.io/parachain",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2032,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000510904009109",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "INTR",
					decimals: 10,
					metadata: "0x6d6574610e1c000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700041853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e0000000000510904009109",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: null,
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
						"INTR",
						"IBTC",
						"DOT",
						"KINT",
						"KBTC",
						"KSM"
					],
					decimals: [
						10,
						8,
						10,
						12,
						8,
						12
					],
					isTestnet: false,
					stateKeys: {
						DOT: "0x01a12dfa1fa4ab9a0000",
						KSM: "0x459d0fd09ec38ee6000a",
						IBTC: "0xd67c5ba80ba065480001",
						INTR: "0xc483de2de1246ea70002",
						KBTC: "0x1fce6bee3ae455b7000b",
						KINT: "0x56a60a12d72ef524000c"
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e28000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d000004000003200000000800080000050300100000050500180000050700c8084c696e7465726274635f7072696d6974697665732843757272656e6379496400011414546f6b656e0400cc012c546f6b656e53796d626f6c00000030466f726569676e41737365740400100138466f726569676e41737365744964000100244c656e64546f6b656e040010012c4c656e64546f6b656e49640002001c4c70546f6b656e0800d0011c4c70546f6b656e0000d0011c4c70546f6b656e00030034537461626c654c70546f6b656e0400100130537461626c65506f6f6c496400040000cc084c696e7465726274635f7072696d6974697665732c546f6b656e53796d626f6c0001180c444f54000000104942544300010010494e54520002000c4b534d000a00104b425443000b00104b494e54000c0000d0084c696e7465726274635f7072696d6974697665731c4c70546f6b656e00010c14546f6b656e0400cc012c546f6b656e53796d626f6c00000030466f726569676e41737365740400100138466f726569676e4173736574496400010034537461626c654c70546f6b656e0400100130537461626c65506f6f6c49640002000069060000040800c8007906082c6f726d6c5f746f6b656e732c4163636f756e7444617461041c42616c616e63650118000c01106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e636500000418546f6b656e730118546f6b656e7304204163636f756e7473010108020569067906c000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000018b8205468652062616c616e6365206f66206120746f6b656e207479706520756e64657220616e206163636f756e742e00fc204e4f54453a2049662074686520746f74616c2069732065766572207a65726f2c206465637265617365206163636f756e7420726566206163636f756e742e001901204e4f54453a2054686973206973206f6e6c79207573656420696e20746865206361736520746861742074686973206d6f64756c65206973207573656420746f2073746f7265282062616c616e6365732e0000000015510904009109",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "invarch",
		isTestnet: false,
		sortIndex: 72,
		genesisHash: null,
		prefix: null,
		name: "InvArch",
		themeColor: "#30bcd0",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/invarch.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 3340,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
		]
	},
	{
		id: "tinker",
		isTestnet: false,
		sortIndex: 73,
		genesisHash: "0xd42e9606a995dfe433dc7955dc2a70f495f350f373daa200098ae84437816ad2",
		prefix: 117,
		name: "InvArch Tinkernet",
		themeColor: "#30bcd0",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/tinker.svg",
		chainName: "InvArch Tinker Network",
		implName: "tinkernet_node",
		specName: "tinkernet_node",
		specVersion: "18",
		nativeToken: {
			id: "tinker-substrate-native-tnkr"
		},
		tokens: [
			{
				id: "tinker-substrate-native-tnkr"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: "https://metadata.novasama.io/qr/tinkernet_node_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/tinkernet_node_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://invarch-tinkernet.api.onfinality.io/public-ws",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2125,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000f9060400e101",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "TNKR",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507002101000003080000000800ed04101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401f104045300000400f90401185665633c543e0000f104083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964210101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73f504011c526561736f6e730000f504083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000f904000002f10400081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200ed04040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000af9060400e101",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e1c000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d000004000003200000000800080000050300100000050500180000050700690600000408001000e506082c6f726d6c5f746f6b656e732c4163636f756e7444617461041c42616c616e63650118000c01106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e636500000418546f6b656e730118546f6b656e7304204163636f756e747301010802056906e506c000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000018b8205468652062616c616e6365206f66206120746f6b656e207479706520756e64657220616e206163636f756e742e00fc204e4f54453a2049662074686520746f74616c2069732065766572207a65726f2c206465637265617365206163636f756e7420726566206163636f756e742e001901204e4f54453a2054686973206973206f6e6c79207573656420696e20746865206361736520746861742074686973206d6f64756c65206973207573656420746f2073746f7265282062616c616e6365732e0000000060f9060400e101",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "joystream",
		isTestnet: false,
		sortIndex: 74,
		genesisHash: "0x6b5e488e0fa8f9821110d5c13f4c468abcd43ce5e297e62b34c53c3346465956",
		prefix: 126,
		name: "Joystream",
		themeColor: "#4038ff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/joystream.svg",
		chainName: "Joystream",
		implName: "joystream-node",
		specName: "joystream-node",
		specVersion: "2001",
		nativeToken: {
			id: "joystream-substrate-native-joy"
		},
		tokens: [
			{
				id: "joystream-substrate-native-joy"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://rpc.joystream.org",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000d9090400110a",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "JOY",
					decimals: 10,
					metadata: "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",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "266666560",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000d9090400110a",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "jur",
		isTestnet: false,
		sortIndex: 75,
		genesisHash: "0x58d1393b47b11707978fbc07e77d7b6f7d9aa88d207dc008a52385f7dba6156a",
		prefix: 42,
		name: "Jur",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Jur Mainnet",
		implName: "jur-node",
		specName: "jur-node",
		specVersion: "103",
		nativeToken: {
			id: "jur-substrate-native-jur"
		},
		tokens: [
			{
				id: "jur-substrate-native-jur"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://jur-mainnet-archive-rpc-1.icebergnodes.io",
				isHealthy: true
			},
			{
				url: "wss://jur-archive-mainnet-1.simplystaking.xyz/VX68C07AR4K2/ws",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "JUR",
					decimals: 18,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700190100000308000000080085010c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e646564566563080454018901045300000400910101185665633c543e00008901083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964190101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e738d01011c526561736f6e7300008d01083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200009101000002890100081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402008501040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e0000000004490204008102",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "500",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000490204008102",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "kabocha",
		isTestnet: false,
		sortIndex: 76,
		genesisHash: "0xfeb426ca713f0f46c96465b8f039890370cf6bfd687c9076ea2843f58a6ae8a7",
		prefix: 27,
		name: "Kabocha",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Kabocha",
		implName: "kabocha-parachain",
		specName: "kabocha-parachain",
		specVersion: "28",
		nativeToken: {
			id: "kabocha-substrate-native-kab"
		},
		tokens: [
			{
				id: "kabocha-substrate-native-kab"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: "https://metadata.novasama.io/qr/kabocha-parachain_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/kabocha-parachain_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://kabocha.jelliedowl.net",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2113,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000c50504000906",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "KAB",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e6365000018000005070081010000030800000008002904102873705f72756e74696d651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e646564566563080454012d04045300000400350401185665633c543e00002d04083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964810101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e733104011c526561736f6e7300003104083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c0002000035040000022d0400081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402002904040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000ac50504000906",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000c50504000906",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "kapex",
		isTestnet: false,
		sortIndex: 77,
		genesisHash: "0x7838c3c774e887c0a53bcba9e64f702361a1a852d5550b86b58cd73827fa1e1e",
		prefix: 2007,
		name: "Kapex",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Kapex",
		implName: "totem-parachain",
		specName: "totem-parachain",
		specVersion: "4",
		nativeToken: {
			id: "kapex-substrate-native-kpx"
		},
		tokens: [
			{
				id: "kapex-substrate-native-kpx"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: "https://metadata.novasama.io/qr/totem-parachain_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/totem-parachain_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://kapex-rpc.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://k-ui.kapex.network",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2007,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000550504009905",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "KPX",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014085470616c6c65745f62616c616e6365735f746f74656d2c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507000d010000030800000008007904101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e646564566563080454017d04045300000400850401185665633c543e00007d04085470616c6c65745f62616c616e6365735f746f74656d2c42616c616e63654c6f636b041c42616c616e63650118000c010869640d0101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e738104011c526561736f6e7300008104085470616c6c65745f62616c616e6365735f746f74656d1c526561736f6e7300010c0c466565000000104d6973630001000c416c6c0002000085040000027d0400081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402007904040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000a550504009905",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000550504009905",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "karura",
		isTestnet: false,
		sortIndex: 78,
		genesisHash: "0xbaf5aabe40646d11f0ee8abbdc64f4a4b7674925cba08e4a05ff9ebed6e2126b",
		prefix: 8,
		name: "Karura",
		themeColor: "#f93d43",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/karura.svg",
		chainName: "Karura",
		implName: "karura",
		specName: "karura",
		specVersion: "2180",
		nativeToken: {
			id: "karura-substrate-native-kar"
		},
		tokens: [
			{
				id: "karura-substrate-native-kar"
			},
			{
				id: "karura-substrate-tokens-3usd"
			},
			{
				id: "karura-substrate-tokens-air"
			},
			{
				id: "karura-substrate-tokens-aris"
			},
			{
				id: "karura-substrate-tokens-ausd"
			},
			{
				id: "karura-substrate-tokens-bnc"
			},
			{
				id: "karura-substrate-tokens-bsx"
			},
			{
				id: "karura-substrate-tokens-crab"
			},
			{
				id: "karura-substrate-tokens-csm"
			},
			{
				id: "karura-substrate-tokens-dai"
			},
			{
				id: "karura-substrate-tokens-eqd"
			},
			{
				id: "karura-substrate-tokens-gens"
			},
			{
				id: "karura-substrate-tokens-hko"
			},
			{
				id: "karura-substrate-tokens-kbtc"
			},
			{
				id: "karura-substrate-tokens-kico"
			},
			{
				id: "karura-substrate-tokens-kint"
			},
			{
				id: "karura-substrate-tokens-kma"
			},
			{
				id: "karura-substrate-tokens-ksm"
			},
			{
				id: "karura-substrate-tokens-lit"
			},
			{
				id: "karura-substrate-tokens-lksm"
			},
			{
				id: "karura-substrate-tokens-lp-kar-ksm"
			},
			{
				id: "karura-substrate-tokens-lp-kar-kusd"
			},
			{
				id: "karura-substrate-tokens-lp-kar-lksm"
			},
			{
				id: "karura-substrate-tokens-lp-kar-qtz"
			},
			{
				id: "karura-substrate-tokens-lp-ksm-aris"
			},
			{
				id: "karura-substrate-tokens-lp-ksm-lksm"
			},
			{
				id: "karura-substrate-tokens-lp-ksm-rmrk"
			},
			{
				id: "karura-substrate-tokens-lp-kusd-air"
			},
			{
				id: "karura-substrate-tokens-lp-kusd-bnc"
			},
			{
				id: "karura-substrate-tokens-lp-kusd-csm"
			},
			{
				id: "karura-substrate-tokens-lp-kusd-kbtc"
			},
			{
				id: "karura-substrate-tokens-lp-kusd-kint"
			},
			{
				id: "karura-substrate-tokens-lp-kusd-ksm"
			},
			{
				id: "karura-substrate-tokens-lp-kusd-lksm"
			},
			{
				id: "karura-substrate-tokens-lp-kusd-pha"
			},
			{
				id: "karura-substrate-tokens-lp-kusd-qtz"
			},
			{
				id: "karura-substrate-tokens-lp-kusd-rmrk"
			},
			{
				id: "karura-substrate-tokens-lp-tai-tksm"
			},
			{
				id: "karura-substrate-tokens-lt"
			},
			{
				id: "karura-substrate-tokens-movr"
			},
			{
				id: "karura-substrate-tokens-neer"
			},
			{
				id: "karura-substrate-tokens-pchu"
			},
			{
				id: "karura-substrate-tokens-pha"
			},
			{
				id: "karura-substrate-tokens-qtz"
			},
			{
				id: "karura-substrate-tokens-rmrk"
			},
			{
				id: "karura-substrate-tokens-sdn"
			},
			{
				id: "karura-substrate-tokens-tai"
			},
			{
				id: "karura-substrate-tokens-teer"
			},
			{
				id: "karura-substrate-tokens-tksm"
			},
			{
				id: "karura-substrate-tokens-tur"
			},
			{
				id: "karura-substrate-tokens-usdcet"
			},
			{
				id: "karura-substrate-tokens-usdt"
			},
			{
				id: "karura-substrate-tokens-vsksm"
			},
			{
				id: "karura-substrate-tokens-wausd"
			}
		],
		account: "*25519",
		subscanUrl: "https://karura.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/karura_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/karura_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://karura.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://karura-rpc-0.aca-api.network",
				isHealthy: true
			},
			{
				url: "wss://karura-rpc-1.aca-api.network",
				isHealthy: true
			},
			{
				url: "wss://karura-rpc-2.aca-api.network/ws",
				isHealthy: true
			},
			{
				url: "wss://karura-rpc-3.aca-api.network/ws",
				isHealthy: true
			},
			{
				url: "wss://karura-rpc.dwellir.com",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2000,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e000079090400b8",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "KAR",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700d80000030800000008001d060c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e646564566563080454012106045300000400290601185665633c543e00002106083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964d801384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e732506011c526561736f6e7300002506083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200002906000002210600081853797374656d011853797374656d041c4163636f756e7401010402000c410100000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000002042616c616e636573012042616c616e63657304144c6f636b7301010402001d06040000000000000a79090400b8",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "100000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e34000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503001000000505001800000507009c0000050400a4083c7072696d69746976655f7479706573104831363000000400a801205b75383b2032305d0000a8000003140000000800cc0c406163616c615f7072696d6974697665732063757272656e63792843757272656e6379496400011814546f6b656e0400d0012c546f6b656e53796d626f6c0000002044657853686172650800d4012044657853686172650000d4012044657853686172650001001445726332300400a4012845766d4164647265737300020050537461626c654173736574506f6f6c546f6b656e0400100144537461626c654173736574506f6f6c49640003003c4c697175696443726f77646c6f616e04001001144c6561736500040030466f726569676e417373657404009c0138466f726569676e4173736574496400050000d00c406163616c615f7072696d6974697665732063757272656e63792c546f6b656e53796d626f6c00013c0c41434100000010415553440001000c444f54000200104c444f540003000c5441500004000c4b4152008000104b5553440081000c4b534d008200104c4b534d0083000c5441490084000c424e4300a8001456534b534d00a9000c50484100aa00104b494e5400ab00104b42544300ac0000d40c406163616c615f7072696d6974697665732063757272656e637920446578536861726500011414546f6b656e0400d0012c546f6b656e53796d626f6c0000001445726332300400a4012845766d416464726573730001003c4c697175696443726f77646c6f616e04001001144c6561736500020030466f726569676e417373657404009c0138466f726569676e4173736574496400030050537461626c654173736574506f6f6c546f6b656e0400100144537461626c654173736574506f6f6c49640004000041060000040800cc005106082c6f726d6c5f746f6b656e732c4163636f756e7444617461041c42616c616e63650118000c01106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e636500000418546f6b656e730118546f6b656e7304204163636f756e7473010108020541065106c000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000b79090400b8",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "khala",
		isTestnet: false,
		sortIndex: 79,
		genesisHash: "0xd43540ba6d3eb4897c28a77d48cb5b729fea37603cbbfc7a86a73b72adb3be8d",
		prefix: 30,
		name: "Khala",
		themeColor: "#03ffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/khala.svg",
		chainName: "Khala",
		implName: "khala",
		specName: "khala",
		specVersion: "1250",
		nativeToken: {
			id: "khala-substrate-native-pha"
		},
		tokens: [
			{
				id: "khala-substrate-native-pha"
			}
		],
		account: "*25519",
		subscanUrl: "https://khala.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/khala_specs.png",
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://khala.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://khala-rpc.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://khala-api.phala.network/ws",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2004,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "PHA",
					decimals: 12,
					metadata: "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",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "10000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000c90a0400090b",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "kico",
		isTestnet: false,
		sortIndex: 80,
		genesisHash: null,
		prefix: null,
		name: "Kico",
		themeColor: "#3bb48c",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/kico.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2107,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
		]
	},
	{
		id: "kilt-spiritnet",
		isTestnet: false,
		sortIndex: 81,
		genesisHash: "0x411f057b9107718c9624d6aa4a3f23c1653898297f3d4d529d9bb6511a39dd21",
		prefix: 38,
		name: "KILT Spiritnet",
		themeColor: "#f66741",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/kilt-spiritnet.svg",
		chainName: "KILT Spiritnet",
		implName: "kilt-spiritnet",
		specName: "kilt-spiritnet",
		specVersion: "11000",
		nativeToken: {
			id: "kilt-spiritnet-substrate-native-kilt"
		},
		tokens: [
			{
				id: "kilt-spiritnet-substrate-native-kilt"
			}
		],
		account: "*25519",
		subscanUrl: "https://spiritnet.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/kilt-spiritnet_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/kilt-spiritnet_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://spiritnet.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://kilt-rpc.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://spiritnet.kilt.io/",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2086,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000590704003104",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "KILT",
					decimals: 15,
					metadata: "0x6d6574610e34000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d6572731c0120526566436f756e7400012470726f7669646572731c0120526566436f756e7400012c73756666696369656e74731c0120526566436f756e740001106461746114012c4163636f756e7444617461000010000005060014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507001c0000050500f101000003080000000800e502101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401e902045300000400f10201185665633c543e0000e902083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964f10101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73ed02011c526561736f6e730000ed02083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000f102000002e90200081853797374656d011853797374656d041c4163636f756e7401010402000c510100000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200e502040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e0000000006590704003104",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "10000000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000590704003104",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "kintsugi",
		isTestnet: false,
		sortIndex: 82,
		genesisHash: "0x9af9a64e6e4da8e3073901c3ff0cc4c3aad9563786d89daf6ad820b6e14a0b8b",
		prefix: 2092,
		name: "Kintsugi",
		themeColor: "#dadad8",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/kintsugi.svg",
		chainName: "kintsugi",
		implName: "kintsugi-parachain",
		specName: "kintsugi-parachain",
		specVersion: "1024004",
		nativeToken: {
			id: "kintsugi-substrate-orml-kint"
		},
		tokens: [
			{
				id: "kintsugi-substrate-native-kint"
			},
			{
				id: "kintsugi-substrate-orml-dot"
			},
			{
				id: "kintsugi-substrate-orml-ibtc"
			},
			{
				id: "kintsugi-substrate-orml-intr"
			},
			{
				id: "kintsugi-substrate-orml-kbtc"
			},
			{
				id: "kintsugi-substrate-orml-kint"
			},
			{
				id: "kintsugi-substrate-orml-ksm"
			},
			{
				id: "kintsugi-substrate-tokens-ausd"
			},
			{
				id: "kintsugi-substrate-tokens-lksm"
			},
			{
				id: "kintsugi-substrate-tokens-lp-kbtc-ksm"
			},
			{
				id: "kintsugi-substrate-tokens-lp-kbtc-usdt"
			},
			{
				id: "kintsugi-substrate-tokens-lp-ksm-kint"
			},
			{
				id: "kintsugi-substrate-tokens-qkbtc"
			},
			{
				id: "kintsugi-substrate-tokens-qksm"
			},
			{
				id: "kintsugi-substrate-tokens-qusdt"
			},
			{
				id: "kintsugi-substrate-tokens-usdt"
			}
		],
		account: "*25519",
		subscanUrl: "https://kintsugi.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/kintsugi-parachain_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/kintsugi-parachain_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://kintsugi.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://api-kusama.interlay.io/parachain",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2092,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000510904009109",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "KINT",
					decimals: 12,
					metadata: "0x6d6574610e1c000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700041853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e0000000000510904009109",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: null,
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
						"KINT",
						"KBTC",
						"KSM",
						"INTR",
						"IBTC",
						"DOT"
					],
					decimals: [
						12,
						8,
						12,
						10,
						8,
						10
					],
					isTestnet: false,
					stateKeys: {
						DOT: "0x01a12dfa1fa4ab9a0000",
						KSM: "0x459d0fd09ec38ee6000a",
						IBTC: "0xd67c5ba80ba065480001",
						INTR: "0xc483de2de1246ea70002",
						KBTC: "0x1fce6bee3ae455b7000b",
						KINT: "0x56a60a12d72ef524000c"
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e28000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d000004000003200000000800080000050300100000050500180000050700c8084c696e7465726274635f7072696d6974697665732843757272656e6379496400011414546f6b656e0400cc012c546f6b656e53796d626f6c00000030466f726569676e41737365740400100138466f726569676e41737365744964000100244c656e64546f6b656e040010012c4c656e64546f6b656e49640002001c4c70546f6b656e0800d0011c4c70546f6b656e0000d0011c4c70546f6b656e00030034537461626c654c70546f6b656e0400100130537461626c65506f6f6c496400040000cc084c696e7465726274635f7072696d6974697665732c546f6b656e53796d626f6c0001180c444f54000000104942544300010010494e54520002000c4b534d000a00104b425443000b00104b494e54000c0000d0084c696e7465726274635f7072696d6974697665731c4c70546f6b656e00010c14546f6b656e0400cc012c546f6b656e53796d626f6c00000030466f726569676e41737365740400100138466f726569676e4173736574496400010034537461626c654c70546f6b656e0400100130537461626c65506f6f6c49640002000069060000040800c8007906082c6f726d6c5f746f6b656e732c4163636f756e7444617461041c42616c616e63650118000c01106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e636500000418546f6b656e730118546f6b656e7304204163636f756e7473010108020569067906c000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000018b8205468652062616c616e6365206f66206120746f6b656e207479706520756e64657220616e206163636f756e742e00fc204e4f54453a2049662074686520746f74616c2069732065766572207a65726f2c206465637265617365206163636f756e7420726566206163636f756e742e001901204e4f54453a2054686973206973206f6e6c79207573656420696e20746865206361736520746861742074686973206d6f64756c65206973207573656420746f2073746f7265282062616c616e6365732e0000000015510904009109",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "kpron",
		isTestnet: false,
		sortIndex: 83,
		genesisHash: null,
		prefix: null,
		name: "Kpron",
		themeColor: "#215fed",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/kpron.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://kusama-kpron-rpc.apron.network/",
				isHealthy: false
			}
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2019,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
		]
	},
	{
		id: "krest",
		isTestnet: false,
		sortIndex: 84,
		genesisHash: "0xb3dd5ad6a82872b30aabaede8f41dfd4ff6c32ff82f8757d034a45be63cf104c",
		prefix: 42,
		name: "Krest",
		themeColor: "#c82901",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/krest.svg",
		chainName: "krest-network",
		implName: "peaq-node-krest",
		specName: "peaq-node-krest",
		specVersion: "3",
		nativeToken: {
			id: "krest-substrate-native-krest"
		},
		tokens: [
			{
				id: "krest-substrate-native-krest"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://wss-krest.peaq.network/",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2241,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e000065060400a906",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "KREST",
					decimals: 18,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507006d010000030800000008008102102873705f72756e74696d651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e6465645665630804540185020453000004008d0201185665633c543e00008502083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c010869646d0101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e738902011c526561736f6e7300008902083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200008d02000002850200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402008102040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000465060400a906",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "500",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
						ACA: "0xb06e3ac92407aa260080",
						DOT: "0x1055d8b266dcb9ea0040",
						PEAQ: "0x01a12dfa1fa4ab9a0000"
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e28000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d000004000003200000000800080000050300180000050700a4083c7072696d69746976655f7479706573104831363000000400a801205b75383b2032305d0000a8000003140000000800c1010c4c706561715f7072696d6974697665735f78636d2063757272656e63792843757272656e6379496400010814546f6b656e0400c501012c546f6b656e53796d626f6c0000001445726332300400a4012845766d4164647265737300010000c5010c4c706561715f7072696d6974697665735f78636d2063757272656e63792c546f6b656e53796d626f6c00010c10504541510000000c444f540040000c4143410080000001060000040800c101001106082c6f726d6c5f746f6b656e732c4163636f756e7444617461041c42616c616e63650118000c01106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e636500000418546f6b656e730118546f6b656e7304204163636f756e7473010108020501061106c000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000018b8205468652062616c616e6365206f66206120746f6b656e207479706520756e64657220616e206163636f756e742e00fc204e4f54453a2049662074686520746f74616c2069732065766572207a65726f2c206465637265617365206163636f756e7420726566206163636f756e742e001901204e4f54453a2054686973206973206f6e6c79207573656420696e20746865206361736520746861742074686973206d6f64756c65206973207573656420746f2073746f7265282062616c616e6365732e000000002365060400a906",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "kulupu",
		isTestnet: false,
		sortIndex: 85,
		genesisHash: "0xf7a99d3cb92853d00d5275c971c132c074636256583fee53b3bbe60d7b8769ba",
		prefix: 16,
		name: "Kulupu",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Kulupu",
		implName: "kulupu",
		specName: "kulupu",
		specVersion: "24",
		nativeToken: {
			id: "kulupu-substrate-native-klp"
		},
		tokens: [
			{
				id: "kulupu-substrate-native-klp"
			}
		],
		account: "*25519",
		subscanUrl: "https://kulupu.subscan.io/",
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://rpc.kulupu.corepaper.org/ws",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 13
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "KLP",
					decimals: 12,
					metadata: null,
					isTestnet: false,
					accountInfoType: null,
					metadataVersion: 13,
					crowdloanPalletId: null,
					existentialDeposit: "100000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 13
				}
			}
		]
	},
	{
		id: "kusari",
		isTestnet: false,
		sortIndex: 86,
		genesisHash: "0x4959f8d87d40d9ef516459ff177111bb03d875e5a7ed69282f6b689a707b69f5",
		prefix: 42,
		name: "Kusari",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "kusari",
		implName: "kusari",
		specName: "kusari",
		specVersion: "19",
		nativeToken: {
			id: "kusari-substrate-native-ksi"
		},
		tokens: [
			{
				id: "kusari-substrate-native-ksi"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://ws.kusari.network",
				isHealthy: false
			}
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "KSI",
					decimals: 18,
					metadata: "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",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "0",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e000085090400c109",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "kylin",
		isTestnet: false,
		sortIndex: 87,
		genesisHash: "0xf2584690455deda322214e97edfffaf4c1233b6e4625e39478496b3e2f5a44c5",
		prefix: 42,
		name: "Kylin",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Kylin Network",
		implName: "kylin",
		specName: "kylin",
		specVersion: "21",
		nativeToken: {
			id: "kylin-substrate-native-kyl"
		},
		tokens: [
			{
				id: "kylin-substrate-native-kyl"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: "https://metadata.novasama.io/qr/kylin_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/kylin_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://polkadot.kylin-node.co.uk",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2052,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "KYL",
					decimals: 18,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507001d010000030800000008009d0310346672616d655f737570706f72741c73746f72616765407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401a103045300000400a90301185665633c543e0000a103083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c010869641d0101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73a503011c526561736f6e730000a503083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000a903000002a10300081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402009d03040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000ad10404000d05",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000d10404000d05",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "listen",
		isTestnet: false,
		sortIndex: 88,
		genesisHash: null,
		prefix: null,
		name: "Listen",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2118,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
		]
	},
	{
		id: "litentry",
		isTestnet: false,
		sortIndex: 89,
		genesisHash: "0x2fc8bb6ed7c0051bdcf4866c322ed32b6276572713607e3297ccf411b8f14aa9",
		prefix: 31,
		name: "Litentry",
		themeColor: "#15ea85",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/litentry.svg",
		chainName: "Litentry",
		implName: "litentry-parachain",
		specName: "litentry-parachain",
		specVersion: "9155",
		nativeToken: {
			id: "litentry-substrate-native-lit"
		},
		tokens: [
			{
				id: "litentry-substrate-native-lit"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: "https://metadata.novasama.io/qr/litentry-parachain_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/litentry-parachain_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://litentry-rpc.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://rpc.litentry-parachain.litentry.io",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2013,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e00006d070400e901",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "LIT",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507006901000003080000000800e104101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401e504045300000400ed0401185665633c543e0000e504083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964690101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73e904011c526561736f6e730000e904083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000ed04000002e50400081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200e104040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000a6d070400e901",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "100000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e18000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d000004000003200000000800080000050300180000050700cd04000004080018001d07082c6f726d6c5f746f6b656e732c4163636f756e7444617461041c42616c616e63650118000c01106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e636500000418546f6b656e730118546f6b656e7304204163636f756e74730101080205cd041d07c000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000018b8205468652062616c616e6365206f66206120746f6b656e207479706520756e64657220616e206163636f756e742e00fc204e4f54453a2049662074686520746f74616c2069732065766572207a65726f2c206465637265617365206163636f756e7420726566206163636f756e742e001901204e4f54453a2054686973206973206f6e6c79207573656420696e20746865206361736520746861742074686973206d6f64756c65206973207573656420746f2073746f7265282062616c616e6365732e00000000376d070400e901",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "litmus",
		isTestnet: false,
		sortIndex: 90,
		genesisHash: "0xda5831fbc8570e3c6336d0d72b8c08f8738beefec812df21ef2afc2982ede09c",
		prefix: 131,
		name: "Litmus",
		themeColor: "#e3e4e6",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/litmus.svg",
		chainName: "Litmus",
		implName: "litmus-parachain",
		specName: "litmus-parachain",
		specVersion: "9151",
		nativeToken: {
			id: "litmus-substrate-native-lit"
		},
		tokens: [
			{
				id: "litmus-substrate-native-lit"
			}
		],
		account: "*25519",
		subscanUrl: "https://litmus.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/litmus-parachain_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/litmus-parachain_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://rpc.litmus-parachain.litentry.io",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2106,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e000035070400e501",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "LIT",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507005501000003080000000800c504101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401c904045300000400d10401185665633c543e0000c904083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964550101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73cd04011c526561736f6e730000cd04083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000d104000002c90400081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200c504040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000a35070400e501",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "100000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e18000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d000004000003200000000800080000050300180000050700b104000004080018008906082c6f726d6c5f746f6b656e732c4163636f756e7444617461041c42616c616e63650118000c01106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e636500000418546f6b656e730118546f6b656e7304204163636f756e74730101080205b1048906c000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000018b8205468652062616c616e6365206f66206120746f6b656e207479706520756e64657220616e206163636f756e742e00fc204e4f54453a2049662074686520746f74616c2069732065766572207a65726f2c206465637265617365206163636f756e7420726566206163636f756e742e001901204e4f54453a2054686973206973206f6e6c79207573656420696e20746865206361736520746861742074686973206d6f64756c65206973207573656420746f2073746f7265282062616c616e6365732e000000003735070400e501",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "logion",
		isTestnet: false,
		sortIndex: 91,
		genesisHash: "0xe9d7420a5f73edef005ccb8e043500aa5b2458f173912184ea93c14dc035a203",
		prefix: 42,
		name: "Logion",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "logion MVP",
		implName: "logion",
		specName: "logion",
		specVersion: "147",
		nativeToken: {
			id: "logion-substrate-native-lgnt"
		},
		tokens: [
			{
				id: "logion-substrate-native-lgnt"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://rpc01.logion.network",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "LGNT",
					decimals: 18,
					metadata: "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",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "500",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000b1030400ed03",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "loom-network",
		isTestnet: false,
		sortIndex: 92,
		genesisHash: null,
		prefix: null,
		name: "Loom",
		themeColor: "#02819b",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/loom-network.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2080,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
		]
	},
	{
		id: "mangata",
		isTestnet: false,
		sortIndex: 93,
		genesisHash: "0xd611f22d291c5b7b69f1e105cca03352984c344c4421977efaa4cbdd1834e2aa",
		prefix: 42,
		name: "MangataX",
		themeColor: "#7aead7",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/mangata.svg",
		chainName: "Mangata Kusama Mainnet",
		implName: "mangata-parachain",
		specName: "mangata-parachain",
		specVersion: "3001",
		nativeToken: {
			id: "mangata-substrate-tokens-mgx"
		},
		tokens: [
			{
				id: "mangata-substrate-native-mgx"
			},
			{
				id: "mangata-substrate-tokens-mgx"
			}
		],
		account: "*25519",
		subscanUrl: "https://mangatax.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/mangata-parachain_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/mangata-parachain_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://kusama-archive.mangata.online",
				isHealthy: true
			},
			{
				url: "wss://kusama-rpc.mangata.online",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2110,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000a1070400c907",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "MGX",
					decimals: 18,
					metadata: "0x6d6574610e18000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e74446174610000100000050500140000040000081853797374656d011853797374656d041c4163636f756e7401010402000c400000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002443726f77646c6f616e012443726f77646c6f616e000000000012a1070400c907",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: null,
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e1c000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d000004000003200000000800080000050300100000050500b400000507004d05000004080010005d05082c6f726d6c5f746f6b656e732c4163636f756e7444617461041c42616c616e636501b4000c011066726565b4011c42616c616e63650001207265736572766564b4011c42616c616e636500011866726f7a656eb4011c42616c616e636500000418546f6b656e730118546f6b656e7304204163636f756e747301010802054d055d05c000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000018b8205468652062616c616e6365206f66206120746f6b656e207479706520756e64657220616e206163636f756e742e00fc204e4f54453a2049662074686520746f74616c2069732065766572207a65726f2c206465637265617365206163636f756e7420726566206163636f756e742e001901204e4f54453a2054686973206973206f6e6c79207573656420696e20746865206361736520746861742074686973206d6f64756c65206973207573656420746f2073746f7265282062616c616e6365732e000000000aa1070400c907",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "manta",
		isTestnet: false,
		sortIndex: 94,
		genesisHash: "0xf3c7ad88f6a80f366c4be216691411ef0622e8b809b1046ea297ef106058d4eb",
		prefix: 77,
		name: "Manta",
		themeColor: "#eb69bd",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/manta.svg",
		chainName: "Manta Parachain",
		implName: "manta",
		specName: "manta",
		specVersion: "4310",
		nativeToken: {
			id: "manta-substrate-native-manta"
		},
		tokens: [
			{
				id: "manta-substrate-native-manta"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://ws.manta.systems",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2104,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "MANTA",
					decimals: 18,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507005101000003080000000800f102101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401f502045300000400fd0201185665633c543e0000f502083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964510101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73f902011c526561736f6e730000f902083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000fd02000002f50200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200f102040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000ad5070400fd07",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "100000000000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000d5070400fd07",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "mars",
		isTestnet: false,
		sortIndex: 95,
		genesisHash: null,
		prefix: null,
		name: "Mars",
		themeColor: "#e56239",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/mars.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2008,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
		]
	},
	{
		id: "mathchain",
		isTestnet: false,
		sortIndex: 96,
		genesisHash: null,
		prefix: null,
		name: "MathChain",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "minix",
		isTestnet: false,
		sortIndex: 97,
		genesisHash: null,
		prefix: null,
		name: "MiniX",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "moonbeam",
		isTestnet: false,
		sortIndex: 98,
		genesisHash: "0xfe58ea77779b7abda7da4ec526d14db9b1e9cd40a217c34892af80a9b332b76d",
		prefix: 1284,
		name: "Moonbeam",
		themeColor: "#53cbc9",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/moonbeam.svg",
		chainName: "Moonbeam",
		implName: "moonbeam",
		specName: "moonbeam",
		specVersion: "2302",
		nativeToken: {
			id: "moonbeam-substrate-native-glmr"
		},
		tokens: [
			{
				id: "moonbeam-substrate-native-glmr"
			}
		],
		account: "secp256k1",
		subscanUrl: "https://moonbeam.subscan.io/",
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://moonbeam.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://1rpc.io/glmr",
				isHealthy: true
			},
			{
				url: "wss://moonbeam-rpc.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://wss.api.moonbeam.network",
				isHealthy: true
			},
			{
				url: "wss://moonbeam.unitedbloc.com",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
			{
				id: "1284"
			}
		],
		parathreads: [
		],
		paraId: 2004,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "GLMR",
					decimals: 18,
					metadata: "0x6d6574610e3000081c6163636f756e742c4163636f756e7449643230000004000401205b75383b2032305d0000040000031400000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700b5010000030800000008002903101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e646564566563080454012d03045300000400350301185665633c543e00002d03083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964b50101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e733103011c526561736f6e7300003103083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c0002000035030000022d0300081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402002903040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000a4d0804008108",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "0",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e00004d0804008108",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "moonriver",
		isTestnet: false,
		sortIndex: 100,
		genesisHash: "0x401a1f9dca3da46f5c4091016c8a2f26dcea05865116b286f60f668207d1474b",
		prefix: 1285,
		name: "Moonriver",
		themeColor: "#f2b705",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/moonriver.svg",
		chainName: "Moonriver",
		implName: "moonriver",
		specName: "moonriver",
		specVersion: "2401",
		nativeToken: {
			id: "moonriver-substrate-native-movr"
		},
		tokens: [
			{
				id: "moonriver-substrate-native-movr"
			}
		],
		account: "secp256k1",
		subscanUrl: "https://moonriver.subscan.io/",
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://moonriver.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://moonriver-rpc.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://wss.api.moonriver.moonbeam.network",
				isHealthy: true
			},
			{
				url: "wss://moonriver.unitedbloc.com",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
			{
				id: "1285"
			}
		],
		parathreads: [
		],
		paraId: 2023,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e3c00081c6163636f756e742c4163636f756e7449643230000004000401205b75383b2032305d000004000003140000000800080000050300100000050500180000050700340000020800900000050000d0000004000025090c3470616c6c65745f61737365747314747970657330417373657444657461696c730c1c42616c616e63650118244163636f756e7449640100384465706f73697442616c616e63650118003001146f776e65720001244163636f756e7449640001186973737565720001244163636f756e74496400011461646d696e0001244163636f756e74496400011c667265657a65720001244163636f756e744964000118737570706c7918011c42616c616e636500011c6465706f7369741801384465706f73697442616c616e636500012c6d696e5f62616c616e636518011c42616c616e636500013469735f73756666696369656e74900110626f6f6c0001206163636f756e747310010c75333200012c73756666696369656e747310010c753332000124617070726f76616c7310010c7533320001187374617475732909012c4173736574537461747573000029090c3470616c6c65745f6173736574731474797065732c417373657453746174757300010c104c6976650000001846726f7a656e0001002844657374726f79696e67000200002d090000040818000031090c3470616c6c65745f6173736574731474797065733041737365744163636f756e740c1c42616c616e63650118384465706f73697442616c616e6365011814457874726101d00010011c62616c616e636518011c42616c616e636500012469735f66726f7a656e900110626f6f6c000118726561736f6e3509017c4578697374656e6365526561736f6e3c4465706f73697442616c616e63653e0001146578747261d001144578747261000035090c3470616c6c65745f6173736574731474797065733c4578697374656e6365526561736f6e041c42616c616e63650118011020436f6e73756d65720000002853756666696369656e740001002c4465706f73697448656c64040018011c42616c616e63650002003c4465706f736974526566756e6465640003000041090c3470616c6c65745f6173736574731474797065733441737365744d6574616461746108384465706f73697442616c616e6365011834426f756e646564537472696e670145090014011c6465706f7369741801384465706f73697442616c616e63650001106e616d6545090134426f756e646564537472696e6700011873796d626f6c45090134426f756e646564537472696e67000120646563696d616c73080108753800012469735f66726f7a656e900110626f6f6c000045090c4c626f756e6465645f636f6c6c656374696f6e732c626f756e6465645f76656328426f756e64656456656308045401080453000004003401185665633c543e0000041841737365747301184173736574730c14417373657400010402182509040004542044657461696c73206f6620616e2061737365742e1c4163636f756e7400010802022d093109040004e42054686520686f6c64696e6773206f662061207370656369666963206163636f756e7420666f7220612073706563696669632061737365742e204d65746164617461010104021841095000000000000000000000000000000000000000000458204d65746164617461206f6620616e2061737365742e000000006881090400b509",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "MOVR",
					decimals: 18,
					metadata: "0x6d6574610e3000081c6163636f756e742c4163636f756e7449643230000004000401205b75383b2032305d0000040000031400000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507006502000003080000000800f5050c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401f905045300000400010601185665633c543e0000f905083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964650201384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73fd05011c526561736f6e730000fd05083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200000106000002f90500081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200f505040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000a81090400b509",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "0",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e000081090400b509",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "myriad",
		isTestnet: false,
		sortIndex: 102,
		genesisHash: "0x74ed91fbc18497f011290f9119a2217908649170337b6414a2d44923ade07063",
		prefix: 42,
		name: "Myriad",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Myriad",
		implName: "myriad",
		specName: "appchain",
		specVersion: "2036",
		nativeToken: {
			id: "myriad-substrate-native-myria"
		},
		tokens: [
			{
				id: "myriad-substrate-native-myria"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: "https://metadata.novasama.io/qr/appchain_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/appchain_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://ws-rpc.myriad.social",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000090504003505",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "MYRIA",
					decimals: 18,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700b9010000030800000008002902101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e646564566563080454012d02045300000400350201185665633c543e00002d02083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964b90101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e733102011c526561736f6e7300003102083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c0002000035020000022d0200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402002902040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e0000000003090504003505",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000090504003505",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "neatcoin",
		isTestnet: false,
		sortIndex: 103,
		genesisHash: "0xfbb541421d30423c9a753ffa844b64fd44d823f513bf49e3b73b3a656309a595",
		prefix: 48,
		name: "Neatcoin",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Neatcoin",
		implName: "neatcoin",
		specName: "neatcoin",
		specVersion: "4",
		nativeToken: {
			id: "neatcoin-substrate-native-neat"
		},
		tokens: [
			{
				id: "neatcoin-substrate-native-neat"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://rpc.neatcoin.org/ws",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000b5070400e907",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "NEAT",
					decimals: 12,
					metadata: "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",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "10000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000b5070400e907",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "nftmart",
		isTestnet: false,
		sortIndex: 104,
		genesisHash: "0xfcf9074303d8f319ad1bf0195b145871977e7c375883b834247cb01ff22f51f9",
		prefix: 12191,
		name: "NFTMart",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "NFTMart",
		implName: "nftmart",
		specName: "nftmart",
		specVersion: "279",
		nativeToken: {
			id: "nftmart-substrate-native-nmt"
		},
		tokens: [
			{
				id: "nftmart-substrate-native-nmt"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://mainnet.nftmart.io/rpc/ws",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 13
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "NMT",
					decimals: 12,
					metadata: null,
					isTestnet: false,
					accountInfoType: null,
					metadataVersion: 13,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 13
				}
			}
		]
	},
	{
		id: "nodle-polkadot",
		isTestnet: false,
		sortIndex: 105,
		genesisHash: "0x97da7ede98d7bad4e36b4d734b6055425a3be036da2a332ea5a7037656427a21",
		prefix: 37,
		name: "Nodle",
		themeColor: "#010717",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/nodle-polkadot.svg",
		chainName: "Nodle Parachain",
		implName: "nodle-para",
		specName: "nodle-para",
		specVersion: "20",
		nativeToken: {
			id: "nodle-polkadot-substrate-native-nodl"
		},
		tokens: [
			{
				id: "nodle-polkadot-substrate-native-nodl"
			}
		],
		account: "*25519",
		subscanUrl: "https://nodle.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/nodle-para_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/nodle-para_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://nodle-parachain.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://eden-rpc.dwellir.com",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2026,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e000099050400d905",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "NODL",
					decimals: 11,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700cc0000030800000008001902101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e646564566563080454011d02045300000400250201185665633c543e00001d02083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964cc01384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e732102011c526561736f6e7300002102083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c0002000025020000021d0200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402001902040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000299050400d905",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "10000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e000099050400d905",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "oak",
		isTestnet: false,
		sortIndex: 106,
		genesisHash: null,
		prefix: null,
		name: "Oak",
		themeColor: "#1ab8d0",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/oak.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://rpc.oak.tech",
				isHealthy: false
			}
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2090,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
		]
	},
	{
		id: "omnibtc",
		isTestnet: false,
		sortIndex: 107,
		genesisHash: null,
		prefix: null,
		name: "OmniBTC",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://psc-parachain.coming.chat",
				isHealthy: false
			}
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2053,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
		]
	},
	{
		id: "origintrail-parachain",
		isTestnet: false,
		sortIndex: 108,
		genesisHash: "0xe7e0962324a3b86c83404dbea483f25fb5dab4c224791c81b756cfc948006174",
		prefix: 101,
		name: "OriginTrail",
		themeColor: "#fb5deb",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/origintrail-parachain.svg",
		chainName: "OriginTrail Parachain",
		implName: "origintrail-parachain",
		specName: "origintrail-parachain",
		specVersion: "111",
		nativeToken: {
			id: "origintrail-parachain-substrate-native-otp"
		},
		tokens: [
			{
				id: "origintrail-parachain-substrate-native-otp"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: "https://metadata.novasama.io/qr/origintrail-parachain_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/origintrail-parachain_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://parachain-rpc.origin-trail.network",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2043,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "OTP",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507002901000003080000000800c5020c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401c902045300000400d10201185665633c543e0000c902083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964290101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73cd02011c526561736f6e730000cd02083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000d102000002c90200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200c502040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000a410504008505",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000410504008505",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "parallel",
		isTestnet: false,
		sortIndex: 109,
		genesisHash: "0xe61a41c53f5dcd0beb09df93b34402aada44cb05117b71059cce40a2723a4e97",
		prefix: 172,
		name: "Parallel",
		themeColor: "#f026a8",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/parallel.svg",
		chainName: "Parallel",
		implName: "parallel",
		specName: "parallel",
		specVersion: "198",
		nativeToken: {
			id: "parallel-substrate-native-para"
		},
		tokens: [
			{
				id: "parallel-substrate-native-para"
			}
		],
		account: "*25519",
		subscanUrl: "https://parallel.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/parallel_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/parallel_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://rpc.parallel.fi",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2012,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "PARA",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507004101000003080000000800ad05101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401b105045300000400b90501185665633c543e0000b105083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964410101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73b505011c526561736f6e730000b505083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000b905000002b10500081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200ad05040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e0000000004390904008109",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "100000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000390904008109",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "heiko-kusama",
		isTestnet: false,
		sortIndex: 110,
		genesisHash: "0x64a1c658a48b2e70a7fb1ad4c39eea35022568c20fc44a6e2e3d0a57aee6053b",
		prefix: 110,
		name: "Parallel Heiko",
		themeColor: "#f026a8",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/heiko-kusama.svg",
		chainName: "Parallel Heiko",
		implName: "heiko",
		specName: "heiko",
		specVersion: "198",
		nativeToken: {
			id: "heiko-kusama-substrate-native-hko"
		},
		tokens: [
			{
				id: "heiko-kusama-substrate-native-hko"
			}
		],
		account: "*25519",
		subscanUrl: "https://parallel-heiko.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/heiko_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/heiko_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://parallel-heiko.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://heiko-rpc.parallel.fi",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2085,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "HKO",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507004101000003080000000800ad05101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401b105045300000400b90501185665633c543e0000b105083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964410101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73b505011c526561736f6e730000b505083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000b905000002b10500081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200ad05040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e0000000004390904008109",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "10000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000390904008109",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "peaq",
		isTestnet: false,
		sortIndex: 111,
		genesisHash: null,
		prefix: null,
		name: "Peaq",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/peaq.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 3338,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
		]
	},
	{
		id: "pendulum",
		isTestnet: false,
		sortIndex: 112,
		genesisHash: "0x5d3c298622d5634ed019bf61ea4b71655030015bde9beb0d6a24743714462c86",
		prefix: 56,
		name: "Pendulum",
		themeColor: "#dae9eb",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/pendulum.svg",
		chainName: "Pendulum",
		implName: "pendulum",
		specName: "pendulum",
		specVersion: "8",
		nativeToken: {
			id: "pendulum-substrate-native-pen"
		},
		tokens: [
			{
				id: "pendulum-substrate-native-pen"
			},
			{
				id: "pendulum-substrate-tokens-dot"
			},
			{
				id: "pendulum-substrate-tokens-usdt"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://rpc-pendulum.prd.pendulumchain.tech",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2094,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000350704007907",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "PEN",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507003d010000030800000008009d02101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401a102045300000400a90201185665633c543e0000a102083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c010869643d0101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73a502011c526561736f6e730000a502083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000a902000002a10200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402009d02040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000a350704007907",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e1c000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d00000400000320000000080008000005030018000005070099010c4070656e64756c756d5f72756e74696d652063757272656e63792843757272656e63794964000108184e61746976650000000c58434d04000801087538000100006d0600000408009901007d06082c6f726d6c5f746f6b656e732c4163636f756e7444617461041c42616c616e63650118000c01106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e636500000418546f6b656e730118546f6b656e7304204163636f756e747301010802056d067d06c000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000018b8205468652062616c616e6365206f66206120746f6b656e207479706520756e64657220616e206163636f756e742e00fc204e4f54453a2049662074686520746f74616c2069732065766572207a65726f2c206465637265617365206163636f756e7420726566206163636f756e742e001901204e4f54453a2054686973206973206f6e6c79207573656420696e20746865206361736520746861742074686973206d6f64756c65206973207573656420746f2073746f7265282062616c616e6365732e0000000035350704007907",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "phala",
		isTestnet: false,
		sortIndex: 113,
		genesisHash: "0x1bb969d85965e4bb5a651abbedf21a54b6b31a21f66b5401cc3f1e286268d736",
		prefix: 30,
		name: "Phala",
		themeColor: "#cdfa50",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/phala.svg",
		chainName: "Phala",
		implName: "phala",
		specName: "phala",
		specVersion: "1250",
		nativeToken: {
			id: "phala-substrate-native-pha"
		},
		tokens: [
			{
				id: "phala-substrate-native-pha"
			}
		],
		account: "*25519",
		subscanUrl: "https://phala.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/phala_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/phala_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://phala.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://phala-rpc.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://api.phala.network/ws",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2035,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "PHA",
					decimals: 12,
					metadata: "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",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "10000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000510a0400990a",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "picasso",
		isTestnet: false,
		sortIndex: 114,
		genesisHash: "0x6811a339673c9daa897944dcdac99c6e2939cc88245ed21951a0a3c9a2be75bc",
		prefix: 49,
		name: "Picasso",
		themeColor: "#8d8884",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/picasso.svg",
		chainName: "Picasso",
		implName: "picasso",
		specName: "picasso",
		specVersion: "10032",
		nativeToken: {
			id: "picasso-substrate-native-pica"
		},
		tokens: [
			{
				id: "picasso-substrate-native-pica"
			},
			{
				id: "picasso-substrate-tokens-ausd"
			},
			{
				id: "picasso-substrate-tokens-bnc"
			},
			{
				id: "picasso-substrate-tokens-dot"
			},
			{
				id: "picasso-substrate-tokens-kar"
			},
			{
				id: "picasso-substrate-tokens-ksm"
			},
			{
				id: "picasso-substrate-tokens-movr"
			},
			{
				id: "picasso-substrate-tokens-usdc"
			},
			{
				id: "picasso-substrate-tokens-usdt"
			},
			{
				id: "picasso-substrate-tokens-vksm"
			},
			{
				id: "picasso-substrate-tokens-wbtc"
			},
			{
				id: "picasso-substrate-tokens-weth"
			}
		],
		account: "*25519",
		subscanUrl: "https://picasso.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/picasso_specs.png",
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://rpc.composablenodes.tech",
				isHealthy: true
			},
			{
				url: "wss://picasso-rpc.dwellir.com",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2087,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000d5090400010a",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "PICA",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700650100000308000000080081060c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e6465645665630804540185060453000004008d0601185665633c543e00008506083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964650101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e738906011c526561736f6e7300008906083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200008d06000002850600081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402008106040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e0000000006d5090400010a",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "100000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e1c000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d00000400000320000000080008000005030018000005070001020c287072696d6974697665732063757272656e63792843757272656e6379496400000400180110753132380000c5080000040800010200d508082c6f726d6c5f746f6b656e732c4163636f756e7444617461041c42616c616e63650118000c01106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e636500000418546f6b656e730118546f6b656e7304204163636f756e74730101080205c508d508c000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000018b8205468652062616c616e6365206f66206120746f6b656e207479706520756e64657220616e206163636f756e742e00fc204e4f54453a2049662074686520746f74616c2069732065766572207a65726f2c206465637265617365206163636f756e7420726566206163636f756e742e001901204e4f54453a2054686973206973206f6e6c79207573656420696e20746865206361736520746861742074686973206d6f64756c65206973207573656420746f2073746f7265282062616c616e6365732e0000000034d5090400010a",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "pichiu",
		isTestnet: false,
		sortIndex: 115,
		genesisHash: null,
		prefix: null,
		name: "Pichiu",
		themeColor: "#c0266c",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/pichiu.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: "https://metadata.novasama.io/qr/pichiu_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/pichiu_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://kusama.kylin-node.co.uk",
				isHealthy: false
			}
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2102,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
		]
	},
	{
		id: "polkadex-polkadot",
		isTestnet: false,
		sortIndex: 116,
		genesisHash: "0x3920bcb4960a1eef5580cd5367ff3f430eef052774f78468852f7b9cb39f8a3c",
		prefix: 88,
		name: "Polkadex",
		themeColor: "#e6007a",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/polkadex-polkadot.svg",
		chainName: "Polkadex Main Network",
		implName: "polkadex-official",
		specName: "node",
		specVersion: "287",
		nativeToken: {
			id: "polkadex-polkadot-substrate-native-pdex"
		},
		tokens: [
			{
				id: "polkadex-polkadot-substrate-native-pdex"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://polkadex.api.onfinality.io/public-ws",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2040,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "PDEX",
					decimals: 12,
					metadata: "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",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000ed0804001909",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "polkadex-standalone",
		isTestnet: false,
		sortIndex: 117,
		genesisHash: "0x3920bcb4960a1eef5580cd5367ff3f430eef052774f78468852f7b9cb39f8a3c",
		prefix: 88,
		name: "Polkadex Standalone",
		themeColor: "#e6007a",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/polkadex-standalone.svg",
		chainName: "Polkadex Main Network",
		implName: "polkadex-official",
		specName: "node",
		specVersion: "287",
		nativeToken: {
			id: "polkadex-standalone-substrate-native-pdex"
		},
		tokens: [
			{
				id: "polkadex-standalone-substrate-native-pdex"
			}
		],
		account: "*25519",
		subscanUrl: "https://polkadex.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/node_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/node_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://mainnet.polkadex.trade",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "PDEX",
					decimals: 12,
					metadata: "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",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000ed0804001909",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "polkasmith",
		isTestnet: false,
		sortIndex: 118,
		genesisHash: null,
		prefix: null,
		name: "PolkaSmith",
		themeColor: "#2cc5f4",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/polkasmith.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2009,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
		]
	},
	{
		id: "polymesh",
		isTestnet: false,
		sortIndex: 120,
		genesisHash: "0x6fbd74e5e1d0a61d52ccfe9d4adaed16dd3a7caa37c6bc4d0c2fa12e8b2f4063",
		prefix: 12,
		name: "Polymesh",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Polymesh Mainnet",
		implName: "polymesh_mainnet",
		specName: "polymesh_mainnet",
		specVersion: "5004001",
		nativeToken: {
			id: "polymesh-substrate-native-polyx"
		},
		tokens: [
			{
				id: "polymesh-substrate-native-polyx"
			}
		],
		account: "*25519",
		subscanUrl: "https://polymesh.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/polymesh_mainnet_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/polymesh_mainnet_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://mainnet-rpc.polymesh.network",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000ad0b0400dd0b",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "POLYX",
					decimals: 6,
					metadata: "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",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "0",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000ad0b0400dd0b",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "quartz",
		isTestnet: false,
		sortIndex: 121,
		genesisHash: "0xcd4d732201ebe5d6b014edda071c4203e16867305332301dc8d092044b28e554",
		prefix: 255,
		name: "Quartz",
		themeColor: "#ff4d6a",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/quartz.svg",
		chainName: "QUARTZ by UNIQUE",
		implName: "quartz",
		specName: "quartz",
		specVersion: "942057",
		nativeToken: {
			id: "quartz-substrate-native-qtz"
		},
		tokens: [
			{
				id: "quartz-substrate-native-qtz"
			}
		],
		account: "*25519",
		subscanUrl: "https://quartz.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/quartz_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/quartz_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://quartz.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://ws-quartz.unique.network",
				isHealthy: true
			},
			{
				url: "wss://us-ws-quartz.unique.network",
				isHealthy: true
			},
			{
				url: "wss://asia-ws-quartz.unique.network",
				isHealthy: true
			},
			{
				url: "wss://eu-ws-quartz.unique.network",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2095,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000c50804000d09",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "QTZ",
					decimals: 18,
					metadata: "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",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "0",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e24000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503001000000505001800000507000d01085470616c6c65745f666f726569676e5f61737365747320417373657449647300010838466f726569676e417373657449640400100138466f726569676e41737365744964000000344e6174697665417373657449640400110101384e617469766543757272656e6379000100001101085470616c6c65745f666f726569676e5f617373657473384e617469766543757272656e6379000108104865726500000018506172656e7400010000750600000408000d01008506082c6f726d6c5f746f6b656e732c4163636f756e7444617461041c42616c616e63650118000c01106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e636500000418546f6b656e730118546f6b656e7304204163636f756e7473010108020575068506c000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000018b8205468652062616c616e6365206f66206120746f6b656e207479706520756e64657220616e206163636f756e742e00fc204e4f54453a2049662074686520746f74616c2069732065766572207a65726f2c206465637265617365206163636f756e7420726566206163636f756e742e001901204e4f54453a2054686973206973206f6e6c79207573656420696e20746865206361736520746861742074686973206d6f64756c65206973207573656420746f2073746f7265282062616c616e6365732e0000000027c50804000d09",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "riochain",
		isTestnet: false,
		sortIndex: 122,
		genesisHash: null,
		prefix: null,
		name: "RioChain",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "riodefi",
		isTestnet: false,
		sortIndex: 123,
		genesisHash: null,
		prefix: null,
		name: "RioDeFi",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2227,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
		]
	},
	{
		id: "robonomics-kusama",
		isTestnet: false,
		sortIndex: 124,
		genesisHash: "0x631ccc82a078481584041656af292834e1ae6daab61d2875b4dd0c14bb9b17bc",
		prefix: 32,
		name: "Robonomics",
		themeColor: "#03a5ed",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/robonomics-kusama.svg",
		chainName: "Robonomics",
		implName: "robonomics-airalab",
		specName: "robonomics",
		specVersion: "31",
		nativeToken: {
			id: "robonomics-kusama-substrate-native-xrt"
		},
		tokens: [
			{
				id: "robonomics-kusama-substrate-native-xrt"
			}
		],
		account: "*25519",
		subscanUrl: "https://robonomics.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/robonomics_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/robonomics_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://robonomics.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://kusama.rpc.robonomics.network/",
				isHealthy: true
			},
			{
				url: "wss://robonomics.leemo.me",
				isHealthy: true
			},
			{
				url: "wss://robonomics.0xsamsara.com",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2048,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "XRT",
					decimals: 9,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e6365000018000005070081010000030800000008008904102873705f72756e74696d651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e646564566563080454018d04045300000400950401185665633c543e00008d04083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964810101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e739104011c526561736f6e7300009104083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c0002000095040000028d04000c1853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e000000000a2042616c616e636573012042616c616e63657304144c6f636b7301010402008904040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000001f2443726f77646c6f616e000181030119010001ad0539310604008905",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000310604008905",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "sakura",
		isTestnet: false,
		sortIndex: 125,
		genesisHash: null,
		prefix: null,
		name: "Sakura",
		themeColor: "#f9fff3",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/sakura.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: "https://sakura.subscan.io/",
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://api-sakura.clover.finance",
				isHealthy: false
			}
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2016,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
		]
	},
	{
		id: "sherpax",
		isTestnet: false,
		sortIndex: 126,
		genesisHash: "0xe195ef16d0c628b5cab1486a233865def6e71f8b7814dd058a6b93a85118b796",
		prefix: 44,
		name: "SherpaX",
		themeColor: "#34c69a",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/sherpax.svg",
		chainName: "SherpaX",
		implName: "SherpaX",
		specName: "SherpaX",
		specVersion: "43",
		nativeToken: {
			id: "sherpax-substrate-native-ksx"
		},
		tokens: [
			{
				id: "sherpax-substrate-native-ksx"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://mainnet.sherpax.io",
				isHealthy: false
			}
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "KSX",
					decimals: 18,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700f501000003080000000800010410346672616d655f737570706f72741c73746f72616765407765616b5f626f756e6465645f766563385765616b426f756e6465645665630804540105040453000004000d0401185665633c543e00000504083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964f50101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e730904011c526561736f6e7300000904083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200000d04000002050400081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402000104040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000a69060400a106",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "10000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e000069060400a106",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "shiden-kusama",
		isTestnet: false,
		sortIndex: 127,
		genesisHash: "0xf1cf9022c7ebb34b162d5b5e34e705a5a740b2d0ecc1009fb89023e62a488108",
		prefix: 5,
		name: "Shiden",
		themeColor: "#bba5e1",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/shiden-kusama.svg",
		chainName: "Shiden",
		implName: "shiden",
		specName: "shiden",
		specVersion: "100",
		nativeToken: {
			id: "shiden-kusama-substrate-native-sdn"
		},
		tokens: [
			{
				id: "shiden-kusama-substrate-native-sdn"
			}
		],
		account: "*25519",
		subscanUrl: "https://shiden.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/shiden_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/shiden_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://shiden.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://shiden-rpc.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://rpc.shiden.astar.network",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
			{
				id: "336"
			}
		],
		parathreads: [
		],
		paraId: 2007,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "SDN",
					decimals: 18,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700450100000308000000080061050c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e6465645665630804540165050453000004006d0501185665633c543e00006505083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964450101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e736905011c526561736f6e7300006905083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200006d05000002650500081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e000000000a2042616c616e636573012042616c616e63657304144c6f636b7301010402006105040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000001f65070400a907",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e000065070400a907",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "snow",
		isTestnet: false,
		sortIndex: 129,
		genesisHash: null,
		prefix: null,
		name: "Snow",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/snow.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: "https://metadata.novasama.io/qr/snow_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/snow_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2129,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
		]
	},
	{
		id: "sora-kusama",
		isTestnet: false,
		sortIndex: 130,
		genesisHash: "0x6d8d9f145c2177fa83512492cdd80a71e29f22473f4a8943a6292149ac319fb9",
		prefix: 420,
		name: "Sora",
		themeColor: "#fd0100",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/sora-kusama.svg",
		chainName: "SORA Kusama",
		implName: "sora_ksm",
		specName: "sora_ksm",
		specVersion: "1",
		nativeToken: {
			id: "sora-kusama-substrate-native-unknown"
		},
		tokens: [
			{
				id: "sora-kusama-substrate-native-unknown"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://ws.parachain-collator-1.c1.sora2.soramitsu.co.jp",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2011,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e00007d030400bd03",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "Unknown",
					decimals: 0,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700dc0000030800000008000d0210346672616d655f737570706f72741c73746f72616765407765616b5f626f756e6465645f766563385765616b426f756e646564566563080454011102045300000400190201185665633c543e00001102083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964dc01384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e731502011c526561736f6e7300001502083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200001902000002110200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402000d02040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000a7d030400bd03",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e00007d030400bd03",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "sora-polkadot",
		isTestnet: false,
		sortIndex: 131,
		genesisHash: null,
		prefix: null,
		name: "Sora",
		themeColor: "#fd0100",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/sora-polkadot.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2025,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
		]
	},
	{
		id: "sora-standalone",
		isTestnet: false,
		sortIndex: 132,
		genesisHash: "0x7e4e32d0feafd4f9c9414b0be86373f9a1efa904809b683453a9af6856d38ad5",
		prefix: 69,
		name: "Sora Standalone",
		themeColor: "#fd0100",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/sora-standalone.svg",
		chainName: "SORA",
		implName: "sora-substrate",
		specName: "sora-substrate",
		specVersion: "58",
		nativeToken: {
			id: "sora-standalone-substrate-native-xor"
		},
		tokens: [
			{
				id: "sora-standalone-substrate-native-xor"
			}
		],
		account: "*25519",
		subscanUrl: "https://sora.subscan.io/",
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://sora.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://ws.mof.sora.org",
				isHealthy: true
			},
			{
				url: "wss://mof2.sora.org",
				isHealthy: true
			},
			{
				url: "wss://mof3.sora.org",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0004184173736574730118417373657473000000000015e50a04001d0b",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "XOR",
					decimals: 18,
					metadata: "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",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "0",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e1c000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503001800000507000d010c18636f6d6d6f6e287072696d69746976657324417373657449643332041c4173736574496401110100040110636f6465040134417373657449643332436f64650000310800000408000d01004108082c6f726d6c5f746f6b656e732c4163636f756e7444617461041c42616c616e63650118000c01106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e636500000418546f6b656e730118546f6b656e7304204163636f756e7473010108020531084108c000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000018b8205468652062616c616e6365206f66206120746f6b656e207479706520756e64657220616e206163636f756e742e00fc204e4f54453a2049662074686520746f74616c2069732065766572207a65726f2c206465637265617365206163636f756e7420726566206163636f756e742e001901204e4f54453a2054686973206973206f6e6c79207573656420696e20746865206361736520746861742074686973206d6f64756c65206973207573656420746f2073746f7265282062616c616e6365732e0000000012e50a04001d0b",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "spanner",
		isTestnet: false,
		sortIndex: 133,
		genesisHash: null,
		prefix: null,
		name: "Spanner",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "stafi",
		isTestnet: false,
		sortIndex: 134,
		genesisHash: null,
		prefix: null,
		name: "Stafi",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: "https://stafi.subscan.io/",
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "statemine",
		isTestnet: false,
		sortIndex: 135,
		genesisHash: "0x48239ef607d7928874027a43a67689209727dfb3d3dc5e5b03a39bdc2eda771a",
		prefix: 2,
		name: "Statemine",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/statemine.svg",
		chainName: "Statemine",
		implName: "statemine",
		specName: "statemine",
		specVersion: "9430",
		nativeToken: {
			id: "statemine-substrate-native-ksm"
		},
		tokens: [
			{
				id: "statemine-substrate-assets-16-aris"
			},
			{
				id: "statemine-substrate-assets-1984-usdt"
			},
			{
				id: "statemine-substrate-assets-8-rmrk"
			},
			{
				id: "statemine-substrate-native-ksm"
			}
		],
		account: "*25519",
		subscanUrl: "https://statemine.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/statemine_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/statemine_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://statemine.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://statemine-rpc.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://statemine-rpc-tn.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://sys.ibp.network/statemine",
				isHealthy: true
			},
			{
				url: "wss://sys.dotters.network/statemine",
				isHealthy: true
			},
			{
				url: "wss://rpc-statemine.luckyfriday.io",
				isHealthy: true
			},
			{
				url: "wss://statemine-rpc.polkadot.io",
				isHealthy: true
			},
			{
				url: "wss://statemine.public.curie.radiumblock.co/ws",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 1000,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e40000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d000004000003200000000800080000050300100000050500180000050700340000020800490100000500009d01000004000031050c3470616c6c65745f61737365747314747970657330417373657444657461696c730c1c42616c616e63650118244163636f756e7449640100384465706f73697442616c616e63650118003001146f776e65720001244163636f756e7449640001186973737565720001244163636f756e74496400011461646d696e0001244163636f756e74496400011c667265657a65720001244163636f756e744964000118737570706c7918011c42616c616e636500011c6465706f7369741801384465706f73697442616c616e636500012c6d696e5f62616c616e636518011c42616c616e636500013469735f73756666696369656e7449010110626f6f6c0001206163636f756e747310010c75333200012c73756666696369656e747310010c753332000124617070726f76616c7310010c7533320001187374617475733505012c4173736574537461747573000035050c3470616c6c65745f6173736574731474797065732c417373657453746174757300010c104c6976650000001846726f7a656e0001002844657374726f79696e67000200003905000004081000003d050c3470616c6c65745f6173736574731474797065733041737365744163636f756e74101c42616c616e63650118384465706f73697442616c616e63650118144578747261019d01244163636f756e74496401000010011c62616c616e636518011c42616c616e6365000118737461747573410501344163636f756e74537461747573000118726561736f6e450501a84578697374656e6365526561736f6e3c4465706f73697442616c616e63652c204163636f756e7449643e00011465787472619d0101144578747261000041050c3470616c6c65745f617373657473147479706573344163636f756e7453746174757300010c184c69717569640000001846726f7a656e0001001c426c6f636b65640002000045050c3470616c6c65745f6173736574731474797065733c4578697374656e6365526561736f6e081c42616c616e63650118244163636f756e7449640100011420436f6e73756d65720000002853756666696369656e740001002c4465706f73697448656c64040018011c42616c616e63650002003c4465706f736974526566756e6465640003002c4465706f73697446726f6d08000001244163636f756e744964000018011c42616c616e63650004000051050c3470616c6c65745f6173736574731474797065733441737365744d6574616461746108384465706f73697442616c616e6365011834426f756e646564537472696e670155050014011c6465706f7369741801384465706f73697442616c616e63650001106e616d6555050134426f756e646564537472696e6700011873796d626f6c55050134426f756e646564537472696e67000120646563696d616c73080108753800012469735f66726f7a656e49010110626f6f6c000055050c4c626f756e6465645f636f6c6c656374696f6e732c626f756e6465645f76656328426f756e64656456656308045401080453000004003401185665633c543e0000041841737365747301184173736574730c14417373657400010402103105040004542044657461696c73206f6620616e2061737365742e1c4163636f756e74000108020239053d05040004e42054686520686f6c64696e6773206f662061207370656369666963206163636f756e7420666f7220612073706563696669632061737365742e204d65746164617461010104021051055000000000000000000000000000000000000000000458204d65746164617461206f6620616e2061737365742e0000000032ed0504001906",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "KSM",
					decimals: 12,
					metadata: "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",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "33333333",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000ed0504001906",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "statemint",
		isTestnet: false,
		sortIndex: 136,
		genesisHash: "0x68d56f15f85d3136970ec16946040bc1752654e906147f7e43e9d539d7c3de2f",
		prefix: 0,
		name: "Statemint",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/statemint.svg",
		chainName: "Statemint",
		implName: "statemint",
		specName: "statemint",
		specVersion: "9430",
		nativeToken: {
			id: "statemint-substrate-native-dot"
		},
		tokens: [
			{
				id: "statemint-substrate-assets-1984-usdt"
			},
			{
				id: "statemint-substrate-native-dot"
			}
		],
		account: "*25519",
		subscanUrl: "https://statemint.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/statemint_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/statemint_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://statemint.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://statemint-rpc.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://statemint-rpc-tn.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://sys.ibp.network/statemint",
				isHealthy: true
			},
			{
				url: "wss://sys.dotters.network/statemint",
				isHealthy: true
			},
			{
				url: "wss://statemint-rpc.polkadot.io",
				isHealthy: true
			},
			{
				url: "wss://statemint.public.curie.radiumblock.co/ws",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 1000,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "DOT",
					decimals: 10,
					metadata: "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",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000ed0504001906",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "subdao",
		isTestnet: false,
		sortIndex: 137,
		genesisHash: null,
		prefix: null,
		name: "SubDAO",
		themeColor: "#d51073",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/subdao.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://parachain-rpc.subdao.org",
				isHealthy: false
			}
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2018,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
		]
	},
	{
		id: "subgame-standalone",
		isTestnet: false,
		sortIndex: 138,
		genesisHash: null,
		prefix: null,
		name: "SubGame",
		themeColor: "#eb027d",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/subgame-standalone.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: "https://subgame.subscan.io/",
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "subgame-kusama",
		isTestnet: false,
		sortIndex: 139,
		genesisHash: null,
		prefix: null,
		name: "SubGame Gamma Kusama",
		themeColor: "#eb027d",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/subgame-kusama.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://gamma.subgame.org/",
				isHealthy: false
			}
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2018,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
		]
	},
	{
		id: "subgame-polkadot",
		isTestnet: false,
		sortIndex: 140,
		genesisHash: null,
		prefix: null,
		name: "SubGame Gamma Polkadot",
		themeColor: "#eb027d",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/subgame-polkadot.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2017,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
		]
	},
	{
		id: "subsocial-polkadot",
		isTestnet: false,
		sortIndex: 141,
		genesisHash: "0x4a12be580bb959937a1c7a61d5cf24428ed67fa571974b4007645d1886e7c89f",
		prefix: 28,
		name: "Subsocial",
		themeColor: "#a4028f",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/subsocial-polkadot.svg",
		chainName: "Subsocial",
		implName: "subsocial-parachain",
		specName: "subsocial-parachain",
		specVersion: "26",
		nativeToken: {
			id: "subsocial-polkadot-substrate-native-sub"
		},
		tokens: [
			{
				id: "subsocial-polkadot-substrate-native-sub"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://para.subsocial.network",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2101,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e000061050400a505",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "SUB",
					decimals: 10,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e6365000018000005070011010000030800000008007d02101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e646564566563080454018102045300000400890201185665633c543e00008102083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964110101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e738502011c526561736f6e7300008502083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200008902000002810200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402007d02040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000a61050400a505",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "100000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e000061050400a505",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "subsocial-standalone",
		isTestnet: false,
		sortIndex: 142,
		genesisHash: null,
		prefix: null,
		name: "Subsocial Standalone",
		themeColor: "#a4028f",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/subsocial-standalone.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "subsocial-x",
		isTestnet: false,
		sortIndex: 143,
		genesisHash: null,
		prefix: null,
		name: "SubsocialX",
		themeColor: "#4d0366",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/subsocial-x.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: "https://metadata.novasama.io/qr/subsocial-parachain_specs.png",
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2100,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
		]
	},
	{
		id: "zero",
		isTestnet: false,
		sortIndex: 144,
		genesisHash: "0x2991d4125ac465d64c4c0b915fedd7168b5961b7676480636e3747f1ad64cfb9",
		prefix: 25,
		name: "Subzero",
		themeColor: "#f6921e",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/zero.svg",
		chainName: "Subzero",
		implName: "live",
		specName: "subzero",
		specVersion: "75",
		nativeToken: {
			id: "zero-substrate-native-zero"
		},
		tokens: [
			{
				id: "zero-substrate-native-zero"
			},
			{
				id: "zero-substrate-orml-dot"
			},
			{
				id: "zero-substrate-orml-game"
			},
			{
				id: "zero-substrate-orml-play"
			},
			{
				id: "zero-substrate-orml-zero"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://rpc-1.kusama.node.zero.io",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2236,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e00004d0904007909",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "ZERO",
					decimals: 18,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507009d0100000308000000080045070c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e646564566563080454014907045300000400510701185665633c543e00004907083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c010869649d0101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e734d07011c526561736f6e7300004d07083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200005107000002490700081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402004507040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e00000000164d0904007909",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "10000000000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
						"ZERO",
						"PLAY",
						"GAME",
						"DOT"
					],
					decimals: [
						18,
						10,
						10,
						10
					],
					isTestnet: false,
					stateKeys: {
						DOT: "0x56a60a12d72ef524000c",
						KSM: "0x7f9938b78bd5ff520082",
						GAME: "0xc483de2de1246ea70002",
						PLAY: "0xd67c5ba80ba065480001",
						ZERO: "0x01a12dfa1fa4ab9a0000"
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e24000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d00000400000320000000080008000005030010000005050018000005070045020c3c7a65726f5f7072696d6974697665732063757272656e63792843757272656e6379496400010814546f6b656e04004902012c546f6b656e53796d626f6c00000030466f726569676e41737365740400100138466f726569676e417373657449640001000049020c3c7a65726f5f7072696d6974697665732063757272656e63792c546f6b656e53796d626f6c000114105a45524f00000010504c41590001001047414d450002000c444f54000c000c4b534d00820000a9080000040800450200b908082c6f726d6c5f746f6b656e732c4163636f756e7444617461041c42616c616e63650118000c01106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e636500000418546f6b656e730118546f6b656e7304204163636f756e74730101080205a908b908c000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000018b8205468652062616c616e6365206f66206120746f6b656e207479706520756e64657220616e206163636f756e742e00fc204e4f54453a2049662074686520746f74616c2069732065766572207a65726f2c206465637265617365206163636f756e7420726566206163636f756e742e001901204e4f54453a2054686973206973206f6e6c79207573656420696e20746865206361736520746861742074686973206d6f64756c65206973207573656420746f2073746f7265282062616c616e6365732e000000003f4d0904007909",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "swapdex",
		isTestnet: false,
		sortIndex: 145,
		genesisHash: "0x15bac4f0a9aad3f46c5fc067fdb59b3ff29738dcd491fe5e37b4b76121163471",
		prefix: 42,
		name: "Swapdex",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "swapdex",
		implName: "swapdex",
		specName: "swapdex",
		specVersion: "14",
		nativeToken: {
			id: "swapdex-substrate-native-sdx"
		},
		tokens: [
			{
				id: "swapdex-substrate-native-sdx"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://ws.swapdex.network",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e38000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d000004000003200000000800080000050300100000050500180000050700280000020800700000040000880000050000490110346672616d655f737570706f72741c73746f726167652c626f756e6465645f76656328426f756e64656456656308045401080453000004002801185665633c543e0000a1060000040810000061080c3470616c6c65745f61737365747314747970657330417373657444657461696c730c1c42616c616e63650118244163636f756e7449640100384465706f73697442616c616e63650118003001146f776e65720001244163636f756e7449640001186973737565720001244163636f756e74496400011461646d696e0001244163636f756e74496400011c667265657a65720001244163636f756e744964000118737570706c7918011c42616c616e636500011c6465706f7369741801384465706f73697442616c616e636500012c6d696e5f62616c616e636518011c42616c616e636500013469735f73756666696369656e74880110626f6f6c0001206163636f756e747310010c75333200012c73756666696369656e747310010c753332000124617070726f76616c7310010c75333200012469735f66726f7a656e880110626f6f6c000065080c3470616c6c65745f6173736574731474797065733041737365744163636f756e740c1c42616c616e63650118384465706f73697442616c616e6365011814457874726101700010011c62616c616e636518011c42616c616e636500012469735f66726f7a656e880110626f6f6c000118726561736f6e6908017c4578697374656e6365526561736f6e3c4465706f73697442616c616e63653e00011465787472617001144578747261000069080c3470616c6c65745f6173736574731474797065733c4578697374656e6365526561736f6e041c42616c616e63650118011020436f6e73756d65720000002853756666696369656e740001002c4465706f73697448656c64040018011c42616c616e63650002003c4465706f736974526566756e6465640003000075080c3470616c6c65745f6173736574731474797065733441737365744d6574616461746108384465706f73697442616c616e6365011834426f756e646564537472696e670149010014011c6465706f7369741801384465706f73697442616c616e63650001106e616d6549010134426f756e646564537472696e6700011873796d626f6c49010134426f756e646564537472696e67000120646563696d616c73080108753800012469735f66726f7a656e880110626f6f6c0000041841737365747301184173736574730c14417373657400010402106108040004542044657461696c73206f6620616e2061737365742e1c4163636f756e740001080202a1066508040004e42054686520686f6c64696e6773206f662061207370656369666963206163636f756e7420666f7220612073706563696669632061737365742e204d65746164617461010104021075085000000000000000000000000000000000000000000458204d65746164617461206f6620616e2061737365742e0000000020cd090400090a",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "SDX",
					decimals: 18,
					metadata: "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",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "0",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000cd090400090a",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "t-3-rn",
		isTestnet: false,
		sortIndex: 146,
		genesisHash: "0x9a33d1af38c2736ecddbbbcdc2cb2c3023e9b91dc295ac3f1473fe226e5944a7",
		prefix: 9935,
		name: "t3rn",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "t3rn",
		implName: "t3rn Circuit Collator",
		specName: "t3rn",
		specVersion: "1",
		nativeToken: {
			id: "t-3-rn-substrate-native-trn"
		},
		tokens: [
			{
				id: "t-3-rn-substrate-native-trn"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://ws.t3rn.io",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 3333,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000590404009d04",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "TRN",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e6365000018000005070015010000030800000008004d03101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e646564566563080454015103045300000400590301185665633c543e00005103083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964150101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e735503011c526561736f6e7300005503083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200005903000002510300081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402004d03040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000a590404009d04",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000590404009d04",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "tanganika",
		isTestnet: false,
		sortIndex: 147,
		genesisHash: null,
		prefix: null,
		name: "Tanganika",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: "https://datahighway.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/datahighway-parachain_specs.png",
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2116,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
		]
	},
	{
		id: "ternoa",
		isTestnet: false,
		sortIndex: 148,
		genesisHash: "0x6859c81ca95ef624c9dfe4dc6e3381c33e5d6509e35e147092bfbc780f777c4e",
		prefix: 42,
		name: "Ternoa",
		themeColor: "#ff8500",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/ternoa.svg",
		chainName: "Ternoa Mainnet",
		implName: "mainnet",
		specName: "mainnet",
		specVersion: "15",
		nativeToken: {
			id: "ternoa-substrate-native-caps"
		},
		tokens: [
			{
				id: "ternoa-substrate-native-caps"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: "https://metadata.novasama.io/qr/mainnet_specs.png",
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://mainnet.ternoa.network",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "CAPS",
					decimals: 18,
					metadata: "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",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "150000000000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e000095080400c908",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "thebifrost-mainnet",
		isTestnet: false,
		sortIndex: 149,
		genesisHash: "0x63e1e2390bf7758f2462ad22b950e7e191f3500226ba6f572346ac06ced516fe",
		prefix: 42,
		name: "The Bifrost",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "BIFROST Mainnet",
		implName: "bifrost-mainnet",
		specName: "thebifrost-mainnet",
		specVersion: "2013",
		nativeToken: {
			id: "thebifrost-mainnet-substrate-native-bfc"
		},
		tokens: [
			{
				id: "thebifrost-mainnet-substrate-native-bfc"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://public-01.mainnet.thebifrost.io/wss",
				isHealthy: true
			},
			{
				url: "wss://public-02.mainnet.thebifrost.io/wss",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000110604004d06",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "BFC",
					decimals: 18,
					metadata: "0x6d6574610e3000081c6163636f756e742c4163636f756e7449643230000004000401205b75383b2032305d0000040000031400000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700d101000003080000000800a9020c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401ad02045300000400b50201185665633c543e0000ad02083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964d10101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73b102011c526561736f6e730000b102083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000b502000002ad0200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200a902040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000a110604004d06",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "0",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000110604004d06",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "trustbase",
		isTestnet: false,
		sortIndex: 150,
		genesisHash: null,
		prefix: null,
		name: "TrustBase",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2078,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
		]
	},
	{
		id: "turing",
		isTestnet: false,
		sortIndex: 151,
		genesisHash: "0x0f62b701fb12d02237a33b84818c11f621653d2b1614c777973babf4652b535d",
		prefix: 51,
		name: "Turing",
		themeColor: "#1db5cf",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/turing.svg",
		chainName: "Turing Network",
		implName: "turing",
		specName: "turing",
		specVersion: "294",
		nativeToken: {
			id: "turing-substrate-native-tur"
		},
		tokens: [
			{
				id: "turing-substrate-native-tur"
			}
		],
		account: "*25519",
		subscanUrl: "https://turing.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/turing_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/turing_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://turing-rpc.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://rpc.turing.oak.tech",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2114,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000b9070400f907",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "TUR",
					decimals: 10,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e6365000018000005070088000003080000000800f102101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401f502045300000400fd0201185665633c543e0000f502083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c010869648801384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73f902011c526561736f6e730000f902083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000fd02000002f50200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200f102040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000ab9070400f907",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "100000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e1c000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503001000000505001800000507001d03000004080010002d03082c6f726d6c5f746f6b656e732c4163636f756e7444617461041c42616c616e63650118000c01106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e636500000418546f6b656e730118546f6b656e7304204163636f756e747301010802051d032d03c000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000018b8205468652062616c616e6365206f66206120746f6b656e207479706520756e64657220616e206163636f756e742e00fc204e4f54453a2049662074686520746f74616c2069732065766572207a65726f2c206465637265617365206163636f756e7420726566206163636f756e742e001901204e4f54453a2054686973206973206f6e6c79207573656420696e20746865206361736520746861742074686973206d6f64756c65206973207573656420746f2073746f7265282062616c616e6365732e000000000bb9070400f907",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "uniarts",
		isTestnet: false,
		sortIndex: 152,
		genesisHash: null,
		prefix: null,
		name: "UniArts",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: "https://uniarts.subscan.io/",
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "unique",
		isTestnet: false,
		sortIndex: 153,
		genesisHash: "0x84322d9cddbf35088f1e54e9a85c967a41a56a4f43445768125e61af166c7d31",
		prefix: 7391,
		name: "Unique",
		themeColor: "#00bfff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unique.svg",
		chainName: "UNIQUE",
		implName: "unique",
		specName: "unique",
		specVersion: "942057",
		nativeToken: {
			id: "unique-substrate-native-unq"
		},
		tokens: [
			{
				id: "unique-substrate-native-unq"
			}
		],
		account: "*25519",
		subscanUrl: "https://unique.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/unique_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/unique_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://ws.unique.network",
				isHealthy: true
			},
			{
				url: "wss://us-ws.unique.network",
				isHealthy: true
			},
			{
				url: "wss://asia-ws.unique.network",
				isHealthy: true
			},
			{
				url: "wss://eu-ws.unique.network",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2037,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e000095070400dd07",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "UNQ",
					decimals: 18,
					metadata: "0x6d6574610e34000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e74446174610000100000050500140c3c70616c6c65745f62616c616e6365731474797065732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e6365000114666c6167731c01284578747261466c61677300001800000507001c0c3c70616c6c65745f62616c616e636573147479706573284578747261466c61677300000400180110753132380000f800000308000000080029030c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e646564566563080454012d03045300000400350301185665633c543e00002d030c3c70616c6c65745f62616c616e6365731474797065732c42616c616e63654c6f636b041c42616c616e63650118000c01086964f801384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e733103011c526561736f6e73000031030c3c70616c6c65745f62616c616e6365731474797065731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c0002000035030000022d0300081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000008004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402002903040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000001e95070400dd07",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "0",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e24000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503001000000505001800000507000501085470616c6c65745f666f726569676e5f61737365747320417373657449647300010838466f726569676e417373657449640400100138466f726569676e41737365744964000000344e6174697665417373657449640400090101384e617469766543757272656e6379000100000901085470616c6c65745f666f726569676e5f617373657473384e617469766543757272656e6379000108104865726500000018506172656e7400010000710500000408000501008105082c6f726d6c5f746f6b656e732c4163636f756e7444617461041c42616c616e63650118000c01106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e636500000418546f6b656e730118546f6b656e7304204163636f756e7473010108020571058105c000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000018b8205468652062616c616e6365206f66206120746f6b656e207479706520756e64657220616e206163636f756e742e00fc204e4f54453a2049662074686520746f74616c2069732065766572207a65726f2c206465637265617365206163636f756e7420726566206163636f756e742e001901204e4f54453a2054686973206973206f6e6c79207573656420696e20746865206361736520746861742074686973206d6f64756c65206973207573656420746f2073746f7265282062616c616e6365732e000000002795070400dd07",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "unitnetwork",
		isTestnet: false,
		sortIndex: 154,
		genesisHash: null,
		prefix: null,
		name: "UnitNetwork",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "unorthodox",
		isTestnet: false,
		sortIndex: 155,
		genesisHash: null,
		prefix: null,
		name: "Unorthodox",
		themeColor: "#22c396",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unorthodox.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2094,
		relay: {
			id: "kusama"
		},
		balanceMetadata: [
		]
	},
	{
		id: "vara",
		isTestnet: false,
		sortIndex: 156,
		genesisHash: "0xfe1b4c55fd4d668101126434206571a7838a8b6b93a6d1b95d607e78e6c53763",
		prefix: 137,
		name: "Vara",
		themeColor: "#03ffc4",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/vara.svg",
		chainName: "Vara Network",
		implName: "vara",
		specName: "vara",
		specVersion: "140",
		nativeToken: {
			id: "vara-substrate-native-vara"
		},
		tokens: [
			{
				id: "vara-substrate-native-vara"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://rpc.vara-network.io",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e00003d0704007d07",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "VARA",
					decimals: 12,
					metadata: "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",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "10000000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e00003d0704007d07",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "watr",
		isTestnet: false,
		sortIndex: 157,
		genesisHash: null,
		prefix: null,
		name: "Watr",
		themeColor: "#f5f5f3",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/watr.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2058,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
		]
	},
	{
		id: "westlake",
		isTestnet: false,
		sortIndex: 158,
		genesisHash: null,
		prefix: null,
		name: "Westlake",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "zeitgeist",
		isTestnet: false,
		sortIndex: 159,
		genesisHash: "0x1bf2a2ecb4a868de66ea8610f2ce7c8c43706561b6476031315f6640fe38e060",
		prefix: 73,
		name: "Zeitgeist",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/zeitgeist.svg",
		chainName: "Zeitgeist",
		implName: "zeitgeist",
		specName: "zeitgeist",
		specVersion: "46",
		nativeToken: {
			id: "zeitgeist-substrate-native-ztg"
		},
		tokens: [
			{
				id: "zeitgeist-substrate-native-ztg"
			}
		],
		account: "*25519",
		subscanUrl: "https://zeitgeist.subscan.io/",
		chainspecQrUrl: "https://metadata.novasama.io/qr/zeitgeist_specs.png",
		latestMetadataQrUrl: "https://metadata.novasama.io/qr/zeitgeist_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://zeitgeist.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://zeitgeist-rpc.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://main.rpc.zeitgeist.pm/ws",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2092,
		relay: {
			id: "polkadot"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000f10804003509",
					isTestnet: false,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: false,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "ZTG",
					decimals: 10,
					metadata: "0x6d6574610e34000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d6572731c0120526566436f756e7400012470726f7669646572731c0120526566436f756e7400012c73756666696369656e74731c0120526566436f756e740001106461746114012c4163636f756e7444617461000010000005060014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507001c000005050001010000030800000008008105101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e6465645665630804540185050453000004008d0501185665633c543e00008505083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964010101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e738905011c526561736f6e7300008905083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200008d05000002850500081853797374656d011853797374656d041c4163636f756e7401010402000c510100000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402008105040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000af10804003509",
					isTestnet: false,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "50000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: false,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e2c000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503001800000507001c0000050500e80000050400f40c507a65697467656973745f7072696d69746976657314617373657414417373657404084d49011801184843617465676f726963616c4f7574636f6d6508001801084d490000e8013443617465676f7279496e646578000000345363616c61724f7574636f6d6508001801084d490000f801385363616c6172506f736974696f6e00010050436f6d62696e61746f7269616c4f7574636f6d6500020024506f6f6c53686172650400fc01505365726465577261707065723c506f6f6c49643e0003000c5a746700040030466f726569676e417373657404001c010c75333200050000f80c507a65697467656973745f7072696d697469766573146173736574385363616c6172506f736974696f6e000108104c6f6e670000001453686f727400010000fc0c507a65697467656973745f7072696d6974697665733473657264655f77726170706572305365726465577261707065720404420118000400180104420000f5060000040800f4000507082c6f726d6c5f746f6b656e732c4163636f756e7444617461041c42616c616e63650118000c01106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e636500000418546f6b656e730118546f6b656e7304204163636f756e74730101080205f5060507c000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000018b8205468652062616c616e6365206f66206120746f6b656e207479706520756e64657220616e206163636f756e742e00fc204e4f54453a2049662074686520746f74616c2069732065766572207a65726f2c206465637265617365206163636f756e7420726566206163636f756e742e001901204e4f54453a2054686973206973206f6e6c79207573656420696e20746865206361736520746861742074686973206d6f64756c65206973207573656420746f2073746f7265282062616c616e6365732e0000000029f10804003509",
					isTestnet: false,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "westend-testnet",
		isTestnet: true,
		sortIndex: 160,
		genesisHash: "0xe143f23803ac50e8f6f8e62695d1ce9e4e1d68aa36c1cd2cfd15340213f3423e",
		prefix: 42,
		name: "Westend",
		themeColor: "#e24a79",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/westend-testnet.svg",
		chainName: "Westend",
		implName: "parity-westend",
		specName: "westend",
		specVersion: "9430",
		nativeToken: {
			id: "westend-testnet-substrate-native-wnd"
		},
		tokens: [
			{
				id: "westend-testnet-substrate-native-wnd"
			}
		],
		account: "*25519",
		subscanUrl: "https://westend.subscan.io/",
		chainspecQrUrl: "https://metadata.parity.io/qr/westend_specs.png",
		latestMetadataQrUrl: "https://metadata.parity.io/qr/westend_metadata_latest.apng",
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://westend.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://westend-rpc.blockops.network/ws",
				isHealthy: true
			},
			{
				url: "wss://westend-rpc.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://westend-rpc-tn.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://rpc.ibp.network/westend",
				isHealthy: true
			},
			{
				url: "wss://rpc.dotters.network/westend",
				isHealthy: true
			},
			{
				url: "wss://rpc-westend.luckyfriday.io",
				isHealthy: true
			},
			{
				url: "wss://westend-rpc.polkadot.io",
				isHealthy: true
			},
			{
				url: "wss://westend.public.curie.radiumblock.co/ws",
				isHealthy: true
			},
			{
				url: "wss://wnd-rpc.stakeworld.io",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
			{
				id: "westend-asset-hub-testnet",
				paraId: 1000,
				name: "AssetHub Testnet"
			},
			{
				id: "westmint-testnet",
				paraId: 1000,
				name: "Westmint"
			},
			{
				id: "westend-collectives-testnet",
				paraId: 1001,
				name: "Collectives Testnet"
			},
			{
				id: "westend-bridge-hub-testnet",
				paraId: 1002,
				name: "BridgeHub Testnet"
			},
			{
				id: "moonshadow-testnet",
				paraId: 2002,
				name: "Moonshadow"
			},
			{
				id: "karura-testnet",
				paraId: 2005,
				name: "Wendala"
			},
			{
				id: "whala-testnet",
				paraId: 2013,
				name: "Whala"
			},
			{
				id: "integritee-testnet",
				paraId: 2081,
				name: "Integritee Testnet"
			},
			{
				id: "kilt-testnet-westend",
				paraId: 2085,
				name: "Wilt"
			},
			{
				id: "charcoal-testnet",
				paraId: 2086,
				name: "Charcoal"
			},
			{
				id: "westend-standard-testnet",
				paraId: 2094,
				name: "Standard"
			},
			{
				id: "interlay-testnet-westend",
				paraId: 2094,
				name: "Interlay Testnet"
			},
			{
				id: "westend-pichiu-testnet",
				paraId: 2112,
				name: "Pichiu Testnet"
			}
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000490b0400750b",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "WND",
					decimals: 12,
					metadata: "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",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: "70792f6366756e64",
					existentialDeposit: "10000000000",
					nominationPoolsPalletId: "70792f6e6f706c73"
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000490b0400750b",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "rococo-testnet",
		isTestnet: true,
		sortIndex: 161,
		genesisHash: "0x6408de7737c59c238890533af25896a2c20608d8b380bb01029acb392781063e",
		prefix: 42,
		name: "Rococo",
		themeColor: "#2291fc",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/rococo-testnet.svg",
		chainName: "Rococo",
		implName: "parity-rococo-v2.0",
		specName: "rococo",
		specVersion: "9420",
		nativeToken: {
			id: "rococo-testnet-substrate-native-roc"
		},
		tokens: [
			{
				id: "rococo-testnet-substrate-native-roc"
			}
		],
		account: "*25519",
		subscanUrl: "https://rococo.subscan.io/",
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://rococo-rpc.polkadot.io",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
			{
				id: "rococo-statemint-testnet",
				paraId: 1000,
				name: "Rockmine"
			},
			{
				id: "rococo-asset-hub-testnet",
				paraId: 1000,
				name: "AssetHub Testnet"
			},
			{
				id: "rococo-contracts-testnet",
				paraId: 1002,
				name: "Contracts"
			},
			{
				id: "encointer-testnet-rococo",
				paraId: 1003,
				name: "Encointer Lietaer"
			},
			{
				id: "rococo-bridgehub-testnet",
				paraId: 1013,
				name: "Bridgehub"
			},
			{
				id: "rococo-phala-testnet",
				paraId: 2004,
				name: "Rhala"
			},
			{
				id: "stagex-testnet",
				paraId: 2007,
				name: "Stagex"
			},
			{
				id: "rococo-sora-testnet",
				paraId: 2011,
				name: "Sora Testnet"
			},
			{
				id: "rococo-crust-testnet",
				paraId: 2012,
				name: "Crust Testnet"
			},
			{
				id: "rocfinity-testnet",
				paraId: 2021,
				name: "Rocfinity"
			},
			{
				id: "rococo-genshiro-testnet",
				paraId: 2024,
				name: "Genshiro Testnet"
			},
			{
				id: "rococo-nodle-testnet",
				paraId: 2026,
				name: "Nodle Testnet"
			},
			{
				id: "rococo-bifrost-testnet",
				paraId: 2030,
				name: "Bifrost Testnet"
			},
			{
				id: "rococo-catalyst-testnet",
				paraId: 2031,
				name: "Catalyst"
			},
			{
				id: "rococo-hydra-dx-testnet",
				paraId: 2034,
				name: "HydraDX Testnet"
			},
			{
				id: "rococo-kaizen-testnet",
				paraId: 2040,
				name: "Kaizen"
			},
			{
				id: "rococo-origin-trail-parachain-testnet",
				paraId: 2043,
				name: "OriginTrail Testnet"
			},
			{
				id: "robonomics-testnet",
				paraId: 2048,
				name: "Robonomics Testnet"
			},
			{
				id: "rococo-moonsama-testnet",
				paraId: 2055,
				name: "Moonsama"
			},
			{
				id: "rococo-aventus-testnet",
				paraId: 2056,
				name: "Aventus Testnet"
			},
			{
				id: "rococo-watr-testnet",
				paraId: 2058,
				name: "Watr Testnet"
			},
			{
				id: "rococo-dolphin-testnet",
				paraId: 2084,
				name: "Dolphin"
			},
			{
				id: "rococo-kilt-testnet",
				paraId: 2086,
				name: "Rilt"
			},
			{
				id: "rococo-picasso-testnet",
				paraId: 2087,
				name: "Picasso Testnet"
			},
			{
				id: "rococo-basilisk-testnet",
				paraId: 2090,
				name: "Basilisk Testnet"
			},
			{
				id: "rococo-md-5-testnet",
				paraId: 2093,
				name: "MD5"
			},
			{
				id: "rococo-ethos-testnet",
				paraId: 2095,
				name: "Ethos"
			},
			{
				id: "rococo-subsocial-testnet",
				paraId: 2100,
				name: "SoonsocialX"
			},
			{
				id: "rococo-zeitgeist-testnet",
				paraId: 2101,
				name: "Zeitgeist Battery Station"
			},
			{
				id: "rococo-pangolin-testnet",
				paraId: 2105,
				name: "Pangolin2"
			},
			{
				id: "rococo-litentry-testnet",
				paraId: 2106,
				name: "Litentry Testnet"
			},
			{
				id: "rococo-mangata-testnet",
				paraId: 2110,
				name: "MangataX Testnet"
			},
			{
				id: "rococo-kabocha-testnet",
				paraId: 2113,
				name: "Kabocha Testnet"
			},
			{
				id: "rococo-turing-testnet",
				paraId: 2114,
				name: "Turing Testnet"
			},
			{
				id: "rococo-spreehafen-testnet",
				paraId: 2116,
				name: "Spreehafen"
			},
			{
				id: "rococo-bajun-testnet",
				paraId: 2119,
				name: "Bajun Testnet"
			},
			{
				id: "rococo-imbue-testnet",
				paraId: 2121,
				name: "Imbue Testnet"
			},
			{
				id: "rococo-amplitude-testnet",
				paraId: 2124,
				name: "Amplitude Testnet"
			},
			{
				id: "rococo-tinkernet-testnet",
				paraId: 2125,
				name: "Tinkernet"
			},
			{
				id: "rococo-integritee-testnet",
				paraId: 3002,
				name: "Integritee Testnet"
			},
			{
				id: "rococo-virto-testnet",
				paraId: 3003,
				name: "Virto"
			},
			{
				id: "arctic-testnet-rococo",
				paraId: 3015,
				name: "Arctic"
			},
			{
				id: "snowbridge-testnet",
				paraId: 3016,
				name: "Snowbridge"
			},
			{
				id: "helixstreet-testnet",
				paraId: 3025,
				name: "Helixstreet"
			},
			{
				id: "t-0-rn-testnet",
				paraId: 3333,
				name: "t0rn"
			},
			{
				id: "tangle-testnet-rococo",
				paraId: 4006,
				name: "Tangle"
			},
			{
				id: "chainoli-testnet",
				paraId: 4023,
				name: "Oli"
			},
			{
				id: "rococo-subzero-testnet",
				paraId: 4040,
				name: "Subzero Testnet"
			},
			{
				id: "rococo-frequency-testnet",
				paraId: 4044,
				name: "Frequency Testnet"
			},
			{
				id: "rococo-confti-testnet",
				paraId: 4094,
				name: "Confti"
			},
			{
				id: "rococo-unit-network-testnet",
				paraId: 4168,
				name: "Unit"
			},
			{
				id: "rococo-acurast-testnet",
				paraId: 4191,
				name: "Acurast"
			},
			{
				id: "rococo-idiyanale-testnet",
				paraId: 4222,
				name: "Idiyanale"
			},
			{
				id: "giant-testnet",
				paraId: 4227,
				name: "Giant"
			},
			{
				id: "rococo-societal-testnet",
				paraId: 4253,
				name: "Societal"
			},
			{
				id: "rococo-bitgreen-testnet",
				paraId: 20048,
				name: "Bitgreen Testnet"
			}
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000d50a0400010b",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "ROC",
					decimals: 12,
					metadata: "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",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: "70792f6366756e64",
					existentialDeposit: "33333333",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000d50a0400010b",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "3-dpass-testnet",
		isTestnet: true,
		sortIndex: 162,
		genesisHash: "0x89c35874d27a80f1c7e75ad140c64b323843c05b05410648de396b7f01178ceb",
		prefix: 72,
		name: "3DPass Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "3dpass - The Ledger of Things (testnet)",
		implName: "poscan-runtime",
		specName: "poscan-runtime",
		specVersion: "112",
		nativeToken: {
			id: "3-dpass-testnet-substrate-native-p3dt"
		},
		tokens: [
			{
				id: "3-dpass-testnet-substrate-native-p3dt"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "P3Dt",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700fd010000030800000008006904102873705f72756e74696d651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e646564566563080454016d04045300000400750401185665633c543e00006d04083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964fd0101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e737104011c526561736f6e7300007104083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c0002000075040000026d0400081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402006904040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e0000000007450704007d07",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000450704007d07",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "rococo-acurast-testnet",
		isTestnet: true,
		sortIndex: 163,
		genesisHash: null,
		prefix: null,
		name: "Acurast",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 4191,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
		]
	},
	{
		id: "ajuna-testnet",
		isTestnet: true,
		sortIndex: 164,
		genesisHash: "0xd5b8d0f514e793f5f4b18788c36dabb533f39904a4ea4e65ab9f97d673889ac4",
		prefix: 42,
		name: "Ajuna Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Ajuna Testnet",
		implName: "ajuna-node",
		specName: "ajuna-node",
		specVersion: "100",
		nativeToken: {
			id: "ajuna-testnet-substrate-native-ajun"
		},
		tokens: [
			{
				id: "ajuna-testnet-substrate-native-ajun"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://rpc-test.ajuna.network",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e38000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503001000000505001800000507002800000208008c0000050000a40000040000f9010c3470616c6c65745f61737365747314747970657330417373657444657461696c730c1c42616c616e63650118244163636f756e7449640100384465706f73697442616c616e63650118003001146f776e65720001244163636f756e7449640001186973737565720001244163636f756e74496400011461646d696e0001244163636f756e74496400011c667265657a65720001244163636f756e744964000118737570706c7918011c42616c616e636500011c6465706f7369741801384465706f73697442616c616e636500012c6d696e5f62616c616e636518011c42616c616e636500013469735f73756666696369656e748c0110626f6f6c0001206163636f756e747310010c75333200012c73756666696369656e747310010c753332000124617070726f76616c7310010c75333200012469735f66726f7a656e8c0110626f6f6c0000fd010000040810000001020c3470616c6c65745f6173736574731474797065733041737365744163636f756e740c1c42616c616e63650118384465706f73697442616c616e6365011814457874726101a40010011c62616c616e636518011c42616c616e636500012469735f66726f7a656e8c0110626f6f6c000118726561736f6e0502017c4578697374656e6365526561736f6e3c4465706f73697442616c616e63653e0001146578747261a401144578747261000005020c3470616c6c65745f6173736574731474797065733c4578697374656e6365526561736f6e041c42616c616e63650118011020436f6e73756d65720000002853756666696369656e740001002c4465706f73697448656c64040018011c42616c616e63650002003c4465706f736974526566756e6465640003000011020c3470616c6c65745f6173736574731474797065733441737365744d6574616461746108384465706f73697442616c616e6365011834426f756e646564537472696e670115020014011c6465706f7369741801384465706f73697442616c616e63650001106e616d6515020134426f756e646564537472696e6700011873796d626f6c15020134426f756e646564537472696e67000120646563696d616c73080108753800012469735f66726f7a656e8c0110626f6f6c0000150210346672616d655f737570706f72741c73746f726167652c626f756e6465645f76656328426f756e64656456656308045401080453000004002801185665633c543e0000041841737365747301184173736574730c1441737365740001040210f901040004542044657461696c73206f6620616e2061737365742e1c4163636f756e740001080202fd010102040004e42054686520686f6c64696e6773206f662061207370656369666963206163636f756e7420666f7220612073706563696669632061737365742e204d65746164617461010104021011025000000000000000000000000000000000000000000458204d65746164617461206f6620616e2061737365742e0000000007090304004503",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "AJUN",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507004501000003080000000800b50110346672616d655f737570706f72741c73746f72616765407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401b901045300000400c10101185665633c543e0000b901083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964450101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73bd01011c526561736f6e730000bd01083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000c101000002b90100081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200b501040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e0000000004090304004503",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "100000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000090304004503",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "aleph-zero-testnet",
		isTestnet: true,
		sortIndex: 165,
		genesisHash: "0x05d5279c52c484cc80396535a316add7d47b1c5b9e0398dd1f584149341460c5",
		prefix: 42,
		name: "Aleph Zero Testnet",
		themeColor: "#91979c",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/aleph-zero-testnet.svg",
		chainName: "Aleph Zero Testnet",
		implName: "aleph-node",
		specName: "aleph-node",
		specVersion: "64",
		nativeToken: {
			id: "aleph-zero-testnet-substrate-native-tzero"
		},
		tokens: [
			{
				id: "aleph-zero-testnet-substrate-native-tzero"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://ws.test.azero.dev",
				isHealthy: true
			},
			{
				url: "wss://aleph-zero-testnet-rpc.dwellir.com",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000c10404000505",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "TZERO",
					decimals: 12,
					metadata: "0x6d6574610e80000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700300000020800e404184f7074696f6e04045401000108104e6f6e6500000010536f6d650400000000010000f0085c70616c6c65745f6e6f6d696e6174696f6e5f706f6f6c7324506f6f6c537461746500010c104f70656e0000001c426c6f636b65640001002844657374726f79696e6700020000250100000610006901000003080000000800a9010000061800bd0100000210001103101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e6465645665630804540115030453000004001d0301185665633c543e00001503083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964690101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e731903011c526561736f6e7300001903083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200001d0300000215030031030c3473705f61726974686d657469632c66697865645f706f696e7424466978656455313238000004001801107531323800003903083870616c6c65745f7374616b696e67345374616b696e674c656467657204045400001401147374617368000130543a3a4163636f756e744964000114746f74616ca901013042616c616e63654f663c543e000118616374697665a901013042616c616e63654f663c543e000124756e6c6f636b696e673d0301f0426f756e6465645665633c556e6c6f636b4368756e6b3c42616c616e63654f663c543e3e2c20543a3a4d6178556e6c6f636b696e674368756e6b733e00013c636c61696d65645f7265776172647349030194426f756e6465645665633c457261496e6465782c20543a3a486973746f727944657074683e00003d03101c73705f636f72651c626f756e6465642c626f756e6465645f76656328426f756e646564566563080454014103045300000400450301185665633c543e00004103083870616c6c65745f7374616b696e672c556e6c6f636b4368756e6b041c42616c616e636501180008011476616c7565a901011c42616c616e636500010c65726125010120457261496e646578000045030000024103004903101c73705f636f72651c626f756e6465642c626f756e6465645f76656328426f756e6465645665630804540110045300000400bd0101185665633c543e00003d04085c70616c6c65745f6e6f6d696e6174696f6e5f706f6f6c7328506f6f6c4d656d626572040454000010011c706f6f6c5f6964100118506f6f6c4964000118706f696e747318013042616c616e63654f663c543e0001706c6173745f7265636f726465645f7265776172645f636f756e74657231030140543a3a526577617264436f756e746572000138756e626f6e64696e675f65726173410401e0426f756e64656442547265654d61703c457261496e6465782c2042616c616e63654f663c543e2c20543a3a4d6178556e626f6e64696e673e00004104101c73705f636f72651c626f756e64656444626f756e6465645f62747265655f6d61703c426f756e64656442547265654d61700c044b0110045601180453000004004504013842547265654d61703c4b2c20563e00004504042042547265654d617008044b011004560118000400490400000049040000024d04004d04000004081018005104085c70616c6c65745f6e6f6d696e6174696f6e5f706f6f6c733c426f6e646564506f6f6c496e6e65720404540000100118706f696e747318013042616c616e63654f663c543e0001147374617465f00124506f6f6c53746174650001386d656d6265725f636f756e74657210010c753332000114726f6c65735504015c506f6f6c526f6c65733c543a3a4163636f756e7449643e00005504085c70616c6c65745f6e6f6d696e6174696f6e5f706f6f6c7324506f6f6c526f6c657304244163636f756e7449640100001001246465706f7369746f720001244163636f756e744964000110726f6f74e401444f7074696f6e3c4163636f756e7449643e0001246e6f6d696e61746f72e401444f7074696f6e3c4163636f756e7449643e00013473746174655f746f67676c6572e401444f7074696f6e3c4163636f756e7449643e00007504101c73705f636f72651c626f756e6465642c626f756e6465645f76656328426f756e64656456656308045401080453000004003001185665633c543e0000101853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402001103040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e00000000051c5374616b696e67011c5374616b696e6704184c6564676572000104020039030400044501204d61702066726f6d20616c6c2028756e6c6f636b6564292022636f6e74726f6c6c657222206163636f756e747320746f2074686520696e666f20726567617264696e6720746865207374616b696e672e00000000083c4e6f6d696e6174696f6e506f6f6c73013c4e6f6d696e6174696f6e506f6f6c730c2c506f6f6c4d656d6265727300010405003d0404000c4020416374697665206d656d626572732e00d02054574f582d4e4f54453a20534146452073696e636520604163636f756e7449646020697320612073656375726520686173682e2c426f6e646564506f6f6c7300010405105104040004682053746f7261676520666f7220626f6e64656420706f6f6c732e204d65746164617461010104051075040400045c204d6574616461746120666f722074686520706f6f6c2e0000000013c10404000505",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "500",
					nominationPoolsPalletId: "70792f6e6f706c73"
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000c10404000505",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "rococo-amplitude-testnet",
		isTestnet: true,
		sortIndex: 166,
		genesisHash: "0xa8d080b07f9c84465aeb9576db5a7838bcbca3ffb78dbfd7d4b56acafc1f29d1",
		prefix: 57,
		name: "Amplitude Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Foucoco",
		implName: "foucoco",
		specName: "foucoco",
		specVersion: "1",
		nativeToken: {
			id: "rococo-amplitude-testnet-substrate-native-ampe"
		},
		tokens: [
			{
				id: "rococo-amplitude-testnet-substrate-native-ampe"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://rpc-foucoco.pendulumchain.tech",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2124,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000ed0804003109",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "AMPE",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700450100000308000000080071030c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e6465645665630804540175030453000004007d0301185665633c543e00007503083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964450101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e737903011c526561736f6e7300007903083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200007d03000002750300081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402007103040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000aed0804003109",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e28000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d00000400000320000000080008000005030018000005070040000003040000000800e1010850737061636577616c6b5f7072696d6974697665732843757272656e63794964000110184e61746976650000000c58434d040008010875380001001c5374656c6c61720400e50101144173736574000200385a656e6c696e6b4c50546f6b656e1000080108753800000801087538000008010875380000080108753800030000e5010850737061636577616c6b5f7072696d69746976657314417373657400010c345374656c6c61724e617469766500000024416c7068614e756d34080110636f646540011842797465733400011869737375657204012c417373657449737375657200010028416c7068614e756d3132080110636f6465e901011c4279746573313200011869737375657204012c417373657449737375657200020000e9010000030c00000008005d070000040800e101006d07082c6f726d6c5f746f6b656e732c4163636f756e7444617461041c42616c616e63650118000c01106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e636500000418546f6b656e730118546f6b656e7304204163636f756e747301010802055d076d07c000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000018b8205468652062616c616e6365206f66206120746f6b656e207479706520756e64657220616e206163636f756e742e00fc204e4f54453a2049662074686520746f74616c2069732065766572207a65726f2c206465637265617365206163636f756e7420726566206163636f756e742e001901204e4f54453a2054686973206973206f6e6c79207573656420696e20746865206361736520746861742074686973206d6f64756c65206973207573656420746f2073746f7265282062616c616e6365732e0000000035ed0804003109",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "nodle-testnet",
		isTestnet: true,
		sortIndex: 167,
		genesisHash: null,
		prefix: null,
		name: "Arcadia",
		themeColor: "#010717",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/nodle-testnet.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "arctic-testnet-rococo",
		isTestnet: true,
		sortIndex: 168,
		genesisHash: null,
		prefix: null,
		name: "Arctic",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 3015,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
		]
	},
	{
		id: "arctic-testnet-standalone",
		isTestnet: true,
		sortIndex: 169,
		genesisHash: null,
		prefix: null,
		name: "Arctic",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: "https://arctic.subscan.io/",
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "ares-gladios-testnet",
		isTestnet: true,
		sortIndex: 170,
		genesisHash: null,
		prefix: null,
		name: "Ares Gladios",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "jaz-testnet",
		isTestnet: true,
		sortIndex: 171,
		genesisHash: null,
		prefix: null,
		name: "Artio",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "rococo-asset-hub-testnet",
		isTestnet: true,
		sortIndex: 172,
		genesisHash: "0x7c34d42fc815d392057c78b49f2755c753440ccd38bcb0405b3bcfb601d08734",
		prefix: 2,
		name: "AssetHub Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Rococo Asset Hub",
		implName: "statemine",
		specName: "statemine",
		specVersion: "9430",
		nativeToken: {
			id: "rococo-asset-hub-testnet-substrate-native-roc"
		},
		tokens: [
			{
				id: "rococo-asset-hub-testnet-substrate-native-roc"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://rococo-asset-hub-rpc.polkadot.io",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 1000,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "ROC",
					decimals: 12,
					metadata: "0x6d6574610e34000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e74446174610000100000050500140c3c70616c6c65745f62616c616e6365731474797065732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e6365000114666c6167731c01284578747261466c61677300001800000507001c0c3c70616c6c65745f62616c616e636573147479706573284578747261466c616773000004001801107531323800000101000003080000000800c5020c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401c902045300000400d10201185665633c543e0000c9020c3c70616c6c65745f62616c616e6365731474797065732c42616c616e63654c6f636b041c42616c616e63650118000c01086964010101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73cd02011c526561736f6e730000cd020c3c70616c6c65745f62616c616e6365731474797065731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000d102000002c90200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000008004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200c502040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000aed0504001906",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "33333333",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000ed0504001906",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "westend-asset-hub-testnet",
		isTestnet: true,
		sortIndex: 173,
		genesisHash: "0x67f9723393ef76214df0118c34bbbd3dbebc8ed46a10973a8c969d48fe7598c9",
		prefix: 42,
		name: "AssetHub Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Westmint",
		implName: "westmint",
		specName: "westmint",
		specVersion: "9435",
		nativeToken: {
			id: "westend-asset-hub-testnet-substrate-native-wnd"
		},
		tokens: [
			{
				id: "westend-asset-hub-testnet-substrate-native-wnd"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://westmint-rpc.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://westmint-rpc-tn.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://sys.ibp.network/westmint",
				isHealthy: true
			},
			{
				url: "wss://sys.dotters.network/westmint",
				isHealthy: true
			},
			{
				url: "wss://westend-asset-hub-rpc.polkadot.io",
				isHealthy: true
			},
			{
				url: "wss://wnd-rpc.stakeworld.io/westmint",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 1000,
		relay: {
			id: "westend-testnet"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "WND",
					decimals: 12,
					metadata: "0x6d6574610e34000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e74446174610000100000050500140c3c70616c6c65745f62616c616e6365731474797065732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e6365000114666c6167731c01284578747261466c61677300001800000507001c0c3c70616c6c65745f62616c616e636573147479706573284578747261466c61677300000400180110753132380000fc000003080000000800e1020c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401e502045300000400ed0201185665633c543e0000e5020c3c70616c6c65745f62616c616e6365731474797065732c42616c616e63654c6f636b041c42616c616e63650118000c01086964fc01384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73e902011c526561736f6e730000e9020c3c70616c6c65745f62616c616e6365731474797065731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000ed02000002e50200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000008004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200e102040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000a490604007506",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000490604007506",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "automata-contextfree-testnet",
		isTestnet: true,
		sortIndex: 174,
		genesisHash: "0x6254c948b5eb7199a112cb308be3385c39c8c942625540ac749c77fe2aebc299",
		prefix: 11820,
		name: "Automata ContextFree",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "ContextFree Network",
		implName: "contextfree",
		specName: "contextfree",
		specVersion: "1007",
		nativeToken: {
			id: "automata-contextfree-testnet-substrate-native-ctx"
		},
		tokens: [
			{
				id: "automata-contextfree-testnet-substrate-native-ctx"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://contextfree.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://cf-api.ata.network",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 13
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "CTX",
					decimals: 18,
					metadata: null,
					isTestnet: true,
					accountInfoType: null,
					metadataVersion: 13,
					crowdloanPalletId: null,
					existentialDeposit: "100000000000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 13
				}
			}
		]
	},
	{
		id: "rococo-aventus-testnet",
		isTestnet: true,
		sortIndex: 175,
		genesisHash: "0xa6ffcef7fb8caadf7f6c5ad8ada65e3eaa90d1604f3eabda546ff1d486865a0c",
		prefix: 42,
		name: "Aventus Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "AvN Rococo",
		implName: "avn-parachain",
		specName: "avn-parachain",
		specVersion: "31",
		nativeToken: {
			id: "rococo-aventus-testnet-substrate-native-avt"
		},
		tokens: [
			{
				id: "rococo-aventus-testnet-substrate-native-avt"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://public-rpc.public-testnet.aventus.io",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2056,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "AVT",
					decimals: 18,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507002101000003080000000800d102101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401d502045300000400dd0201185665633c543e0000d502083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964210101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73d902011c526561736f6e730000d902083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000dd02000002d50200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200d102040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000a89060400b506",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "0",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e000089060400b506",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "rococo-bajun-testnet",
		isTestnet: true,
		sortIndex: 176,
		genesisHash: "0x3760ad17b18b0e99e9fc4b0c569afa5f41b86758a50d5ebfc37bc665ef88f065",
		prefix: 1337,
		name: "Bajun Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Bajun Rococo",
		implName: "bajun",
		specName: "bajun",
		specVersion: "120",
		nativeToken: {
			id: "rococo-bajun-testnet-substrate-native-baju"
		},
		tokens: [
			{
				id: "rococo-bajun-testnet-substrate-native-baju"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://rpc-rococo.bajun.network",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2119,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000ad070400d907",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "BAJU",
					decimals: 12,
					metadata: "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",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000ad070400d907",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "rococo-basilisk-testnet",
		isTestnet: true,
		sortIndex: 177,
		genesisHash: "0x317498e4a13cc902ee6b1886686101ac2dbc37a3bc1456f3ce7ee6d0efb45c50",
		prefix: 10041,
		name: "Basilisk Testnet",
		themeColor: "#4cffaf",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/rococo-basilisk-testnet.svg",
		chainName: "Basilisk testnet",
		implName: "basilisk",
		specName: "basilisk",
		specVersion: "101",
		nativeToken: {
			id: "rococo-basilisk-testnet-substrate-native-bsx"
		},
		tokens: [
			{
				id: "rococo-basilisk-testnet-substrate-native-bsx"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://basilisk-rococo-rpc.play.hydration.cloud",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2090,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e000071080400b108",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "BSX",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507007101000003080000000800d902101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401dd02045300000400e50201185665633c543e0000dd02083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964710101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73e102011c526561736f6e730000e102083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000e502000002dd0200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200d902040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000271080400b108",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e1c000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d000004000003200000000800080000050300100000050500180000050700a107000004080010004908082c6f726d6c5f746f6b656e732c4163636f756e7444617461041c42616c616e63650118000c01106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e636500000418546f6b656e730118546f6b656e7304204163636f756e74730101080205a1074908c000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000018b8205468652062616c616e6365206f66206120746f6b656e207479706520756e64657220616e206163636f756e742e00fc204e4f54453a2049662074686520746f74616c2069732065766572207a65726f2c206465637265617365206163636f756e7420726566206163636f756e742e001901204e4f54453a2054686973206973206f6e6c79207573656420696e20746865206361736520746861742074686973206d6f64756c65206973207573656420746f2073746f7265282062616c616e6365732e000000009771080400b108",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "edgeware-testnet",
		isTestnet: true,
		sortIndex: 178,
		genesisHash: "0x8da6a03e0989154ff8c1977cbc0cbd55f6879d8759c272a4f3c078cef794bf5f",
		prefix: 7,
		name: "Beresheet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Beresheet v46",
		implName: "beresheet-node",
		specName: "beresheet",
		specVersion: "10054",
		nativeToken: {
			id: "edgeware-testnet-substrate-native-tedg"
		},
		tokens: [
			{
				id: "edgeware-testnet-substrate-native-tedg"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://beresheet.jelliedowl.net",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "tEDG",
					decimals: 18,
					metadata: "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",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "10000000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e00002d0804006d08",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "rococo-bifrost-testnet",
		isTestnet: true,
		sortIndex: 179,
		genesisHash: "0x0c003b98abbedae774f5e13cd6146781317016725ab4db34312ea2681e9901f3",
		prefix: 6,
		name: "Bifrost Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Bifrost K Rococo",
		implName: "bifrost_polkadot",
		specName: "bifrost_polkadot",
		specVersion: "976",
		nativeToken: {
			id: "rococo-bifrost-testnet-substrate-native-bnc"
		},
		tokens: [
			{
				id: "rococo-bifrost-testnet-substrate-native-bnc"
			},
			{
				id: "rococo-bifrost-testnet-substrate-orml-bnc"
			},
			{
				id: "rococo-bifrost-testnet-substrate-orml-dot"
			},
			{
				id: "rococo-bifrost-testnet-substrate-orml-kar"
			},
			{
				id: "rococo-bifrost-testnet-substrate-orml-ksm"
			},
			{
				id: "rococo-bifrost-testnet-substrate-orml-kusd"
			},
			{
				id: "rococo-bifrost-testnet-substrate-orml-movr"
			},
			{
				id: "rococo-bifrost-testnet-substrate-orml-pha"
			},
			{
				id: "rococo-bifrost-testnet-substrate-orml-rmrk"
			},
			{
				id: "rococo-bifrost-testnet-substrate-orml-zlk"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://bifrost-rpc.rococo.liebi.com/ws",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2030,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e00006d0a0400b10a",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "BNC",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e6365000018000005070031010000030800000008006d04101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e646564566563080454017104045300000400790401185665633c543e00007104083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964310101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e737504011c526561736f6e7300007504083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200007904000002710400081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402006d04040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000a6d0a0400b10a",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "10000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
						"BNC",
						"KUSD",
						"DOT",
						"KSM",
						"KAR",
						"ZLK",
						"PHA",
						"RMRK",
						"MOVR"
					],
					decimals: [
						12,
						12,
						10,
						12,
						12,
						18,
						12,
						10,
						18
					],
					isTestnet: true,
					stateKeys: {
						ASG: "0x283537e217dff4590200",
						BNC: "0x4a6fdeede9332ffc0201",
						DOT: "0x40c8bff02912d7a00203",
						ETH: "0x6eea53e67b8cc2660205",
						KAR: "0xca82739c8129d4d20206",
						KSM: "0x1dab0d33717892710204",
						PHA: "0xc3413250cf88fd430208",
						ZLK: "0xb682815e8b9cd45d0207",
						KUSD: "0xfb747b895a9033f80202",
						MOVR: "0xac435ba151a0ded6020a",
						RMRK: "0x3aabf5b1eec116df0209"
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "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",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "bifrost-testnet",
		isTestnet: true,
		sortIndex: 180,
		genesisHash: null,
		prefix: null,
		name: "Bifrost Testnet",
		themeColor: "#68baf9",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/bifrost-testnet.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: "https://bifrost-testnet.subscan.io/",
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "bitcountry-testnet",
		isTestnet: true,
		sortIndex: 181,
		genesisHash: null,
		prefix: null,
		name: "Bit.Country",
		themeColor: "#f8fcfc",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/bitcountry-testnet.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "rococo-bitgreen-testnet",
		isTestnet: true,
		sortIndex: 182,
		genesisHash: null,
		prefix: null,
		name: "Bitgreen Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 20048,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
		]
	},
	{
		id: "rococo-bridgehub-testnet",
		isTestnet: true,
		sortIndex: 183,
		genesisHash: "0x6de3dc58adbc525bad4ae201a8660c5be8949e10308457b176510c72a413f3a3",
		prefix: 42,
		name: "Bridgehub",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Rococo BridgeHub",
		implName: "bridge-hub-rococo",
		specName: "bridge-hub-rococo",
		specVersion: "9420",
		nativeToken: {
			id: "rococo-bridgehub-testnet-substrate-native-roc"
		},
		tokens: [
			{
				id: "rococo-bridgehub-testnet-substrate-native-roc"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://rococo-bridge-hub-rpc.polkadot.io",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 1013,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000490504009505",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "ROC",
					decimals: 12,
					metadata: "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",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "3333333",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000490504009505",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "westend-bridge-hub-testnet",
		isTestnet: true,
		sortIndex: 184,
		genesisHash: null,
		prefix: null,
		name: "BridgeHub Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 1002,
		relay: {
			id: "westend-testnet"
		},
		balanceMetadata: [
		]
	},
	{
		id: "rococo-catalyst-testnet",
		isTestnet: true,
		sortIndex: 185,
		genesisHash: "0x6cb9c6d7d3c9150a1f3cd75784834c53a12d5e0c2d4ed9bf694a901be564eac9",
		prefix: 36,
		name: "Catalyst",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Catalyst Testnet",
		implName: "centrifuge",
		specName: "centrifuge",
		specVersion: "1019",
		nativeToken: {
			id: "rococo-catalyst-testnet-substrate-native-ncfg"
		},
		tokens: [
			{
				id: "rococo-catalyst-testnet-substrate-native-ncfg"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://fullnode.catalyst.cntrfg.com",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2031,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000350b0400650b",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "NCFG",
					decimals: 18,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700a9010000030800000008005104101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e6465645665630804540155040453000004005d0401185665633c543e00005504083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964a90101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e735904011c526561736f6e7300005904083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200005d04000002550400081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402005104040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e0000000014350b0400650b",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e000418546f6b656e73000175060115010001cd0862350b0400650b",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "cere-testnet",
		isTestnet: true,
		sortIndex: 186,
		genesisHash: "0x42b9b44b4950b6c1edae543a7696caf8d0a160e9bc0424ab4ab217f7a8ba30dc",
		prefix: 54,
		name: "Cere Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Cere Testnet",
		implName: "substrate-node",
		specName: "node",
		specVersion: "47000",
		nativeToken: {
			id: "cere-testnet-substrate-native-cere"
		},
		tokens: [
			{
				id: "cere-testnet-substrate-native-cere"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://archive.testnet.cere.network/ws",
				isHealthy: false
			},
			{
				url: "wss://testnet.cere-archive.republiccrypto-runtime.com:444",
				isHealthy: true
			}
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e00006d080400a508",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "CERE",
					decimals: 10,
					metadata: "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",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "10000000000",
					nominationPoolsPalletId: "70792f6e6f706c73"
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e00006d080400a508",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "cess-testnet",
		isTestnet: true,
		sortIndex: 187,
		genesisHash: "0x0abae7e7557e91fc16e9f383c7108f7227e1f97970361e53e6fa3d59971f27b3",
		prefix: 11330,
		name: "Cess",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "cess-testnet",
		implName: "cess-node",
		specName: "cess-node",
		specVersion: "106",
		nativeToken: {
			id: "cess-testnet-substrate-native-tcess"
		},
		tokens: [
			{
				id: "cess-testnet-substrate-native-tcess"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://testnet-rpc0.cess.cloud/ws/",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "TCESS",
					decimals: 12,
					metadata: "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",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e000065080400a108",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "charcoal-testnet",
		isTestnet: true,
		sortIndex: 188,
		genesisHash: null,
		prefix: null,
		name: "Charcoal",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2086,
		relay: {
			id: "westend-testnet"
		},
		balanceMetadata: [
		]
	},
	{
		id: "clover-testnet",
		isTestnet: true,
		sortIndex: 189,
		genesisHash: null,
		prefix: null,
		name: "Clover Testnet",
		themeColor: "#0aa777",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/clover-testnet.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: "https://clover-testnet.subscan.io/",
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "westend-collectives-testnet",
		isTestnet: true,
		sortIndex: 190,
		genesisHash: "0x713daf193a6301583ff467be736da27ef0a72711b248927ba413f573d2b38e44",
		prefix: 0,
		name: "Collectives Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Westend Collectives",
		implName: "collectives",
		specName: "collectives",
		specVersion: "9430",
		nativeToken: {
			id: "westend-collectives-testnet-substrate-native-wnd"
		},
		tokens: [
			{
				id: "westend-collectives-testnet-substrate-native-wnd"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://sys.ibp.network/collectives-westend",
				isHealthy: true
			},
			{
				url: "wss://sys.dotters.network/collectives-westend",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 1001,
		relay: {
			id: "westend-testnet"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e00009d050400dd05",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "WND",
					decimals: 12,
					metadata: "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",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e00009d050400dd05",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "rococo-confti-testnet",
		isTestnet: true,
		sortIndex: 191,
		genesisHash: null,
		prefix: null,
		name: "Confti",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 4094,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
		]
	},
	{
		id: "rococo-contracts-testnet",
		isTestnet: true,
		sortIndex: 192,
		genesisHash: "0xc5442742bb6288bb3835ea1c9032981f06433ee5fc65d6e216c4422c0c19b989",
		prefix: 42,
		name: "Contracts",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Contracts on Rococo",
		implName: "contracts-rococo",
		specName: "contracts-rococo",
		specVersion: "9420",
		nativeToken: {
			id: "rococo-contracts-testnet-substrate-native-roc"
		},
		tokens: [
			{
				id: "rococo-contracts-testnet-substrate-native-roc"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://rococo-contracts-rpc.polkadot.io",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 1002,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000b90404009501",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "ROC",
					decimals: 12,
					metadata: "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",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "33333333",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000b90404009501",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "creditcoin-testnet",
		isTestnet: true,
		sortIndex: 193,
		genesisHash: "0xc2e43792c8acc075e564558f9a2184a0ffe9b0fd573969599eee9b647358c6cf",
		prefix: 42,
		name: "Creditcoin Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Creditcoin PoS Testnet",
		implName: "creditcoin-node",
		specName: "creditcoin-node",
		specVersion: "223",
		nativeToken: {
			id: "creditcoin-testnet-substrate-native-ctc"
		},
		tokens: [
			{
				id: "creditcoin-testnet-substrate-native-ctc"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://rpc.testnet.creditcoin.network/ws",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000290604005506",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "CTC",
					decimals: 18,
					metadata: "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",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "500",
					nominationPoolsPalletId: "637265646974636f"
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000290604005506",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "crust-maxwell-testnet",
		isTestnet: true,
		sortIndex: 194,
		genesisHash: null,
		prefix: null,
		name: "Crust Maxwell",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "rococo-crust-testnet",
		isTestnet: true,
		sortIndex: 195,
		genesisHash: null,
		prefix: null,
		name: "Crust Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2012,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
		]
	},
	{
		id: "curio-testnet",
		isTestnet: true,
		sortIndex: 196,
		genesisHash: null,
		prefix: null,
		name: "Curio",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "debio-testnet",
		isTestnet: true,
		sortIndex: 197,
		genesisHash: "0xc15da258748903f5341b1cfb0d9f3afa7ed0bfc59be5e1185b6e303277b5237a",
		prefix: 42,
		name: "DeBio Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "DeBio Testnet",
		implName: "debio",
		specName: "appchain",
		specVersion: "2040",
		nativeToken: {
			id: "debio-testnet-substrate-native-dbio"
		},
		tokens: [
			{
				id: "debio-testnet-substrate-native-dbio"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://ws-rpc.testnet.debio.network",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000e90604001507",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "DBIO",
					decimals: 18,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507004d03000003080000000800bd03101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401c103045300000400c90301185665633c543e0000c103083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c010869644d0301384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73c503011c526561736f6e730000c503083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000c903000002c10300081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200bd03040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e0000000003e90604001507",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "10000000000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000e90604001507",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "dock-testnet",
		isTestnet: true,
		sortIndex: 198,
		genesisHash: null,
		prefix: null,
		name: "Dock Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "rococo-dolphin-testnet",
		isTestnet: true,
		sortIndex: 199,
		genesisHash: null,
		prefix: null,
		name: "Dolphin",
		themeColor: "#0091ff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/rococo-dolphin-testnet.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: "https://dolphin.subscan.io/",
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2084,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
		]
	},
	{
		id: "dolphin-testnet",
		isTestnet: true,
		sortIndex: 200,
		genesisHash: null,
		prefix: null,
		name: "Dolphin",
		themeColor: "#0091ff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/dolphin-testnet.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: "https://dolphin.subscan.io/",
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "dotmog-testnet",
		isTestnet: true,
		sortIndex: 201,
		genesisHash: null,
		prefix: null,
		name: "DOTMog",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "encointer-testnet-standalone",
		isTestnet: true,
		sortIndex: 202,
		genesisHash: "0xa91674169884b8f312efbca48b3ad02bbf93eed0817502092c93f8f8f8a2884b",
		prefix: 42,
		name: "Encointer Gesell",
		themeColor: "#8a8888",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/encointer-testnet-standalone.svg",
		chainName: "Encointer Testnet Gesell",
		implName: "encointer-node-notee",
		specName: "encointer-node-notee",
		specVersion: "25",
		nativeToken: {
			id: "encointer-testnet-standalone-substrate-native-ert"
		},
		tokens: [
			{
				id: "encointer-testnet-standalone-substrate-native-ert"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://gesell.encointer.org",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000a1030400c903",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "ERT",
					decimals: 12,
					metadata: "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",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "500",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000a1030400c903",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "encointer-testnet-rococo",
		isTestnet: true,
		sortIndex: 203,
		genesisHash: "0x5d2947b8565abdf7112beff1c52b8fb017d86ef11cca9e64644f2fe3de878598",
		prefix: 2,
		name: "Encointer Lietaer",
		themeColor: "#8a8888",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/encointer-testnet-rococo.svg",
		chainName: "Encointer on Rococo",
		implName: "encointer-parachain",
		specName: "encointer-parachain",
		specVersion: "13",
		nativeToken: {
			id: "encointer-testnet-rococo-substrate-native-roc"
		},
		tokens: [
			{
				id: "encointer-testnet-rococo-substrate-native-roc"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://rococo.api.encointer.org",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 1003,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000290504005505",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "ROC",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700f4000003080000000800a502102873705f72756e74696d651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401a902045300000400b10201185665633c543e0000a902083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964f401384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73ad02011c526561736f6e730000ad02083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000b102000002a90200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200a502040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000a290504005505",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "3333333",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000290504005505",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "equilibrium-testnet",
		isTestnet: true,
		sortIndex: 204,
		genesisHash: null,
		prefix: null,
		name: "Equilibrium Testnet",
		themeColor: "#1792ff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/equilibrium-testnet.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "rococo-ethos-testnet",
		isTestnet: true,
		sortIndex: 205,
		genesisHash: "0xca0fbfc359bc053c91dfcd6e9f05556a70e82238ea34ee66417aa9bdda70a2de",
		prefix: 42,
		name: "Ethos",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Ethos Testnet",
		implName: "jur-chain",
		specName: "jur-chain",
		specVersion: "2",
		nativeToken: {
			id: "rococo-ethos-testnet-substrate-native-jur"
		},
		tokens: [
			{
				id: "rococo-ethos-testnet-substrate-native-jur"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://ethos.jur.io",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2095,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "JUR",
					decimals: 18,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507000d010000030800000008003102101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e6465645665630804540135020453000004003d0201185665633c543e00003502083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c010869640d0101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e733902011c526561736f6e7300003902083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200003d02000002350200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402003102040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000afd0304003d04",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000fd0304003d04",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "fantour-testnet",
		isTestnet: true,
		sortIndex: 206,
		genesisHash: null,
		prefix: null,
		name: "Fantour",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "ferrum-testnet",
		isTestnet: true,
		sortIndex: 207,
		genesisHash: "0xc032a5fe0d482817a5ecd2429ed446d19b932968211e226302575ac06b42011e",
		prefix: 42,
		name: "Ferrum",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Ferrum Testnet",
		implName: "ferrum-testnet",
		specName: "ferrum-testnet",
		specVersion: "1",
		nativeToken: {
			id: "ferrum-testnet-substrate-native-tfrm"
		},
		tokens: [
			{
				id: "ferrum-testnet-substrate-native-tfrm"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://testnet.dev.svcs.ferrumnetwork.io",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000a1040400dd04",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "tFRM",
					decimals: 18,
					metadata: "0x6d6574610e30000c4466657272756d5f7072696d6974697665732c6163636f756e74496432302c4163636f756e7449643230000004000401205b75383b2032305d0000040000031400000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507000501000003080000000800b1020c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401b502045300000400bd0201185665633c543e0000b502083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964050101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73b902011c526561736f6e730000b902083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000bd02000002b50200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200b102040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000aa1040400dd04",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000a1040400dd04",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "substrate-testnet",
		isTestnet: true,
		sortIndex: 208,
		genesisHash: null,
		prefix: null,
		name: "Flaming Fir",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "fragnova-testnet",
		isTestnet: true,
		sortIndex: 209,
		genesisHash: "0x67194ef2b65ae98b9ec75a739ee636c675bb1e98eb5964551fc5d83e50d64e4b",
		prefix: 93,
		name: "Fragnova Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Fragnova Testnet",
		implName: "fragnova-hstn",
		specName: "fragnova-testnet",
		specVersion: "1",
		nativeToken: {
			id: "fragnova-testnet-substrate-native-nova"
		},
		tokens: [
			{
				id: "fragnova-testnet-substrate-native-nova"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "NOVA",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507006901000003080000000800d5010c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401d901045300000400e10101185665633c543e0000d901083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964690101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73dd01011c526561736f6e730000dd01083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000e101000002d90100081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200d501040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e00000000058d050400b505",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "500",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e00008d050400b505",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "rococo-frequency-testnet",
		isTestnet: true,
		sortIndex: 210,
		genesisHash: "0x0c33dfffa907de5683ae21cc6b4af899b5c4de83f3794ed75b2dc74e1b088e72",
		prefix: 42,
		name: "Frequency Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Frequency Rococo",
		implName: "frequency",
		specName: "frequency-rococo",
		specVersion: "44",
		nativeToken: {
			id: "rococo-frequency-testnet-substrate-native-xrqcy"
		},
		tokens: [
			{
				id: "rococo-frequency-testnet-substrate-native-xrqcy"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://frequency-rococo-rpc.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://rpc.rococo.frequency.xyz",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 4044,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000b1040400e504",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "XRQCY",
					decimals: 8,
					metadata: "0x6d6574610e34000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e74446174610000100000050500140c3c70616c6c65745f62616c616e6365731474797065732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e6365000114666c6167731c01284578747261466c61677300001800000507001c0c3c70616c6c65745f62616c616e636573147479706573284578747261466c616773000004001801107531323800006d0100000308000000080071030c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e6465645665630804540175030453000004007d0301185665633c543e000075030c3c70616c6c65745f62616c616e6365731474797065732c42616c616e63654c6f636b041c42616c616e63650118000c010869646d0101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e737903011c526561736f6e73000079030c3c70616c6c65745f62616c616e6365731474797065731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200007d03000002750300081853797374656d011853797374656d041c4163636f756e7401010402000c410100000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000800000000000002042616c616e636573012042616c616e63657304144c6f636b7301010402007103040000000000000ab1040400e504",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000b1040400e504",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "galital-testnet",
		isTestnet: true,
		sortIndex: 211,
		genesisHash: null,
		prefix: null,
		name: "Galital PC2",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "galois-testnet",
		isTestnet: true,
		sortIndex: 212,
		genesisHash: null,
		prefix: null,
		name: "Galois",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "gamepower-testnet",
		isTestnet: true,
		sortIndex: 213,
		genesisHash: null,
		prefix: null,
		name: "GamePower",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "geek-testnet",
		isTestnet: true,
		sortIndex: 214,
		genesisHash: null,
		prefix: null,
		name: "GeekCash",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "rococo-genshiro-testnet",
		isTestnet: true,
		sortIndex: 215,
		genesisHash: null,
		prefix: null,
		name: "Genshiro Testnet",
		themeColor: "#e8662d",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/rococo-genshiro-testnet.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2024,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
		]
	},
	{
		id: "giant-testnet",
		isTestnet: true,
		sortIndex: 216,
		genesisHash: null,
		prefix: null,
		name: "Giant",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 4227,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
		]
	},
	{
		id: "halongbay-testnet",
		isTestnet: true,
		sortIndex: 218,
		genesisHash: null,
		prefix: null,
		name: "Halongbay",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "helixstreet-testnet",
		isTestnet: true,
		sortIndex: 219,
		genesisHash: null,
		prefix: null,
		name: "Helixstreet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 3025,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
		]
	},
	{
		id: "rococo-hydra-dx-testnet",
		isTestnet: true,
		sortIndex: 220,
		genesisHash: "0x5feea83342ce43200cb12b265cf21dc4e0e603571e2ac237e74ef45fb6913f52",
		prefix: 63,
		name: "HydraDX Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "HydraDX testnet",
		implName: "hydradx",
		specName: "hydradx",
		specVersion: "164",
		nativeToken: {
			id: "rococo-hydra-dx-testnet-substrate-native-hdx"
		},
		tokens: [
			{
				id: "rococo-hydra-dx-testnet-substrate-native-hdx"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://rococo-hydradx-rpc.hydration.dev",
				isHealthy: false
			}
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2034,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000bd080400fd08",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "HDX",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507008101000003080000000800dd02101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401e102045300000400e90201185665633c543e0000e102083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964810101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73e502011c526561736f6e730000e502083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000e902000002e10200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000012042616c616e636573012042616c616e63657304144c6f636b730101040200dd02040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e0000000007bd080400fd08",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e1c000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503001000000505001800000507001907000004080010002907082c6f726d6c5f746f6b656e732c4163636f756e7444617461041c42616c616e63650118000c01106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e636500000418546f6b656e730118546f6b656e7304204163636f756e7473010108020519072907c000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000018b8205468652062616c616e6365206f66206120746f6b656e207479706520756e64657220616e206163636f756e742e00fc204e4f54453a2049662074686520746f74616c2069732065766572207a65726f2c206465637265617365206163636f756e7420726566206163636f756e742e001901204e4f54453a2054686973206973206f6e6c79207573656420696e20746865206361736520746861742074686973206d6f64756c65206973207573656420746f2073746f7265282062616c616e6365732e000000004dbd080400fd08",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "rococo-idiyanale-testnet",
		isTestnet: true,
		sortIndex: 221,
		genesisHash: null,
		prefix: null,
		name: "Idiyanale",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 4222,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
		]
	},
	{
		id: "rococo-imbue-testnet",
		isTestnet: true,
		sortIndex: 222,
		genesisHash: null,
		prefix: null,
		name: "Imbue Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2121,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
		]
	},
	{
		id: "rococo-integritee-testnet",
		isTestnet: true,
		sortIndex: 223,
		genesisHash: "0xafd7dcd3f6713a1b4bdf9b71edcf37d3ad019ec71743d89012ce227d00e59a08",
		prefix: 13,
		name: "Integritee Testnet",
		themeColor: "#777aac",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/rococo-integritee-testnet.svg",
		chainName: "Integritee on Rococo",
		implName: "integritee-full",
		specName: "integritee-parachain",
		specVersion: "35",
		nativeToken: {
			id: "rococo-integritee-testnet-substrate-native-teer"
		},
		tokens: [
			{
				id: "rococo-integritee-testnet-substrate-native-teer"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://rococo.api.integritee.network",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 3002,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e000065060400a506",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "TEER",
					decimals: 12,
					metadata: "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",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e000065060400a506",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "integritee-testnet",
		isTestnet: true,
		sortIndex: 224,
		genesisHash: null,
		prefix: null,
		name: "Integritee Testnet",
		themeColor: "#777aac",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/integritee-testnet.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2081,
		relay: {
			id: "westend-testnet"
		},
		balanceMetadata: [
		]
	},
	{
		id: "interlay-testnet-standalone",
		isTestnet: true,
		sortIndex: 225,
		genesisHash: "0x418ae94c9fce02b1ab3b5bc211cd2f2133426f2861d97482bbdfdac1bbb0fb92",
		prefix: 2032,
		name: "Interlay Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "interBTC",
		implName: "interlay-parachain",
		specName: "interlay-parachain",
		specVersion: "1024003",
		nativeToken: {
			id: "interlay-testnet-standalone-substrate-native-intr"
		},
		tokens: [
			{
				id: "interlay-testnet-standalone-substrate-native-intr"
			},
			{
				id: "interlay-testnet-standalone-substrate-orml-dot"
			},
			{
				id: "interlay-testnet-standalone-substrate-orml-ibtc"
			},
			{
				id: "interlay-testnet-standalone-substrate-orml-intr"
			},
			{
				id: "interlay-testnet-standalone-substrate-orml-kbtc"
			},
			{
				id: "interlay-testnet-standalone-substrate-orml-kint"
			},
			{
				id: "interlay-testnet-standalone-substrate-orml-ksm"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://api-testnet.interlay.io/parachain/",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000510904009109",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "INTR",
					decimals: 10,
					metadata: "0x6d6574610e1c000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700041853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e0000000000510904009109",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: null,
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
						"INTR",
						"IBTC",
						"DOT",
						"KINT",
						"KBTC",
						"KSM"
					],
					decimals: [
						10,
						8,
						10,
						12,
						8,
						12
					],
					isTestnet: true,
					stateKeys: {
						DOT: "0x01a12dfa1fa4ab9a0000",
						KSM: "0x459d0fd09ec38ee6000a",
						IBTC: "0xd67c5ba80ba065480001",
						INTR: "0xc483de2de1246ea70002",
						KBTC: "0x1fce6bee3ae455b7000b",
						KINT: "0x56a60a12d72ef524000c"
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e28000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d000004000003200000000800080000050300100000050500180000050700c8084c696e7465726274635f7072696d6974697665732843757272656e6379496400011414546f6b656e0400cc012c546f6b656e53796d626f6c00000030466f726569676e41737365740400100138466f726569676e41737365744964000100244c656e64546f6b656e040010012c4c656e64546f6b656e49640002001c4c70546f6b656e0800d0011c4c70546f6b656e0000d0011c4c70546f6b656e00030034537461626c654c70546f6b656e0400100130537461626c65506f6f6c496400040000cc084c696e7465726274635f7072696d6974697665732c546f6b656e53796d626f6c0001180c444f54000000104942544300010010494e54520002000c4b534d000a00104b425443000b00104b494e54000c0000d0084c696e7465726274635f7072696d6974697665731c4c70546f6b656e00010c14546f6b656e0400cc012c546f6b656e53796d626f6c00000030466f726569676e41737365740400100138466f726569676e4173736574496400010034537461626c654c70546f6b656e0400100130537461626c65506f6f6c49640002000069060000040800c8007906082c6f726d6c5f746f6b656e732c4163636f756e7444617461041c42616c616e63650118000c01106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e636500000418546f6b656e730118546f6b656e7304204163636f756e7473010108020569067906c000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000018b8205468652062616c616e6365206f66206120746f6b656e207479706520756e64657220616e206163636f756e742e00fc204e4f54453a2049662074686520746f74616c2069732065766572207a65726f2c206465637265617365206163636f756e7420726566206163636f756e742e001901204e4f54453a2054686973206973206f6e6c79207573656420696e20746865206361736520746861742074686973206d6f64756c65206973207573656420746f2073746f7265282062616c616e6365732e0000000015510904009109",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "interlay-testnet-westend",
		isTestnet: true,
		sortIndex: 226,
		genesisHash: null,
		prefix: null,
		name: "Interlay Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2094,
		relay: {
			id: "westend-testnet"
		},
		balanceMetadata: [
		]
	},
	{
		id: "brainstorm-testnet",
		isTestnet: true,
		sortIndex: 227,
		genesisHash: null,
		prefix: null,
		name: "InvArch Brainstorm",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "ipse-testnet",
		isTestnet: true,
		sortIndex: 228,
		genesisHash: null,
		prefix: null,
		name: "Ipse",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://testnet-china.ipse.io",
				isHealthy: false
			},
			{
				url: "wss://testnet-europe.ipse.io",
				isHealthy: false
			},
			{
				url: "wss://testnet-usa.ipse.io",
				isHealthy: false
			}
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "jupiter-testnet",
		isTestnet: true,
		sortIndex: 229,
		genesisHash: null,
		prefix: null,
		name: "Jupiter",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "jur-testnet",
		isTestnet: true,
		sortIndex: 230,
		genesisHash: "0x2b6b6874374b6d8fa1851f9d31f3a69f9a671ec55307a75c92d2a02fd41cbd05",
		prefix: 42,
		name: "Jur Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Jur Testnet",
		implName: "jur-node",
		specName: "jur-node",
		specVersion: "104",
		nativeToken: {
			id: "jur-testnet-substrate-native-jur"
		},
		tokens: [
			{
				id: "jur-testnet-substrate-native-jur"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://testnet.jur.io",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "JUR",
					decimals: 18,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700250100000308000000080091010c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e6465645665630804540195010453000004009d0101185665633c543e00009501083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964250101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e739901011c526561736f6e7300009901083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200009d01000002950100081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402009101040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e0000000004d90204001103",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "500",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000d90204001103",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "rococo-kabocha-testnet",
		isTestnet: true,
		sortIndex: 231,
		genesisHash: null,
		prefix: null,
		name: "Kabocha Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2113,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
		]
	},
	{
		id: "rococo-kaizen-testnet",
		isTestnet: true,
		sortIndex: 232,
		genesisHash: null,
		prefix: null,
		name: "Kaizen",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2040,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
		]
	},
	{
		id: "karmachain-testnet",
		isTestnet: true,
		sortIndex: 233,
		genesisHash: "0xe8d3716e1f331e596ac2565867c6581aba91cb1d614e1e181b1ccc68172ed978",
		prefix: 42,
		name: "Karmachain",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Karmachain TN2",
		implName: "karmachain-node",
		specName: "karmachain-node",
		specVersion: "100",
		nativeToken: {
			id: "karmachain-testnet-substrate-native-kcoin"
		},
		tokens: [
			{
				id: "karmachain-testnet-substrate-native-kcoin"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://testnet.karmaco.in/testnet/ws",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000a1040400e504",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "KCoin",
					decimals: 6,
					metadata: "0x6d6574610e50000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700150100000610005501000003080000000800d5010c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401d901045300000400e10101185665633c543e0000d901083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964550101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73dd01011c526561736f6e730000dd01083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000e101000002d90100010200000618002d0200000210008503083870616c6c65745f7374616b696e67345374616b696e674c656467657204045400001401147374617368000130543a3a4163636f756e744964000114746f74616c0102013042616c616e63654f663c543e0001186163746976650102013042616c616e63654f663c543e000124756e6c6f636b696e67890301f0426f756e6465645665633c556e6c6f636b4368756e6b3c42616c616e63654f663c543e3e2c20543a3a4d6178556e6c6f636b696e674368756e6b733e00013c636c61696d65645f7265776172647395030194426f756e6465645665633c457261496e6465782c20543a3a486973746f727944657074683e000089030c4c626f756e6465645f636f6c6c656374696f6e732c626f756e6465645f76656328426f756e646564566563080454018d03045300000400910301185665633c543e00008d03083870616c6c65745f7374616b696e672c556e6c6f636b4368756e6b041c42616c616e636501180008011476616c75650102011c42616c616e636500010c65726115010120457261496e646578000091030000028d030095030c4c626f756e6465645f636f6c6c656374696f6e732c626f756e6465645f76656328426f756e64656456656308045401100453000004002d0201185665633c543e00000c1853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200d501040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e00000000031c5374616b696e67011c5374616b696e6704184c6564676572000104020085030400044501204d61702066726f6d20616c6c2028756e6c6f636b6564292022636f6e74726f6c6c657222206163636f756e747320746f2074686520696e666f20726567617264696e6720746865207374616b696e672e0000000007a1040400e504",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "100",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000a1040400e504",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "kate-testnet",
		isTestnet: true,
		sortIndex: 234,
		genesisHash: "0xd12003ac837853b062aaccca5ce87ac4838c48447e41db4a3dcfb5bf312350c6",
		prefix: 42,
		name: "Kate",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Avail Kate Testnet",
		implName: "data-avail",
		specName: "data-avail",
		specVersion: "11",
		nativeToken: {
			id: "kate-testnet-substrate-native-avl"
		},
		tokens: [
			{
				id: "kate-testnet-substrate-native-avl"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://kate.avail.tools/ws",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000190704005507",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "AVL",
					decimals: 18,
					metadata: "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",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "10000000000000",
					nominationPoolsPalletId: "70792f6e6f706c73"
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000190704005507",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "khala-testnet",
		isTestnet: true,
		sortIndex: 235,
		genesisHash: null,
		prefix: null,
		name: "Khala Testnet",
		themeColor: "#03ffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/khala-testnet.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "kilt-testnet-standalone",
		isTestnet: true,
		sortIndex: 236,
		genesisHash: "0x702ef00dfc905780f406963494ef3653402f55ac8e995bc6c50706025fe79470",
		prefix: 38,
		name: "KILT Mashnet",
		themeColor: "#f66741",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/kilt-testnet-standalone.svg",
		chainName: "KILT Testnet",
		implName: "mashnet-node",
		specName: "mashnet-node",
		specVersion: "8",
		nativeToken: {
			id: "kilt-testnet-standalone-substrate-native-kilt"
		},
		tokens: [
			{
				id: "kilt-testnet-standalone-substrate-native-kilt"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://full-nodes.kilt.io:9944/",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 12
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "KILT",
					decimals: 15,
					metadata: null,
					isTestnet: true,
					accountInfoType: null,
					metadataVersion: 12,
					crowdloanPalletId: null,
					existentialDeposit: "500",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 12
				}
			}
		]
	},
	{
		id: "kilt-testnet-standalone-2",
		isTestnet: true,
		sortIndex: 237,
		genesisHash: "0xa0c6e3bac382b316a68bca7141af1fba507207594c761076847ce358aeedcc21",
		prefix: 38,
		name: "KILT Peregrine",
		themeColor: "#f66741",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/kilt-testnet-standalone-2.svg",
		chainName: "KILT Peregrine",
		implName: "mashnet-node",
		specName: "mashnet-node",
		specVersion: "11000",
		nativeToken: {
			id: "kilt-testnet-standalone-2-substrate-native-pilt"
		},
		tokens: [
			{
				id: "kilt-testnet-standalone-2-substrate-native-pilt"
			}
		],
		account: "*25519",
		subscanUrl: "https://kilt-testnet.subscan.io/",
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://peregrine.kilt.io/parachain-public-ws/",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e000065070400c103",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "PILT",
					decimals: 15,
					metadata: "0x6d6574610e34000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d6572731c0120526566436f756e7400012470726f7669646572731c0120526566436f756e7400012c73756666696369656e74731c0120526566436f756e740001106461746114012c4163636f756e7444617461000010000005060014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507001c0000050500f901000003080000000800ed02101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401f102045300000400f90201185665633c543e0000f102083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964f90101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73f502011c526561736f6e730000f502083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000f902000002f10200081853797374656d011853797374656d041c4163636f756e7401010402000c510100000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200ed02040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000665070400c103",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "10000000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e000065070400c103",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "kintsugi-testnet",
		isTestnet: true,
		sortIndex: 238,
		genesisHash: "0x3b7131242c89df153ceafdd20b0194e25bae386f0bb7322b131d57c4b507ea57",
		prefix: 2092,
		name: "Kintsugi Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "interBTC",
		implName: "kintsugi-parachain",
		specName: "kintsugi-parachain",
		specVersion: "1024000",
		nativeToken: {
			id: "kintsugi-testnet-substrate-native-kint"
		},
		tokens: [
			{
				id: "kintsugi-testnet-substrate-native-kint"
			},
			{
				id: "kintsugi-testnet-substrate-orml-dot"
			},
			{
				id: "kintsugi-testnet-substrate-orml-ibtc"
			},
			{
				id: "kintsugi-testnet-substrate-orml-intr"
			},
			{
				id: "kintsugi-testnet-substrate-orml-kbtc"
			},
			{
				id: "kintsugi-testnet-substrate-orml-kint"
			},
			{
				id: "kintsugi-testnet-substrate-orml-ksm"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://api-dev-kintsugi.interlay.io/parachain",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000510904009109",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "KINT",
					decimals: 12,
					metadata: "0x6d6574610e1c000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700041853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e0000000000510904009109",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: null,
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
						"KINT",
						"KBTC",
						"KSM",
						"INTR",
						"IBTC",
						"DOT"
					],
					decimals: [
						12,
						8,
						12,
						10,
						8,
						10
					],
					isTestnet: true,
					stateKeys: {
						DOT: "0x01a12dfa1fa4ab9a0000",
						KSM: "0x459d0fd09ec38ee6000a",
						IBTC: "0xd67c5ba80ba065480001",
						INTR: "0xc483de2de1246ea70002",
						KBTC: "0x1fce6bee3ae455b7000b",
						KINT: "0x56a60a12d72ef524000c"
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e28000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d000004000003200000000800080000050300100000050500180000050700c8084c696e7465726274635f7072696d6974697665732843757272656e6379496400011414546f6b656e0400cc012c546f6b656e53796d626f6c00000030466f726569676e41737365740400100138466f726569676e41737365744964000100244c656e64546f6b656e040010012c4c656e64546f6b656e49640002001c4c70546f6b656e0800d0011c4c70546f6b656e0000d0011c4c70546f6b656e00030034537461626c654c70546f6b656e0400100130537461626c65506f6f6c496400040000cc084c696e7465726274635f7072696d6974697665732c546f6b656e53796d626f6c0001180c444f54000000104942544300010010494e54520002000c4b534d000a00104b425443000b00104b494e54000c0000d0084c696e7465726274635f7072696d6974697665731c4c70546f6b656e00010c14546f6b656e0400cc012c546f6b656e53796d626f6c00000030466f726569676e41737365740400100138466f726569676e4173736574496400010034537461626c654c70546f6b656e0400100130537461626c65506f6f6c49640002000069060000040800c8007906082c6f726d6c5f746f6b656e732c4163636f756e7444617461041c42616c616e63650118000c01106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e636500000418546f6b656e730118546f6b656e7304204163636f756e7473010108020569067906c000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000018b8205468652062616c616e6365206f66206120746f6b656e207479706520756e64657220616e206163636f756e742e00fc204e4f54453a2049662074686520746f74616c2069732065766572207a65726f2c206465637265617365206163636f756e7420726566206163636f756e742e001901204e4f54453a2054686973206973206f6e6c79207573656420696e20746865206361736520746861742074686973206d6f64756c65206973207573656420746f2073746f7265282062616c616e6365732e0000000015510904009109",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "klugdossier-testnet",
		isTestnet: true,
		sortIndex: 239,
		genesisHash: null,
		prefix: null,
		name: "Klug Dossier",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "kylin-testnet",
		isTestnet: true,
		sortIndex: 240,
		genesisHash: null,
		prefix: null,
		name: "Kylin Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "rococo-litentry-testnet",
		isTestnet: true,
		sortIndex: 241,
		genesisHash: "0x6940b1852737722c0aa768710e20105ab8c6a80b63a0339cb99892ffdce38283",
		prefix: 42,
		name: "Litentry Testnet",
		themeColor: "#15ea85",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/rococo-litentry-testnet.svg",
		chainName: "Litentry-rococo",
		implName: "rococo-parachain",
		specName: "rococo-parachain",
		specVersion: "9160",
		nativeToken: {
			id: "rococo-litentry-testnet-substrate-native-lit"
		},
		tokens: [
			{
				id: "rococo-litentry-testnet-substrate-native-lit"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://rpc.rococo-parachain-sg.litentry.io",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2106,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000dd0804004102",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "LIT",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507006d01000003080000000800d5050c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401d905045300000400e10501185665633c543e0000d905083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c010869646d0101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73dd05011c526561736f6e730000dd05083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000e105000002d90500081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200d505040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000add0804004102",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "100000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e18000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d000004000003200000000800080000050300180000050700c105000004080018002908082c6f726d6c5f746f6b656e732c4163636f756e7444617461041c42616c616e63650118000c01106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e636500000418546f6b656e730118546f6b656e7304204163636f756e74730101080205c1052908c000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000018b8205468652062616c616e6365206f66206120746f6b656e207479706520756e64657220616e206163636f756e742e00fc204e4f54453a2049662074686520746f74616c2069732065766572207a65726f2c206465637265617365206163636f756e7420726566206163636f756e742e001901204e4f54453a2054686973206973206f6e6c79207573656420696e20746865206361736520746861742074686973206d6f64756c65206973207573656420746f2073746f7265282062616c616e6365732e0000000037dd0804004102",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "litentry-testnet",
		isTestnet: true,
		sortIndex: 242,
		genesisHash: null,
		prefix: null,
		name: "Litentry Testnet",
		themeColor: "#15ea85",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/litentry-testnet.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "logion-testnet-standalone",
		isTestnet: true,
		sortIndex: 243,
		genesisHash: "0xa980b64e029e4e27078c3380b4e12f22b8340c357c9beacc3f2986b80079b44f",
		prefix: 2021,
		name: "Logion Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Chimay",
		implName: "logion",
		specName: "logion",
		specVersion: "5",
		nativeToken: {
			id: "logion-testnet-standalone-substrate-native-chy"
		},
		tokens: [
			{
				id: "logion-testnet-standalone-substrate-native-chy"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://chimay.logion.network",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e000089050400cd05",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "CHY",
					decimals: 18,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700f4000003080000000800b1020c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401b502045300000400bd0201185665633c543e0000b502083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964f401384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73b902011c526561736f6e730000b902083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000bd02000002b50200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200b102040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000a89050400cd05",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e000089050400cd05",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "logion-testnet-standalone-2",
		isTestnet: true,
		sortIndex: 244,
		genesisHash: "0x187898dc7fd56923944e4cda86d7a27408e397292bcbec72fec5f82268c2cfe0",
		prefix: 42,
		name: "Logion Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "logion Testnet",
		implName: "logion",
		specName: "logion",
		specVersion: "147",
		nativeToken: {
			id: "logion-testnet-standalone-2-substrate-native-lgnt"
		},
		tokens: [
			{
				id: "logion-testnet-standalone-2-substrate-native-lgnt"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://test-rpc01.logion.network",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "LGNT",
					decimals: 18,
					metadata: "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",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "500",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000b1030400ed03",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "mandala-testnet",
		isTestnet: true,
		sortIndex: 245,
		genesisHash: null,
		prefix: null,
		name: "Mandala",
		themeColor: "#e40c5b",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/mandala-testnet.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: "https://acala-testnet.subscan.io/",
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "rococo-mangata-testnet",
		isTestnet: true,
		sortIndex: 246,
		genesisHash: "0x797fe0d6ea6917b5a36707961d819dca1826628123510730425c3bafc65ccf59",
		prefix: 42,
		name: "MangataX Testnet",
		themeColor: "#00457a",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/rococo-mangata-testnet.svg",
		chainName: "Mangata Public Testnet",
		implName: "mangata-parachain",
		specName: "mangata-parachain",
		specVersion: "3001",
		nativeToken: {
			id: "rococo-mangata-testnet-substrate-native-mgat"
		},
		tokens: [
			{
				id: "rococo-mangata-testnet-substrate-native-mgat"
			}
		],
		account: "*25519",
		subscanUrl: "https://mangata-testnet.subscan.io/",
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://collator-01-ws-rococo.mangata.online",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2110,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000a5070400cd07",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "MGAT",
					decimals: 18,
					metadata: "0x6d6574610e18000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e74446174610000100000050500140000040000081853797374656d011853797374656d041c4163636f756e7401010402000c400000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002443726f77646c6f616e012443726f77646c6f616e000000000012a5070400cd07",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: null,
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e1c000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d000004000003200000000800080000050300100000050500b400000507005105000004080010006105082c6f726d6c5f746f6b656e732c4163636f756e7444617461041c42616c616e636501b4000c011066726565b4011c42616c616e63650001207265736572766564b4011c42616c616e636500011866726f7a656eb4011c42616c616e636500000418546f6b656e730118546f6b656e7304204163636f756e7473010108020551056105c000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000018b8205468652062616c616e6365206f66206120746f6b656e207479706520756e64657220616e206163636f756e742e00fc204e4f54453a2049662074686520746f74616c2069732065766572207a65726f2c206465637265617365206163636f756e7420726566206163636f756e742e001901204e4f54453a2054686973206973206f6e6c79207573656420696e20746865206361736520746861742074686973206d6f64756c65206973207573656420746f2073746f7265282062616c616e6365732e000000000aa5070400cd07",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "manta-testnet",
		isTestnet: true,
		sortIndex: 247,
		genesisHash: null,
		prefix: null,
		name: "Manta Testnet",
		themeColor: "#eb69bd",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/manta-testnet.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "rococo-md-5-testnet",
		isTestnet: true,
		sortIndex: 248,
		genesisHash: "0x38656c27a232ae030ad8262ef9d6e6c63ca9fe68affbf5db26a4159340621210",
		prefix: 42,
		name: "MD5",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "MD5 Network",
		implName: "hashed",
		specName: "hashed",
		specVersion: "2",
		nativeToken: {
			id: "rococo-md-5-testnet-substrate-native-md5"
		},
		tokens: [
			{
				id: "rococo-md-5-testnet-substrate-native-md5"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://c1.md5.hashed.live",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2093,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "MD5",
					decimals: 18,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700f0000003080000000800c902102873705f72756e74696d651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401cd02045300000400d50201185665633c543e0000cd02083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964f001384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73d102011c526561736f6e730000d102083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000d502000002cd0200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200c902040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000afd0704002908",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000fd0704002908",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "minix-testnet",
		isTestnet: true,
		sortIndex: 249,
		genesisHash: null,
		prefix: null,
		name: "MiniX Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "moonbase-alpha-testnet",
		isTestnet: true,
		sortIndex: 250,
		genesisHash: "0x91bc6e169807aaa54802737e1c504b2577d4fafedd5a02c10293b1cd60e39527",
		prefix: 1287,
		name: "Moonbase Alpha",
		themeColor: "#4cb1b3",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/moonbase-alpha-testnet.svg",
		chainName: "Moonbase Alpha",
		implName: "moonbase",
		specName: "moonbase",
		specVersion: "2401",
		nativeToken: {
			id: "moonbase-alpha-testnet-substrate-native-dev"
		},
		tokens: [
			{
				id: "moonbase-alpha-testnet-substrate-native-dev"
			}
		],
		account: "secp256k1",
		subscanUrl: "https://moonbase.subscan.io/",
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://moonbeam-alpha.api.onfinality.io/public-ws",
				isHealthy: true
			},
			{
				url: "wss://wss.api.moonbase.moonbeam.network",
				isHealthy: true
			},
			{
				url: "wss://moonbase.unitedbloc.com",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
			{
				id: "1287"
			}
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "DEV",
					decimals: 18,
					metadata: "0x6d6574610e3000081c6163636f756e742c4163636f756e7449643230000004000401205b75383b2032305d0000040000031400000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700ad01000003080000000800c9050c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401cd05045300000400d50501185665633c543e0000cd05083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964ad0101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73d105011c526561736f6e730000d105083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000d505000002cd0500081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200c905040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000391090400c509",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "0",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e000091090400c509",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "rococo-moonsama-testnet",
		isTestnet: true,
		sortIndex: 252,
		genesisHash: null,
		prefix: null,
		name: "Moonsama",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2055,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
		]
	},
	{
		id: "moonshadow-testnet",
		isTestnet: true,
		sortIndex: 253,
		genesisHash: null,
		prefix: null,
		name: "Moonshadow",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2002,
		relay: {
			id: "westend-testnet"
		},
		balanceMetadata: [
		]
	},
	{
		id: "mybank-testnet",
		isTestnet: true,
		sortIndex: 254,
		genesisHash: null,
		prefix: null,
		name: "mybank.network",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "myriad-testnet",
		isTestnet: true,
		sortIndex: 255,
		genesisHash: "0x7d45920ff7956e45ef6107720e41b1cfdbd0a50371d6e9072f67070fb285fe16",
		prefix: 42,
		name: "Myriad Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Myriad Testnet",
		implName: "myriad",
		specName: "appchain",
		specVersion: "2036",
		nativeToken: {
			id: "myriad-testnet-substrate-native-myria"
		},
		tokens: [
			{
				id: "myriad-testnet-substrate-native-myria"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://ws-rpc.testnet.myriad.social",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000090504003505",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "MYRIA",
					decimals: 18,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700b9010000030800000008002902101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e646564566563080454012d02045300000400350201185665633c543e00002d02083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964b90101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e733102011c526561736f6e7300003102083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c0002000035020000022d0200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402002902040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e0000000003090504003505",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000090504003505",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "nftmart-testnet",
		isTestnet: true,
		sortIndex: 256,
		genesisHash: null,
		prefix: null,
		name: "NFTMart Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "rococo-nodle-testnet",
		isTestnet: true,
		sortIndex: 257,
		genesisHash: "0x0fd167da222f10dae826a0433fe4daadcf4a36c2a6bd5c1b085857d5b79030af",
		prefix: 37,
		name: "Nodle Testnet",
		themeColor: "#010717",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/rococo-nodle-testnet.svg",
		chainName: "Nodle Testing Parachain",
		implName: "nodle-para",
		specName: "nodle-para",
		specVersion: "23",
		nativeToken: {
			id: "rococo-nodle-testnet-substrate-native-notnodl"
		},
		tokens: [
			{
				id: "rococo-nodle-testnet-substrate-native-notnodl"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://nodle-paradis.api.onfinality.io/public-ws",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2026,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000d90504001906",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "notNODL",
					decimals: 11,
					metadata: "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",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "10000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000d90504001906",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "chainoli-testnet",
		isTestnet: true,
		sortIndex: 258,
		genesisHash: null,
		prefix: null,
		name: "Oli",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 4023,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
		]
	},
	{
		id: "opal-testnet",
		isTestnet: true,
		sortIndex: 259,
		genesisHash: "0xc87870ef90a438d574b8e320f17db372c50f62beb52e479c8ff6ee5b460670b9",
		prefix: 42,
		name: "Opal",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "OPAL by UNIQUE",
		implName: "opal",
		specName: "opal",
		specVersion: "942057",
		nativeToken: {
			id: "opal-testnet-substrate-native-opl"
		},
		tokens: [
			{
				id: "opal-testnet-substrate-native-opl"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://ws-opal.unique.network",
				isHealthy: true
			},
			{
				url: "wss://us-ws-opal.unique.network",
				isHealthy: true
			},
			{
				url: "wss://asia-ws-opal.unique.network",
				isHealthy: true
			},
			{
				url: "wss://eu-ws-opal.unique.network",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000d50804001d09",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "OPL",
					decimals: 18,
					metadata: "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",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "0",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e24000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503001000000505001800000507000d01085470616c6c65745f666f726569676e5f61737365747320417373657449647300010838466f726569676e417373657449640400100138466f726569676e41737365744964000000344e6174697665417373657449640400110101384e617469766543757272656e6379000100001101085470616c6c65745f666f726569676e5f617373657473384e617469766543757272656e6379000108104865726500000018506172656e7400010000810600000408000d01009106082c6f726d6c5f746f6b656e732c4163636f756e7444617461041c42616c616e63650118000c01106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e636500000418546f6b656e730118546f6b656e7304204163636f756e7473010108020581069106c000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000018b8205468652062616c616e6365206f66206120746f6b656e207479706520756e64657220616e206163636f756e742e00fc204e4f54453a2049662074686520746f74616c2069732065766572207a65726f2c206465637265617365206163636f756e7420726566206163636f756e742e001901204e4f54453a2054686973206973206f6e6c79207573656420696e20746865206361736520746861742074686973206d6f64756c65206973207573656420746f2073746f7265282062616c616e6365732e0000000027d50804001d09",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "opportunity-testnet",
		isTestnet: true,
		sortIndex: 260,
		genesisHash: null,
		prefix: null,
		name: "Opportunity",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "rococo-origin-trail-parachain-testnet",
		isTestnet: true,
		sortIndex: 261,
		genesisHash: "0xf2b8faefcf9c370872d0b4d2eee31d46b4de4a8688153d23d82a39e2d6bc8bbc",
		prefix: 101,
		name: "OriginTrail Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "OriginTrail Parachain Testnet",
		implName: "origintrail-parachain",
		specName: "origintrail-parachain",
		specVersion: "112",
		nativeToken: {
			id: "rococo-origin-trail-parachain-testnet-substrate-native-otp"
		},
		tokens: [
			{
				id: "rococo-origin-trail-parachain-testnet-substrate-native-otp"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://parachain-testnet-rpc.origin-trail.network/",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2043,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "OTP",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507003501000003080000000800b5040c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401b904045300000400c10401185665633c543e0000b904083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964350101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73bd04011c526561736f6e730000bd04083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000c104000002b90400081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200b504040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000ab5060400f906",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000b5060400f906",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "rococo-pangolin-testnet",
		isTestnet: true,
		sortIndex: 262,
		genesisHash: "0xb067215e6232ffeed7cede2f92ac6b65f2121523fa221fc76f2e4430086c6b70",
		prefix: 42,
		name: "Pangolin2",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Pangolin2",
		implName: "DarwiniaOfficialRust",
		specName: "Pangolin2",
		specVersion: "6340",
		nativeToken: {
			id: "rococo-pangolin-testnet-substrate-native-pring"
		},
		tokens: [
			{
				id: "rococo-pangolin-testnet-substrate-native-pring"
			}
		],
		account: "secp256k1",
		subscanUrl: "https://pangolin-parachain.subscan.io/",
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://pangolin-rpc.darwinia.network",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2105,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "PRING",
					decimals: 18,
					metadata: "0x6d6574610e3000082866705f6163636f756e742c4163636f756e7449643230000004000401205b75383b2032305d0000040000031400000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700a50100000308000000080091030c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e6465645665630804540195030453000004009d0301185665633c543e00009503083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964a50101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e739903011c526561736f6e7300009903083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200009d03000002950300081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402009103040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000595090400c909",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "0",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e000095090400c909",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "pangoro-testnet",
		isTestnet: true,
		sortIndex: 263,
		genesisHash: "0xaaa8b33b723b30b44e45e4e6c01936cc92e7559b4184fb0cee2853d55610fcbf",
		prefix: 18,
		name: "Pangoro2",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Pangoro2",
		implName: "DarwiniaOfficialRust",
		specName: "Pangoro2",
		specVersion: "6310",
		nativeToken: {
			id: "pangoro-testnet-substrate-native-oring"
		},
		tokens: [
			{
				id: "pangoro-testnet-substrate-native-oring"
			}
		],
		account: "secp256k1",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://pangoro-rpc.darwinia.network",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "ORING",
					decimals: 18,
					metadata: "0x6d6574610e3000082866705f6163636f756e742c4163636f756e7449643230000004000401205b75383b2032305d0000040000031400000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700a50100000308000000080091030c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e6465645665630804540195030453000004009d0301185665633c543e00009503083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964a50101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e739903011c526561736f6e7300009903083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200009d03000002950300081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402009103040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000595090400c909",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "0",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e000095090400c909",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "phala-testnet",
		isTestnet: true,
		sortIndex: 264,
		genesisHash: "0x35e83f8f298c9b90ce08ee860d0eeeece48044c3a3475b7d50b2255994a921a7",
		prefix: 30,
		name: "Phala Testnet",
		themeColor: "#cdfa50",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/phala-testnet.svg",
		chainName: "Phala Development",
		implName: "phala-node",
		specName: "phala-node",
		specVersion: "1",
		nativeToken: {
			id: "phala-testnet-substrate-native-unknown"
		},
		tokens: [
			{
				id: "phala-testnet-substrate-native-unknown"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://poc5.phala.network/ws",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "Unknown",
					decimals: 0,
					metadata: "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",
					isTestnet: true,
					accountInfoType: 24,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "10000000000",
					nominationPoolsPalletId: "70792f6e6f706c73"
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000950a0400d10a",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "phoenix-testnet",
		isTestnet: true,
		sortIndex: 265,
		genesisHash: null,
		prefix: null,
		name: "Phoenix Mashnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "rococo-picasso-testnet",
		isTestnet: true,
		sortIndex: 266,
		genesisHash: "0x1fb83e6e5fafa90d85ac934e3a8efdced33f9adfe3d5552d7af118fe854992d2",
		prefix: 49,
		name: "Picasso Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Picasso Testnet (Rococo Relay)",
		implName: "picasso",
		specName: "picasso",
		specVersion: "10032",
		nativeToken: {
			id: "rococo-picasso-testnet-substrate-native-pica"
		},
		tokens: [
			{
				id: "rococo-picasso-testnet-substrate-native-pica"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://picasso-rococo-rpc-lb.composablenodes.tech",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2087,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000d5090400010a",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "PICA",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700650100000308000000080081060c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e6465645665630804540185060453000004008d0601185665633c543e00008506083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964650101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e738906011c526561736f6e7300008906083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200008d06000002850600081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402008106040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e0000000006d5090400010a",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "100000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e1c000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d00000400000320000000080008000005030018000005070001020c287072696d6974697665732063757272656e63792843757272656e6379496400000400180110753132380000c5080000040800010200d508082c6f726d6c5f746f6b656e732c4163636f756e7444617461041c42616c616e63650118000c01106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e636500000418546f6b656e730118546f6b656e7304204163636f756e74730101080205c508d508c000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000018b8205468652062616c616e6365206f66206120746f6b656e207479706520756e64657220616e206163636f756e742e00fc204e4f54453a2049662074686520746f74616c2069732065766572207a65726f2c206465637265617365206163636f756e7420726566206163636f756e742e001901204e4f54453a2054686973206973206f6e6c79207573656420696e20746865206361736520746861742074686973206d6f64756c65206973207573656420746f2073746f7265282062616c616e6365732e0000000034d5090400010a",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "pichiu-testnet",
		isTestnet: true,
		sortIndex: 267,
		genesisHash: null,
		prefix: null,
		name: "Pichiu Testnet",
		themeColor: "#c0266c",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/pichiu-testnet.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "westend-pichiu-testnet",
		isTestnet: true,
		sortIndex: 268,
		genesisHash: null,
		prefix: null,
		name: "Pichiu Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2112,
		relay: {
			id: "westend-testnet"
		},
		balanceMetadata: [
		]
	},
	{
		id: "polkadex-testnet",
		isTestnet: true,
		sortIndex: 269,
		genesisHash: null,
		prefix: null,
		name: "Polkadex Testnet",
		themeColor: "#e6007a",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/polkadex-testnet.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "polymesh-testnet",
		isTestnet: true,
		sortIndex: 270,
		genesisHash: "0x2ace05e703aa50b48c0ccccfc8b424f7aab9a1e2c424ed12e45d20b1e8ffd0d6",
		prefix: 42,
		name: "Polymesh Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Polymesh Testnet",
		implName: "polymesh_testnet",
		specName: "polymesh_testnet",
		specVersion: "5004001",
		nativeToken: {
			id: "polymesh-testnet-substrate-native-polyx"
		},
		tokens: [
			{
				id: "polymesh-testnet-substrate-native-polyx"
			}
		],
		account: "*25519",
		subscanUrl: "https://polymesh-testnet.subscan.io/",
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://testnet-rpc.polymesh.live",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000bd0b0400ed0b",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "POLYX",
					decimals: 6,
					metadata: "0x6d6574610e44000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e74446174610000100000050500141064706f6c796d6573685f636f6d6d6f6e5f7574696c6974696573187472616974732062616c616e6365732c4163636f756e744461746100001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700dd0100000618007d040000021000c90400000610000d0500000308000000080099050000029d05009d05083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c010869640d0501384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73a105011c526561736f6e730000a1051064706f6c796d6573685f636f6d6d6f6e5f7574696c6974696573187472616974732062616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200002d09083870616c6c65745f7374616b696e67345374616b696e674c656467657208244163636f756e74496401001c42616c616e636501180014011473746173680001244163636f756e744964000114746f74616cdd01011c42616c616e6365000118616374697665dd01011c42616c616e6365000124756e6c6f636b696e67310901645665633c556e6c6f636b4368756e6b3c42616c616e63653e3e00013c636c61696d65645f726577617264737d0401345665633c457261496e6465783e000031090000023509003509083870616c6c65745f7374616b696e672c556e6c6f636b4368756e6b041c42616c616e636501180008011476616c7565dd01011c42616c616e636500010c657261c9040120457261496e64657800000c1853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402009905040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e00000000051c5374616b696e67011c5374616b696e6704184c656467657200010402002d090400044501204d61702066726f6d20616c6c2028756e6c6f636b6564292022636f6e74726f6c6c657222206163636f756e747320746f2074686520696e666f20726567617264696e6720746865207374616b696e672e0000000011bd0b0400ed0b",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "0",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000bd0b0400ed0b",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "pontem-testnet",
		isTestnet: true,
		sortIndex: 271,
		genesisHash: null,
		prefix: null,
		name: "Pontem",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "prism-testnet",
		isTestnet: true,
		sortIndex: 272,
		genesisHash: null,
		prefix: null,
		name: "Prism",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "realis-testnet",
		isTestnet: true,
		sortIndex: 273,
		genesisHash: null,
		prefix: null,
		name: "Realis.Network",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "rococo-phala-testnet",
		isTestnet: true,
		sortIndex: 274,
		genesisHash: "0x2c0c4eaa199decaf7410c4764a7f88e17eaa04a188b0d025397a15839cb4b6bf",
		prefix: 30,
		name: "Rhala",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Khala",
		implName: "rhala",
		specName: "rhala",
		specVersion: "1241",
		nativeToken: {
			id: "rococo-phala-testnet-substrate-native-pha"
		},
		tokens: [
			{
				id: "rococo-phala-testnet-substrate-native-pha"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://rhala-node.phala.network/ws",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2004,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "PHA",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507001501000003080000000800d5070c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401d907045300000400e10701185665633c543e0000d907083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964150101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73dd07011c526561736f6e730000dd07083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000e107000002d90700081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200d507040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e0000000028f10a0400310b",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "10000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000f10a0400310b",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "rococo-kilt-testnet",
		isTestnet: true,
		sortIndex: 275,
		genesisHash: null,
		prefix: null,
		name: "Rilt",
		themeColor: "#f66741",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/rococo-kilt-testnet.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2086,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
		]
	},
	{
		id: "riochain-testnet",
		isTestnet: true,
		sortIndex: 276,
		genesisHash: null,
		prefix: null,
		name: "RioChain Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "robonomics-testnet",
		isTestnet: true,
		sortIndex: 277,
		genesisHash: null,
		prefix: null,
		name: "Robonomics Testnet",
		themeColor: "#03a5ed",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/robonomics-testnet.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2048,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
		]
	},
	{
		id: "rocfinity-testnet",
		isTestnet: true,
		sortIndex: 278,
		genesisHash: null,
		prefix: null,
		name: "Rocfinity",
		themeColor: "#496ddb",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/rocfinity-testnet.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2021,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
		]
	},
	{
		id: "rococo-statemint-testnet",
		isTestnet: true,
		sortIndex: 279,
		genesisHash: "0x7c34d42fc815d392057c78b49f2755c753440ccd38bcb0405b3bcfb601d08734",
		prefix: 2,
		name: "Rockmine",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/rococo-statemint-testnet.svg",
		chainName: "Rococo Asset Hub",
		implName: "statemine",
		specName: "statemine",
		specVersion: "9430",
		nativeToken: {
			id: "rococo-statemint-testnet-substrate-native-roc"
		},
		tokens: [
			{
				id: "rococo-statemint-testnet-substrate-native-roc"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://rococo-rockmine-rpc.polkadot.io",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 1000,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "ROC",
					decimals: 12,
					metadata: "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",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "33333333",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000ed0504001906",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "sherpax-testnet",
		isTestnet: true,
		sortIndex: 281,
		genesisHash: "0xbcffcb56cf05eb71e5f59eaf35de2bbe330f925a065d852859b1737ce02342a0",
		prefix: 44,
		name: "Sherpax",
		themeColor: "#34c69a",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/sherpax-testnet.svg",
		chainName: "SherpaX Testnet",
		implName: "SherpaX",
		specName: "SherpaX",
		specVersion: "43",
		nativeToken: {
			id: "sherpax-testnet-substrate-native-ksx"
		},
		tokens: [
			{
				id: "sherpax-testnet-substrate-native-ksx"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://sherpax-testnet.chainx.org",
				isHealthy: false
			}
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "KSX",
					decimals: 18,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700f501000003080000000800010410346672616d655f737570706f72741c73746f72616765407765616b5f626f756e6465645f766563385765616b426f756e6465645665630804540105040453000004000d0401185665633c543e00000504083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964f50101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e730904011c526561736f6e7300000904083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200000d04000002050400081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402000104040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000a69060400a106",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "10000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e000069060400a106",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "shibuya-testnet",
		isTestnet: true,
		sortIndex: 282,
		genesisHash: "0xddb89973361a170839f80f152d2e9e38a376a5a7eccefcade763f46a8e567019",
		prefix: 5,
		name: "Shibuya",
		themeColor: "#bba5e1",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/shibuya-testnet.svg",
		chainName: "Shibuya Testnet",
		implName: "shibuya",
		specName: "shibuya",
		specVersion: "101",
		nativeToken: {
			id: "shibuya-testnet-substrate-native-sby"
		},
		tokens: [
			{
				id: "shibuya-testnet-substrate-native-sby"
			}
		],
		account: "*25519",
		subscanUrl: "https://shibuya.subscan.io/",
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://shibuya-rpc.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://rpc.shibuya.astar.network",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
			{
				id: "81"
			}
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "SBY",
					decimals: 18,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507005101000003080000000800ed050c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401f105045300000400f90501185665633c543e0000f105083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964510101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73f505011c526561736f6e730000f505083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000f905000002f10500081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e000000000a2042616c616e636573012042616c616e63657304144c6f636b730101040200ed05040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000001f5d080400a108",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e00005d080400a108",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "skyekiwi-testnet",
		isTestnet: true,
		sortIndex: 284,
		genesisHash: "0xb5bfb91886508f2b7abc78bec8dffef3c9ad43e3b46caec6b581292f0e5b52ce",
		prefix: 42,
		name: "SkyeKiwi",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "SkyeKiwi Testnet Alpha",
		implName: "skyekiwi-testnet-alpha",
		specName: "skyekiwi-testnet-alpha",
		specVersion: "105",
		nativeToken: {
			id: "skyekiwi-testnet-substrate-native-unknown"
		},
		tokens: [
			{
				id: "skyekiwi-testnet-substrate-native-unknown"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://staging.rpc.skye.kiwi",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e000095020400d102",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "Unknown",
					decimals: 0,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507002501000003080000000800810110346672616d655f737570706f72741c73746f72616765407765616b5f626f756e6465645f766563385765616b426f756e6465645665630804540185010453000004008d0101185665633c543e00008501083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964250101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e738901011c526561736f6e7300008901083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200008d01000002850100081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402008101040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000495020400d102",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "500",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e000095020400d102",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "snowbridge-testnet",
		isTestnet: true,
		sortIndex: 285,
		genesisHash: null,
		prefix: null,
		name: "Snowbridge",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 3016,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
		]
	},
	{
		id: "rococo-societal-testnet",
		isTestnet: true,
		sortIndex: 286,
		genesisHash: "0xb5cba5dedb1f78ee67b06933d9a12c69db59d5c59884110a293b832f1076ef10",
		prefix: 42,
		name: "Societal",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Societal Rococo Testnet",
		implName: "societal-node",
		specName: "node",
		specVersion: "100",
		nativeToken: {
			id: "rococo-societal-testnet-substrate-native-sctl"
		},
		tokens: [
			{
				id: "rococo-societal-testnet-substrate-native-sctl"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://node-ws-rococo.testnet.sctl.link",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 4253,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "SCTL",
					decimals: 12,
					metadata: "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",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "0",
					nominationPoolsPalletId: "70792f6e6f706c73"
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000dd0c04000d0d",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "soonsocial-testnet",
		isTestnet: true,
		sortIndex: 287,
		genesisHash: null,
		prefix: null,
		name: "Soonsocial",
		themeColor: "#a4028f",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/soonsocial-testnet.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "rococo-subsocial-testnet",
		isTestnet: true,
		sortIndex: 288,
		genesisHash: "0x01f15f9d48ea279640cb35267bfd33a88bb4c21ebb00b129e9bc2d2236aaafdb",
		prefix: 28,
		name: "SoonsocialX",
		themeColor: "#4d0366",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/rococo-subsocial-testnet.svg",
		chainName: "SoonSocial",
		implName: "soonsocial-parachain",
		specName: "soonsocial-parachain",
		specVersion: "2302",
		nativeToken: {
			id: "rococo-subsocial-testnet-substrate-native-soon"
		},
		tokens: [
			{
				id: "rococo-subsocial-testnet-substrate-native-soon"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://rco-para.subsocial.network",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2100,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000350504007905",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "SOON",
					decimals: 10,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e6365000018000005070011010000030800000008007d02101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e646564566563080454018102045300000400890201185665633c543e00008102083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964110101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e738502011c526561736f6e7300008502083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200008902000002810200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402007d02040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000a350504007905",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "100000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000350504007905",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "rococo-sora-testnet",
		isTestnet: true,
		sortIndex: 289,
		genesisHash: "0x8685a8d3e57fa8024b91b8ead6cc97acf953889c6fb0a355602826a1e2db198f",
		prefix: 420,
		name: "Sora Testnet",
		themeColor: "#fd0100",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/rococo-sora-testnet.svg",
		chainName: "SORA Rococo",
		implName: "sora_ksm",
		specName: "sora_ksm",
		specVersion: "4",
		nativeToken: {
			id: "rococo-sora-testnet-substrate-native-rxor"
		},
		tokens: [
			{
				id: "rococo-sora-testnet-substrate-native-rxor"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://ws.parachain-collator-1.c1.stg1.sora2.soramitsu.co.jp",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2011,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000a5040400e104",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "RXOR",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700f4000003080000000800e102101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401e502045300000400ed0201185665633c543e0000e502083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964f401384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73e902011c526561736f6e730000e902083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000ed02000002e50200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200e102040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000aa5040400e104",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000a5040400e104",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "sora-substrate-testnet",
		isTestnet: true,
		sortIndex: 290,
		genesisHash: "0x3266816be9fa51b32cfea58d3e33ca77246bc9618595a4300e44c8856a8d8a17",
		prefix: 69,
		name: "Sora Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "SORA-staging Testnet",
		implName: "sora-substrate",
		specName: "sora-substrate",
		specVersion: "58",
		nativeToken: {
			id: "sora-substrate-testnet-substrate-native-xor"
		},
		tokens: [
			{
				id: "sora-substrate-testnet-substrate-native-xor"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://ws.framenode-1.s1.stg1.sora2.soramitsu.co.jp",
				isHealthy: true
			},
			{
				url: "wss://ws.framenode-2.s1.stg1.sora2.soramitsu.co.jp",
				isHealthy: true
			},
			{
				url: "wss://ws.framenode-3.s2.stg1.sora2.soramitsu.co.jp",
				isHealthy: true
			},
			{
				url: "wss://ws.framenode-4.s2.stg1.sora2.soramitsu.co.jp",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e00041841737365747301184173736574730000000000155d0d0400890d",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "XOR",
					decimals: 18,
					metadata: "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",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "0",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e1c000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503001800000507000d010c18636f6d6d6f6e287072696d69746976657324417373657449643332041c4173736574496401110100040110636f6465040134417373657449643332436f64650000150a00000408000d0100250a082c6f726d6c5f746f6b656e732c4163636f756e7444617461041c42616c616e63650118000c01106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e636500000418546f6b656e730118546f6b656e7304204163636f756e74730101080205150a250ac000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000018b8205468652062616c616e6365206f66206120746f6b656e207479706520756e64657220616e206163636f756e742e00fc204e4f54453a2049662074686520746f74616c2069732065766572207a65726f2c206465637265617365206163636f756e7420726566206163636f756e742e001901204e4f54453a2054686973206973206f6e6c79207573656420696e20746865206361736520746861742074686973206d6f64756c65206973207573656420746f2073746f7265282062616c616e6365732e00000000125d0d0400890d",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "datahighway-testnet",
		isTestnet: true,
		sortIndex: 291,
		genesisHash: null,
		prefix: null,
		name: "Spreehafen",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "rococo-spreehafen-testnet",
		isTestnet: true,
		sortIndex: 292,
		genesisHash: null,
		prefix: null,
		name: "Spreehafen",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2116,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
		]
	},
	{
		id: "stagex-testnet",
		isTestnet: true,
		sortIndex: 293,
		genesisHash: null,
		prefix: null,
		name: "Stagex",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2007,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
		]
	},
	{
		id: "westend-standard-testnet",
		isTestnet: true,
		sortIndex: 294,
		genesisHash: null,
		prefix: null,
		name: "Standard",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2094,
		relay: {
			id: "westend-testnet"
		},
		balanceMetadata: [
		]
	},
	{
		id: "subdao-testnet",
		isTestnet: true,
		sortIndex: 295,
		genesisHash: null,
		prefix: null,
		name: "SubDAO Testnet",
		themeColor: "#d51073",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/subdao-testnet.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "subgame-testnet",
		isTestnet: true,
		sortIndex: 296,
		genesisHash: null,
		prefix: null,
		name: "SubGame Testnet",
		themeColor: "#eb027d",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/subgame-testnet.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "subspace-testnet",
		isTestnet: true,
		sortIndex: 297,
		genesisHash: null,
		prefix: null,
		name: "Subspace",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "subspace-farmnet-testnet",
		isTestnet: true,
		sortIndex: 298,
		genesisHash: null,
		prefix: null,
		name: "Subspace Farmnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "subspace-gemini-1-testnet",
		isTestnet: true,
		sortIndex: 299,
		genesisHash: "0x9ee86eefc3cc61c71a7751bba7f25e442da2512f408e6286153b3ccc055dccf0",
		prefix: 2254,
		name: "Subspace Gemini",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Subspace Gemini 1",
		implName: "subspace",
		specName: "subspace",
		specVersion: "2",
		nativeToken: {
			id: "subspace-gemini-1-testnet-substrate-native-tssc"
		},
		tokens: [
			{
				id: "subspace-gemini-1-testnet-substrate-native-tssc"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://eu.gemini-1b.subspace.network/ws",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000c50204000903",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "tSSC",
					decimals: 18,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507002901000003080000000800c10110346672616d655f737570706f72741c73746f72616765407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401c501045300000400cd0101185665633c543e0000c501083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964290101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73c901011c526561736f6e730000c901083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000cd01000002c50100081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200c101040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e0000000005c50204000903",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "500",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000c50204000903",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "subspace-gemini-2-a-testnet",
		isTestnet: true,
		sortIndex: 300,
		genesisHash: "0x43d10ffd50990380ffe6c9392145431d630ae67e89dbc9c014cac2a417759101",
		prefix: 2254,
		name: "Subspace Gemini 2a",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Subspace Gemini 2a",
		implName: "subspace",
		specName: "subspace",
		specVersion: "4",
		nativeToken: {
			id: "subspace-gemini-2-a-testnet-substrate-native-tssc"
		},
		tokens: [
			{
				id: "subspace-gemini-2-a-testnet-substrate-native-tssc"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://eu-0.gemini-2a.subspace.network/ws",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000c90204000d03",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "tSSC",
					decimals: 18,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507002d01000003080000000800c501102873705f72756e74696d651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401c901045300000400d10101185665633c543e0000c901083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c010869642d0101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73cd01011c526561736f6e730000cd01083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000d101000002c90100081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200c501040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e0000000005c90204000d03",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "500",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000c90204000d03",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "rococo-subzero-testnet",
		isTestnet: true,
		sortIndex: 301,
		genesisHash: null,
		prefix: null,
		name: "Subzero Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 4040,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
		]
	},
	{
		id: "sumi-testnet",
		isTestnet: true,
		sortIndex: 302,
		genesisHash: "0x6ec5e8eaf4627331d77e3ee130a1c8507d78a9367c66634e3f1cec59258ec540",
		prefix: 42,
		name: "Sumi Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Staging Testnet",
		implName: "substrate-node",
		specName: "node",
		specVersion: "272",
		nativeToken: {
			id: "sumi-testnet-substrate-native-sumi"
		},
		tokens: [
			{
				id: "sumi-testnet-substrate-native-sumi"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://testnet1.sumi.xyz",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000290604005506",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "SUMI",
					decimals: 12,
					metadata: "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",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "100000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000290604005506",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "t-0-rn-testnet",
		isTestnet: true,
		sortIndex: 303,
		genesisHash: "0x569de72a10e8426ea1d3515dd473a57af15a38b6dda3b714bdd6968cf928e011",
		prefix: 42,
		name: "t0rn",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "t0rn",
		implName: "Circuit Collator",
		specName: "t0rn",
		specVersion: "109",
		nativeToken: {
			id: "t-0-rn-testnet-substrate-native-t0rn"
		},
		tokens: [
			{
				id: "t-0-rn-testnet-substrate-native-t0rn"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://ws.t0rn.io",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 3333,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "T0RN",
					decimals: 12,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e6365000018000005070039010000030800000008008d06102873705f72756e74696d651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e646564566563080454019106045300000400990601185665633c543e00009106083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964390101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e739506011c526561736f6e7300009506083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200009906000002910600081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402008d06040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000a190904005109",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000190904005109",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "tangle-testnet-rococo",
		isTestnet: true,
		sortIndex: 304,
		genesisHash: null,
		prefix: null,
		name: "Tangle",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 4006,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
		]
	},
	{
		id: "tangle-testnet-standalone",
		isTestnet: true,
		sortIndex: 305,
		genesisHash: null,
		prefix: null,
		name: "Tangle Alpha",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "ternoa-alphanet-testnet",
		isTestnet: true,
		sortIndex: 306,
		genesisHash: "0x18bcdb75a0bba577b084878db2dc2546eb21504eaad4b564bb7d47f9d02b6ace",
		prefix: 42,
		name: "Ternoa Alphanet",
		themeColor: "#ff8500",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/ternoa-alphanet-testnet.svg",
		chainName: "Ternoa Alphanet",
		implName: "alphanet",
		specName: "alphanet",
		specVersion: "15",
		nativeToken: {
			id: "ternoa-alphanet-testnet-substrate-native-caps"
		},
		tokens: [
			{
				id: "ternoa-alphanet-testnet-substrate-native-caps"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://alphanet.ternoa.com",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "CAPS",
					decimals: 18,
					metadata: "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",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "150000000000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e000095080400c908",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "ternoa-testnet",
		isTestnet: true,
		sortIndex: 307,
		genesisHash: null,
		prefix: null,
		name: "Ternoa Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "thebifrost-testnet",
		isTestnet: true,
		sortIndex: 308,
		genesisHash: "0x15b34a3b7443c73fa1f687cce2d8e5981f6a2eaad54809a6b6af28e83d2adaff",
		prefix: 42,
		name: "The Bifrost Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "BIFROST Testnet",
		implName: "bifrost-testnet",
		specName: "thebifrost-testnet",
		specVersion: "453",
		nativeToken: {
			id: "thebifrost-testnet-substrate-native-bfc"
		},
		tokens: [
			{
				id: "thebifrost-testnet-substrate-native-bfc"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://public-01.testnet.thebifrost.io/ws",
				isHealthy: true
			},
			{
				url: "wss://public-02.testnet.thebifrost.io/ws",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000110604004d06",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "BFC",
					decimals: 18,
					metadata: "0x6d6574610e3000081c6163636f756e742c4163636f756e7449643230000004000401205b75383b2032305d0000040000031400000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e63650000180000050700d101000003080000000800a9020c4c626f756e6465645f636f6c6c656374696f6e73407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401ad02045300000400b50201185665633c543e0000ad02083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964d10101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73b102011c526561736f6e730000b102083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000b502000002ad0200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200a902040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000a110604004d06",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "0",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000110604004d06",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "rococo-tinkernet-testnet",
		isTestnet: true,
		sortIndex: 309,
		genesisHash: null,
		prefix: null,
		name: "Tinkernet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2125,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
		]
	},
	{
		id: "laminar-testnet",
		isTestnet: true,
		sortIndex: 310,
		genesisHash: null,
		prefix: null,
		name: "Turbulence",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "rococo-turing-testnet",
		isTestnet: true,
		sortIndex: 311,
		genesisHash: "0xd54f0988402deb4548538626ce37e4a318441ea0529ca369400ebec4e04dfe4b",
		prefix: 51,
		name: "Turing Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Turing Staging",
		implName: "turing",
		specName: "turing",
		specVersion: "294",
		nativeToken: {
			id: "rococo-turing-testnet-substrate-native-tur"
		},
		tokens: [
			{
				id: "rococo-turing-testnet-substrate-native-tur"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://rpc.turing-staging.oak.tech",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2114,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000b9070400f907",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "TUR",
					decimals: 10,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e6365000018000005070088000003080000000800f102101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401f502045300000400fd0201185665633c543e0000f502083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c010869648801384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73f902011c526561736f6e730000f902083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000fd02000002f50200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200f102040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000ab9070400f907",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "100000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e1c000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503001000000505001800000507001d03000004080010002d03082c6f726d6c5f746f6b656e732c4163636f756e7444617461041c42616c616e63650118000c01106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e636500000418546f6b656e730118546f6b656e7304204163636f756e747301010802051d032d03c000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000018b8205468652062616c616e6365206f66206120746f6b656e207479706520756e64657220616e206163636f756e742e00fc204e4f54453a2049662074686520746f74616c2069732065766572207a65726f2c206465637265617365206163636f756e7420726566206163636f756e742e001901204e4f54453a2054686973206973206f6e6c79207573656420696e20746865206361736520746861742074686973206d6f64756c65206973207573656420746f2073746f7265282062616c616e6365732e000000000bb9070400f907",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "uniarts-testnet",
		isTestnet: true,
		sortIndex: 312,
		genesisHash: null,
		prefix: null,
		name: "UniArts Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "unique-testnet",
		isTestnet: true,
		sortIndex: 313,
		genesisHash: null,
		prefix: null,
		name: "Unique Testnet",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "rococo-unit-network-testnet",
		isTestnet: true,
		sortIndex: 314,
		genesisHash: null,
		prefix: null,
		name: "Unit",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://www.unitnode3.info:443",
				isHealthy: false
			}
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 4168,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
		]
	},
	{
		id: "unitv-testnet",
		isTestnet: true,
		sortIndex: 315,
		genesisHash: null,
		prefix: null,
		name: "Unit",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "rococo-virto-testnet",
		isTestnet: true,
		sortIndex: 316,
		genesisHash: null,
		prefix: null,
		name: "Virto",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 3003,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
		]
	},
	{
		id: "vodka-testnet",
		isTestnet: true,
		sortIndex: 317,
		genesisHash: null,
		prefix: null,
		name: "Vodka",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "rococo-watr-testnet",
		isTestnet: true,
		sortIndex: 318,
		genesisHash: "0xb53c620c41860278fa3068a5367c8eedceefce8a7c29237d830bc09a71737b5d",
		prefix: 19,
		name: "Watr Testnet",
		themeColor: "#f5f5f3",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/rococo-watr-testnet.svg",
		chainName: "Watr Network",
		implName: "watr-devnet",
		specName: "watr-devnet",
		specVersion: "1220",
		nativeToken: {
			id: "rococo-watr-testnet-substrate-native-watrd"
		},
		tokens: [
			{
				id: "rococo-watr-testnet-substrate-native-watrd"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://rpc.dev.watr.org",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
			{
				id: "688"
			}
		],
		parathreads: [
		],
		paraId: 2058,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "WATRD",
					decimals: 18,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507001101000003080000000800ed04101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401f104045300000400f90401185665633c543e0000f104083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964110101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73f504011c526561736f6e730000f504083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000f904000002f10400081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200ed04040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000aad060400f506",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "10000000000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000ad060400f506",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "web-3-games-testnet",
		isTestnet: true,
		sortIndex: 320,
		genesisHash: "0x74e94f7e899e688df0693e35d30d9e5f4163eded281980bf4977c60f750d788c",
		prefix: 42,
		name: "Web3Games",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Web3Games Development Testnet",
		implName: "web3games-node",
		specName: "web3games-node",
		specVersion: "2",
		nativeToken: {
			id: "web-3-games-testnet-substrate-native-w3g"
		},
		tokens: [
			{
				id: "web-3-games-testnet-substrate-native-w3g"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://devnet.web3games.org",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000510404009104",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "W3G",
					decimals: 18,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507009d010000030800000008001102102873705f72756e74696d651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e6465645665630804540115020453000004001d0201185665633c543e00001502083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c010869649d0101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e731902011c526561736f6e7300001902083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200001d02000002150200081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402001102040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e0000000005510404009104",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "0",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000510404009104",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "karura-testnet",
		isTestnet: true,
		sortIndex: 321,
		genesisHash: null,
		prefix: null,
		name: "Wendala",
		themeColor: "#f93d43",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/karura-testnet.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2005,
		relay: {
			id: "westend-testnet"
		},
		balanceMetadata: [
		]
	},
	{
		id: "westmint-testnet",
		isTestnet: true,
		sortIndex: 322,
		genesisHash: "0x67f9723393ef76214df0118c34bbbd3dbebc8ed46a10973a8c969d48fe7598c9",
		prefix: 42,
		name: "Westmint",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "Westmint",
		implName: "westmint",
		specName: "westmint",
		specVersion: "9435",
		nativeToken: {
			id: "westmint-testnet-substrate-native-wnd"
		},
		tokens: [
			{
				id: "westmint-testnet-substrate-native-wnd"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://westmint-rpc.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://westmint-rpc-tn.dwellir.com",
				isHealthy: true
			},
			{
				url: "wss://sys.ibp.network/westmint",
				isHealthy: true
			},
			{
				url: "wss://sys.dotters.network/westmint",
				isHealthy: true
			},
			{
				url: "wss://westmint-rpc.polkadot.io",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 1000,
		relay: {
			id: "westend-testnet"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "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",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "WND",
					decimals: 12,
					metadata: "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",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "1000000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000490604007506",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "whala-testnet",
		isTestnet: true,
		sortIndex: 323,
		genesisHash: null,
		prefix: null,
		name: "Whala",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2013,
		relay: {
			id: "westend-testnet"
		},
		balanceMetadata: [
		]
	},
	{
		id: "kilt-testnet-westend",
		isTestnet: true,
		sortIndex: 324,
		genesisHash: null,
		prefix: null,
		name: "Wilt",
		themeColor: "#f66741",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/kilt-testnet-westend.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2085,
		relay: {
			id: "westend-testnet"
		},
		balanceMetadata: [
		]
	},
	{
		id: "xsocial-testnet",
		isTestnet: true,
		sortIndex: 325,
		genesisHash: "0x1333ee260a234d3a246b85239e279bbdc7618db7188f2dd73f7322963fcd4d02",
		prefix: 42,
		name: "xSocial",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: "XSocial Testnet",
		implName: "subsocial-xsocial-testnet",
		specName: "xsocial",
		specVersion: "108",
		nativeToken: {
			id: "xsocial-testnet-substrate-native-sub"
		},
		tokens: [
			{
				id: "xsocial-testnet-substrate-native-sub"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://xsocial.subsocial.network",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000290304006103",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "SUB",
					decimals: 10,
					metadata: "0x6d6574610e30000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d657273100120526566436f756e7400012470726f766964657273100120526566436f756e7400012c73756666696369656e7473100120526566436f756e740001106461746114012c4163636f756e7444617461000010000005050014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507006501000003080000000800d101101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e64656456656308045401d501045300000400dd0101185665633c543e0000d501083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964650101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e73d901011c526561736f6e730000d901083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c00020000dd01000002d50100081853797374656d011853797374656d041c4163636f756e7401010402000c4101000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b730101040200d101040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e0000000005290304006103",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "100000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e0000290304006103",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "z-cloak-testnet",
		isTestnet: true,
		sortIndex: 326,
		genesisHash: null,
		prefix: null,
		name: "zCloak",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	},
	{
		id: "rococo-zeitgeist-testnet",
		isTestnet: true,
		sortIndex: 327,
		genesisHash: "0xb90cd3a37b4793c6494b78962986f4f6ed3ec2eda91a6b84fd8457d24f606b9c",
		prefix: 73,
		name: "Zeitgeist Battery Station",
		themeColor: "#ffffff",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/rococo-zeitgeist-testnet.svg",
		chainName: "Battery Station",
		implName: "zeitgeist",
		specName: "zeitgeist",
		specVersion: "46",
		nativeToken: {
			id: "rococo-zeitgeist-testnet-substrate-native-zbs"
		},
		tokens: [
			{
				id: "rococo-zeitgeist-testnet-substrate-native-zbs"
			}
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
			{
				url: "wss://bsr.zeitgeist.pm",
				isHealthy: true
			}
		],
		isHealthy: true,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: 2101,
		relay: {
			id: "rococo-testnet"
		},
		balanceMetadata: [
			{
				moduleType: "substrate-assets",
				metadata: {
					metadata: "0x6d6574610e0000250904006909",
					isTestnet: true,
					metadataVersion: 14
				}
			},
			{
				moduleType: "substrate-equilibrium",
				metadata: {
					metadata: null,
					isTestnet: true,
					metadataVersion: 0
				}
			},
			{
				moduleType: "substrate-native",
				metadata: {
					symbol: "ZBS",
					decimals: 10,
					metadata: "0x6d6574610e34000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503000c08306672616d655f73797374656d2c4163636f756e74496e666f0814496e64657801102c4163636f756e74446174610114001401146e6f6e6365100114496e646578000124636f6e73756d6572731c0120526566436f756e7400012470726f7669646572731c0120526566436f756e7400012c73756666696369656e74731c0120526566436f756e740001106461746114012c4163636f756e7444617461000010000005060014083c70616c6c65745f62616c616e6365732c4163636f756e7444617461041c42616c616e63650118001001106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500012c6d6973635f66726f7a656e18011c42616c616e63650001286665655f66726f7a656e18011c42616c616e636500001800000507001c000005050001010000030800000008009105101c73705f636f72651c626f756e646564407765616b5f626f756e6465645f766563385765616b426f756e6465645665630804540195050453000004009d0501185665633c543e00009505083c70616c6c65745f62616c616e6365732c42616c616e63654c6f636b041c42616c616e63650118000c01086964010101384c6f636b4964656e746966696572000118616d6f756e7418011c42616c616e636500011c726561736f6e739905011c526561736f6e7300009905083c70616c6c65745f62616c616e6365731c526561736f6e7300010c0c466565000000104d6973630001000c416c6c000200009d05000002950500081853797374656d011853797374656d041c4163636f756e7401010402000c510100000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000004e8205468652066756c6c206163636f756e7420696e666f726d6174696f6e20666f72206120706172746963756c6172206163636f756e742049442e00000000002042616c616e636573012042616c616e63657304144c6f636b7301010402009105040008b820416e79206c6971756964697479206c6f636b73206f6e20736f6d65206163636f756e742062616c616e6365732e2501204e4f54453a2053686f756c64206f6e6c79206265206163636573736564207768656e2073657474696e672c206368616e67696e6720616e642066726565696e672061206c6f636b2e000000000a250904006909",
					isTestnet: true,
					accountInfoType: 3,
					metadataVersion: 14,
					crowdloanPalletId: null,
					existentialDeposit: "50000000",
					nominationPoolsPalletId: null
				}
			},
			{
				moduleType: "substrate-orml",
				metadata: {
					symbols: [
					],
					decimals: [
					],
					isTestnet: true,
					stateKeys: {
					}
				}
			},
			{
				moduleType: "substrate-tokens",
				metadata: {
					metadata: "0x6d6574610e2c000c1c73705f636f72651863727970746f2c4163636f756e7449643332000004000401205b75383b2033325d0000040000032000000008000800000503001800000507001c0000050500e80000050400f40c507a65697467656973745f7072696d69746976657314617373657414417373657404084d49011801184843617465676f726963616c4f7574636f6d6508001801084d490000e8013443617465676f7279496e646578000000345363616c61724f7574636f6d6508001801084d490000f801385363616c6172506f736974696f6e00010050436f6d62696e61746f7269616c4f7574636f6d6500020024506f6f6c53686172650400fc01505365726465577261707065723c506f6f6c49643e0003000c5a746700040030466f726569676e417373657404001c010c75333200050000f80c507a65697467656973745f7072696d697469766573146173736574385363616c6172506f736974696f6e000108104c6f6e670000001453686f727400010000fc0c507a65697467656973745f7072696d6974697665733473657264655f7772617070657230536572646557726170706572040442011800040018010442000005070000040800f4001507082c6f726d6c5f746f6b656e732c4163636f756e7444617461041c42616c616e63650118000c01106672656518011c42616c616e6365000120726573657276656418011c42616c616e636500011866726f7a656e18011c42616c616e636500000418546f6b656e730118546f6b656e7304204163636f756e7473010108020505071507c000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000018b8205468652062616c616e6365206f66206120746f6b656e207479706520756e64657220616e206163636f756e742e00fc204e4f54453a2049662074686520746f74616c2069732065766572207a65726f2c206465637265617365206163636f756e7420726566206163636f756e742e001901204e4f54453a2054686973206973206f6e6c79207573656420696e20746865206361736520746861742074686973206d6f64756c65206973207573656420746f2073746f7265282062616c616e6365732e0000000029250904006909",
					isTestnet: true,
					metadataVersion: 14
				}
			}
		]
	},
	{
		id: "zero-testnet",
		isTestnet: true,
		sortIndex: 328,
		genesisHash: null,
		prefix: null,
		name: "Zero Alphaville",
		themeColor: "#f6921e",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/zero-testnet.svg",
		chainName: null,
		implName: null,
		specName: null,
		specVersion: null,
		nativeToken: null,
		tokens: [
		],
		account: "*25519",
		subscanUrl: null,
		chainspecQrUrl: null,
		latestMetadataQrUrl: null,
		isUnknownFeeToken: false,
		rpcs: [
		],
		isHealthy: false,
		evmNetworks: [
		],
		parathreads: [
		],
		paraId: null,
		relay: null,
		balanceMetadata: [
		]
	}
];

var initEvmNetworksResponse = [
	{
		id: "787",
		isTestnet: false,
		sortIndex: 6,
		name: "Acala",
		themeColor: "#e61059",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/acala.svg",
		nativeToken: {
			id: "787-evm-native-aca"
		},
		tokens: [
			{
				id: "787-evm-native-aca"
			}
		],
		explorerUrl: "https://blockscout.acala.network",
		rpcs: [
			{
				url: "https://eth-rpc-acala.aca-api.network",
				isHealthy: true
			},
			{
				url: "https://rpc.evm.acala.network",
				isHealthy: true
			}
		],
		isHealthy: true,
		substrateChain: {
			id: "acala"
		}
	},
	{
		id: "42161",
		isTestnet: false,
		sortIndex: 11,
		name: "Arbitrum",
		themeColor: "#2d374b",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/42161.svg",
		nativeToken: {
			id: "42161-evm-native-eth"
		},
		tokens: [
			{
				id: "42161-evm-native-eth"
			}
		],
		explorerUrl: "https://arbiscan.io/",
		rpcs: [
			{
				url: "https://arb1.arbitrum.io/rpc",
				isHealthy: true
			},
			{
				url: "https://rpc.ankr.com/arbitrum",
				isHealthy: true
			}
		],
		isHealthy: true,
		substrateChain: null
	},
	{
		id: "592",
		isTestnet: false,
		sortIndex: 17,
		name: "Astar",
		themeColor: "#03b0fb",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/astar.svg",
		nativeToken: {
			id: "592-evm-native-astr"
		},
		tokens: [
			{
				id: "592-evm-erc20-0x1fe622e91e54d6ad00b01917351ea6081426764a"
			},
			{
				id: "592-evm-erc20-0x3795c36e7d12a8c252a20c5a7b455f7c57b60283"
			},
			{
				id: "592-evm-erc20-0x4bf769b05e832fcdc9053fffbc78ca889acb5e1e"
			},
			{
				id: "592-evm-erc20-0x6a2d262d56735dba19dd70682b39f6be9a931d98"
			},
			{
				id: "592-evm-erc20-0x6de33698e9e9b787e09d3bd7771ef63557e148bb"
			},
			{
				id: "592-evm-erc20-0x75364d4f779d0bd0facd9a218c67f87dd9aff3b4"
			},
			{
				id: "592-evm-erc20-0x7756a83563f0f56937a6fdf668e7d9f387c0d199"
			},
			{
				id: "592-evm-erc20-0x7f27352d5f83db87a5a3e00f4b07cc2138d8ee52"
			},
			{
				id: "592-evm-erc20-0x81ecac0d6be0550a00ff064a4f9dd2400585fe9c"
			},
			{
				id: "592-evm-erc20-0xad543f18cff85c77e140e3e5e3c3392f6ba9d5ca"
			},
			{
				id: "592-evm-erc20-0xaeaaf0e2c81af264101b9129c00f4440ccf0f720"
			},
			{
				id: "592-evm-erc20-0xb361dad0cc1a03404b650a69d9a5adb5af8a531f"
			},
			{
				id: "592-evm-erc20-0xdd90e5e87a2081dcf0391920868ebc2ffb81a1af"
			},
			{
				id: "592-evm-erc20-0xfcde4a87b8b6fa58326bb462882f1778158b02f1"
			},
			{
				id: "592-evm-native-astr"
			}
		],
		explorerUrl: "https://blockscout.com/astar",
		rpcs: [
			{
				url: "https://evm.astar.network",
				isHealthy: true
			},
			{
				url: "https://astar-rpc.dwellir.com",
				isHealthy: true
			},
			{
				url: "https://astar.api.onfinality.io/public",
				isHealthy: true
			}
		],
		isHealthy: true,
		substrateChain: {
			id: "astar"
		}
	},
	{
		id: "56",
		isTestnet: false,
		sortIndex: 24,
		name: "Binance Smart Chain",
		themeColor: "#f3ba2f",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/56.svg",
		nativeToken: {
			id: "56-evm-native-bnb"
		},
		tokens: [
			{
				id: "56-evm-native-bnb"
			}
		],
		explorerUrl: "https://bscscan.com",
		rpcs: [
			{
				url: "https://rpc.ankr.com/bsc",
				isHealthy: true
			},
			{
				url: "https://bsc-dataseed2.binance.org",
				isHealthy: true
			},
			{
				url: "https://bsc-dataseed3.binance.org",
				isHealthy: true
			},
			{
				url: "https://bsc-dataseed4.binance.org",
				isHealthy: true
			}
		],
		isHealthy: true,
		substrateChain: null
	},
	{
		id: "46",
		isTestnet: false,
		sortIndex: 46,
		name: "Darwinia",
		themeColor: "#db378a",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/darwinia.svg",
		nativeToken: {
			id: "46-evm-native-ring"
		},
		tokens: [
			{
				id: "46-evm-native-ring"
			}
		],
		explorerUrl: "https://darwinia.subview.xyz",
		rpcs: [
			{
				url: "https://rpc.darwinia.network",
				isHealthy: true
			}
		],
		isHealthy: true,
		substrateChain: {
			id: "darwinia"
		}
	},
	{
		id: "2021",
		isTestnet: false,
		sortIndex: 52,
		name: "Edgeware",
		themeColor: "#ff3b80",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/edgeware.svg",
		nativeToken: {
			id: "2021-evm-native-edg"
		},
		tokens: [
			{
				id: "2021-evm-native-edg"
			}
		],
		explorerUrl: "https://edgscan.live",
		rpcs: [
			{
				url: "https://mainnet2.edgewa.re/evm",
				isHealthy: true
			},
			{
				url: "https://edgeware-evm.jelliedowl.net",
				isHealthy: true
			},
			{
				url: "https://mainnet3.edgewa.re/evm",
				isHealthy: true
			},
			{
				url: "https://mainnet4.edgewa.re/evm",
				isHealthy: true
			},
			{
				url: "https://mainnet5.edgewa.re/evm",
				isHealthy: false
			}
		],
		isHealthy: true,
		substrateChain: {
			id: "edgeware"
		}
	},
	{
		id: "1",
		isTestnet: false,
		sortIndex: 57,
		name: "Ethereum",
		themeColor: "#8a92b2",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/1.svg",
		nativeToken: {
			id: "1-evm-native-eth"
		},
		tokens: [
			{
				id: "1-evm-erc20-0x471ea49dd8e60e697f4cac262b5fafcc307506e4"
			},
			{
				id: "1-evm-erc20-0x67f6b5bc5670fd29bcc8af3d6633b2840aba2f30"
			},
			{
				id: "1-evm-erc20-0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48"
			},
			{
				id: "1-evm-erc20-0xc221b7e65ffc80de234bbb6667abdd46593d34f0"
			},
			{
				id: "1-evm-erc20-0xdac17f958d2ee523a2206206994597c13d831ec7"
			},
			{
				id: "1-evm-native-eth"
			}
		],
		explorerUrl: "https://etherscan.io",
		rpcs: [
			{
				url: "https://rpc.ankr.com/eth",
				isHealthy: true
			},
			{
				url: "https://eth.api.onfinality.io/public",
				isHealthy: true
			},
			{
				url: "https://eth.llamarpc.com",
				isHealthy: true
			}
		],
		isHealthy: true,
		substrateChain: null
	},
	{
		id: "100",
		isTestnet: false,
		sortIndex: 63,
		name: "Gnosis",
		themeColor: "#8e8e9e",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/100.svg",
		nativeToken: {
			id: "100-evm-native-xdai"
		},
		tokens: [
			{
				id: "100-evm-native-xdai"
			}
		],
		explorerUrl: "https://blockscout.com/xdai/mainnet/",
		rpcs: [
			{
				url: "https://rpc.ankr.com/gnosis",
				isHealthy: true
			},
			{
				url: "https://gnosis-mainnet.public.blastapi.io",
				isHealthy: true
			},
			{
				url: "https://rpc.gnosischain.com/",
				isHealthy: true
			}
		],
		isHealthy: true,
		substrateChain: null
	},
	{
		id: "1284",
		isTestnet: false,
		sortIndex: 99,
		name: "Moonbeam",
		themeColor: "#53cbc9",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/moonbeam.svg",
		nativeToken: {
			id: "1284-evm-native-glmr"
		},
		tokens: [
			{
				id: "1284-evm-erc20-0x65b09ef8c5a096c5fd3a80f1f7369e56eb932412"
			},
			{
				id: "1284-evm-erc20-0x818ec0a7fe18ff94269904fced6ae3dae6d6dc0b"
			},
			{
				id: "1284-evm-erc20-0x8f552a71efe5eefc207bf75485b356a0b3f01ec9"
			},
			{
				id: "1284-evm-erc20-0x931715fee2d06333043d11f658c8ce934ac61d0c"
			},
			{
				id: "1284-evm-erc20-0xffffffff1fcacbd218edc0eba20fc2308c778080"
			},
			{
				id: "1284-evm-erc20-0xffffffffa922fef94566104a6e5a35a4fcddaa9f"
			},
			{
				id: "1284-evm-native-glmr"
			}
		],
		explorerUrl: "https://moonbeam.moonscan.io/",
		rpcs: [
			{
				url: "https://rpc.api.moonbeam.network",
				isHealthy: true
			},
			{
				url: "https://moonbeam.api.onfinality.io/public",
				isHealthy: true
			},
			{
				url: "https://moonbeam-rpc.dwellir.com",
				isHealthy: true
			}
		],
		isHealthy: true,
		substrateChain: {
			id: "moonbeam"
		}
	},
	{
		id: "1285",
		isTestnet: false,
		sortIndex: 101,
		name: "Moonriver",
		themeColor: "#f2b705",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/moonriver.svg",
		nativeToken: {
			id: "1285-evm-native-movr"
		},
		tokens: [
			{
				id: "1285-evm-erc20-0xc2392dd3e3fed2c8ed9f7f0bdf6026fcd1348453"
			},
			{
				id: "1285-evm-erc20-0xe3f5a90f9cb311505cd691a46596599aa1a0ad7d"
			},
			{
				id: "1285-evm-erc20-0xffffffff893264794d9d57e1e0e21e0042af5a0a"
			},
			{
				id: "1285-evm-native-movr"
			}
		],
		explorerUrl: "https://moonriver.moonscan.io/",
		rpcs: [
			{
				url: "https://rpc.api.moonriver.moonbeam.network",
				isHealthy: true
			},
			{
				url: "https://moonriver.api.onfinality.io/public",
				isHealthy: true
			},
			{
				url: "https://moonriver-rpc.dwellir.com",
				isHealthy: true
			}
		],
		isHealthy: true,
		substrateChain: {
			id: "moonriver"
		}
	},
	{
		id: "137",
		isTestnet: false,
		sortIndex: 119,
		name: "Polygon",
		themeColor: "#8f5ae8",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/137.svg",
		nativeToken: {
			id: "137-evm-native-matic"
		},
		tokens: [
			{
				id: "137-evm-erc20-0x2791bca1f2de4661ed88a30c99a7a9449aa84174"
			},
			{
				id: "137-evm-erc20-0xc2132d05d31c914a87c6611c10748aeb04b58e8f"
			},
			{
				id: "137-evm-erc20-0xd6df932a45c0f255f85145f286ea0b292b21c90b"
			},
			{
				id: "137-evm-native-matic"
			}
		],
		explorerUrl: "https://polygonscan.com/",
		rpcs: [
			{
				url: "https://polygon-rpc.com/",
				isHealthy: true
			},
			{
				url: "https://rpc.ankr.com/polygon",
				isHealthy: true
			},
			{
				url: "https://polygon-mainnet.public.blastapi.io",
				isHealthy: true
			}
		],
		isHealthy: true,
		substrateChain: null
	},
	{
		id: "336",
		isTestnet: false,
		sortIndex: 128,
		name: "Shiden",
		themeColor: "#bba5e1",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/shiden-kusama.svg",
		nativeToken: {
			id: "336-evm-native-sdn"
		},
		tokens: [
			{
				id: "336-evm-native-sdn"
			}
		],
		explorerUrl: "https://blockscout.com/shiden",
		rpcs: [
			{
				url: "https://evm.shiden.astar.network",
				isHealthy: true
			},
			{
				url: "https://shiden.api.onfinality.io/public",
				isHealthy: true
			},
			{
				url: "https://shiden-rpc.dwellir.com",
				isHealthy: true
			}
		],
		isHealthy: true,
		substrateChain: {
			id: "shiden-kusama"
		}
	},
	{
		id: "5",
		isTestnet: true,
		sortIndex: 217,
		name: "Goerli",
		themeColor: "#8a92b2",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/5.svg",
		nativeToken: {
			id: "5-evm-native-eth"
		},
		tokens: [
			{
				id: "5-evm-native-eth"
			}
		],
		explorerUrl: "https://goerli.etherscan.io",
		rpcs: [
			{
				url: "https://rpc.ankr.com/eth_goerli",
				isHealthy: true
			}
		],
		isHealthy: true,
		substrateChain: null
	},
	{
		id: "1287",
		isTestnet: true,
		sortIndex: 251,
		name: "Moonbase Alpha",
		themeColor: "#4cb1b3",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/moonbase-alpha-testnet.svg",
		nativeToken: {
			id: "1287-evm-native-dev"
		},
		tokens: [
			{
				id: "1287-evm-native-dev"
			}
		],
		explorerUrl: "https://moonbase.moonscan.io/",
		rpcs: [
			{
				url: "https://rpc.api.moonbase.moonbeam.network",
				isHealthy: true
			},
			{
				url: "https://moonbeam-alpha.api.onfinality.io/public",
				isHealthy: true
			}
		],
		isHealthy: true,
		substrateChain: {
			id: "moonbase-alpha-testnet"
		}
	},
	{
		id: "11155111",
		isTestnet: true,
		sortIndex: 280,
		name: "Sepolia",
		themeColor: "#8a92b2",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/11155111.svg",
		nativeToken: {
			id: "11155111-evm-native-eth"
		},
		tokens: [
			{
				id: "11155111-evm-native-eth"
			}
		],
		explorerUrl: "https://sepolia.etherscan.io",
		rpcs: [
			{
				url: "https://rpc.sepolia.org",
				isHealthy: true
			}
		],
		isHealthy: true,
		substrateChain: null
	},
	{
		id: "81",
		isTestnet: true,
		sortIndex: 283,
		name: "Shibuya",
		themeColor: "#bba5e1",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/shibuya-testnet.svg",
		nativeToken: {
			id: "81-evm-native-sby"
		},
		tokens: [
			{
				id: "81-evm-native-sby"
			}
		],
		explorerUrl: "https://blockscout.com/shibuya",
		rpcs: [
			{
				url: "https://evm.shibuya.astar.network",
				isHealthy: true
			}
		],
		isHealthy: true,
		substrateChain: {
			id: "shibuya-testnet"
		}
	},
	{
		id: "688",
		isTestnet: true,
		sortIndex: 319,
		name: "Watr Testnet",
		themeColor: "#f5f5f3",
		logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/rococo-watr-testnet.svg",
		nativeToken: {
			id: "688-evm-native-watrd"
		},
		tokens: [
			{
				id: "688-evm-native-watrd"
			}
		],
		explorerUrl: "https://explorer.watr.org/",
		rpcs: [
			{
				url: "https://rpc.dev.watr.org",
				isHealthy: true
			}
		],
		isHealthy: true,
		substrateChain: {
			id: "rococo-watr-testnet"
		}
	}
];

var initTokensResponse = [
	{
		id: "100-evm-native-xdai",
		data: {
			id: "100-evm-native-xdai",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/100.svg",
			type: "evm-native",
			symbol: "xDAI",
			decimals: 18,
			isTestnet: false,
			evmNetwork: {
				id: "100"
			},
			themeColor: "#8e8e9e",
			coingeckoId: "xdai"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
			{
				id: "100"
			}
		]
	},
	{
		id: "11155111-evm-native-eth",
		data: {
			id: "11155111-evm-native-eth",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/eth.svg",
			type: "evm-native",
			symbol: "ETH",
			decimals: 18,
			isTestnet: true,
			evmNetwork: {
				id: "11155111"
			},
			themeColor: "#8a92b2"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
			{
				id: "11155111"
			}
		]
	},
	{
		id: "1284-evm-erc20-0x65b09ef8c5a096c5fd3a80f1f7369e56eb932412",
		data: {
			id: "1284-evm-erc20-0x65b09ef8c5a096c5fd3a80f1f7369e56eb932412",
			logo: "https://assets.coingecko.com/coins/images/18547/large/200_MB_DarkVersion_logo.png?1682406216",
			type: "evm-erc20",
			symbol: "BEANS",
			decimals: 18,
			isTestnet: false,
			evmNetwork: {
				id: "1284"
			},
			themeColor: "#ba649e",
			coingeckoId: "moonbeans",
			contractAddress: "0x65b09ef8c5A096C5Fd3A80f1F7369E56eB932412"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "1284-evm-erc20-0x818ec0a7fe18ff94269904fced6ae3dae6d6dc0b",
		data: {
			id: "1284-evm-erc20-0x818ec0a7fe18ff94269904fced6ae3dae6d6dc0b",
			logo: "https://assets.coingecko.com/coins/images/6319/large/USD_Coin_icon.png?1547042389",
			type: "evm-erc20",
			symbol: "multiUSDC",
			decimals: 6,
			isTestnet: false,
			evmNetwork: {
				id: "1284"
			},
			themeColor: "#2775ca",
			coingeckoId: "usd-coin",
			contractAddress: "0x818ec0a7fe18ff94269904fced6ae3dae6d6dc0b"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "1284-evm-erc20-0x8f552a71efe5eefc207bf75485b356a0b3f01ec9",
		data: {
			id: "1284-evm-erc20-0x8f552a71efe5eefc207bf75485b356a0b3f01ec9",
			logo: "https://assets.coingecko.com/coins/images/6319/large/USD_Coin_icon.png?1547042389",
			type: "evm-erc20",
			symbol: "madUSDC",
			decimals: 6,
			isTestnet: false,
			evmNetwork: {
				id: "1284"
			},
			themeColor: "#2775ca",
			coingeckoId: "usd-coin",
			contractAddress: "0x8f552a71EFE5eeFc207Bf75485b356A0b3f01eC9"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "1284-evm-erc20-0x931715fee2d06333043d11f658c8ce934ac61d0c",
		data: {
			id: "1284-evm-erc20-0x931715fee2d06333043d11f658c8ce934ac61d0c",
			logo: "https://assets.coingecko.com/coins/images/6319/large/USD_Coin_icon.png?1547042389",
			type: "evm-erc20",
			symbol: "whUSDC",
			decimals: 6,
			isTestnet: false,
			evmNetwork: {
				id: "1284"
			},
			themeColor: "#2775ca",
			coingeckoId: "usd-coin",
			contractAddress: "0x931715fee2d06333043d11f658c8ce934ac61d0c"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "1284-evm-erc20-0xffffffff1fcacbd218edc0eba20fc2308c778080",
		data: {
			id: "1284-evm-erc20-0xffffffff1fcacbd218edc0eba20fc2308c778080",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/xcdot.svg",
			type: "evm-erc20",
			symbol: "xcDOT",
			decimals: 10,
			isTestnet: false,
			evmNetwork: {
				id: "1284"
			},
			themeColor: "#e6007a",
			coingeckoId: "polkadot",
			contractAddress: "0xFfFFfFff1FcaCBd218EDc0EbA20Fc2308C778080"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "1284-evm-erc20-0xffffffffa922fef94566104a6e5a35a4fcddaa9f",
		data: {
			id: "1284-evm-erc20-0xffffffffa922fef94566104a6e5a35a4fcddaa9f",
			logo: "https://assets.coingecko.com/coins/images/20634/large/upOKBONH_400x400.jpg?1647420536",
			type: "evm-erc20",
			symbol: "xcACA",
			decimals: 12,
			isTestnet: false,
			evmNetwork: {
				id: "1284"
			},
			themeColor: "#fa413f",
			coingeckoId: "acala",
			contractAddress: "0xffffFFffa922Fef94566104a6e5A35a4fCDDAA9f"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "1284-evm-native-glmr",
		data: {
			id: "1284-evm-native-glmr",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/moonbeam.svg",
			type: "evm-native",
			symbol: "GLMR",
			decimals: 18,
			mirrorOf: "moonbeam-substrate-native-glmr",
			isTestnet: false,
			evmNetwork: {
				id: "1284"
			},
			themeColor: "#53cbc9",
			coingeckoId: "moonbeam"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
			{
				id: "1284"
			}
		]
	},
	{
		id: "1285-evm-erc20-0xc2392dd3e3fed2c8ed9f7f0bdf6026fcd1348453",
		data: {
			id: "1285-evm-erc20-0xc2392dd3e3fed2c8ed9f7f0bdf6026fcd1348453",
			logo: "https://assets.coingecko.com/coins/images/18547/large/200_MB_DarkVersion_logo.png?1682406216",
			type: "evm-erc20",
			symbol: "BEANS",
			decimals: 18,
			isTestnet: false,
			evmNetwork: {
				id: "1285"
			},
			themeColor: "#ba649e",
			coingeckoId: "moonbeans",
			contractAddress: "0xC2392DD3e3fED2c8Ed9f7f0bDf6026fcd1348453"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "1285-evm-erc20-0xe3f5a90f9cb311505cd691a46596599aa1a0ad7d",
		data: {
			id: "1285-evm-erc20-0xe3f5a90f9cb311505cd691a46596599aa1a0ad7d",
			logo: "https://assets.coingecko.com/coins/images/6319/large/USD_Coin_icon.png?1547042389",
			type: "evm-erc20",
			symbol: "USDC",
			decimals: 6,
			isTestnet: false,
			evmNetwork: {
				id: "1285"
			},
			themeColor: "#2775ca",
			coingeckoId: "usd-coin",
			contractAddress: "0xE3F5a90F9cb311505cd691a46596599aA1A0AD7D"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "1285-evm-erc20-0xffffffff893264794d9d57e1e0e21e0042af5a0a",
		data: {
			id: "1285-evm-erc20-0xffffffff893264794d9d57e1e0e21e0042af5a0a",
			logo: "https://assets.coingecko.com/coins/images/18656/large/download_%281%29_%281%29.png?1632865271",
			type: "evm-erc20",
			symbol: "xcRMRK",
			decimals: 10,
			isTestnet: false,
			evmNetwork: {
				id: "1285"
			},
			themeColor: "#3c2a77",
			coingeckoId: "rmrk",
			contractAddress: "0xffffffFF893264794d9d57E1E0E21E0042aF5A0A"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "1285-evm-native-movr",
		data: {
			id: "1285-evm-native-movr",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/moonriver.svg",
			type: "evm-native",
			symbol: "MOVR",
			decimals: 18,
			mirrorOf: "moonriver-substrate-native-movr",
			isTestnet: false,
			evmNetwork: {
				id: "1285"
			},
			themeColor: "#f2b705",
			coingeckoId: "moonriver"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
			{
				id: "1285"
			}
		]
	},
	{
		id: "1287-evm-native-dev",
		data: {
			id: "1287-evm-native-dev",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/moonbase-alpha-testnet.svg",
			type: "evm-native",
			symbol: "DEV",
			decimals: 18,
			mirrorOf: "moonbase-alpha-testnet-substrate-native-dev",
			isTestnet: true,
			evmNetwork: {
				id: "1287"
			},
			themeColor: "#4cb1b3"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
			{
				id: "1287"
			}
		]
	},
	{
		id: "137-evm-erc20-0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
		data: {
			id: "137-evm-erc20-0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
			logo: "https://assets.coingecko.com/coins/images/6319/large/USD_Coin_icon.png?1547042389",
			type: "evm-erc20",
			symbol: "USDC",
			decimals: 6,
			isTestnet: false,
			evmNetwork: {
				id: "137"
			},
			themeColor: "#2775ca",
			coingeckoId: "usd-coin",
			contractAddress: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "137-evm-erc20-0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
		data: {
			id: "137-evm-erc20-0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/usdt.svg",
			type: "evm-erc20",
			symbol: "USDT",
			decimals: 6,
			isTestnet: false,
			evmNetwork: {
				id: "137"
			},
			themeColor: "#53ae94",
			coingeckoId: "tether",
			contractAddress: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "137-evm-erc20-0xd6df932a45c0f255f85145f286ea0b292b21c90b",
		data: {
			id: "137-evm-erc20-0xd6df932a45c0f255f85145f286ea0b292b21c90b",
			logo: "https://assets.coingecko.com/coins/images/12645/large/AAVE.png?1601374110",
			type: "evm-erc20",
			symbol: "AAVE",
			decimals: 18,
			isTestnet: false,
			evmNetwork: {
				id: "137"
			},
			themeColor: "#8d70aa",
			coingeckoId: "aave",
			contractAddress: "0xD6DF932A45C0f255f85145f286eA0b292B21C90B"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "137-evm-native-matic",
		data: {
			id: "137-evm-native-matic",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/137.svg",
			type: "evm-native",
			symbol: "MATIC",
			decimals: 18,
			isTestnet: false,
			evmNetwork: {
				id: "137"
			},
			themeColor: "#8f5ae8",
			coingeckoId: "matic-network"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
			{
				id: "137"
			}
		]
	},
	{
		id: "1-evm-erc20-0x471ea49dd8e60e697f4cac262b5fafcc307506e4",
		data: {
			id: "1-evm-erc20-0x471ea49dd8e60e697f4cac262b5fafcc307506e4",
			logo: "https://assets.coingecko.com/coins/images/18656/large/download_%281%29_%281%29.png?1632865271",
			type: "evm-erc20",
			symbol: "xcRMRK",
			decimals: 10,
			isTestnet: false,
			evmNetwork: {
				id: "1"
			},
			themeColor: "#3c2a77",
			coingeckoId: "rmrk",
			contractAddress: "0x471Ea49dd8E60E697f4cac262b5fafCc307506e4"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "1-evm-erc20-0x67f6b5bc5670fd29bcc8af3d6633b2840aba2f30",
		data: {
			id: "1-evm-erc20-0x67f6b5bc5670fd29bcc8af3d6633b2840aba2f30",
			logo: "https://assets.coingecko.com/coins/images/22617/large/astr.png?1642314057",
			type: "evm-erc20",
			symbol: "ASTAR",
			decimals: 18,
			isTestnet: false,
			evmNetwork: {
				id: "1"
			},
			themeColor: "#0089f6",
			coingeckoId: "astar",
			contractAddress: "0x67f6b5bc5670fd29bcc8af3d6633b2840aba2f30"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "1-evm-erc20-0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
		data: {
			id: "1-evm-erc20-0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
			logo: "https://assets.coingecko.com/coins/images/6319/large/USD_Coin_icon.png?1547042389",
			type: "evm-erc20",
			symbol: "USDC",
			decimals: 6,
			isTestnet: false,
			evmNetwork: {
				id: "1"
			},
			themeColor: "#2775ca",
			coingeckoId: "usd-coin",
			contractAddress: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "1-evm-erc20-0xc221b7e65ffc80de234bbb6667abdd46593d34f0",
		data: {
			id: "1-evm-erc20-0xc221b7e65ffc80de234bbb6667abdd46593d34f0",
			logo: "https://assets.coingecko.com/coins/images/17106/large/WCFG.jpg?1626266462",
			type: "evm-erc20",
			symbol: "WCFG",
			decimals: 18,
			isTestnet: false,
			evmNetwork: {
				id: "1"
			},
			themeColor: "#ffffff",
			coingeckoId: "wrapped-centrifuge",
			contractAddress: "0xc221b7e65ffc80de234bbb6667abdd46593d34f0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "1-evm-erc20-0xdac17f958d2ee523a2206206994597c13d831ec7",
		data: {
			id: "1-evm-erc20-0xdac17f958d2ee523a2206206994597c13d831ec7",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/usdt.svg",
			type: "evm-erc20",
			symbol: "USDT",
			decimals: 6,
			isTestnet: false,
			evmNetwork: {
				id: "1"
			},
			themeColor: "#53ae94",
			coingeckoId: "tether",
			contractAddress: "0xdac17f958d2ee523a2206206994597c13d831ec7"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "1-evm-native-eth",
		data: {
			id: "1-evm-native-eth",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/eth.svg",
			type: "evm-native",
			symbol: "ETH",
			decimals: 18,
			isTestnet: false,
			evmNetwork: {
				id: "1"
			},
			themeColor: "#8a92b2",
			coingeckoId: "ethereum"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
			{
				id: "1"
			}
		]
	},
	{
		id: "2021-evm-native-edg",
		data: {
			id: "2021-evm-native-edg",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/edgeware.svg",
			type: "evm-native",
			symbol: "EDG",
			decimals: 18,
			isTestnet: false,
			evmNetwork: {
				id: "2021"
			},
			themeColor: "#ff3b80",
			coingeckoId: "edgeware"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
			{
				id: "2021"
			}
		]
	},
	{
		id: "336-evm-native-sdn",
		data: {
			id: "336-evm-native-sdn",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/shiden-kusama.svg",
			type: "evm-native",
			symbol: "SDN",
			decimals: 18,
			isTestnet: false,
			evmNetwork: {
				id: "336"
			},
			themeColor: "#bba5e1",
			coingeckoId: "shiden"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
			{
				id: "336"
			}
		]
	},
	{
		id: "3-dpass-substrate-native-p3d",
		data: {
			id: "3-dpass-substrate-native-p3d",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "3-dpass"
			},
			symbol: "P3D",
			decimals: 12,
			isTestnet: false,
			themeColor: "#ffffff",
			existentialDeposit: "1"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "3-dpass"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "3-dpass-testnet-substrate-native-p3dt",
		data: {
			id: "3-dpass-testnet-substrate-native-p3dt",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "3-dpass-testnet"
			},
			symbol: "P3Dt",
			decimals: 12,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "1"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "3-dpass-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "42161-evm-native-eth",
		data: {
			id: "42161-evm-native-eth",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/eth.svg",
			type: "evm-native",
			symbol: "ETH",
			decimals: 18,
			isTestnet: false,
			evmNetwork: {
				id: "42161"
			},
			themeColor: "#8a92b2",
			coingeckoId: "ethereum"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
			{
				id: "42161"
			}
		]
	},
	{
		id: "46-evm-native-ring",
		data: {
			id: "46-evm-native-ring",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ring.svg",
			type: "evm-native",
			symbol: "RING",
			decimals: 18,
			mirrorOf: "darwinia-substrate-native-ring",
			isTestnet: false,
			evmNetwork: {
				id: "46"
			},
			themeColor: "#eef1f7",
			coingeckoId: "darwinia-network-native-token"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
			{
				id: "46"
			}
		]
	},
	{
		id: "56-evm-native-bnb",
		data: {
			id: "56-evm-native-bnb",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/56.svg",
			type: "evm-native",
			symbol: "BNB",
			decimals: 18,
			isTestnet: false,
			evmNetwork: {
				id: "56"
			},
			themeColor: "#f3ba2f",
			coingeckoId: "binancecoin"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
			{
				id: "56"
			}
		]
	},
	{
		id: "592-evm-erc20-0x1fe622e91e54d6ad00b01917351ea6081426764a",
		data: {
			id: "592-evm-erc20-0x1fe622e91e54d6ad00b01917351ea6081426764a",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/astar.svg",
			type: "evm-erc20",
			symbol: "PKEX",
			decimals: 18,
			isTestnet: false,
			evmNetwork: {
				id: "592"
			},
			themeColor: "#03b0fb",
			coingeckoId: "polkaex",
			contractAddress: "0x1fE622E91e54D6AD00B01917351Ea6081426764A"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "592-evm-erc20-0x3795c36e7d12a8c252a20c5a7b455f7c57b60283",
		data: {
			id: "592-evm-erc20-0x3795c36e7d12a8c252a20c5a7b455f7c57b60283",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/usdt.svg",
			type: "evm-erc20",
			symbol: "USDT",
			decimals: 6,
			isTestnet: false,
			evmNetwork: {
				id: "592"
			},
			themeColor: "#53ae94",
			coingeckoId: "tether",
			contractAddress: "0x3795C36e7D12A8c252A20C5a7B455f7c57b60283"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "592-evm-erc20-0x4bf769b05e832fcdc9053fffbc78ca889acb5e1e",
		data: {
			id: "592-evm-erc20-0x4bf769b05e832fcdc9053fffbc78ca889acb5e1e",
			logo: "https://assets.coingecko.com/coins/images/9576/large/BUSD.png?1568947766",
			type: "evm-erc20",
			symbol: "BUSD",
			decimals: 18,
			isTestnet: false,
			evmNetwork: {
				id: "592"
			},
			themeColor: "#f0b90b",
			coingeckoId: "binance-usd",
			contractAddress: "0x4Bf769b05E832FCdc9053fFFBC78Ca889aCb5E1E"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "592-evm-erc20-0x6a2d262d56735dba19dd70682b39f6be9a931d98",
		data: {
			id: "592-evm-erc20-0x6a2d262d56735dba19dd70682b39f6be9a931d98",
			logo: "https://assets.coingecko.com/coins/images/6319/large/USD_Coin_icon.png?1547042389",
			type: "evm-erc20",
			symbol: "USDC",
			decimals: 6,
			isTestnet: false,
			evmNetwork: {
				id: "592"
			},
			themeColor: "#2775ca",
			coingeckoId: "usd-coin",
			contractAddress: "0x6a2d262D56735DbA19Dd70682B39F6bE9a931D98"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "592-evm-erc20-0x6de33698e9e9b787e09d3bd7771ef63557e148bb",
		data: {
			id: "592-evm-erc20-0x6de33698e9e9b787e09d3bd7771ef63557e148bb",
			logo: "https://assets.coingecko.com/coins/images/9956/large/Badge_Dai.png?1687143508",
			type: "evm-erc20",
			symbol: "DAI",
			decimals: 18,
			isTestnet: false,
			evmNetwork: {
				id: "592"
			},
			themeColor: "#fab222",
			coingeckoId: "dai",
			contractAddress: "0x6De33698e9e9b787e09d3Bd7771ef63557E148bb"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "592-evm-erc20-0x75364d4f779d0bd0facd9a218c67f87dd9aff3b4",
		data: {
			id: "592-evm-erc20-0x75364d4f779d0bd0facd9a218c67f87dd9aff3b4",
			logo: "https://assets.coingecko.com/coins/images/18027/large/tFOtjrr3_400x400.png?1630291767",
			type: "evm-erc20",
			symbol: "SDN",
			decimals: 18,
			isTestnet: false,
			evmNetwork: {
				id: "592"
			},
			themeColor: "#744fb7",
			coingeckoId: "shiden",
			contractAddress: "0x75364D4F779d0Bd0facD9a218c67f87dD9Aff3b4"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "592-evm-erc20-0x7756a83563f0f56937a6fdf668e7d9f387c0d199",
		data: {
			id: "592-evm-erc20-0x7756a83563f0f56937a6fdf668e7d9f387c0d199",
			logo: "https://assets.coingecko.com/coins/images/12124/large/Curve.png?1597369484",
			type: "evm-erc20",
			symbol: "CRV",
			decimals: 18,
			isTestnet: false,
			evmNetwork: {
				id: "592"
			},
			themeColor: "#50ffa7",
			coingeckoId: "curve-dao-token",
			contractAddress: "0x7756a83563f0f56937a6fdf668e7d9f387c0d199"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "592-evm-erc20-0x7f27352d5f83db87a5a3e00f4b07cc2138d8ee52",
		data: {
			id: "592-evm-erc20-0x7f27352d5f83db87a5a3e00f4b07cc2138d8ee52",
			logo: "https://assets.coingecko.com/coins/images/825/large/bnb-icon2_2x.png?1644979850",
			type: "evm-erc20",
			symbol: "BNB",
			decimals: 18,
			isTestnet: false,
			evmNetwork: {
				id: "592"
			},
			themeColor: "#f0b90b",
			coingeckoId: "binancecoin",
			contractAddress: "0x7f27352D5F83Db87a5A3E00f4B07Cc2138D8ee52"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "592-evm-erc20-0x81ecac0d6be0550a00ff064a4f9dd2400585fe9c",
		data: {
			id: "592-evm-erc20-0x81ecac0d6be0550a00ff064a4f9dd2400585fe9c",
			logo: "https://assets.coingecko.com/coins/images/2518/large/weth.png?1628852295",
			type: "evm-erc20",
			symbol: "WETH",
			decimals: 18,
			isTestnet: false,
			evmNetwork: {
				id: "592"
			},
			themeColor: "#ffffff",
			coingeckoId: "weth",
			contractAddress: "0x81ECac0D6Be0550A00FF064a4f9dd2400585FE9c"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "592-evm-erc20-0xad543f18cff85c77e140e3e5e3c3392f6ba9d5ca",
		data: {
			id: "592-evm-erc20-0xad543f18cff85c77e140e3e5e3c3392f6ba9d5ca",
			logo: "https://assets.coingecko.com/coins/images/7598/large/wrapped_bitcoin_wbtc.png?1548822744",
			type: "evm-erc20",
			symbol: "WBTC",
			decimals: 8,
			isTestnet: false,
			evmNetwork: {
				id: "592"
			},
			themeColor: "#282038",
			coingeckoId: "wrapped-bitcoin",
			contractAddress: "0xad543f18cff85c77e140e3e5e3c3392f6ba9d5ca"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "592-evm-erc20-0xaeaaf0e2c81af264101b9129c00f4440ccf0f720",
		data: {
			id: "592-evm-erc20-0xaeaaf0e2c81af264101b9129c00f4440ccf0f720",
			logo: "https://assets.coingecko.com/coins/images/22617/large/astr.png?1642314057",
			type: "evm-erc20",
			symbol: "WASTAR",
			decimals: 18,
			isTestnet: false,
			evmNetwork: {
				id: "592"
			},
			themeColor: "#0089f6",
			coingeckoId: "astar",
			contractAddress: "0xAeaaf0e2c81Af264101B9129C00F4440cCF0F720"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "592-evm-erc20-0xb361dad0cc1a03404b650a69d9a5adb5af8a531f",
		data: {
			id: "592-evm-erc20-0xb361dad0cc1a03404b650a69d9a5adb5af8a531f",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/astar.svg",
			type: "evm-erc20",
			symbol: "ESW",
			decimals: 18,
			isTestnet: false,
			evmNetwork: {
				id: "592"
			},
			themeColor: "#03b0fb",
			contractAddress: "0xb361dad0cc1a03404b650a69d9a5adb5af8a531f"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "592-evm-erc20-0xdd90e5e87a2081dcf0391920868ebc2ffb81a1af",
		data: {
			id: "592-evm-erc20-0xdd90e5e87a2081dcf0391920868ebc2ffb81a1af",
			logo: "https://assets.coingecko.com/coins/images/4713/large/matic-token-icon.png?1624446912",
			type: "evm-erc20",
			symbol: "MATIC",
			decimals: 18,
			isTestnet: false,
			evmNetwork: {
				id: "592"
			},
			themeColor: "#8247e5",
			coingeckoId: "matic-network",
			contractAddress: "0xdd90E5E87A2081Dcf0391920868eBc2FFB81a1aF"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "592-evm-erc20-0xfcde4a87b8b6fa58326bb462882f1778158b02f1",
		data: {
			id: "592-evm-erc20-0xfcde4a87b8b6fa58326bb462882f1778158b02f1",
			logo: "https://assets.coingecko.com/coins/images/12645/large/AAVE.png?1601374110",
			type: "evm-erc20",
			symbol: "AAVE",
			decimals: 18,
			isTestnet: false,
			evmNetwork: {
				id: "592"
			},
			themeColor: "#8d70aa",
			coingeckoId: "aave",
			contractAddress: "0xfcde4a87b8b6fa58326bb462882f1778158b02f1"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "592-evm-native-astr",
		data: {
			id: "592-evm-native-astr",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/astar.svg",
			type: "evm-native",
			symbol: "ASTR",
			decimals: 18,
			isTestnet: false,
			evmNetwork: {
				id: "592"
			},
			themeColor: "#03b0fb",
			coingeckoId: "astar"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
			{
				id: "592"
			}
		]
	},
	{
		id: "5-evm-native-eth",
		data: {
			id: "5-evm-native-eth",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/eth.svg",
			type: "evm-native",
			symbol: "ETH",
			decimals: 18,
			isTestnet: true,
			evmNetwork: {
				id: "5"
			},
			themeColor: "#8a92b2",
			coingeckoId: "goerli-eth"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
			{
				id: "5"
			}
		]
	},
	{
		id: "688-evm-native-watrd",
		data: {
			id: "688-evm-native-watrd",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/rococo-watr-testnet.svg",
			type: "evm-native",
			symbol: "WATRD",
			decimals: 18,
			isTestnet: true,
			evmNetwork: {
				id: "688"
			},
			themeColor: "#f5f5f3"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
			{
				id: "688"
			}
		]
	},
	{
		id: "787-evm-native-aca",
		data: {
			id: "787-evm-native-aca",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/aca.svg",
			type: "evm-native",
			symbol: "ACA",
			decimals: 18,
			mirrorOf: "acala-substrate-native-aca",
			isTestnet: false,
			evmNetwork: {
				id: "787"
			},
			themeColor: "#e61059",
			coingeckoId: "acala"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
			{
				id: "787"
			}
		]
	},
	{
		id: "81-evm-native-sby",
		data: {
			id: "81-evm-native-sby",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/shibuya-testnet.svg",
			type: "evm-native",
			symbol: "SBY",
			decimals: 18,
			isTestnet: true,
			evmNetwork: {
				id: "81"
			},
			themeColor: "#bba5e1"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
			{
				id: "81"
			}
		]
	},
	{
		id: "acala-substrate-native-aca",
		data: {
			id: "acala-substrate-native-aca",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/aca.svg",
			type: "substrate-native",
			chain: {
				id: "acala"
			},
			symbol: "ACA",
			decimals: 12,
			isTestnet: false,
			themeColor: "#e61059",
			coingeckoId: "acala",
			existentialDeposit: "100000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "acala"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "acala-substrate-tokens-ape",
		data: {
			id: "acala-substrate-tokens-ape",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/acala.svg",
			type: "substrate-tokens",
			chain: {
				id: "acala"
			},
			symbol: "APE",
			decimals: 18,
			isTestnet: false,
			onChainId: "{\"Erc20\":\"0xf4c723e61709d90f89939c1852f516e373d418a8\"}",
			themeColor: "#e61059",
			existentialDeposit: "3000000000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "acala-substrate-tokens-astr",
		data: {
			id: "acala-substrate-tokens-astr",
			logo: "https://assets.coingecko.com/coins/images/22617/large/astr.png?1642314057",
			type: "substrate-tokens",
			chain: {
				id: "acala"
			},
			symbol: "ASTR",
			decimals: 18,
			isTestnet: false,
			onChainId: "{\"ForeignAsset\":2}",
			themeColor: "#0089f6",
			coingeckoId: "astar",
			existentialDeposit: "100000000000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "acala-substrate-tokens-ausd",
		data: {
			id: "acala-substrate-tokens-ausd",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ausd.svg",
			type: "substrate-tokens",
			chain: {
				id: "acala"
			},
			symbol: "aUSD",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"Token\":\"AUSD\"}",
			themeColor: "#e40c5b",
			coingeckoId: "acala-dollar",
			existentialDeposit: "100000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "acala-substrate-tokens-dai",
		data: {
			id: "acala-substrate-tokens-dai",
			logo: "https://assets.coingecko.com/coins/images/9956/large/Badge_Dai.png?1687143508",
			type: "substrate-tokens",
			chain: {
				id: "acala"
			},
			symbol: "DAI",
			decimals: 18,
			isTestnet: false,
			onChainId: "{\"Erc20\":\"0x54a37a01cd75b616d63e0ab665bffdb0143c52ae\"}",
			themeColor: "#fab222",
			coingeckoId: "dai",
			existentialDeposit: "10000000000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "acala-substrate-tokens-dot",
		data: {
			id: "acala-substrate-tokens-dot",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/dot.svg",
			type: "substrate-tokens",
			chain: {
				id: "acala"
			},
			symbol: "DOT",
			decimals: 10,
			isTestnet: false,
			onChainId: "{\"Token\":\"DOT\"}",
			themeColor: "#e6007a",
			coingeckoId: "polkadot",
			existentialDeposit: "100000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "acala-substrate-tokens-eq",
		data: {
			id: "acala-substrate-tokens-eq",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/eq.svg",
			type: "substrate-tokens",
			chain: {
				id: "acala"
			},
			symbol: "EQ",
			decimals: 9,
			isTestnet: false,
			onChainId: "{\"ForeignAsset\":7}",
			themeColor: "#e6f2ff",
			coingeckoId: "equilibrium-token",
			existentialDeposit: "1000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "acala-substrate-tokens-eqd",
		data: {
			id: "acala-substrate-tokens-eqd",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/eqd.svg",
			type: "substrate-tokens",
			chain: {
				id: "acala"
			},
			symbol: "EQD",
			decimals: 9,
			isTestnet: false,
			onChainId: "{\"ForeignAsset\":8}",
			themeColor: "#3897f9",
			existentialDeposit: "1000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "acala-substrate-tokens-glmr",
		data: {
			id: "acala-substrate-tokens-glmr",
			logo: "https://assets.coingecko.com/coins/images/22459/large/glmr.png?1641880985",
			type: "substrate-tokens",
			chain: {
				id: "acala"
			},
			symbol: "GLMR",
			decimals: 18,
			isTestnet: false,
			onChainId: "{\"ForeignAsset\":0}",
			themeColor: "#53cbc8",
			coingeckoId: "moonbeam",
			existentialDeposit: "100000000000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "acala-substrate-tokens-ibtc",
		data: {
			id: "acala-substrate-tokens-ibtc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ibtc.svg",
			type: "substrate-tokens",
			chain: {
				id: "acala"
			},
			symbol: "iBTC",
			decimals: 8,
			isTestnet: false,
			onChainId: "{\"ForeignAsset\":3}",
			themeColor: "#ffffff",
			coingeckoId: "interbtc",
			existentialDeposit: "100"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "acala-substrate-tokens-intr",
		data: {
			id: "acala-substrate-tokens-intr",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/intr.svg",
			type: "substrate-tokens",
			chain: {
				id: "acala"
			},
			symbol: "INTR",
			decimals: 10,
			isTestnet: false,
			onChainId: "{\"ForeignAsset\":4}",
			themeColor: "#ffffff",
			coingeckoId: "interlay",
			existentialDeposit: "1000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "acala-substrate-tokens-lcdot",
		data: {
			id: "acala-substrate-tokens-lcdot",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/acala-substrate-tokens-lcdot.svg",
			type: "substrate-tokens",
			chain: {
				id: "acala"
			},
			symbol: "lcDOT",
			decimals: 10,
			isTestnet: false,
			onChainId: "{\"LiquidCrowdloan\":13}",
			themeColor: "#ffd8e5",
			coingeckoId: "liquid-crowdloan-dot",
			existentialDeposit: "100000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "acala-substrate-tokens-ldot",
		data: {
			id: "acala-substrate-tokens-ldot",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/acala-substrate-tokens-ldot.svg",
			type: "substrate-tokens",
			chain: {
				id: "acala"
			},
			symbol: "LDOT",
			decimals: 10,
			isTestnet: false,
			onChainId: "{\"Token\":\"LDOT\"}",
			themeColor: "#ffd8e5",
			coingeckoId: "liquid-staking-dot",
			existentialDeposit: "500000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "acala-substrate-tokens-lp-aca-ausd",
		data: {
			id: "acala-substrate-tokens-lp-aca-ausd",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/acala.svg",
			type: "substrate-tokens",
			chain: {
				id: "acala"
			},
			symbol: "lp ACA-aUSD",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"DexShare\":[{\"Token\":\"ACA\"},{\"Token\":\"AUSD\"}]}",
			themeColor: "#e61059",
			existentialDeposit: "100000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "acala-substrate-tokens-lp-ausd-ibtc",
		data: {
			id: "acala-substrate-tokens-lp-ausd-ibtc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/acala.svg",
			type: "substrate-tokens",
			chain: {
				id: "acala"
			},
			symbol: "lp aUSD-iBTC",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"DexShare\":[{\"Token\":\"AUSD\"},{\"ForeignAsset\":3}]}",
			themeColor: "#e61059",
			existentialDeposit: "100000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "acala-substrate-tokens-lp-ausd-intr",
		data: {
			id: "acala-substrate-tokens-lp-ausd-intr",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/acala.svg",
			type: "substrate-tokens",
			chain: {
				id: "acala"
			},
			symbol: "lp aUSD-INTR",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"DexShare\":[{\"Token\":\"AUSD\"},{\"ForeignAsset\":4}]}",
			themeColor: "#e61059",
			existentialDeposit: "100000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "acala-substrate-tokens-lp-ausd-lcdot",
		data: {
			id: "acala-substrate-tokens-lp-ausd-lcdot",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/acala.svg",
			type: "substrate-tokens",
			chain: {
				id: "acala"
			},
			symbol: "lp aUSD-lcDOT",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"DexShare\":[{\"Token\":\"AUSD\"},{\"LiquidCrowdloan\":13}]}",
			themeColor: "#e61059",
			existentialDeposit: "100000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "acala-substrate-tokens-lp-ausd-ldot",
		data: {
			id: "acala-substrate-tokens-lp-ausd-ldot",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/acala.svg",
			type: "substrate-tokens",
			chain: {
				id: "acala"
			},
			symbol: "lp aUSD-LDOT",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"DexShare\":[{\"Token\":\"AUSD\"},{\"Token\":\"LDOT\"}]}",
			themeColor: "#e61059",
			existentialDeposit: "100000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "acala-substrate-tokens-lp-dot-lcdot",
		data: {
			id: "acala-substrate-tokens-lp-dot-lcdot",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/acala.svg",
			type: "substrate-tokens",
			chain: {
				id: "acala"
			},
			symbol: "lp DOT-lcDOT",
			decimals: 10,
			isTestnet: false,
			onChainId: "{\"DexShare\":[{\"Token\":\"DOT\"},{\"LiquidCrowdloan\":13}]}",
			themeColor: "#e61059",
			existentialDeposit: "100000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "acala-substrate-tokens-para",
		data: {
			id: "acala-substrate-tokens-para",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/acala.svg",
			type: "substrate-tokens",
			chain: {
				id: "acala"
			},
			symbol: "PARA",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"ForeignAsset\":1}",
			themeColor: "#e61059",
			existentialDeposit: "100000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "acala-substrate-tokens-pha",
		data: {
			id: "acala-substrate-tokens-pha",
			logo: "https://assets.coingecko.com/coins/images/12451/large/phala.png?1600061318",
			type: "substrate-tokens",
			chain: {
				id: "acala"
			},
			symbol: "PHA",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"ForeignAsset\":9}",
			themeColor: "#ffffff",
			coingeckoId: "pha",
			existentialDeposit: "100000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "acala-substrate-tokens-tap",
		data: {
			id: "acala-substrate-tokens-tap",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/acala.svg",
			type: "substrate-tokens",
			chain: {
				id: "acala"
			},
			symbol: "TAP",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"Token\":\"TAP\"}",
			themeColor: "#e61059",
			coingeckoId: "tapio-protocol",
			existentialDeposit: "1000000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "acala-substrate-tokens-tdot",
		data: {
			id: "acala-substrate-tokens-tdot",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/tdot.svg",
			type: "substrate-tokens",
			chain: {
				id: "acala"
			},
			symbol: "tDOT",
			decimals: 10,
			isTestnet: false,
			onChainId: "{\"StableAssetPoolToken\":0}",
			themeColor: "#b026cf",
			existentialDeposit: "100000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "acala-substrate-tokens-usdcet",
		data: {
			id: "acala-substrate-tokens-usdcet",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/acala.svg",
			type: "substrate-tokens",
			chain: {
				id: "acala"
			},
			symbol: "USDCet",
			decimals: 6,
			isTestnet: false,
			onChainId: "{\"Erc20\":\"0x07df96d1341a7d16ba1ad431e2c847d978bc2bce\"}",
			themeColor: "#e61059",
			existentialDeposit: "10000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "acala-substrate-tokens-wbtc",
		data: {
			id: "acala-substrate-tokens-wbtc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/acala.svg",
			type: "substrate-tokens",
			chain: {
				id: "acala"
			},
			symbol: "WBTC",
			decimals: 8,
			isTestnet: false,
			onChainId: "{\"Erc20\":\"0xc80084af223c8b598536178d9361dc55bfda6818\"}",
			themeColor: "#e61059",
			existentialDeposit: "60"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "acala-substrate-tokens-weth",
		data: {
			id: "acala-substrate-tokens-weth",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/acala.svg",
			type: "substrate-tokens",
			chain: {
				id: "acala"
			},
			symbol: "WETH",
			decimals: 18,
			isTestnet: false,
			onChainId: "{\"Erc20\":\"0x5a4d6acdc4e3e5ab15717f407afe957f7a242578\"}",
			themeColor: "#e61059",
			existentialDeposit: "8500000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "ajuna-substrate-native-ajun",
		data: {
			id: "ajuna-substrate-native-ajun",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/ajuna.svg",
			type: "substrate-native",
			chain: {
				id: "ajuna"
			},
			symbol: "AJUN",
			decimals: 12,
			isTestnet: false,
			themeColor: "#5785c4",
			existentialDeposit: "1000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "ajuna"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "ajuna-testnet-substrate-native-ajun",
		data: {
			id: "ajuna-testnet-substrate-native-ajun",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "ajuna-testnet"
			},
			symbol: "AJUN",
			decimals: 12,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "100000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "ajuna-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "aleph-zero-substrate-native-azero",
		data: {
			id: "aleph-zero-substrate-native-azero",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/aleph-zero.svg",
			type: "substrate-native",
			chain: {
				id: "aleph-zero"
			},
			symbol: "AZERO",
			decimals: 12,
			isTestnet: false,
			themeColor: "#91979c",
			coingeckoId: "aleph-zero",
			existentialDeposit: "500"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "aleph-zero"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "aleph-zero-testnet-substrate-native-tzero",
		data: {
			id: "aleph-zero-testnet-substrate-native-tzero",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/aleph-zero-testnet.svg",
			type: "substrate-native",
			chain: {
				id: "aleph-zero-testnet"
			},
			symbol: "TZERO",
			decimals: 12,
			isTestnet: true,
			themeColor: "#91979c",
			existentialDeposit: "500"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "aleph-zero-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "altair-substrate-native-air",
		data: {
			id: "altair-substrate-native-air",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/altair.svg",
			type: "substrate-native",
			chain: {
				id: "altair"
			},
			symbol: "AIR",
			decimals: 18,
			isTestnet: false,
			themeColor: "#bb8b49",
			coingeckoId: "altair",
			existentialDeposit: "1000000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "altair"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "amplitude-substrate-native-ampe",
		data: {
			id: "amplitude-substrate-native-ampe",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/amplitude.svg",
			type: "substrate-native",
			chain: {
				id: "amplitude"
			},
			symbol: "AMPE",
			decimals: 12,
			isTestnet: false,
			themeColor: "#5defa7",
			existentialDeposit: "1000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "amplitude"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "amplitude-substrate-tokens-ksm",
		data: {
			id: "amplitude-substrate-tokens-ksm",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ksm.svg",
			type: "substrate-tokens",
			chain: {
				id: "amplitude"
			},
			symbol: "KSM",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"XCM\":0}",
			themeColor: "#ffffff",
			coingeckoId: "kusama",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "amplitude-substrate-tokens-usdt",
		data: {
			id: "amplitude-substrate-tokens-usdt",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/usdt.svg",
			type: "substrate-tokens",
			chain: {
				id: "amplitude"
			},
			symbol: "USDT",
			decimals: 6,
			isTestnet: false,
			onChainId: "{\"XCM\":1}",
			themeColor: "#53ae94",
			coingeckoId: "tether",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "ares-odyssey-substrate-native-ares",
		data: {
			id: "ares-odyssey-substrate-native-ares",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/ares-odyssey.svg",
			type: "substrate-native",
			chain: {
				id: "ares-odyssey"
			},
			symbol: "ARES",
			decimals: 12,
			isTestnet: false,
			themeColor: "#2b9ff3",
			coingeckoId: "ares-protocol",
			existentialDeposit: "500"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "ares-odyssey"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "astar-substrate-assets-18446744073709551616-aca",
		data: {
			id: "astar-substrate-assets-18446744073709551616-aca",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/aca.svg",
			type: "substrate-assets",
			chain: {
				id: "astar"
			},
			symbol: "ACA",
			assetId: "18446744073709551616",
			decimals: 12,
			isFrozen: false,
			isTestnet: false,
			themeColor: "#e61059",
			coingeckoId: "acala",
			existentialDeposit: "1"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "astar-substrate-assets-18446744073709551617-ausd",
		data: {
			id: "astar-substrate-assets-18446744073709551617-ausd",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ausd.svg",
			type: "substrate-assets",
			chain: {
				id: "astar"
			},
			symbol: "aUSD",
			assetId: "18446744073709551617",
			decimals: 12,
			isFrozen: false,
			isTestnet: false,
			themeColor: "#e40c5b",
			coingeckoId: "acala-dollar",
			existentialDeposit: "1"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "astar-substrate-assets-18446744073709551618-ldot",
		data: {
			id: "astar-substrate-assets-18446744073709551618-ldot",
			logo: "https://assets.coingecko.com/coins/images/25847/large/iShot2022-06-02_13.14.07-removebg-preview.png?1654146888",
			type: "substrate-assets",
			chain: {
				id: "astar"
			},
			symbol: "LDOT",
			assetId: "18446744073709551618",
			decimals: 10,
			isFrozen: false,
			isTestnet: false,
			themeColor: "#ffd8e5",
			coingeckoId: "liquid-staking-dot",
			existentialDeposit: "1"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "astar-substrate-assets-18446744073709551619-glmr",
		data: {
			id: "astar-substrate-assets-18446744073709551619-glmr",
			logo: "https://assets.coingecko.com/coins/images/22459/large/glmr.png?1641880985",
			type: "substrate-assets",
			chain: {
				id: "astar"
			},
			symbol: "GLMR",
			assetId: "18446744073709551619",
			decimals: 18,
			isFrozen: false,
			isTestnet: false,
			themeColor: "#53cbc8",
			coingeckoId: "moonbeam",
			existentialDeposit: "1"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "astar-substrate-assets-18446744073709551620-ibtc",
		data: {
			id: "astar-substrate-assets-18446744073709551620-ibtc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ibtc.svg",
			type: "substrate-assets",
			chain: {
				id: "astar"
			},
			symbol: "iBTC",
			assetId: "18446744073709551620",
			decimals: 8,
			isFrozen: false,
			isTestnet: false,
			themeColor: "#ffffff",
			coingeckoId: "interbtc",
			existentialDeposit: "1"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "astar-substrate-assets-18446744073709551621-intr",
		data: {
			id: "astar-substrate-assets-18446744073709551621-intr",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/intr.svg",
			type: "substrate-assets",
			chain: {
				id: "astar"
			},
			symbol: "INTR",
			assetId: "18446744073709551621",
			decimals: 10,
			isFrozen: false,
			isTestnet: false,
			themeColor: "#ffffff",
			coingeckoId: "interlay",
			existentialDeposit: "1"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "astar-substrate-assets-18446744073709551622-pha",
		data: {
			id: "astar-substrate-assets-18446744073709551622-pha",
			logo: "https://assets.coingecko.com/coins/images/12451/large/phala.png?1600061318",
			type: "substrate-assets",
			chain: {
				id: "astar"
			},
			symbol: "PHA",
			assetId: "18446744073709551622",
			decimals: 12,
			isFrozen: false,
			isTestnet: false,
			themeColor: "#ffffff",
			coingeckoId: "pha",
			existentialDeposit: "1"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "astar-substrate-assets-18446744073709551623-bnc",
		data: {
			id: "astar-substrate-assets-18446744073709551623-bnc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/bnc.svg",
			type: "substrate-assets",
			chain: {
				id: "astar"
			},
			symbol: "BNC",
			assetId: "18446744073709551623",
			decimals: 12,
			isFrozen: false,
			isTestnet: false,
			themeColor: "#68baf9",
			coingeckoId: "bifrost-native-coin",
			existentialDeposit: "1"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "astar-substrate-assets-18446744073709551624-vdot",
		data: {
			id: "astar-substrate-assets-18446744073709551624-vdot",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/astar.svg",
			type: "substrate-assets",
			chain: {
				id: "astar"
			},
			symbol: "VDOT",
			assetId: "18446744073709551624",
			decimals: 10,
			isFrozen: false,
			isTestnet: false,
			themeColor: "#03b0fb",
			existentialDeposit: "1"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "astar-substrate-assets-18446744073709551625-clv",
		data: {
			id: "astar-substrate-assets-18446744073709551625-clv",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/astar.svg",
			type: "substrate-assets",
			chain: {
				id: "astar"
			},
			symbol: "CLV",
			assetId: "18446744073709551625",
			decimals: 18,
			isFrozen: false,
			isTestnet: false,
			themeColor: "#03b0fb",
			existentialDeposit: "1"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "astar-substrate-assets-18446744073709551626-vsdot",
		data: {
			id: "astar-substrate-assets-18446744073709551626-vsdot",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/astar.svg",
			type: "substrate-assets",
			chain: {
				id: "astar"
			},
			symbol: "VSDOT",
			assetId: "18446744073709551626",
			decimals: 10,
			isFrozen: false,
			isTestnet: false,
			themeColor: "#03b0fb",
			existentialDeposit: "1"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "astar-substrate-assets-18446744073709551627-ring",
		data: {
			id: "astar-substrate-assets-18446744073709551627-ring",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ring.svg",
			type: "substrate-assets",
			chain: {
				id: "astar"
			},
			symbol: "RING",
			assetId: "18446744073709551627",
			decimals: 18,
			isFrozen: false,
			isTestnet: false,
			themeColor: "#eef1f7",
			coingeckoId: "darwinia-network-native-token",
			existentialDeposit: "1"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "astar-substrate-assets-18446744073709551628-eq",
		data: {
			id: "astar-substrate-assets-18446744073709551628-eq",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/eq.svg",
			type: "substrate-assets",
			chain: {
				id: "astar"
			},
			symbol: "EQ",
			assetId: "18446744073709551628",
			decimals: 9,
			isFrozen: false,
			isTestnet: false,
			themeColor: "#e6f2ff",
			coingeckoId: "equilibrium-token",
			existentialDeposit: "1"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "astar-substrate-assets-18446744073709551629-eqd",
		data: {
			id: "astar-substrate-assets-18446744073709551629-eqd",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/eqd.svg",
			type: "substrate-assets",
			chain: {
				id: "astar"
			},
			symbol: "EQD",
			assetId: "18446744073709551629",
			decimals: 9,
			isFrozen: false,
			isTestnet: false,
			themeColor: "#3897f9",
			existentialDeposit: "1"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "astar-substrate-assets-340282366920938463463374607431768211455-dot",
		data: {
			id: "astar-substrate-assets-340282366920938463463374607431768211455-dot",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/dot.svg",
			type: "substrate-assets",
			chain: {
				id: "astar"
			},
			symbol: "DOT",
			assetId: "340282366920938463463374607431768211455",
			decimals: 10,
			isFrozen: false,
			isTestnet: false,
			themeColor: "#e6007a",
			coingeckoId: "polkadot",
			existentialDeposit: "1"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "astar-substrate-assets-4294969280-usdt",
		data: {
			id: "astar-substrate-assets-4294969280-usdt",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/usdt.svg",
			type: "substrate-assets",
			chain: {
				id: "astar"
			},
			symbol: "USDT",
			assetId: "4294969280",
			decimals: 6,
			isFrozen: false,
			isTestnet: false,
			themeColor: "#53ae94",
			coingeckoId: "tether",
			existentialDeposit: "1"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "astar-substrate-native-astr",
		data: {
			id: "astar-substrate-native-astr",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/astar.svg",
			type: "substrate-native",
			chain: {
				id: "astar"
			},
			symbol: "ASTR",
			decimals: 18,
			isTestnet: false,
			themeColor: "#03b0fb",
			coingeckoId: "astar",
			existentialDeposit: "1000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "astar"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "automata-contextfree-testnet-substrate-native-ctx",
		data: {
			id: "automata-contextfree-testnet-substrate-native-ctx",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "automata-contextfree-testnet"
			},
			symbol: "CTX",
			decimals: 18,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "100000000000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "automata-contextfree-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "automata-substrate-native-ata",
		data: {
			id: "automata-substrate-native-ata",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "automata"
			},
			symbol: "ATA",
			decimals: 18,
			isTestnet: false,
			themeColor: "#ffffff",
			coingeckoId: "automata",
			existentialDeposit: "1000000000000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "automata"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "aventus-substrate-native-avt",
		data: {
			id: "aventus-substrate-native-avt",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "aventus"
			},
			symbol: "AVT",
			decimals: 18,
			isTestnet: false,
			themeColor: "#ffffff",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "aventus"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "bajun-substrate-native-baju",
		data: {
			id: "bajun-substrate-native-baju",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/bajun.svg",
			type: "substrate-native",
			chain: {
				id: "bajun"
			},
			symbol: "BAJU",
			decimals: 12,
			isTestnet: false,
			themeColor: "#f36468",
			coingeckoId: "ajuna-network",
			existentialDeposit: "1000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "bajun"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "basilisk-substrate-native-bsx",
		data: {
			id: "basilisk-substrate-native-bsx",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/basilisk.svg",
			type: "substrate-native",
			chain: {
				id: "basilisk"
			},
			symbol: "BSX",
			decimals: 12,
			isTestnet: false,
			themeColor: "#4cffaf",
			coingeckoId: "basilisk",
			existentialDeposit: "1000000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "basilisk"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "basilisk-substrate-tokens-ausd",
		data: {
			id: "basilisk-substrate-tokens-ausd",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ausd.svg",
			type: "substrate-tokens",
			chain: {
				id: "basilisk"
			},
			symbol: "aUSD",
			decimals: 12,
			isTestnet: false,
			onChainId: 2,
			themeColor: "#e40c5b",
			coingeckoId: "acala-dollar",
			existentialDeposit: "10000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "basilisk-substrate-tokens-dai",
		data: {
			id: "basilisk-substrate-tokens-dai",
			logo: "https://assets.coingecko.com/coins/images/9956/large/Badge_Dai.png?1687143508",
			type: "substrate-tokens",
			chain: {
				id: "basilisk"
			},
			symbol: "DAI",
			decimals: 18,
			isTestnet: false,
			onChainId: 13,
			themeColor: "#fab222",
			coingeckoId: "dai",
			existentialDeposit: "10000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "basilisk-substrate-tokens-ksm",
		data: {
			id: "basilisk-substrate-tokens-ksm",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ksm.svg",
			type: "substrate-tokens",
			chain: {
				id: "basilisk"
			},
			symbol: "KSM",
			decimals: 12,
			isTestnet: false,
			onChainId: 1,
			themeColor: "#ffffff",
			coingeckoId: "kusama",
			existentialDeposit: "100000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "basilisk-substrate-tokens-tnkr",
		data: {
			id: "basilisk-substrate-tokens-tnkr",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/basilisk.svg",
			type: "substrate-tokens",
			chain: {
				id: "basilisk"
			},
			symbol: "TNKR",
			decimals: 12,
			isTestnet: false,
			onChainId: 6,
			themeColor: "#4cffaf",
			existentialDeposit: "1000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "basilisk-substrate-tokens-usdcet",
		data: {
			id: "basilisk-substrate-tokens-usdcet",
			logo: "https://assets.coingecko.com/coins/images/23019/large/USDCet_wh_small.png?1644223449",
			type: "substrate-tokens",
			chain: {
				id: "basilisk"
			},
			symbol: "USDCet",
			decimals: 6,
			isTestnet: false,
			onChainId: 9,
			themeColor: "#2775ca",
			coingeckoId: "usd-coin-wormhole-from-ethereum",
			existentialDeposit: "10000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "basilisk-substrate-tokens-usdt",
		data: {
			id: "basilisk-substrate-tokens-usdt",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/usdt.svg",
			type: "substrate-tokens",
			chain: {
				id: "basilisk"
			},
			symbol: "USDT",
			decimals: 6,
			isTestnet: false,
			onChainId: 14,
			themeColor: "#53ae94",
			coingeckoId: "tether",
			existentialDeposit: "10000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "basilisk-substrate-tokens-wbtc",
		data: {
			id: "basilisk-substrate-tokens-wbtc",
			logo: "https://assets.coingecko.com/coins/images/1/large/bitcoin.png?1547033579",
			type: "substrate-tokens",
			chain: {
				id: "basilisk"
			},
			symbol: "wBTC",
			decimals: 8,
			isTestnet: false,
			onChainId: 11,
			themeColor: "#f7931a",
			coingeckoId: "bitcoin",
			existentialDeposit: "1000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "basilisk-substrate-tokens-weth",
		data: {
			id: "basilisk-substrate-tokens-weth",
			logo: "https://assets.coingecko.com/coins/images/279/large/ethereum.png?1595348880",
			type: "substrate-tokens",
			chain: {
				id: "basilisk"
			},
			symbol: "wETH",
			decimals: 18,
			isTestnet: false,
			onChainId: 10,
			themeColor: "#62688f",
			coingeckoId: "ethereum",
			existentialDeposit: "10000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "basilisk-substrate-tokens-wusdt",
		data: {
			id: "basilisk-substrate-tokens-wusdt",
			logo: "https://assets.coingecko.com/coins/images/325/large/Tether.png?1668148663",
			type: "substrate-tokens",
			chain: {
				id: "basilisk"
			},
			symbol: "wUSDT",
			decimals: 6,
			isTestnet: false,
			onChainId: 12,
			themeColor: "#009393",
			coingeckoId: "tether",
			existentialDeposit: "10000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "bifrost-kusama-substrate-native-bnc",
		data: {
			id: "bifrost-kusama-substrate-native-bnc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/bnc.svg",
			type: "substrate-native",
			chain: {
				id: "bifrost-kusama"
			},
			symbol: "BNC",
			decimals: 12,
			isTestnet: false,
			themeColor: "#68baf9",
			coingeckoId: "bifrost-native-coin",
			existentialDeposit: "10000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "bifrost-kusama"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "bifrost-kusama-substrate-orml-bnc",
		data: {
			id: "bifrost-kusama-substrate-orml-bnc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/bnc.svg",
			type: "substrate-orml",
			chain: {
				id: "bifrost-kusama"
			},
			symbol: "BNC",
			decimals: 12,
			stateKey: "0x4a6fdeede9332ffc0201",
			isTestnet: false,
			themeColor: "#68baf9",
			coingeckoId: "bifrost-native-coin",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "bifrost-kusama-substrate-orml-dot",
		data: {
			id: "bifrost-kusama-substrate-orml-dot",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/dot.svg",
			type: "substrate-orml",
			chain: {
				id: "bifrost-kusama"
			},
			symbol: "DOT",
			decimals: 10,
			stateKey: "0x40c8bff02912d7a00203",
			isTestnet: false,
			themeColor: "#e6007a",
			coingeckoId: "polkadot",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "bifrost-kusama-substrate-orml-kar",
		data: {
			id: "bifrost-kusama-substrate-orml-kar",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/kar.svg",
			type: "substrate-orml",
			chain: {
				id: "bifrost-kusama"
			},
			symbol: "KAR",
			decimals: 12,
			stateKey: "0xca82739c8129d4d20206",
			isTestnet: false,
			themeColor: "#f93d43",
			coingeckoId: "karura",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "bifrost-kusama-substrate-orml-ksm",
		data: {
			id: "bifrost-kusama-substrate-orml-ksm",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ksm.svg",
			type: "substrate-orml",
			chain: {
				id: "bifrost-kusama"
			},
			symbol: "KSM",
			decimals: 12,
			stateKey: "0x1dab0d33717892710204",
			isTestnet: false,
			themeColor: "#ffffff",
			coingeckoId: "kusama",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "bifrost-kusama-substrate-orml-kusd",
		data: {
			id: "bifrost-kusama-substrate-orml-kusd",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ausd.svg",
			type: "substrate-orml",
			chain: {
				id: "bifrost-kusama"
			},
			symbol: "aUSD",
			decimals: 12,
			stateKey: "0xfb747b895a9033f80202",
			isTestnet: false,
			themeColor: "#e40c5b",
			coingeckoId: "acala-dollar",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "bifrost-kusama-substrate-orml-movr",
		data: {
			id: "bifrost-kusama-substrate-orml-movr",
			logo: "https://assets.coingecko.com/coins/images/17984/large/9285.png?1630028620",
			type: "substrate-orml",
			chain: {
				id: "bifrost-kusama"
			},
			symbol: "MOVR",
			decimals: 18,
			stateKey: "0xac435ba151a0ded6020a",
			isTestnet: false,
			themeColor: "#f2b705",
			coingeckoId: "moonriver",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "bifrost-kusama-substrate-orml-pha",
		data: {
			id: "bifrost-kusama-substrate-orml-pha",
			logo: "https://assets.coingecko.com/coins/images/12451/large/phala.png?1600061318",
			type: "substrate-orml",
			chain: {
				id: "bifrost-kusama"
			},
			symbol: "PHA",
			decimals: 12,
			stateKey: "0xc3413250cf88fd430208",
			isTestnet: false,
			themeColor: "#ffffff",
			coingeckoId: "pha",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "bifrost-kusama-substrate-orml-rmrk",
		data: {
			id: "bifrost-kusama-substrate-orml-rmrk",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/rmrk.svg",
			type: "substrate-orml",
			chain: {
				id: "bifrost-kusama"
			},
			symbol: "RMRK",
			decimals: 10,
			stateKey: "0x3aabf5b1eec116df0209",
			isTestnet: false,
			themeColor: "#3d2a76",
			coingeckoId: "rmrk",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "bifrost-kusama-substrate-orml-zlk",
		data: {
			id: "bifrost-kusama-substrate-orml-zlk",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/zlk.svg",
			type: "substrate-orml",
			chain: {
				id: "bifrost-kusama"
			},
			symbol: "ZLK",
			decimals: 18,
			stateKey: "0xb682815e8b9cd45d0207",
			isTestnet: false,
			themeColor: "#ffffff",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "bifrost-kusama-substrate-tokens-ausd",
		data: {
			id: "bifrost-kusama-substrate-tokens-ausd",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ausd.svg",
			type: "substrate-tokens",
			chain: {
				id: "bifrost-kusama"
			},
			symbol: "aUSD",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"Stable\":\"KUSD\"}",
			themeColor: "#e40c5b",
			coingeckoId: "acala-dollar",
			existentialDeposit: "10000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "bifrost-kusama-substrate-tokens-usdt",
		data: {
			id: "bifrost-kusama-substrate-tokens-usdt",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/usdt.svg",
			type: "substrate-tokens",
			chain: {
				id: "bifrost-kusama"
			},
			symbol: "USDT",
			decimals: 6,
			isTestnet: false,
			onChainId: "{\"Token2\":0}",
			themeColor: "#53ae94",
			coingeckoId: "tether",
			existentialDeposit: "10000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "bifrost-kusama-substrate-tokens-vbnc",
		data: {
			id: "bifrost-kusama-substrate-tokens-vbnc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/bifrost-kusama.svg",
			type: "substrate-tokens",
			chain: {
				id: "bifrost-kusama"
			},
			symbol: "vBNC",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"VToken\":\"BNC\"}",
			themeColor: "#68baf9",
			existentialDeposit: "8000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "bifrost-kusama-substrate-tokens-vksm",
		data: {
			id: "bifrost-kusama-substrate-tokens-vksm",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/bifrost-kusama-substrate-tokens-vksm.svg",
			type: "substrate-tokens",
			chain: {
				id: "bifrost-kusama"
			},
			symbol: "vKSM",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"VToken\":\"KSM\"}",
			themeColor: "#ed924c",
			existentialDeposit: "100000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "bifrost-kusama-substrate-tokens-vsksm",
		data: {
			id: "bifrost-kusama-substrate-tokens-vsksm",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/bifrost-kusama-substrate-tokens-vsksm.svg",
			type: "substrate-tokens",
			chain: {
				id: "bifrost-kusama"
			},
			symbol: "vsKSM",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"VSToken\":\"KSM\"}",
			themeColor: "#e86656",
			existentialDeposit: "100000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "bifrost-polkadot-substrate-native-bnc",
		data: {
			id: "bifrost-polkadot-substrate-native-bnc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/bnc.svg",
			type: "substrate-native",
			chain: {
				id: "bifrost-polkadot"
			},
			symbol: "BNC",
			decimals: 12,
			isTestnet: false,
			themeColor: "#68baf9",
			coingeckoId: "bifrost-native-coin",
			existentialDeposit: "10000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "bifrost-polkadot"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "bifrost-polkadot-substrate-orml-bnc",
		data: {
			id: "bifrost-polkadot-substrate-orml-bnc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/bnc.svg",
			type: "substrate-orml",
			chain: {
				id: "bifrost-polkadot"
			},
			symbol: "BNC",
			decimals: 12,
			stateKey: "0x4a6fdeede9332ffc0201",
			isTestnet: false,
			themeColor: "#68baf9",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "bifrost-polkadot-substrate-tokens-astr",
		data: {
			id: "bifrost-polkadot-substrate-tokens-astr",
			logo: "https://assets.coingecko.com/coins/images/22617/large/astr.png?1642314057",
			type: "substrate-tokens",
			chain: {
				id: "bifrost-polkadot"
			},
			symbol: "ASTR",
			decimals: 18,
			isTestnet: false,
			onChainId: "{\"Token2\":3}",
			themeColor: "#0089f6",
			coingeckoId: "astar",
			existentialDeposit: "1000000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "bifrost-polkadot-substrate-tokens-dot",
		data: {
			id: "bifrost-polkadot-substrate-tokens-dot",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/dot.svg",
			type: "substrate-tokens",
			chain: {
				id: "bifrost-polkadot"
			},
			symbol: "DOT",
			decimals: 10,
			isTestnet: false,
			onChainId: "{\"Token2\":0}",
			themeColor: "#e6007a",
			coingeckoId: "polkadot",
			existentialDeposit: "1000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "bifrost-polkadot-substrate-tokens-glmr",
		data: {
			id: "bifrost-polkadot-substrate-tokens-glmr",
			logo: "https://assets.coingecko.com/coins/images/22459/large/glmr.png?1641880985",
			type: "substrate-tokens",
			chain: {
				id: "bifrost-polkadot"
			},
			symbol: "GLMR",
			decimals: 18,
			isTestnet: false,
			onChainId: "{\"Token2\":1}",
			themeColor: "#53cbc8",
			coingeckoId: "moonbeam",
			existentialDeposit: "1000000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "bifrost-polkadot-substrate-tokens-vdot",
		data: {
			id: "bifrost-polkadot-substrate-tokens-vdot",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/bifrost-polkadot-substrate-tokens-vdot.svg",
			type: "substrate-tokens",
			chain: {
				id: "bifrost-polkadot"
			},
			symbol: "vDOT",
			decimals: 10,
			isTestnet: false,
			onChainId: "{\"VToken2\":0}",
			themeColor: "#e6007a",
			existentialDeposit: "100000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "bifrost-polkadot-substrate-tokens-vsdot",
		data: {
			id: "bifrost-polkadot-substrate-tokens-vsdot",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/bifrost-polkadot-substrate-tokens-vsdot.svg",
			type: "substrate-tokens",
			chain: {
				id: "bifrost-polkadot"
			},
			symbol: "vsDOT",
			decimals: 10,
			isTestnet: false,
			onChainId: "{\"VSToken2\":0}",
			themeColor: "#e6007a",
			existentialDeposit: "100000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "bitcountry-pioneer-substrate-native-neer",
		data: {
			id: "bitcountry-pioneer-substrate-native-neer",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/bitcountry-pioneer.svg",
			type: "substrate-native",
			chain: {
				id: "bitcountry-pioneer"
			},
			symbol: "NEER",
			decimals: 18,
			isTestnet: false,
			themeColor: "#f8fcfc",
			coingeckoId: "metaverse-network-pioneer",
			existentialDeposit: "100000000000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "bitcountry-pioneer"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "bitcountry-pioneer-substrate-tokens-ausd",
		data: {
			id: "bitcountry-pioneer-substrate-tokens-ausd",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ausd.svg",
			type: "substrate-tokens",
			chain: {
				id: "bitcountry-pioneer"
			},
			symbol: "aUSD",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"Stable\":0}",
			themeColor: "#e40c5b",
			coingeckoId: "acala-dollar",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "bitcountry-pioneer-substrate-tokens-bit",
		data: {
			id: "bitcountry-pioneer-substrate-tokens-bit",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/bitcountry-pioneer.svg",
			type: "substrate-tokens",
			chain: {
				id: "bitcountry-pioneer"
			},
			symbol: "BIT",
			decimals: 18,
			isTestnet: false,
			onChainId: "{\"MiningResource\":0}",
			themeColor: "#f8fcfc",
			coingeckoId: "bit",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "bitcountry-pioneer-substrate-tokens-kar",
		data: {
			id: "bitcountry-pioneer-substrate-tokens-kar",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/kar.svg",
			type: "substrate-tokens",
			chain: {
				id: "bitcountry-pioneer"
			},
			symbol: "KAR",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"NativeToken\":2}",
			themeColor: "#f93d43",
			coingeckoId: "karura",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "bitcountry-pioneer-substrate-tokens-ksm",
		data: {
			id: "bitcountry-pioneer-substrate-tokens-ksm",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ksm.svg",
			type: "substrate-tokens",
			chain: {
				id: "bitcountry-pioneer"
			},
			symbol: "KSM",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"NativeToken\":1}",
			themeColor: "#ffffff",
			coingeckoId: "kusama",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "bitgreen-substrate-native-bbb",
		data: {
			id: "bitgreen-substrate-native-bbb",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/bitgreen.svg",
			type: "substrate-native",
			chain: {
				id: "bitgreen"
			},
			symbol: "BBB",
			decimals: 18,
			isTestnet: false,
			themeColor: "#c0ff00",
			existentialDeposit: "1000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "bitgreen"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "bittensor-substrate-native-tao",
		data: {
			id: "bittensor-substrate-native-tao",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/bittensor.svg",
			type: "substrate-native",
			chain: {
				id: "bittensor"
			},
			symbol: "TAO",
			decimals: 9,
			isTestnet: false,
			themeColor: "#ffffff",
			coingeckoId: "bittensor",
			existentialDeposit: "500"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "bittensor"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "calamari-substrate-native-kma",
		data: {
			id: "calamari-substrate-native-kma",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/calamari.svg",
			type: "substrate-native",
			chain: {
				id: "calamari"
			},
			symbol: "KMA",
			decimals: 12,
			isTestnet: false,
			themeColor: "#ff991f",
			coingeckoId: "calamari-network",
			existentialDeposit: "100000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "calamari"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "centrifuge-polkadot-substrate-native-cfg",
		data: {
			id: "centrifuge-polkadot-substrate-native-cfg",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/centrifuge-polkadot.svg",
			type: "substrate-native",
			chain: {
				id: "centrifuge-polkadot"
			},
			symbol: "CFG",
			decimals: 18,
			isTestnet: false,
			themeColor: "#ffffff",
			coingeckoId: "centrifuge",
			existentialDeposit: "1000000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "centrifuge-polkadot"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "cere-substrate-native-cere",
		data: {
			id: "cere-substrate-native-cere",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "cere"
			},
			symbol: "CERE",
			decimals: 10,
			isTestnet: false,
			themeColor: "#ffffff",
			existentialDeposit: "10000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "cere"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "cere-testnet-substrate-native-cere",
		data: {
			id: "cere-testnet-substrate-native-cere",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "cere-testnet"
			},
			symbol: "CERE",
			decimals: 10,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "10000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "cere-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "cess-testnet-substrate-native-tcess",
		data: {
			id: "cess-testnet-substrate-native-tcess",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "cess-testnet"
			},
			symbol: "TCESS",
			decimals: 12,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "1000000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "cess-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "chainx-substrate-native-pcx",
		data: {
			id: "chainx-substrate-native-pcx",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "chainx"
			},
			symbol: "PCX",
			decimals: 8,
			isTestnet: false,
			themeColor: "#ffffff",
			coingeckoId: "chainx",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "chainx"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "clover-substrate-native-clv",
		data: {
			id: "clover-substrate-native-clv",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/clover.svg",
			type: "substrate-native",
			chain: {
				id: "clover"
			},
			symbol: "CLV",
			decimals: 18,
			isTestnet: false,
			themeColor: "#0aa777",
			coingeckoId: "clover-finance",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "clover"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "composable-finance-substrate-native-layr",
		data: {
			id: "composable-finance-substrate-native-layr",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/composable-finance.svg",
			type: "substrate-native",
			chain: {
				id: "composable-finance"
			},
			symbol: "LAYR",
			decimals: 12,
			isTestnet: false,
			themeColor: "#9f3da2",
			coingeckoId: "composable-finance-layr",
			existentialDeposit: "100000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "composable-finance"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "composable-finance-substrate-tokens-ausd",
		data: {
			id: "composable-finance-substrate-tokens-ausd",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ausd.svg",
			type: "substrate-tokens",
			chain: {
				id: "composable-finance"
			},
			symbol: "aUSD",
			decimals: 12,
			isTestnet: false,
			onChainId: 129,
			themeColor: "#e40c5b",
			coingeckoId: "acala-dollar",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "composable-finance-substrate-tokens-bnc",
		data: {
			id: "composable-finance-substrate-tokens-bnc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/bnc.svg",
			type: "substrate-tokens",
			chain: {
				id: "composable-finance"
			},
			symbol: "BNC",
			decimals: 12,
			isTestnet: false,
			onChainId: 102,
			themeColor: "#68baf9",
			coingeckoId: "bifrost-native-coin",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "composable-finance-substrate-tokens-dot",
		data: {
			id: "composable-finance-substrate-tokens-dot",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/dot.svg",
			type: "substrate-tokens",
			chain: {
				id: "composable-finance"
			},
			symbol: "DOT",
			decimals: 10,
			isTestnet: false,
			onChainId: 6,
			themeColor: "#e6007a",
			coingeckoId: "polkadot",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "composable-finance-substrate-tokens-kar",
		data: {
			id: "composable-finance-substrate-tokens-kar",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/kar.svg",
			type: "substrate-tokens",
			chain: {
				id: "composable-finance"
			},
			symbol: "KAR",
			decimals: 12,
			isTestnet: false,
			onChainId: 101,
			themeColor: "#f93d43",
			coingeckoId: "karura",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "composable-finance-substrate-tokens-ksm",
		data: {
			id: "composable-finance-substrate-tokens-ksm",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ksm.svg",
			type: "substrate-tokens",
			chain: {
				id: "composable-finance"
			},
			symbol: "KSM",
			decimals: 12,
			isTestnet: false,
			onChainId: 4,
			themeColor: "#ffffff",
			coingeckoId: "kusama",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "composable-finance-substrate-tokens-movr",
		data: {
			id: "composable-finance-substrate-tokens-movr",
			logo: "https://assets.coingecko.com/coins/images/17984/large/9285.png?1630028620",
			type: "substrate-tokens",
			chain: {
				id: "composable-finance"
			},
			symbol: "MOVR",
			decimals: 18,
			isTestnet: false,
			onChainId: 104,
			themeColor: "#f2b705",
			coingeckoId: "moonriver",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "composable-finance-substrate-tokens-usdc",
		data: {
			id: "composable-finance-substrate-tokens-usdc",
			logo: "https://assets.coingecko.com/coins/images/6319/large/USD_Coin_icon.png?1547042389",
			type: "substrate-tokens",
			chain: {
				id: "composable-finance"
			},
			symbol: "USDC",
			decimals: 6,
			isTestnet: false,
			onChainId: 131,
			themeColor: "#2775ca",
			coingeckoId: "usd-coin",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "composable-finance-substrate-tokens-usdt",
		data: {
			id: "composable-finance-substrate-tokens-usdt",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/usdt.svg",
			type: "substrate-tokens",
			chain: {
				id: "composable-finance"
			},
			symbol: "USDT",
			decimals: 6,
			isTestnet: false,
			onChainId: 130,
			themeColor: "#53ae94",
			coingeckoId: "tether",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "composable-finance-substrate-tokens-vksm",
		data: {
			id: "composable-finance-substrate-tokens-vksm",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/composable-finance.svg",
			type: "substrate-tokens",
			chain: {
				id: "composable-finance"
			},
			symbol: "vKSM",
			decimals: 12,
			isTestnet: false,
			onChainId: 103,
			themeColor: "#9f3da2",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "composable-finance-substrate-tokens-wbtc",
		data: {
			id: "composable-finance-substrate-tokens-wbtc",
			logo: "https://assets.coingecko.com/coins/images/1/large/bitcoin.png?1547033579",
			type: "substrate-tokens",
			chain: {
				id: "composable-finance"
			},
			symbol: "wBTC",
			decimals: 8,
			isTestnet: false,
			onChainId: 132,
			themeColor: "#f7931a",
			coingeckoId: "bitcoin",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "composable-finance-substrate-tokens-weth",
		data: {
			id: "composable-finance-substrate-tokens-weth",
			logo: "https://assets.coingecko.com/coins/images/279/large/ethereum.png?1595348880",
			type: "substrate-tokens",
			chain: {
				id: "composable-finance"
			},
			symbol: "wETH",
			decimals: 18,
			isTestnet: false,
			onChainId: 133,
			themeColor: "#62688f",
			coingeckoId: "ethereum",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "crab-substrate-native-crab",
		data: {
			id: "crab-substrate-native-crab",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/crab.svg",
			type: "substrate-native",
			chain: {
				id: "crab"
			},
			symbol: "CRAB",
			decimals: 18,
			isTestnet: false,
			themeColor: "#512dbc",
			coingeckoId: "darwinia-crab-network",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "crab"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "creditcoin-substrate-native-ctc",
		data: {
			id: "creditcoin-substrate-native-ctc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "creditcoin"
			},
			symbol: "CTC",
			decimals: 18,
			isTestnet: false,
			themeColor: "#ffffff",
			existentialDeposit: "500"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "creditcoin"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "creditcoin-testnet-substrate-native-ctc",
		data: {
			id: "creditcoin-testnet-substrate-native-ctc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "creditcoin-testnet"
			},
			symbol: "CTC",
			decimals: 18,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "500"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "creditcoin-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "crown-sterling-substrate-native-csov",
		data: {
			id: "crown-sterling-substrate-native-csov",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "crown-sterling"
			},
			symbol: "CSOV",
			decimals: 12,
			isTestnet: false,
			themeColor: "#ffffff",
			existentialDeposit: "1"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "crown-sterling"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "crust-parachain-substrate-native-cru",
		data: {
			id: "crust-parachain-substrate-native-cru",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/crust-parachain.svg",
			type: "substrate-native",
			chain: {
				id: "crust-parachain"
			},
			symbol: "CRU",
			decimals: 12,
			isTestnet: false,
			themeColor: "#f08727",
			coingeckoId: "crust-network",
			existentialDeposit: "100000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "crust-parachain"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "crust-substrate-native-cru",
		data: {
			id: "crust-substrate-native-cru",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/crust.svg",
			type: "substrate-native",
			chain: {
				id: "crust"
			},
			symbol: "CRU",
			decimals: 12,
			isTestnet: false,
			themeColor: "#f08727",
			coingeckoId: "crust-network",
			existentialDeposit: "100000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "crust"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "darwinia-substrate-native-ring",
		data: {
			id: "darwinia-substrate-native-ring",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ring.svg",
			type: "substrate-native",
			chain: {
				id: "darwinia"
			},
			symbol: "RING",
			decimals: 18,
			isTestnet: false,
			themeColor: "#eef1f7",
			coingeckoId: "darwinia-network-native-token",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "darwinia"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "debio-substrate-native-dbio",
		data: {
			id: "debio-substrate-native-dbio",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "debio"
			},
			symbol: "DBIO",
			decimals: 18,
			isTestnet: false,
			themeColor: "#ffffff",
			existentialDeposit: "10000000000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "debio"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "debio-testnet-substrate-native-dbio",
		data: {
			id: "debio-testnet-substrate-native-dbio",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "debio-testnet"
			},
			symbol: "DBIO",
			decimals: 18,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "10000000000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "debio-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "dock-pos-mainnet-substrate-native-dock",
		data: {
			id: "dock-pos-mainnet-substrate-native-dock",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "dock-pos-mainnet"
			},
			symbol: "DOCK",
			decimals: 6,
			isTestnet: false,
			themeColor: "#ffffff",
			coingeckoId: "dock",
			existentialDeposit: "500"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "dock-pos-mainnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "dorafactory-substrate-native-dora",
		data: {
			id: "dorafactory-substrate-native-dora",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "dorafactory"
			},
			symbol: "DORA",
			decimals: 12,
			isTestnet: false,
			themeColor: "#ffffff",
			coingeckoId: "dora-factory",
			existentialDeposit: "1000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "dorafactory"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "edgeware-substrate-native-edg",
		data: {
			id: "edgeware-substrate-native-edg",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/edgeware.svg",
			type: "substrate-native",
			chain: {
				id: "edgeware"
			},
			symbol: "EDG",
			decimals: 18,
			isTestnet: false,
			themeColor: "#ff3b80",
			coingeckoId: "edgeware",
			existentialDeposit: "10000000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "edgeware"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "edgeware-testnet-substrate-native-tedg",
		data: {
			id: "edgeware-testnet-substrate-native-tedg",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "edgeware-testnet"
			},
			symbol: "tEDG",
			decimals: 18,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "10000000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "edgeware-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "efinity-polkadot-substrate-native-efi",
		data: {
			id: "efinity-polkadot-substrate-native-efi",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/efinity-polkadot.svg",
			type: "substrate-native",
			chain: {
				id: "efinity-polkadot"
			},
			symbol: "EFI",
			decimals: 18,
			isTestnet: false,
			themeColor: "#496ddb",
			coingeckoId: "efinity",
			existentialDeposit: "1000000000000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "efinity-polkadot"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "encointer-substrate-native-ksm",
		data: {
			id: "encointer-substrate-native-ksm",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ksm.svg",
			type: "substrate-native",
			chain: {
				id: "encointer"
			},
			symbol: "KSM",
			decimals: 12,
			isTestnet: false,
			themeColor: "#ffffff",
			coingeckoId: "kusama",
			existentialDeposit: "3333333"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "encointer"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "encointer-testnet-rococo-substrate-native-roc",
		data: {
			id: "encointer-testnet-rococo-substrate-native-roc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/encointer-testnet-rococo.svg",
			type: "substrate-native",
			chain: {
				id: "encointer-testnet-rococo"
			},
			symbol: "ROC",
			decimals: 12,
			isTestnet: true,
			themeColor: "#8a8888",
			existentialDeposit: "3333333"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "encointer-testnet-rococo"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "encointer-testnet-standalone-substrate-native-ert",
		data: {
			id: "encointer-testnet-standalone-substrate-native-ert",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/encointer-testnet-standalone.svg",
			type: "substrate-native",
			chain: {
				id: "encointer-testnet-standalone"
			},
			symbol: "ERT",
			decimals: 12,
			isTestnet: true,
			themeColor: "#8a8888",
			existentialDeposit: "500"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "encointer-testnet-standalone"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "equilibrium-polkadot-substrate-equilibrium-aca",
		data: {
			id: "equilibrium-polkadot-substrate-equilibrium-aca",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/aca.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "equilibrium-polkadot"
			},
			symbol: "ACA",
			assetId: "6382433",
			decimals: 9,
			isTestnet: false,
			themeColor: "#e61059",
			coingeckoId: "acala",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "equilibrium-polkadot-substrate-equilibrium-astr",
		data: {
			id: "equilibrium-polkadot-substrate-equilibrium-astr",
			logo: "https://assets.coingecko.com/coins/images/22617/large/astr.png?1642314057",
			type: "substrate-equilibrium",
			chain: {
				id: "equilibrium-polkadot"
			},
			symbol: "ASTR",
			assetId: "1634956402",
			decimals: 9,
			isTestnet: false,
			themeColor: "#0089f6",
			coingeckoId: "astar",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "equilibrium-polkadot-substrate-equilibrium-bnb",
		data: {
			id: "equilibrium-polkadot-substrate-equilibrium-bnb",
			logo: "https://assets.coingecko.com/coins/images/825/large/bnb-icon2_2x.png?1644979850",
			type: "substrate-equilibrium",
			chain: {
				id: "equilibrium-polkadot"
			},
			symbol: "BNB",
			assetId: "6450786",
			decimals: 9,
			isTestnet: false,
			themeColor: "#f0b90b",
			coingeckoId: "binancecoin",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "equilibrium-polkadot-substrate-equilibrium-bnc",
		data: {
			id: "equilibrium-polkadot-substrate-equilibrium-bnc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/bnc.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "equilibrium-polkadot"
			},
			symbol: "BNC",
			assetId: "6450787",
			decimals: 9,
			isTestnet: false,
			themeColor: "#68baf9",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "equilibrium-polkadot-substrate-equilibrium-busd",
		data: {
			id: "equilibrium-polkadot-substrate-equilibrium-busd",
			logo: "https://assets.coingecko.com/coins/images/9576/large/BUSD.png?1568947766",
			type: "substrate-equilibrium",
			chain: {
				id: "equilibrium-polkadot"
			},
			symbol: "BUSD",
			assetId: "1651864420",
			decimals: 9,
			isTestnet: false,
			themeColor: "#f0b90b",
			coingeckoId: "binance-usd",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "equilibrium-polkadot-substrate-equilibrium-cd613",
		data: {
			id: "equilibrium-polkadot-substrate-equilibrium-cd613",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/equilibrium-polkadot.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "equilibrium-polkadot"
			},
			symbol: "CD613",
			assetId: "426883035443",
			decimals: 9,
			isTestnet: false,
			themeColor: "#1792ff",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "equilibrium-polkadot-substrate-equilibrium-cd714",
		data: {
			id: "equilibrium-polkadot-substrate-equilibrium-cd714",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/equilibrium-polkadot.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "equilibrium-polkadot"
			},
			symbol: "CD714",
			assetId: "426883100980",
			decimals: 9,
			isTestnet: false,
			themeColor: "#1792ff",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "equilibrium-polkadot-substrate-equilibrium-cd815",
		data: {
			id: "equilibrium-polkadot-substrate-equilibrium-cd815",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/equilibrium-polkadot.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "equilibrium-polkadot"
			},
			symbol: "CD815",
			assetId: "426883166517",
			decimals: 9,
			isTestnet: false,
			themeColor: "#1792ff",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "equilibrium-polkadot-substrate-equilibrium-cru",
		data: {
			id: "equilibrium-polkadot-substrate-equilibrium-cru",
			logo: "https://assets.coingecko.com/coins/images/12549/large/sAB3KVzD_400x400.jpg?1600680411",
			type: "substrate-equilibrium",
			chain: {
				id: "equilibrium-polkadot"
			},
			symbol: "CRU",
			assetId: "6517365",
			decimals: 9,
			isTestnet: false,
			themeColor: "#fc8b11",
			coingeckoId: "crust-network",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "equilibrium-polkadot-substrate-equilibrium-dot",
		data: {
			id: "equilibrium-polkadot-substrate-equilibrium-dot",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/dot.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "equilibrium-polkadot"
			},
			symbol: "DOT",
			assetId: "6582132",
			decimals: 9,
			isTestnet: false,
			themeColor: "#e6007a",
			coingeckoId: "polkadot",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "equilibrium-polkadot-substrate-equilibrium-eq",
		data: {
			id: "equilibrium-polkadot-substrate-equilibrium-eq",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/eq.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "equilibrium-polkadot"
			},
			symbol: "EQ",
			assetId: "25969",
			decimals: 9,
			isTestnet: false,
			themeColor: "#e6f2ff",
			coingeckoId: "equilibrium-token",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "equilibrium-polkadot"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "equilibrium-polkadot-substrate-equilibrium-eqd",
		data: {
			id: "equilibrium-polkadot-substrate-equilibrium-eqd",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/eqd.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "equilibrium-polkadot"
			},
			symbol: "EQD",
			assetId: "6648164",
			decimals: 9,
			isTestnet: false,
			themeColor: "#3897f9",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "equilibrium-polkadot-substrate-equilibrium-eqdot",
		data: {
			id: "equilibrium-polkadot-substrate-equilibrium-eqdot",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/eqdot.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "equilibrium-polkadot"
			},
			symbol: "EQDOT",
			assetId: "435694104436",
			decimals: 9,
			isTestnet: false,
			themeColor: "#f9fafb",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "equilibrium-polkadot-substrate-equilibrium-glmr",
		data: {
			id: "equilibrium-polkadot-substrate-equilibrium-glmr",
			logo: "https://assets.coingecko.com/coins/images/22459/large/glmr.png?1641880985",
			type: "substrate-equilibrium",
			chain: {
				id: "equilibrium-polkadot"
			},
			symbol: "GLMR",
			assetId: "1735159154",
			decimals: 9,
			isTestnet: false,
			themeColor: "#53cbc8",
			coingeckoId: "moonbeam",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "equilibrium-polkadot-substrate-equilibrium-ibtc",
		data: {
			id: "equilibrium-polkadot-substrate-equilibrium-ibtc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ibtc.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "equilibrium-polkadot"
			},
			symbol: "iBTC",
			assetId: "1768060003",
			decimals: 9,
			isTestnet: false,
			themeColor: "#ffffff",
			coingeckoId: "interbtc",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "equilibrium-polkadot-substrate-equilibrium-intr",
		data: {
			id: "equilibrium-polkadot-substrate-equilibrium-intr",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/intr.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "equilibrium-polkadot"
			},
			symbol: "INTR",
			assetId: "1768846450",
			decimals: 9,
			isTestnet: false,
			themeColor: "#ffffff",
			coingeckoId: "interlay",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "equilibrium-polkadot-substrate-equilibrium-lit",
		data: {
			id: "equilibrium-polkadot-substrate-equilibrium-lit",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/equilibrium-polkadot.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "equilibrium-polkadot"
			},
			symbol: "LIT",
			assetId: "7104884",
			decimals: 9,
			isTestnet: false,
			themeColor: "#1792ff",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "equilibrium-polkadot-substrate-equilibrium-lpt0",
		data: {
			id: "equilibrium-polkadot-substrate-equilibrium-lpt0",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/equilibrium-polkadot.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "equilibrium-polkadot"
			},
			symbol: "LPT0",
			assetId: "1819309104",
			decimals: 9,
			isTestnet: false,
			themeColor: "#1792ff",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "equilibrium-polkadot-substrate-equilibrium-lpt1",
		data: {
			id: "equilibrium-polkadot-substrate-equilibrium-lpt1",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/equilibrium-polkadot.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "equilibrium-polkadot"
			},
			symbol: "LPT1",
			assetId: "1819309105",
			decimals: 9,
			isTestnet: false,
			themeColor: "#1792ff",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "equilibrium-polkadot-substrate-equilibrium-mxeth",
		data: {
			id: "equilibrium-polkadot-substrate-equilibrium-mxeth",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/equilibrium-polkadot.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "equilibrium-polkadot"
			},
			symbol: "MXETH",
			assetId: "470171350120",
			decimals: 9,
			isTestnet: false,
			themeColor: "#1792ff",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "equilibrium-polkadot-substrate-equilibrium-mxusdc",
		data: {
			id: "equilibrium-polkadot-substrate-equilibrium-mxusdc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/equilibrium-polkadot.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "equilibrium-polkadot"
			},
			symbol: "MXUSDC",
			assetId: "120364133999715",
			decimals: 9,
			isTestnet: false,
			themeColor: "#1792ff",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "equilibrium-polkadot-substrate-equilibrium-mxwbtc",
		data: {
			id: "equilibrium-polkadot-substrate-equilibrium-mxwbtc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/equilibrium-polkadot.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "equilibrium-polkadot"
			},
			symbol: "MXWBTC",
			assetId: "120364166444131",
			decimals: 9,
			isTestnet: false,
			themeColor: "#1792ff",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "equilibrium-polkadot-substrate-equilibrium-para",
		data: {
			id: "equilibrium-polkadot-substrate-equilibrium-para",
			logo: "https://assets.coingecko.com/coins/images/27219/large/parallel_finance.png?1662615534",
			type: "substrate-equilibrium",
			chain: {
				id: "equilibrium-polkadot"
			},
			symbol: "PARA",
			assetId: "1885434465",
			decimals: 9,
			isTestnet: false,
			themeColor: "#ffffff",
			coingeckoId: "parallel-finance",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "equilibrium-polkadot-substrate-equilibrium-pha",
		data: {
			id: "equilibrium-polkadot-substrate-equilibrium-pha",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/equilibrium-polkadot.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "equilibrium-polkadot"
			},
			symbol: "PHA",
			assetId: "7366753",
			decimals: 9,
			isTestnet: false,
			themeColor: "#1792ff",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "equilibrium-polkadot-substrate-equilibrium-usdt",
		data: {
			id: "equilibrium-polkadot-substrate-equilibrium-usdt",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/usdt.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "equilibrium-polkadot"
			},
			symbol: "USDT",
			assetId: "1970496628",
			decimals: 9,
			isTestnet: false,
			themeColor: "#53ae94",
			coingeckoId: "tether",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "equilibrium-polkadot-substrate-equilibrium-xdot",
		data: {
			id: "equilibrium-polkadot-substrate-equilibrium-xdot",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/equilibrium-polkadot-substrate-equilibrium-xdot.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "equilibrium-polkadot"
			},
			symbol: "XDOT",
			assetId: "2019848052",
			decimals: 9,
			isTestnet: false,
			themeColor: "#233445",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "equilibrium-polkadot-substrate-equilibrium-xdot2",
		data: {
			id: "equilibrium-polkadot-substrate-equilibrium-xdot2",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/equilibrium-polkadot-substrate-equilibrium-xdot2.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "equilibrium-polkadot"
			},
			symbol: "XDOT2",
			assetId: "517081101362",
			decimals: 9,
			isTestnet: false,
			themeColor: "#4c70d4",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "equilibrium-polkadot-substrate-equilibrium-xdot3",
		data: {
			id: "equilibrium-polkadot-substrate-equilibrium-xdot3",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/equilibrium-polkadot-substrate-equilibrium-xdot3.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "equilibrium-polkadot"
			},
			symbol: "XDOT3",
			assetId: "517081101363",
			decimals: 9,
			isTestnet: false,
			themeColor: "#7952da",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "ferrum-testnet-substrate-native-tfrm",
		data: {
			id: "ferrum-testnet-substrate-native-tfrm",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "ferrum-testnet"
			},
			symbol: "tFRM",
			decimals: 18,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "1000000000000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "ferrum-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "fragnova-substrate-native-nova",
		data: {
			id: "fragnova-substrate-native-nova",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "fragnova"
			},
			symbol: "NOVA",
			decimals: 12,
			isTestnet: false,
			themeColor: "#ffffff",
			existentialDeposit: "500"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "fragnova"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "fragnova-testnet-substrate-native-nova",
		data: {
			id: "fragnova-testnet-substrate-native-nova",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "fragnova-testnet"
			},
			symbol: "NOVA",
			decimals: 12,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "500"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "fragnova-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "frequency-substrate-native-frqcy",
		data: {
			id: "frequency-substrate-native-frqcy",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "frequency"
			},
			symbol: "FRQCY",
			decimals: 8,
			isTestnet: false,
			themeColor: "#ffffff",
			existentialDeposit: "1000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "frequency"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "genshiro-kusama-substrate-equilibrium-bnb",
		data: {
			id: "genshiro-kusama-substrate-equilibrium-bnb",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/genshiro-kusama.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "genshiro-kusama"
			},
			symbol: "BNB",
			assetId: "6450786",
			decimals: 9,
			isTestnet: false,
			themeColor: "#e8662d",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "genshiro-kusama-substrate-equilibrium-busd",
		data: {
			id: "genshiro-kusama-substrate-equilibrium-busd",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/genshiro-kusama.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "genshiro-kusama"
			},
			symbol: "BUSD",
			assetId: "1651864420",
			decimals: 9,
			isTestnet: false,
			themeColor: "#e8662d",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "genshiro-kusama-substrate-equilibrium-crv",
		data: {
			id: "genshiro-kusama-substrate-equilibrium-crv",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/genshiro-kusama.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "genshiro-kusama"
			},
			symbol: "CRV",
			assetId: "6517366",
			decimals: 9,
			isTestnet: false,
			themeColor: "#e8662d",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "genshiro-kusama-substrate-equilibrium-dai",
		data: {
			id: "genshiro-kusama-substrate-equilibrium-dai",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/genshiro-kusama.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "genshiro-kusama"
			},
			symbol: "DAI",
			assetId: "6578537",
			decimals: 9,
			isTestnet: false,
			themeColor: "#e8662d",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "genshiro-kusama-substrate-equilibrium-dot",
		data: {
			id: "genshiro-kusama-substrate-equilibrium-dot",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/dot.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "genshiro-kusama"
			},
			symbol: "DOT",
			assetId: "6582132",
			decimals: 9,
			isTestnet: false,
			themeColor: "#e6007a",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "genshiro-kusama-substrate-equilibrium-eqd",
		data: {
			id: "genshiro-kusama-substrate-equilibrium-eqd",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/eqd.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "genshiro-kusama"
			},
			symbol: "EQD",
			assetId: "6648164",
			decimals: 9,
			isTestnet: false,
			themeColor: "#3897f9",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "genshiro-kusama-substrate-equilibrium-eth",
		data: {
			id: "genshiro-kusama-substrate-equilibrium-eth",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/eth.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "genshiro-kusama"
			},
			symbol: "ETH",
			assetId: "6648936",
			decimals: 9,
			isTestnet: false,
			themeColor: "#8a92b2",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "genshiro-kusama-substrate-equilibrium-gens",
		data: {
			id: "genshiro-kusama-substrate-equilibrium-gens",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/genshiro-kusama.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "genshiro-kusama"
			},
			symbol: "GENS",
			assetId: "1734700659",
			decimals: 9,
			isTestnet: false,
			themeColor: "#e8662d",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "genshiro-kusama-substrate-equilibrium-hdot",
		data: {
			id: "genshiro-kusama-substrate-equilibrium-hdot",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/genshiro-kusama.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "genshiro-kusama"
			},
			symbol: "HDOT",
			assetId: "1751412596",
			decimals: 9,
			isTestnet: false,
			themeColor: "#e8662d",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "genshiro-kusama-substrate-equilibrium-hko",
		data: {
			id: "genshiro-kusama-substrate-equilibrium-hko",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/genshiro-kusama.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "genshiro-kusama"
			},
			symbol: "HKO",
			assetId: "6843247",
			decimals: 9,
			isTestnet: false,
			themeColor: "#e8662d",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "genshiro-kusama-substrate-equilibrium-kar",
		data: {
			id: "genshiro-kusama-substrate-equilibrium-kar",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/kar.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "genshiro-kusama"
			},
			symbol: "KAR",
			assetId: "7037298",
			decimals: 9,
			isTestnet: false,
			themeColor: "#f93d43",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "genshiro-kusama-substrate-equilibrium-ksm",
		data: {
			id: "genshiro-kusama-substrate-equilibrium-ksm",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ksm.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "genshiro-kusama"
			},
			symbol: "KSM",
			assetId: "7041901",
			decimals: 9,
			isTestnet: false,
			themeColor: "#ffffff",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "genshiro-kusama-substrate-equilibrium-lpt0",
		data: {
			id: "genshiro-kusama-substrate-equilibrium-lpt0",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/genshiro-kusama.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "genshiro-kusama"
			},
			symbol: "LPT0",
			assetId: "1819309104",
			decimals: 9,
			isTestnet: false,
			themeColor: "#e8662d",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "genshiro-kusama-substrate-equilibrium-usdc",
		data: {
			id: "genshiro-kusama-substrate-equilibrium-usdc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/genshiro-kusama.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "genshiro-kusama"
			},
			symbol: "USDC",
			assetId: "1970496611",
			decimals: 9,
			isTestnet: false,
			themeColor: "#e8662d",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "genshiro-kusama-substrate-equilibrium-usdt",
		data: {
			id: "genshiro-kusama-substrate-equilibrium-usdt",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/usdt.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "genshiro-kusama"
			},
			symbol: "USDT",
			assetId: "1970496628",
			decimals: 9,
			isTestnet: false,
			themeColor: "#53ae94",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "genshiro-kusama-substrate-equilibrium-wbtc",
		data: {
			id: "genshiro-kusama-substrate-equilibrium-wbtc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/genshiro-kusama.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "genshiro-kusama"
			},
			symbol: "WBTC",
			assetId: "2002941027",
			decimals: 9,
			isTestnet: false,
			themeColor: "#e8662d",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "genshiro-kusama-substrate-equilibrium-xdot",
		data: {
			id: "genshiro-kusama-substrate-equilibrium-xdot",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/genshiro-kusama.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "genshiro-kusama"
			},
			symbol: "XDOT",
			assetId: "2019848052",
			decimals: 9,
			isTestnet: false,
			themeColor: "#e8662d",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "genshiro-kusama-substrate-equilibrium-xdot2",
		data: {
			id: "genshiro-kusama-substrate-equilibrium-xdot2",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/genshiro-kusama.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "genshiro-kusama"
			},
			symbol: "XDOT2",
			assetId: "517081101362",
			decimals: 9,
			isTestnet: false,
			themeColor: "#e8662d",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "genshiro-kusama-substrate-equilibrium-xdot3",
		data: {
			id: "genshiro-kusama-substrate-equilibrium-xdot3",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/genshiro-kusama.svg",
			type: "substrate-equilibrium",
			chain: {
				id: "genshiro-kusama"
			},
			symbol: "XDOT3",
			assetId: "517081101363",
			decimals: 9,
			isTestnet: false,
			themeColor: "#e8662d",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "gm-substrate-native-fren",
		data: {
			id: "gm-substrate-native-fren",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/fren.svg",
			type: "substrate-native",
			chain: {
				id: "gm"
			},
			symbol: "FREN",
			decimals: 12,
			isTestnet: false,
			themeColor: "#9d318b",
			existentialDeposit: "1000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "gm"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "gm-substrate-tokens-gm",
		data: {
			id: "gm-substrate-tokens-gm",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/gm.svg",
			type: "substrate-tokens",
			chain: {
				id: "gm"
			},
			symbol: "GM",
			decimals: 0,
			isTestnet: false,
			onChainId: 1,
			themeColor: "#e07445",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "gm-substrate-tokens-gn",
		data: {
			id: "gm-substrate-tokens-gn",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/gn.svg",
			type: "substrate-tokens",
			chain: {
				id: "gm"
			},
			symbol: "GN",
			decimals: 0,
			isTestnet: false,
			onChainId: 2,
			themeColor: "#85338c",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "hashed-substrate-native-hash",
		data: {
			id: "hashed-substrate-native-hash",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/hashed.svg",
			type: "substrate-native",
			chain: {
				id: "hashed"
			},
			symbol: "HASH",
			decimals: 18,
			isTestnet: false,
			themeColor: "#22b6b4",
			existentialDeposit: "1000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "hashed"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "heiko-kusama-substrate-native-hko",
		data: {
			id: "heiko-kusama-substrate-native-hko",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/heiko-kusama.svg",
			type: "substrate-native",
			chain: {
				id: "heiko-kusama"
			},
			symbol: "HKO",
			decimals: 12,
			isTestnet: false,
			themeColor: "#f026a8",
			existentialDeposit: "10000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "heiko-kusama"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "humanode-substrate-native-hmnd",
		data: {
			id: "humanode-substrate-native-hmnd",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "humanode"
			},
			symbol: "HMND",
			decimals: 18,
			isTestnet: false,
			themeColor: "#ffffff",
			existentialDeposit: "500"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "humanode"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "hydradx-substrate-native-hdx",
		data: {
			id: "hydradx-substrate-native-hdx",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/hydradx.svg",
			type: "substrate-native",
			chain: {
				id: "hydradx"
			},
			symbol: "HDX",
			decimals: 12,
			isTestnet: false,
			themeColor: "#52b2ed",
			coingeckoId: "hydradx",
			existentialDeposit: "1000000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "hydradx"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "hydradx-substrate-tokens-ape",
		data: {
			id: "hydradx-substrate-tokens-ape",
			logo: "https://assets.coingecko.com/coins/images/24383/large/apecoin.jpg?1647476455",
			type: "substrate-tokens",
			chain: {
				id: "hydradx"
			},
			symbol: "APE",
			decimals: 18,
			isTestnet: false,
			onChainId: 6,
			themeColor: "#ffffff",
			coingeckoId: "apecoin",
			existentialDeposit: "2518891687657430"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "hydradx-substrate-tokens-astr",
		data: {
			id: "hydradx-substrate-tokens-astr",
			logo: "https://assets.coingecko.com/coins/images/22617/large/astr.png?1642314057",
			type: "substrate-tokens",
			chain: {
				id: "hydradx"
			},
			symbol: "ASTR",
			decimals: 18,
			isTestnet: false,
			onChainId: 9,
			themeColor: "#0089f6",
			coingeckoId: "astar",
			existentialDeposit: "147058823529412000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "hydradx-substrate-tokens-bnc",
		data: {
			id: "hydradx-substrate-tokens-bnc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/bnc.svg",
			type: "substrate-tokens",
			chain: {
				id: "hydradx"
			},
			symbol: "BNC",
			decimals: 12,
			isTestnet: false,
			onChainId: 14,
			themeColor: "#68baf9",
			coingeckoId: "bifrost-native-coin",
			existentialDeposit: "68795189840"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "hydradx-substrate-tokens-cfg",
		data: {
			id: "hydradx-substrate-tokens-cfg",
			logo: "https://assets.coingecko.com/coins/images/15380/large/centrifuge.PNG?1620695821",
			type: "substrate-tokens",
			chain: {
				id: "hydradx"
			},
			symbol: "CFG",
			decimals: 18,
			isTestnet: false,
			onChainId: 13,
			themeColor: "#ffffff",
			coingeckoId: "centrifuge",
			existentialDeposit: "32467532467532500"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "hydradx-substrate-tokens-dai",
		data: {
			id: "hydradx-substrate-tokens-dai",
			logo: "https://assets.coingecko.com/coins/images/9956/large/Badge_Dai.png?1687143508",
			type: "substrate-tokens",
			chain: {
				id: "hydradx"
			},
			symbol: "DAI",
			decimals: 18,
			isTestnet: false,
			onChainId: 2,
			themeColor: "#fab222",
			coingeckoId: "dai",
			existentialDeposit: "10000000000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "hydradx-substrate-tokens-dot",
		data: {
			id: "hydradx-substrate-tokens-dot",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/dot.svg",
			type: "substrate-tokens",
			chain: {
				id: "hydradx"
			},
			symbol: "DOT",
			decimals: 10,
			isTestnet: false,
			onChainId: 5,
			themeColor: "#e6007a",
			coingeckoId: "polkadot",
			existentialDeposit: "17540000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "hydradx-substrate-tokens-ibtc",
		data: {
			id: "hydradx-substrate-tokens-ibtc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ibtc.svg",
			type: "substrate-tokens",
			chain: {
				id: "hydradx"
			},
			symbol: "iBTC",
			decimals: 8,
			isTestnet: false,
			onChainId: 11,
			themeColor: "#ffffff",
			coingeckoId: "interbtc",
			existentialDeposit: "36"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "hydradx-substrate-tokens-lrna",
		data: {
			id: "hydradx-substrate-tokens-lrna",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/hydradx.svg",
			type: "substrate-tokens",
			chain: {
				id: "hydradx"
			},
			symbol: "LRNA",
			decimals: 12,
			isTestnet: false,
			onChainId: 1,
			themeColor: "#52b2ed",
			existentialDeposit: "400000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "hydradx-substrate-tokens-pha",
		data: {
			id: "hydradx-substrate-tokens-pha",
			logo: "https://assets.coingecko.com/coins/images/12451/large/phala.png?1600061318",
			type: "substrate-tokens",
			chain: {
				id: "hydradx"
			},
			symbol: "PHA",
			decimals: 12,
			isTestnet: false,
			onChainId: 8,
			themeColor: "#ffffff",
			coingeckoId: "pha",
			existentialDeposit: "54945054945"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "hydradx-substrate-tokens-usdc",
		data: {
			id: "hydradx-substrate-tokens-usdc",
			logo: "https://assets.coingecko.com/coins/images/6319/large/USD_Coin_icon.png?1547042389",
			type: "substrate-tokens",
			chain: {
				id: "hydradx"
			},
			symbol: "USDC",
			decimals: 6,
			isTestnet: false,
			onChainId: 7,
			themeColor: "#2775ca",
			coingeckoId: "usd-coin",
			existentialDeposit: "10000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "hydradx-substrate-tokens-usdt",
		data: {
			id: "hydradx-substrate-tokens-usdt",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/usdt.svg",
			type: "substrate-tokens",
			chain: {
				id: "hydradx"
			},
			symbol: "USDT",
			decimals: 6,
			isTestnet: false,
			onChainId: 10,
			themeColor: "#53ae94",
			coingeckoId: "tether",
			existentialDeposit: "10000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "hydradx-substrate-tokens-vdot",
		data: {
			id: "hydradx-substrate-tokens-vdot",
			logo: "https://assets.coingecko.com/coins/images/12171/large/polkadot.png?1639712644",
			type: "substrate-tokens",
			chain: {
				id: "hydradx"
			},
			symbol: "vDOT",
			decimals: 10,
			isTestnet: false,
			onChainId: 15,
			themeColor: "#e6007a",
			coingeckoId: "polkadot",
			existentialDeposit: "18761726"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "hydradx-substrate-tokens-wbtc",
		data: {
			id: "hydradx-substrate-tokens-wbtc",
			logo: "https://assets.coingecko.com/coins/images/1/large/bitcoin.png?1547033579",
			type: "substrate-tokens",
			chain: {
				id: "hydradx"
			},
			symbol: "WBTC",
			decimals: 8,
			isTestnet: false,
			onChainId: 3,
			themeColor: "#f7931a",
			coingeckoId: "bitcoin",
			existentialDeposit: "44"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "hydradx-substrate-tokens-weth",
		data: {
			id: "hydradx-substrate-tokens-weth",
			logo: "https://assets.coingecko.com/coins/images/279/large/ethereum.png?1595348880",
			type: "substrate-tokens",
			chain: {
				id: "hydradx"
			},
			symbol: "WETH",
			decimals: 18,
			isTestnet: false,
			onChainId: 4,
			themeColor: "#62688f",
			coingeckoId: "ethereum",
			existentialDeposit: "7000000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "hydradx-substrate-tokens-ztg",
		data: {
			id: "hydradx-substrate-tokens-ztg",
			logo: "https://assets.coingecko.com/coins/images/26210/large/LsjPurB1DcPm4cjLIZPNwmf9HP4qi-AZNesp9jIeLTwhQqYcdazsjTB4WgmZIVxf0KRpJQ2FQRY4q85MO2xkhi4Ygml1LoFXSG0zbF79I2jth4c5MeJh65SCyXQ15JxBKP4inx0NmJqnzNVS5jIorb3IYowlrySARMc6hFIDq-t02Ax6gVqSxERewbJ_ZkuSWPMdB3do_ko-ccdFKyG.jpg?1656921495",
			type: "substrate-tokens",
			chain: {
				id: "hydradx"
			},
			symbol: "ZTG",
			decimals: 10,
			isTestnet: false,
			onChainId: 12,
			themeColor: "#ffffff",
			coingeckoId: "zeitgeist",
			existentialDeposit: "1204151916"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "imbue-substrate-native-imbu",
		data: {
			id: "imbue-substrate-native-imbu",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/imbue.svg",
			type: "substrate-native",
			chain: {
				id: "imbue"
			},
			symbol: "IMBU",
			decimals: 12,
			isTestnet: false,
			themeColor: "#97ff00",
			coingeckoId: "imbue-network",
			existentialDeposit: "100000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "imbue"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "integritee-kusama-substrate-native-teer",
		data: {
			id: "integritee-kusama-substrate-native-teer",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/integritee-kusama.svg",
			type: "substrate-native",
			chain: {
				id: "integritee-kusama"
			},
			symbol: "TEER",
			decimals: 12,
			isTestnet: false,
			themeColor: "#777aac",
			coingeckoId: "integritee",
			existentialDeposit: "1000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "integritee-kusama"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "integritee-polkadot-substrate-native-teer",
		data: {
			id: "integritee-polkadot-substrate-native-teer",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/integritee-polkadot.svg",
			type: "substrate-native",
			chain: {
				id: "integritee-polkadot"
			},
			symbol: "TEER",
			decimals: 12,
			isTestnet: false,
			themeColor: "#777aac",
			coingeckoId: "integritee",
			existentialDeposit: "1000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "integritee-polkadot"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "interlay-substrate-native-intr",
		data: {
			id: "interlay-substrate-native-intr",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/intr.svg",
			type: "substrate-native",
			chain: {
				id: "interlay"
			},
			symbol: "INTR",
			decimals: 10,
			isTestnet: false,
			themeColor: "#ffffff",
			coingeckoId: "interlay",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "interlay-substrate-orml-dot",
		data: {
			id: "interlay-substrate-orml-dot",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/dot.svg",
			type: "substrate-orml",
			chain: {
				id: "interlay"
			},
			symbol: "DOT",
			decimals: 10,
			stateKey: "0x01a12dfa1fa4ab9a0000",
			isTestnet: false,
			themeColor: "#e6007a",
			coingeckoId: "polkadot",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "interlay-substrate-orml-ibtc",
		data: {
			id: "interlay-substrate-orml-ibtc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ibtc.svg",
			type: "substrate-orml",
			chain: {
				id: "interlay"
			},
			symbol: "iBTC",
			decimals: 8,
			stateKey: "0xd67c5ba80ba065480001",
			isTestnet: false,
			themeColor: "#ffffff",
			coingeckoId: "interbtc",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "interlay-substrate-orml-intr",
		data: {
			id: "interlay-substrate-orml-intr",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/intr.svg",
			type: "substrate-orml",
			chain: {
				id: "interlay"
			},
			symbol: "INTR",
			decimals: 10,
			stateKey: "0xc483de2de1246ea70002",
			isTestnet: false,
			themeColor: "#ffffff",
			coingeckoId: "interlay",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "interlay"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "interlay-substrate-orml-kbtc",
		data: {
			id: "interlay-substrate-orml-kbtc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/kbtc.svg",
			type: "substrate-orml",
			chain: {
				id: "interlay"
			},
			symbol: "kBTC",
			decimals: 8,
			stateKey: "0x1fce6bee3ae455b7000b",
			isTestnet: false,
			themeColor: "#ffffff",
			coingeckoId: "kintsugi-btc",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "interlay-substrate-orml-kint",
		data: {
			id: "interlay-substrate-orml-kint",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/kint.svg",
			type: "substrate-orml",
			chain: {
				id: "interlay"
			},
			symbol: "KINT",
			decimals: 12,
			stateKey: "0x56a60a12d72ef524000c",
			isTestnet: false,
			themeColor: "#bf9e82",
			coingeckoId: "kintsugi",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "interlay-substrate-orml-ksm",
		data: {
			id: "interlay-substrate-orml-ksm",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ksm.svg",
			type: "substrate-orml",
			chain: {
				id: "interlay"
			},
			symbol: "KSM",
			decimals: 12,
			stateKey: "0x459d0fd09ec38ee6000a",
			isTestnet: false,
			themeColor: "#ffffff",
			coingeckoId: "kusama",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "interlay-substrate-tokens-ldot",
		data: {
			id: "interlay-substrate-tokens-ldot",
			logo: "https://assets.coingecko.com/coins/images/25847/large/iShot2022-06-02_13.14.07-removebg-preview.png?1654146888",
			type: "substrate-tokens",
			chain: {
				id: "interlay"
			},
			symbol: "LDOT",
			decimals: 10,
			isTestnet: false,
			onChainId: "{\"ForeignAsset\":1}",
			themeColor: "#ffd8e5",
			coingeckoId: "liquid-staking-dot",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "interlay-substrate-tokens-lp-dot-intr",
		data: {
			id: "interlay-substrate-tokens-lp-dot-intr",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/interlay.svg",
			type: "substrate-tokens",
			chain: {
				id: "interlay"
			},
			symbol: "lp DOT-INTR",
			decimals: 18,
			isTestnet: false,
			onChainId: "{\"LpToken\":[{\"Token\":\"DOT\"},{\"Token\":\"INTR\"}]}",
			themeColor: "#948d9d",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "interlay-substrate-tokens-lp-ibtc-dot",
		data: {
			id: "interlay-substrate-tokens-lp-ibtc-dot",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/interlay.svg",
			type: "substrate-tokens",
			chain: {
				id: "interlay"
			},
			symbol: "lp iBTC-DOT",
			decimals: 18,
			isTestnet: false,
			onChainId: "{\"LpToken\":[{\"Token\":\"IBTC\"},{\"Token\":\"DOT\"}]}",
			themeColor: "#948d9d",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "interlay-substrate-tokens-lp-ibtc-usdt",
		data: {
			id: "interlay-substrate-tokens-lp-ibtc-usdt",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/interlay.svg",
			type: "substrate-tokens",
			chain: {
				id: "interlay"
			},
			symbol: "lp iBTC-USDT",
			decimals: 18,
			isTestnet: false,
			onChainId: "{\"LpToken\":[{\"Token\":\"IBTC\"},{\"ForeignAsset\":2}]}",
			themeColor: "#948d9d",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "interlay-substrate-tokens-qdot",
		data: {
			id: "interlay-substrate-tokens-qdot",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/qdot.svg",
			type: "substrate-tokens",
			chain: {
				id: "interlay"
			},
			symbol: "qDOT",
			decimals: 10,
			isTestnet: false,
			onChainId: "{\"LendToken\":2}",
			themeColor: "#311caf",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "interlay-substrate-tokens-qibtc",
		data: {
			id: "interlay-substrate-tokens-qibtc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/qibtc.svg",
			type: "substrate-tokens",
			chain: {
				id: "interlay"
			},
			symbol: "qIBTC",
			decimals: 8,
			isTestnet: false,
			onChainId: "{\"LendToken\":1}",
			themeColor: "#c4bee8",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "interlay-substrate-tokens-qusdt",
		data: {
			id: "interlay-substrate-tokens-qusdt",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/qusdt.svg",
			type: "substrate-tokens",
			chain: {
				id: "interlay"
			},
			symbol: "qUSDT",
			decimals: 6,
			isTestnet: false,
			onChainId: "{\"LendToken\":3}",
			themeColor: "#311caf",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "interlay-substrate-tokens-usdt",
		data: {
			id: "interlay-substrate-tokens-usdt",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/usdt.svg",
			type: "substrate-tokens",
			chain: {
				id: "interlay"
			},
			symbol: "USDT",
			decimals: 6,
			isTestnet: false,
			onChainId: "{\"ForeignAsset\":2}",
			themeColor: "#53ae94",
			coingeckoId: "tether",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "interlay-testnet-standalone-substrate-native-intr",
		data: {
			id: "interlay-testnet-standalone-substrate-native-intr",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/intr.svg",
			type: "substrate-native",
			chain: {
				id: "interlay-testnet-standalone"
			},
			symbol: "INTR",
			decimals: 10,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "interlay-testnet-standalone"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "interlay-testnet-standalone-substrate-orml-dot",
		data: {
			id: "interlay-testnet-standalone-substrate-orml-dot",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/dot.svg",
			type: "substrate-orml",
			chain: {
				id: "interlay-testnet-standalone"
			},
			symbol: "DOT",
			decimals: 10,
			stateKey: "0x01a12dfa1fa4ab9a0000",
			isTestnet: true,
			themeColor: "#e6007a",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "interlay-testnet-standalone-substrate-orml-ibtc",
		data: {
			id: "interlay-testnet-standalone-substrate-orml-ibtc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ibtc.svg",
			type: "substrate-orml",
			chain: {
				id: "interlay-testnet-standalone"
			},
			symbol: "IBTC",
			decimals: 8,
			stateKey: "0xd67c5ba80ba065480001",
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "interlay-testnet-standalone-substrate-orml-intr",
		data: {
			id: "interlay-testnet-standalone-substrate-orml-intr",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/intr.svg",
			type: "substrate-orml",
			chain: {
				id: "interlay-testnet-standalone"
			},
			symbol: "INTR",
			decimals: 10,
			stateKey: "0xc483de2de1246ea70002",
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "interlay-testnet-standalone-substrate-orml-kbtc",
		data: {
			id: "interlay-testnet-standalone-substrate-orml-kbtc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/kbtc.svg",
			type: "substrate-orml",
			chain: {
				id: "interlay-testnet-standalone"
			},
			symbol: "KBTC",
			decimals: 8,
			stateKey: "0x1fce6bee3ae455b7000b",
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "interlay-testnet-standalone-substrate-orml-kint",
		data: {
			id: "interlay-testnet-standalone-substrate-orml-kint",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/kint.svg",
			type: "substrate-orml",
			chain: {
				id: "interlay-testnet-standalone"
			},
			symbol: "KINT",
			decimals: 12,
			stateKey: "0x56a60a12d72ef524000c",
			isTestnet: true,
			themeColor: "#bf9e82",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "interlay-testnet-standalone-substrate-orml-ksm",
		data: {
			id: "interlay-testnet-standalone-substrate-orml-ksm",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ksm.svg",
			type: "substrate-orml",
			chain: {
				id: "interlay-testnet-standalone"
			},
			symbol: "KSM",
			decimals: 12,
			stateKey: "0x459d0fd09ec38ee6000a",
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "ipci-substrate-native-mito",
		data: {
			id: "ipci-substrate-native-mito",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "ipci"
			},
			symbol: "MITO",
			decimals: 12,
			isTestnet: false,
			themeColor: "#ffffff",
			existentialDeposit: "1000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "ipci"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "joystream-substrate-native-joy",
		data: {
			id: "joystream-substrate-native-joy",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/joystream.svg",
			type: "substrate-native",
			chain: {
				id: "joystream"
			},
			symbol: "JOY",
			decimals: 10,
			isTestnet: false,
			themeColor: "#4038ff",
			existentialDeposit: "266666560"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "joystream"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "jur-substrate-native-jur",
		data: {
			id: "jur-substrate-native-jur",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "jur"
			},
			symbol: "JUR",
			decimals: 18,
			isTestnet: false,
			themeColor: "#ffffff",
			existentialDeposit: "500"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "jur"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "jur-testnet-substrate-native-jur",
		data: {
			id: "jur-testnet-substrate-native-jur",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "jur-testnet"
			},
			symbol: "JUR",
			decimals: 18,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "500"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "jur-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "kabocha-substrate-native-kab",
		data: {
			id: "kabocha-substrate-native-kab",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "kabocha"
			},
			symbol: "KAB",
			decimals: 12,
			isTestnet: false,
			themeColor: "#ffffff",
			existentialDeposit: "1000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "kabocha"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "kapex-substrate-native-kpx",
		data: {
			id: "kapex-substrate-native-kpx",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "kapex"
			},
			symbol: "KPX",
			decimals: 12,
			isTestnet: false,
			themeColor: "#ffffff",
			existentialDeposit: "1"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "kapex"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karmachain-testnet-substrate-native-kcoin",
		data: {
			id: "karmachain-testnet-substrate-native-kcoin",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "karmachain-testnet"
			},
			symbol: "KCoin",
			decimals: 6,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "100"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "karmachain-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-native-kar",
		data: {
			id: "karura-substrate-native-kar",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/kar.svg",
			type: "substrate-native",
			chain: {
				id: "karura"
			},
			symbol: "KAR",
			decimals: 12,
			isTestnet: false,
			themeColor: "#f93d43",
			coingeckoId: "karura",
			existentialDeposit: "100000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "karura"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-3usd",
		data: {
			id: "karura-substrate-tokens-3usd",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/3usd.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "3USD",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"StableAssetPoolToken\":1}",
			themeColor: "#b026cf",
			existentialDeposit: "10000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-air",
		data: {
			id: "karura-substrate-tokens-air",
			logo: "https://assets.coingecko.com/coins/images/23548/large/altair.jpeg?1644423866",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "AIR",
			decimals: 18,
			isTestnet: false,
			onChainId: "{\"ForeignAsset\":12}",
			themeColor: "#f9b65d",
			coingeckoId: "altair",
			existentialDeposit: "100000000000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-aris",
		data: {
			id: "karura-substrate-tokens-aris",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/aris.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "ARIS",
			decimals: 8,
			isTestnet: false,
			onChainId: "{\"ForeignAsset\":1}",
			themeColor: "#fa8297",
			existentialDeposit: "1000000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-ausd",
		data: {
			id: "karura-substrate-tokens-ausd",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ausd.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "aUSD",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"Token\":\"KUSD\"}",
			themeColor: "#e40c5b",
			coingeckoId: "acala-dollar",
			existentialDeposit: "10000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-bnc",
		data: {
			id: "karura-substrate-tokens-bnc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/bnc.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "BNC",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"Token\":\"BNC\"}",
			themeColor: "#68baf9",
			coingeckoId: "bifrost-native-coin",
			existentialDeposit: "8000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-bsx",
		data: {
			id: "karura-substrate-tokens-bsx",
			logo: "https://assets.coingecko.com/coins/images/26810/large/bsx.png?1660375348",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "BSX",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"ForeignAsset\":11}",
			themeColor: "#4effb0",
			coingeckoId: "basilisk",
			existentialDeposit: "1000000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-crab",
		data: {
			id: "karura-substrate-tokens-crab",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/crab.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "CRAB",
			decimals: 18,
			isTestnet: false,
			onChainId: "{\"ForeignAsset\":13}",
			themeColor: "#512dbc",
			existentialDeposit: "1000000000000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-csm",
		data: {
			id: "karura-substrate-tokens-csm",
			logo: "https://assets.coingecko.com/coins/images/16037/large/2_mnCYZfHmLg2bFrjM3vKtPw.png?1622680217",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "CSM",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"ForeignAsset\":5}",
			themeColor: "#ffffff",
			coingeckoId: "crust-storage-market",
			existentialDeposit: "1000000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-dai",
		data: {
			id: "karura-substrate-tokens-dai",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/karura.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "DAI",
			decimals: 18,
			isTestnet: false,
			onChainId: "{\"Erc20\":\"0x4bb6afb5fa2b07a5d1c499e1c3ddb5a15e709a71\"}",
			themeColor: "#f93d43",
			existentialDeposit: "10000000000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-eqd",
		data: {
			id: "karura-substrate-tokens-eqd",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/eqd.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "EQD",
			decimals: 9,
			isTestnet: false,
			onChainId: "{\"ForeignAsset\":15}",
			themeColor: "#3897f9",
			existentialDeposit: "10000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-gens",
		data: {
			id: "karura-substrate-tokens-gens",
			logo: "https://assets.coingecko.com/coins/images/16444/large/genshiro.PNG?1624234640",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "GENS",
			decimals: 9,
			isTestnet: false,
			onChainId: "{\"ForeignAsset\":14}",
			themeColor: "#848788",
			coingeckoId: "genshiro",
			existentialDeposit: "1000000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-hko",
		data: {
			id: "karura-substrate-tokens-hko",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/karura.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "HKO",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"ForeignAsset\":4}",
			themeColor: "#f93d43",
			existentialDeposit: "100000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-kbtc",
		data: {
			id: "karura-substrate-tokens-kbtc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/kbtc.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "kBTC",
			decimals: 8,
			isTestnet: false,
			onChainId: "{\"Token\":\"KBTC\"}",
			themeColor: "#ffffff",
			coingeckoId: "kintsugi-btc",
			existentialDeposit: "66"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-kico",
		data: {
			id: "karura-substrate-tokens-kico",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/karura.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "KICO",
			decimals: 14,
			isTestnet: false,
			onChainId: "{\"ForeignAsset\":6}",
			themeColor: "#f93d43",
			existentialDeposit: "100000000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-kint",
		data: {
			id: "karura-substrate-tokens-kint",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/kint.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "KINT",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"Token\":\"KINT\"}",
			themeColor: "#bf9e82",
			coingeckoId: "kintsugi",
			existentialDeposit: "133330000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-kma",
		data: {
			id: "karura-substrate-tokens-kma",
			logo: "https://assets.coingecko.com/coins/images/20976/large/kma.png?1638161627",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "KMA",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"ForeignAsset\":10}",
			themeColor: "#fe981f",
			coingeckoId: "calamari-network",
			existentialDeposit: "100000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-ksm",
		data: {
			id: "karura-substrate-tokens-ksm",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ksm.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "KSM",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"Token\":\"KSM\"}",
			themeColor: "#ffffff",
			coingeckoId: "kusama",
			existentialDeposit: "100000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-lit",
		data: {
			id: "karura-substrate-tokens-lit",
			logo: "https://assets.coingecko.com/coins/images/13825/large/logo_200x200.png?1612153317",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "LIT",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"ForeignAsset\":20}",
			themeColor: "#14ea85",
			coingeckoId: "litentry",
			existentialDeposit: "100000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-lksm",
		data: {
			id: "karura-substrate-tokens-lksm",
			logo: "https://assets.coingecko.com/coins/images/25817/large/LKSM.png?1653992477",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "LKSM",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"Token\":\"LKSM\"}",
			themeColor: "#eb1c53",
			coingeckoId: "liquid-ksm",
			existentialDeposit: "500000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-lp-kar-ksm",
		data: {
			id: "karura-substrate-tokens-lp-kar-ksm",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/karura.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "lp KAR-KSM",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"DexShare\":[{\"Token\":\"KAR\"},{\"Token\":\"KSM\"}]}",
			themeColor: "#f93d43",
			existentialDeposit: "100000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-lp-kar-kusd",
		data: {
			id: "karura-substrate-tokens-lp-kar-kusd",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/karura.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "lp KAR-KUSD",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"DexShare\":[{\"Token\":\"KAR\"},{\"Token\":\"KUSD\"}]}",
			themeColor: "#f93d43",
			existentialDeposit: "100000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-lp-kar-lksm",
		data: {
			id: "karura-substrate-tokens-lp-kar-lksm",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/karura.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "lp KAR-LKSM",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"DexShare\":[{\"Token\":\"KAR\"},{\"Token\":\"LKSM\"}]}",
			themeColor: "#f93d43",
			existentialDeposit: "100000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-lp-kar-qtz",
		data: {
			id: "karura-substrate-tokens-lp-kar-qtz",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/karura.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "lp KAR-QTZ",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"DexShare\":[{\"Token\":\"KAR\"},{\"ForeignAsset\":2}]}",
			themeColor: "#f93d43",
			existentialDeposit: "100000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-lp-ksm-aris",
		data: {
			id: "karura-substrate-tokens-lp-ksm-aris",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/karura.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "lp KSM-ARIS",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"DexShare\":[{\"Token\":\"KSM\"},{\"ForeignAsset\":1}]}",
			themeColor: "#f93d43",
			existentialDeposit: "100000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-lp-ksm-lksm",
		data: {
			id: "karura-substrate-tokens-lp-ksm-lksm",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/karura.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "lp KSM-LKSM",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"DexShare\":[{\"Token\":\"KSM\"},{\"Token\":\"LKSM\"}]}",
			themeColor: "#f93d43",
			existentialDeposit: "100000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-lp-ksm-rmrk",
		data: {
			id: "karura-substrate-tokens-lp-ksm-rmrk",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/karura.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "lp KSM-RMRK",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"DexShare\":[{\"Token\":\"KSM\"},{\"ForeignAsset\":0}]}",
			themeColor: "#f93d43",
			existentialDeposit: "100000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-lp-kusd-air",
		data: {
			id: "karura-substrate-tokens-lp-kusd-air",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/karura.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "lp KUSD-AIR",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"DexShare\":[{\"Token\":\"KUSD\"},{\"ForeignAsset\":12}]}",
			themeColor: "#f93d43",
			existentialDeposit: "10000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-lp-kusd-bnc",
		data: {
			id: "karura-substrate-tokens-lp-kusd-bnc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/karura.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "lp KUSD-BNC",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"DexShare\":[{\"Token\":\"KUSD\"},{\"Token\":\"BNC\"}]}",
			themeColor: "#f93d43",
			existentialDeposit: "10000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-lp-kusd-csm",
		data: {
			id: "karura-substrate-tokens-lp-kusd-csm",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/karura.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "lp KUSD-CSM",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"DexShare\":[{\"Token\":\"KUSD\"},{\"ForeignAsset\":5}]}",
			themeColor: "#f93d43",
			existentialDeposit: "10000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-lp-kusd-kbtc",
		data: {
			id: "karura-substrate-tokens-lp-kusd-kbtc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/karura.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "lp KUSD-KBTC",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"DexShare\":[{\"Token\":\"KUSD\"},{\"Token\":\"KBTC\"}]}",
			themeColor: "#f93d43",
			existentialDeposit: "10000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-lp-kusd-kint",
		data: {
			id: "karura-substrate-tokens-lp-kusd-kint",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/karura.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "lp KUSD-KINT",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"DexShare\":[{\"Token\":\"KUSD\"},{\"Token\":\"KINT\"}]}",
			themeColor: "#f93d43",
			existentialDeposit: "10000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-lp-kusd-ksm",
		data: {
			id: "karura-substrate-tokens-lp-kusd-ksm",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/karura.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "lp KUSD-KSM",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"DexShare\":[{\"Token\":\"KUSD\"},{\"Token\":\"KSM\"}]}",
			themeColor: "#f93d43",
			existentialDeposit: "10000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-lp-kusd-lksm",
		data: {
			id: "karura-substrate-tokens-lp-kusd-lksm",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/karura.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "lp KUSD-LKSM",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"DexShare\":[{\"Token\":\"KUSD\"},{\"Token\":\"LKSM\"}]}",
			themeColor: "#f93d43",
			existentialDeposit: "10000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-lp-kusd-pha",
		data: {
			id: "karura-substrate-tokens-lp-kusd-pha",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/karura.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "lp KUSD-PHA",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"DexShare\":[{\"Token\":\"KUSD\"},{\"Token\":\"PHA\"}]}",
			themeColor: "#f93d43",
			existentialDeposit: "10000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-lp-kusd-qtz",
		data: {
			id: "karura-substrate-tokens-lp-kusd-qtz",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/karura.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "lp KUSD-QTZ",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"DexShare\":[{\"Token\":\"KUSD\"},{\"ForeignAsset\":2}]}",
			themeColor: "#f93d43",
			existentialDeposit: "10000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-lp-kusd-rmrk",
		data: {
			id: "karura-substrate-tokens-lp-kusd-rmrk",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/karura.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "lp KUSD-RMRK",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"DexShare\":[{\"Token\":\"KUSD\"},{\"ForeignAsset\":0}]}",
			themeColor: "#f93d43",
			existentialDeposit: "10000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-lp-tai-tksm",
		data: {
			id: "karura-substrate-tokens-lp-tai-tksm",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/karura.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "lp TAI-tKSM",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"DexShare\":[{\"Token\":\"TAI\"},{\"StableAssetPoolToken\":0}]}",
			themeColor: "#f93d43",
			existentialDeposit: "1000000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-lt",
		data: {
			id: "karura-substrate-tokens-lt",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/karura.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "LT",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"ForeignAsset\":19}",
			themeColor: "#f93d43",
			existentialDeposit: "1000000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-movr",
		data: {
			id: "karura-substrate-tokens-movr",
			logo: "https://assets.coingecko.com/coins/images/17984/large/9285.png?1630028620",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "MOVR",
			decimals: 18,
			isTestnet: false,
			onChainId: "{\"ForeignAsset\":3}",
			themeColor: "#f2b705",
			coingeckoId: "moonriver",
			existentialDeposit: "1000000000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-neer",
		data: {
			id: "karura-substrate-tokens-neer",
			logo: "https://assets.coingecko.com/coins/images/26705/large/14294.png?1659666139",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "NEER",
			decimals: 18,
			isTestnet: false,
			onChainId: "{\"ForeignAsset\":9}",
			themeColor: "#aa47cb",
			coingeckoId: "metaverse-network-pioneer",
			existentialDeposit: "100000000000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-pchu",
		data: {
			id: "karura-substrate-tokens-pchu",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/karura.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "PCHU",
			decimals: 18,
			isTestnet: false,
			onChainId: "{\"ForeignAsset\":17}",
			themeColor: "#f93d43",
			existentialDeposit: "100000000000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-pha",
		data: {
			id: "karura-substrate-tokens-pha",
			logo: "https://assets.coingecko.com/coins/images/12451/large/phala.png?1600061318",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "PHA",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"Token\":\"PHA\"}",
			themeColor: "#ffffff",
			coingeckoId: "pha",
			existentialDeposit: "40000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-qtz",
		data: {
			id: "karura-substrate-tokens-qtz",
			logo: "https://assets.coingecko.com/coins/images/23648/large/Q_logo-short_dark.png?1644911183",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "QTZ",
			decimals: 18,
			isTestnet: false,
			onChainId: "{\"ForeignAsset\":2}",
			themeColor: "#ff4d6a",
			coingeckoId: "quartz",
			existentialDeposit: "1000000000000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-rmrk",
		data: {
			id: "karura-substrate-tokens-rmrk",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/rmrk.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "RMRK",
			decimals: 10,
			isTestnet: false,
			onChainId: "{\"ForeignAsset\":0}",
			themeColor: "#3d2a76",
			coingeckoId: "rmrk",
			existentialDeposit: "100000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-sdn",
		data: {
			id: "karura-substrate-tokens-sdn",
			logo: "https://assets.coingecko.com/coins/images/18027/large/tFOtjrr3_400x400.png?1630291767",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "SDN",
			decimals: 18,
			isTestnet: false,
			onChainId: "{\"ForeignAsset\":18}",
			themeColor: "#744fb7",
			coingeckoId: "shiden",
			existentialDeposit: "10000000000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-tai",
		data: {
			id: "karura-substrate-tokens-tai",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/tai.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "TAI",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"Token\":\"TAI\"}",
			themeColor: "#b026cf",
			coingeckoId: "taiga",
			existentialDeposit: "1000000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-teer",
		data: {
			id: "karura-substrate-tokens-teer",
			logo: "https://assets.coingecko.com/coins/images/21131/large/teer.PNG?1638351281",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "TEER",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"ForeignAsset\":8}",
			themeColor: "#ffffff",
			coingeckoId: "integritee",
			existentialDeposit: "100000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-tksm",
		data: {
			id: "karura-substrate-tokens-tksm",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/tksm.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "tKSM",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"StableAssetPoolToken\":0}",
			themeColor: "#b026cf",
			existentialDeposit: "100000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-tur",
		data: {
			id: "karura-substrate-tokens-tur",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/karura.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "TUR",
			decimals: 10,
			isTestnet: false,
			onChainId: "{\"ForeignAsset\":16}",
			themeColor: "#f93d43",
			existentialDeposit: "40000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-usdcet",
		data: {
			id: "karura-substrate-tokens-usdcet",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/karura.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "USDCet",
			decimals: 6,
			isTestnet: false,
			onChainId: "{\"Erc20\":\"0x1f3a10587a20114ea25ba1b388ee2dd4a337ce27\"}",
			themeColor: "#f93d43",
			existentialDeposit: "10000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-usdt",
		data: {
			id: "karura-substrate-tokens-usdt",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/usdt.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "USDT",
			decimals: 6,
			isTestnet: false,
			onChainId: "{\"ForeignAsset\":7}",
			themeColor: "#53ae94",
			coingeckoId: "tether",
			existentialDeposit: "10000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-vsksm",
		data: {
			id: "karura-substrate-tokens-vsksm",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/karura.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "VSKSM",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"Token\":\"VSKSM\"}",
			themeColor: "#f93d43",
			existentialDeposit: "100000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "karura-substrate-tokens-wausd",
		data: {
			id: "karura-substrate-tokens-wausd",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/karura.svg",
			type: "substrate-tokens",
			chain: {
				id: "karura"
			},
			symbol: "waUSD",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"Erc20\":\"0xe20683ad1ed8bbeed7e1ae74be10f19d8045b530\"}",
			themeColor: "#f93d43",
			existentialDeposit: "100000000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "kate-testnet-substrate-native-avl",
		data: {
			id: "kate-testnet-substrate-native-avl",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "kate-testnet"
			},
			symbol: "AVL",
			decimals: 18,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "10000000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "kate-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "khala-substrate-native-pha",
		data: {
			id: "khala-substrate-native-pha",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/khala.svg",
			type: "substrate-native",
			chain: {
				id: "khala"
			},
			symbol: "PHA",
			decimals: 12,
			isTestnet: false,
			themeColor: "#03ffff",
			coingeckoId: "pha",
			existentialDeposit: "10000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "khala"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "kilt-spiritnet-substrate-native-kilt",
		data: {
			id: "kilt-spiritnet-substrate-native-kilt",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/kilt-spiritnet.svg",
			type: "substrate-native",
			chain: {
				id: "kilt-spiritnet"
			},
			symbol: "KILT",
			decimals: 15,
			isTestnet: false,
			themeColor: "#f66741",
			coingeckoId: "kilt-protocol",
			existentialDeposit: "10000000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "kilt-spiritnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "kilt-testnet-standalone-2-substrate-native-pilt",
		data: {
			id: "kilt-testnet-standalone-2-substrate-native-pilt",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/kilt-testnet-standalone-2.svg",
			type: "substrate-native",
			chain: {
				id: "kilt-testnet-standalone-2"
			},
			symbol: "PILT",
			decimals: 15,
			isTestnet: true,
			themeColor: "#f66741",
			existentialDeposit: "10000000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "kilt-testnet-standalone-2"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "kilt-testnet-standalone-substrate-native-kilt",
		data: {
			id: "kilt-testnet-standalone-substrate-native-kilt",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/kilt-testnet-standalone.svg",
			type: "substrate-native",
			chain: {
				id: "kilt-testnet-standalone"
			},
			symbol: "KILT",
			decimals: 15,
			isTestnet: true,
			themeColor: "#f66741",
			existentialDeposit: "500"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "kilt-testnet-standalone"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "kintsugi-substrate-native-kint",
		data: {
			id: "kintsugi-substrate-native-kint",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/kint.svg",
			type: "substrate-native",
			chain: {
				id: "kintsugi"
			},
			symbol: "KINT",
			decimals: 12,
			isTestnet: false,
			themeColor: "#bf9e82",
			coingeckoId: "kintsugi",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "kintsugi-substrate-orml-dot",
		data: {
			id: "kintsugi-substrate-orml-dot",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/dot.svg",
			type: "substrate-orml",
			chain: {
				id: "kintsugi"
			},
			symbol: "DOT",
			decimals: 10,
			stateKey: "0x01a12dfa1fa4ab9a0000",
			isTestnet: false,
			themeColor: "#e6007a",
			coingeckoId: "polkadot",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "kintsugi-substrate-orml-ibtc",
		data: {
			id: "kintsugi-substrate-orml-ibtc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ibtc.svg",
			type: "substrate-orml",
			chain: {
				id: "kintsugi"
			},
			symbol: "iBTC",
			decimals: 8,
			stateKey: "0xd67c5ba80ba065480001",
			isTestnet: false,
			themeColor: "#ffffff",
			coingeckoId: "interbtc",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "kintsugi-substrate-orml-intr",
		data: {
			id: "kintsugi-substrate-orml-intr",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/intr.svg",
			type: "substrate-orml",
			chain: {
				id: "kintsugi"
			},
			symbol: "INTR",
			decimals: 10,
			stateKey: "0xc483de2de1246ea70002",
			isTestnet: false,
			themeColor: "#ffffff",
			coingeckoId: "interlay",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "kintsugi-substrate-orml-kbtc",
		data: {
			id: "kintsugi-substrate-orml-kbtc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/kbtc.svg",
			type: "substrate-orml",
			chain: {
				id: "kintsugi"
			},
			symbol: "kBTC",
			decimals: 8,
			stateKey: "0x1fce6bee3ae455b7000b",
			isTestnet: false,
			themeColor: "#ffffff",
			coingeckoId: "kintsugi-btc",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "kintsugi-substrate-orml-kint",
		data: {
			id: "kintsugi-substrate-orml-kint",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/kint.svg",
			type: "substrate-orml",
			chain: {
				id: "kintsugi"
			},
			symbol: "KINT",
			decimals: 12,
			stateKey: "0x56a60a12d72ef524000c",
			isTestnet: false,
			themeColor: "#bf9e82",
			coingeckoId: "kintsugi",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "kintsugi"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "kintsugi-substrate-orml-ksm",
		data: {
			id: "kintsugi-substrate-orml-ksm",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ksm.svg",
			type: "substrate-orml",
			chain: {
				id: "kintsugi"
			},
			symbol: "KSM",
			decimals: 12,
			stateKey: "0x459d0fd09ec38ee6000a",
			isTestnet: false,
			themeColor: "#ffffff",
			coingeckoId: "kusama",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "kintsugi-substrate-tokens-ausd",
		data: {
			id: "kintsugi-substrate-tokens-ausd",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ausd.svg",
			type: "substrate-tokens",
			chain: {
				id: "kintsugi"
			},
			symbol: "aUSD",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"ForeignAsset\":1}",
			themeColor: "#e40c5b",
			coingeckoId: "acala-dollar",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "kintsugi-substrate-tokens-lksm",
		data: {
			id: "kintsugi-substrate-tokens-lksm",
			logo: "https://assets.coingecko.com/coins/images/25817/large/LKSM.png?1653992477",
			type: "substrate-tokens",
			chain: {
				id: "kintsugi"
			},
			symbol: "LKSM",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"ForeignAsset\":2}",
			themeColor: "#eb1c53",
			coingeckoId: "liquid-ksm",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "kintsugi-substrate-tokens-lp-kbtc-ksm",
		data: {
			id: "kintsugi-substrate-tokens-lp-kbtc-ksm",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/kintsugi.svg",
			type: "substrate-tokens",
			chain: {
				id: "kintsugi"
			},
			symbol: "lp kBTC-KSM",
			decimals: 18,
			isTestnet: false,
			onChainId: "{\"LpToken\":[{\"Token\":\"KBTC\"},{\"Token\":\"KSM\"}]}",
			themeColor: "#dadad8",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "kintsugi-substrate-tokens-lp-kbtc-usdt",
		data: {
			id: "kintsugi-substrate-tokens-lp-kbtc-usdt",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/kintsugi.svg",
			type: "substrate-tokens",
			chain: {
				id: "kintsugi"
			},
			symbol: "lp kBTC-USDT",
			decimals: 18,
			isTestnet: false,
			onChainId: "{\"LpToken\":[{\"Token\":\"KBTC\"},{\"ForeignAsset\":3}]}",
			themeColor: "#dadad8",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "kintsugi-substrate-tokens-lp-ksm-kint",
		data: {
			id: "kintsugi-substrate-tokens-lp-ksm-kint",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/kintsugi.svg",
			type: "substrate-tokens",
			chain: {
				id: "kintsugi"
			},
			symbol: "lp KSM-KINT",
			decimals: 18,
			isTestnet: false,
			onChainId: "{\"LpToken\":[{\"Token\":\"KSM\"},{\"Token\":\"KINT\"}]}",
			themeColor: "#dadad8",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "kintsugi-substrate-tokens-qkbtc",
		data: {
			id: "kintsugi-substrate-tokens-qkbtc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/qkbtc.svg",
			type: "substrate-tokens",
			chain: {
				id: "kintsugi"
			},
			symbol: "qKBTC",
			decimals: 8,
			isTestnet: false,
			onChainId: "{\"LendToken\":1}",
			themeColor: "#cbbdb8",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "kintsugi-substrate-tokens-qksm",
		data: {
			id: "kintsugi-substrate-tokens-qksm",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/qksm.svg",
			type: "substrate-tokens",
			chain: {
				id: "kintsugi"
			},
			symbol: "qKSM",
			decimals: 12,
			isTestnet: false,
			onChainId: "{\"LendToken\":2}",
			themeColor: "#311caf",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "kintsugi-substrate-tokens-qusdt",
		data: {
			id: "kintsugi-substrate-tokens-qusdt",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/qusdt.svg",
			type: "substrate-tokens",
			chain: {
				id: "kintsugi"
			},
			symbol: "qUSDT",
			decimals: 6,
			isTestnet: false,
			onChainId: "{\"LendToken\":3}",
			themeColor: "#311caf",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "kintsugi-substrate-tokens-usdt",
		data: {
			id: "kintsugi-substrate-tokens-usdt",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/usdt.svg",
			type: "substrate-tokens",
			chain: {
				id: "kintsugi"
			},
			symbol: "USDT",
			decimals: 6,
			isTestnet: false,
			onChainId: "{\"ForeignAsset\":3}",
			themeColor: "#53ae94",
			coingeckoId: "tether",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "kintsugi-testnet-substrate-native-kint",
		data: {
			id: "kintsugi-testnet-substrate-native-kint",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/kint.svg",
			type: "substrate-native",
			chain: {
				id: "kintsugi-testnet"
			},
			symbol: "KINT",
			decimals: 12,
			isTestnet: true,
			themeColor: "#bf9e82",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "kintsugi-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "kintsugi-testnet-substrate-orml-dot",
		data: {
			id: "kintsugi-testnet-substrate-orml-dot",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/dot.svg",
			type: "substrate-orml",
			chain: {
				id: "kintsugi-testnet"
			},
			symbol: "DOT",
			decimals: 10,
			stateKey: "0x01a12dfa1fa4ab9a0000",
			isTestnet: true,
			themeColor: "#e6007a",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "kintsugi-testnet-substrate-orml-ibtc",
		data: {
			id: "kintsugi-testnet-substrate-orml-ibtc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ibtc.svg",
			type: "substrate-orml",
			chain: {
				id: "kintsugi-testnet"
			},
			symbol: "IBTC",
			decimals: 8,
			stateKey: "0xd67c5ba80ba065480001",
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "kintsugi-testnet-substrate-orml-intr",
		data: {
			id: "kintsugi-testnet-substrate-orml-intr",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/intr.svg",
			type: "substrate-orml",
			chain: {
				id: "kintsugi-testnet"
			},
			symbol: "INTR",
			decimals: 10,
			stateKey: "0xc483de2de1246ea70002",
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "kintsugi-testnet-substrate-orml-kbtc",
		data: {
			id: "kintsugi-testnet-substrate-orml-kbtc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/kbtc.svg",
			type: "substrate-orml",
			chain: {
				id: "kintsugi-testnet"
			},
			symbol: "KBTC",
			decimals: 8,
			stateKey: "0x1fce6bee3ae455b7000b",
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "kintsugi-testnet-substrate-orml-kint",
		data: {
			id: "kintsugi-testnet-substrate-orml-kint",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/kint.svg",
			type: "substrate-orml",
			chain: {
				id: "kintsugi-testnet"
			},
			symbol: "KINT",
			decimals: 12,
			stateKey: "0x56a60a12d72ef524000c",
			isTestnet: true,
			themeColor: "#bf9e82",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "kintsugi-testnet-substrate-orml-ksm",
		data: {
			id: "kintsugi-testnet-substrate-orml-ksm",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ksm.svg",
			type: "substrate-orml",
			chain: {
				id: "kintsugi-testnet"
			},
			symbol: "KSM",
			decimals: 12,
			stateKey: "0x459d0fd09ec38ee6000a",
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "krest-substrate-native-krest",
		data: {
			id: "krest-substrate-native-krest",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/krest.svg",
			type: "substrate-native",
			chain: {
				id: "krest"
			},
			symbol: "KREST",
			decimals: 18,
			isTestnet: false,
			themeColor: "#c82901",
			existentialDeposit: "500"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "krest"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "kulupu-substrate-native-klp",
		data: {
			id: "kulupu-substrate-native-klp",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "kulupu"
			},
			symbol: "KLP",
			decimals: 12,
			isTestnet: false,
			themeColor: "#ffffff",
			existentialDeposit: "100000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "kulupu"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "kusama-asset-hub-substrate-native-ksm",
		data: {
			id: "kusama-asset-hub-substrate-native-ksm",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ksm.svg",
			type: "substrate-native",
			chain: {
				id: "kusama-asset-hub"
			},
			symbol: "KSM",
			decimals: 12,
			isTestnet: false,
			themeColor: "#ffffff",
			existentialDeposit: "33333333"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "kusama-asset-hub"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "kusama-bridge-hub-substrate-native-ksm",
		data: {
			id: "kusama-bridge-hub-substrate-native-ksm",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ksm.svg",
			type: "substrate-native",
			chain: {
				id: "kusama-bridge-hub"
			},
			symbol: "KSM",
			decimals: 12,
			isTestnet: false,
			themeColor: "#ffffff",
			existentialDeposit: "33333333"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "kusama-bridge-hub"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "kusama-substrate-native-ksm",
		data: {
			id: "kusama-substrate-native-ksm",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ksm.svg",
			type: "substrate-native",
			chain: {
				id: "kusama"
			},
			symbol: "KSM",
			decimals: 12,
			isTestnet: false,
			themeColor: "#ffffff",
			coingeckoId: "kusama",
			existentialDeposit: "333333333"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "kusama"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "kusari-substrate-native-ksi",
		data: {
			id: "kusari-substrate-native-ksi",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "kusari"
			},
			symbol: "KSI",
			decimals: 18,
			isTestnet: false,
			themeColor: "#ffffff",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "kusari"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "kylin-substrate-native-kyl",
		data: {
			id: "kylin-substrate-native-kyl",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "kylin"
			},
			symbol: "KYL",
			decimals: 18,
			isTestnet: false,
			themeColor: "#ffffff",
			existentialDeposit: "1000000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "kylin"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "litentry-substrate-native-lit",
		data: {
			id: "litentry-substrate-native-lit",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/litentry.svg",
			type: "substrate-native",
			chain: {
				id: "litentry"
			},
			symbol: "LIT",
			decimals: 12,
			isTestnet: false,
			themeColor: "#15ea85",
			coingeckoId: "litentry",
			existentialDeposit: "100000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "litentry"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "litmus-substrate-native-lit",
		data: {
			id: "litmus-substrate-native-lit",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/litmus.svg",
			type: "substrate-native",
			chain: {
				id: "litmus"
			},
			symbol: "LIT",
			decimals: 12,
			isTestnet: false,
			themeColor: "#e3e4e6",
			existentialDeposit: "100000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "litmus"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "logion-substrate-native-lgnt",
		data: {
			id: "logion-substrate-native-lgnt",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "logion"
			},
			symbol: "LGNT",
			decimals: 18,
			isTestnet: false,
			themeColor: "#ffffff",
			existentialDeposit: "500"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "logion"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "logion-testnet-standalone-2-substrate-native-lgnt",
		data: {
			id: "logion-testnet-standalone-2-substrate-native-lgnt",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "logion-testnet-standalone-2"
			},
			symbol: "LGNT",
			decimals: 18,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "500"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "logion-testnet-standalone-2"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "logion-testnet-standalone-substrate-native-chy",
		data: {
			id: "logion-testnet-standalone-substrate-native-chy",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "logion-testnet-standalone"
			},
			symbol: "CHY",
			decimals: 18,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "1000000000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "logion-testnet-standalone"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "mangata-substrate-native-mgx",
		data: {
			id: "mangata-substrate-native-mgx",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/mangata.svg",
			type: "substrate-native",
			chain: {
				id: "mangata"
			},
			symbol: "MGX",
			decimals: 18,
			isTestnet: false,
			themeColor: "#7aead7",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "mangata-substrate-tokens-mgx",
		data: {
			id: "mangata-substrate-tokens-mgx",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/mangata.svg",
			type: "substrate-tokens",
			chain: {
				id: "mangata"
			},
			symbol: "MGX",
			decimals: 18,
			isTestnet: false,
			onChainId: 0,
			themeColor: "#7aead7",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "mangata"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "manta-substrate-native-manta",
		data: {
			id: "manta-substrate-native-manta",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/manta.svg",
			type: "substrate-native",
			chain: {
				id: "manta"
			},
			symbol: "MANTA",
			decimals: 18,
			isTestnet: false,
			themeColor: "#eb69bd",
			existentialDeposit: "100000000000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "manta"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "moonbase-alpha-testnet-substrate-native-dev",
		data: {
			id: "moonbase-alpha-testnet-substrate-native-dev",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/moonbase-alpha-testnet.svg",
			type: "substrate-native",
			chain: {
				id: "moonbase-alpha-testnet"
			},
			symbol: "DEV",
			decimals: 18,
			isTestnet: true,
			themeColor: "#4cb1b3",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "moonbase-alpha-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "moonbeam-substrate-native-glmr",
		data: {
			id: "moonbeam-substrate-native-glmr",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/moonbeam.svg",
			type: "substrate-native",
			chain: {
				id: "moonbeam"
			},
			symbol: "GLMR",
			decimals: 18,
			isTestnet: false,
			themeColor: "#53cbc9",
			coingeckoId: "moonbeam",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "moonbeam"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "moonriver-substrate-native-movr",
		data: {
			id: "moonriver-substrate-native-movr",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/moonriver.svg",
			type: "substrate-native",
			chain: {
				id: "moonriver"
			},
			symbol: "MOVR",
			decimals: 18,
			isTestnet: false,
			themeColor: "#f2b705",
			coingeckoId: "moonriver",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "moonriver"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "myriad-substrate-native-myria",
		data: {
			id: "myriad-substrate-native-myria",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "myriad"
			},
			symbol: "MYRIA",
			decimals: 18,
			isTestnet: false,
			themeColor: "#ffffff",
			coingeckoId: "myriad-social",
			existentialDeposit: "1000000000000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "myriad"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "myriad-testnet-substrate-native-myria",
		data: {
			id: "myriad-testnet-substrate-native-myria",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "myriad-testnet"
			},
			symbol: "MYRIA",
			decimals: 18,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "1000000000000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "myriad-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "neatcoin-substrate-native-neat",
		data: {
			id: "neatcoin-substrate-native-neat",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "neatcoin"
			},
			symbol: "NEAT",
			decimals: 12,
			isTestnet: false,
			themeColor: "#ffffff",
			existentialDeposit: "10000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "neatcoin"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "nftmart-substrate-native-nmt",
		data: {
			id: "nftmart-substrate-native-nmt",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "nftmart"
			},
			symbol: "NMT",
			decimals: 12,
			isTestnet: false,
			themeColor: "#ffffff",
			coingeckoId: "nftmart-token",
			existentialDeposit: "1000000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "nftmart"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "nodle-polkadot-substrate-native-nodl",
		data: {
			id: "nodle-polkadot-substrate-native-nodl",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/nodle-polkadot.svg",
			type: "substrate-native",
			chain: {
				id: "nodle-polkadot"
			},
			symbol: "NODL",
			decimals: 11,
			isTestnet: false,
			themeColor: "#41a175",
			coingeckoId: "nodle-network",
			existentialDeposit: "10000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "nodle-polkadot"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "opal-testnet-substrate-native-opl",
		data: {
			id: "opal-testnet-substrate-native-opl",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "opal-testnet"
			},
			symbol: "OPL",
			decimals: 18,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "opal-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "origintrail-parachain-substrate-native-otp",
		data: {
			id: "origintrail-parachain-substrate-native-otp",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/origintrail-parachain.svg",
			type: "substrate-native",
			chain: {
				id: "origintrail-parachain"
			},
			symbol: "OTP",
			decimals: 12,
			isTestnet: false,
			themeColor: "#fb5deb",
			existentialDeposit: "1000000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "origintrail-parachain"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "pangoro-testnet-substrate-native-oring",
		data: {
			id: "pangoro-testnet-substrate-native-oring",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "pangoro-testnet"
			},
			symbol: "ORING",
			decimals: 18,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "pangoro-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "parallel-substrate-native-para",
		data: {
			id: "parallel-substrate-native-para",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/parallel.svg",
			type: "substrate-native",
			chain: {
				id: "parallel"
			},
			symbol: "PARA",
			decimals: 12,
			isTestnet: false,
			themeColor: "#f026a8",
			existentialDeposit: "100000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "parallel"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "pendulum-substrate-native-pen",
		data: {
			id: "pendulum-substrate-native-pen",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/pendulum.svg",
			type: "substrate-native",
			chain: {
				id: "pendulum"
			},
			symbol: "PEN",
			decimals: 12,
			isTestnet: false,
			themeColor: "#dae9eb",
			coingeckoId: "pendulum-chain",
			existentialDeposit: "1000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "pendulum"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "pendulum-substrate-tokens-dot",
		data: {
			id: "pendulum-substrate-tokens-dot",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/dot.svg",
			type: "substrate-tokens",
			chain: {
				id: "pendulum"
			},
			symbol: "DOT",
			decimals: 10,
			isTestnet: false,
			onChainId: "{\"XCM\":0}",
			themeColor: "#e6007a",
			coingeckoId: "polkadot",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "pendulum-substrate-tokens-usdt",
		data: {
			id: "pendulum-substrate-tokens-usdt",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/usdt.svg",
			type: "substrate-tokens",
			chain: {
				id: "pendulum"
			},
			symbol: "USDT",
			decimals: 6,
			isTestnet: false,
			onChainId: "{\"XCM\":1}",
			themeColor: "#53ae94",
			coingeckoId: "tether",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "phala-substrate-native-pha",
		data: {
			id: "phala-substrate-native-pha",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/phala.svg",
			type: "substrate-native",
			chain: {
				id: "phala"
			},
			symbol: "PHA",
			decimals: 12,
			isTestnet: false,
			themeColor: "#cdfa50",
			coingeckoId: "pha",
			existentialDeposit: "10000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "phala"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "phala-testnet-substrate-native-unknown",
		data: {
			id: "phala-testnet-substrate-native-unknown",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "phala-testnet"
			},
			symbol: "Unknown",
			decimals: 0,
			isTestnet: true,
			themeColor: "#505050",
			existentialDeposit: "10000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "phala-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "picasso-substrate-native-pica",
		data: {
			id: "picasso-substrate-native-pica",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/picasso.svg",
			type: "substrate-native",
			chain: {
				id: "picasso"
			},
			symbol: "PICA",
			decimals: 12,
			isTestnet: false,
			themeColor: "#ef8211",
			coingeckoId: "picasso",
			existentialDeposit: "100000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "picasso"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "picasso-substrate-tokens-ausd",
		data: {
			id: "picasso-substrate-tokens-ausd",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ausd.svg",
			type: "substrate-tokens",
			chain: {
				id: "picasso"
			},
			symbol: "aUSD",
			decimals: 12,
			isTestnet: false,
			onChainId: 129,
			themeColor: "#e40c5b",
			coingeckoId: "acala-dollar",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "picasso-substrate-tokens-bnc",
		data: {
			id: "picasso-substrate-tokens-bnc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/bnc.svg",
			type: "substrate-tokens",
			chain: {
				id: "picasso"
			},
			symbol: "BNC",
			decimals: 12,
			isTestnet: false,
			onChainId: 102,
			themeColor: "#68baf9",
			coingeckoId: "bifrost-native-coin",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "picasso-substrate-tokens-dot",
		data: {
			id: "picasso-substrate-tokens-dot",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/dot.svg",
			type: "substrate-tokens",
			chain: {
				id: "picasso"
			},
			symbol: "DOT",
			decimals: 10,
			isTestnet: false,
			onChainId: 6,
			themeColor: "#e6007a",
			coingeckoId: "polkadot",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "picasso-substrate-tokens-kar",
		data: {
			id: "picasso-substrate-tokens-kar",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/kar.svg",
			type: "substrate-tokens",
			chain: {
				id: "picasso"
			},
			symbol: "KAR",
			decimals: 12,
			isTestnet: false,
			onChainId: 101,
			themeColor: "#f93d43",
			coingeckoId: "karura",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "picasso-substrate-tokens-ksm",
		data: {
			id: "picasso-substrate-tokens-ksm",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ksm.svg",
			type: "substrate-tokens",
			chain: {
				id: "picasso"
			},
			symbol: "KSM",
			decimals: 12,
			isTestnet: false,
			onChainId: 4,
			themeColor: "#ffffff",
			coingeckoId: "kusama",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "picasso-substrate-tokens-movr",
		data: {
			id: "picasso-substrate-tokens-movr",
			logo: "https://assets.coingecko.com/coins/images/17984/large/9285.png?1630028620",
			type: "substrate-tokens",
			chain: {
				id: "picasso"
			},
			symbol: "MOVR",
			decimals: 18,
			isTestnet: false,
			onChainId: 104,
			themeColor: "#f2b705",
			coingeckoId: "moonriver",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "picasso-substrate-tokens-usdc",
		data: {
			id: "picasso-substrate-tokens-usdc",
			logo: "https://assets.coingecko.com/coins/images/6319/large/USD_Coin_icon.png?1547042389",
			type: "substrate-tokens",
			chain: {
				id: "picasso"
			},
			symbol: "USDC",
			decimals: 6,
			isTestnet: false,
			onChainId: 131,
			themeColor: "#2775ca",
			coingeckoId: "usd-coin",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "picasso-substrate-tokens-usdt",
		data: {
			id: "picasso-substrate-tokens-usdt",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/usdt.svg",
			type: "substrate-tokens",
			chain: {
				id: "picasso"
			},
			symbol: "USDT",
			decimals: 6,
			isTestnet: false,
			onChainId: 130,
			themeColor: "#53ae94",
			coingeckoId: "tether",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "picasso-substrate-tokens-vksm",
		data: {
			id: "picasso-substrate-tokens-vksm",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/picasso.svg",
			type: "substrate-tokens",
			chain: {
				id: "picasso"
			},
			symbol: "vKSM",
			decimals: 12,
			isTestnet: false,
			onChainId: 103,
			themeColor: "#8d8884",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "picasso-substrate-tokens-wbtc",
		data: {
			id: "picasso-substrate-tokens-wbtc",
			logo: "https://assets.coingecko.com/coins/images/1/large/bitcoin.png?1547033579",
			type: "substrate-tokens",
			chain: {
				id: "picasso"
			},
			symbol: "wBTC",
			decimals: 8,
			isTestnet: false,
			onChainId: 132,
			themeColor: "#f7931a",
			coingeckoId: "bitcoin",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "picasso-substrate-tokens-weth",
		data: {
			id: "picasso-substrate-tokens-weth",
			logo: "https://assets.coingecko.com/coins/images/279/large/ethereum.png?1595348880",
			type: "substrate-tokens",
			chain: {
				id: "picasso"
			},
			symbol: "wETH",
			decimals: 18,
			isTestnet: false,
			onChainId: 133,
			themeColor: "#62688f",
			coingeckoId: "ethereum",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "polkadex-polkadot-substrate-native-pdex",
		data: {
			id: "polkadex-polkadot-substrate-native-pdex",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/polkadex-polkadot.svg",
			type: "substrate-native",
			chain: {
				id: "polkadex-polkadot"
			},
			symbol: "PDEX",
			decimals: 12,
			isTestnet: false,
			themeColor: "#e6007a",
			existentialDeposit: "1000000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "polkadex-polkadot"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "polkadex-standalone-substrate-native-pdex",
		data: {
			id: "polkadex-standalone-substrate-native-pdex",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/polkadex-standalone.svg",
			type: "substrate-native",
			chain: {
				id: "polkadex-standalone"
			},
			symbol: "PDEX",
			decimals: 12,
			isTestnet: false,
			themeColor: "#e6007a",
			coingeckoId: "polkadex",
			existentialDeposit: "1000000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "polkadex-standalone"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "polkadot-asset-hub-substrate-native-dot",
		data: {
			id: "polkadot-asset-hub-substrate-native-dot",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/dot.svg",
			type: "substrate-native",
			chain: {
				id: "polkadot-asset-hub"
			},
			symbol: "DOT",
			decimals: 10,
			isTestnet: false,
			themeColor: "#e6007a",
			existentialDeposit: "1000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "polkadot-asset-hub"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "polkadot-bridge-hub-substrate-native-dot",
		data: {
			id: "polkadot-bridge-hub-substrate-native-dot",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/dot.svg",
			type: "substrate-native",
			chain: {
				id: "polkadot-bridge-hub"
			},
			symbol: "DOT",
			decimals: 10,
			isTestnet: false,
			themeColor: "#e6007a",
			existentialDeposit: "1000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "polkadot-bridge-hub"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "polkadot-collectives-substrate-native-dot",
		data: {
			id: "polkadot-collectives-substrate-native-dot",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/dot.svg",
			type: "substrate-native",
			chain: {
				id: "polkadot-collectives"
			},
			symbol: "DOT",
			decimals: 10,
			isTestnet: false,
			themeColor: "#e6007a",
			existentialDeposit: "1000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "polkadot-collectives"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "polkadot-substrate-native-dot",
		data: {
			id: "polkadot-substrate-native-dot",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/dot.svg",
			type: "substrate-native",
			chain: {
				id: "polkadot"
			},
			symbol: "DOT",
			decimals: 10,
			isTestnet: false,
			themeColor: "#e6007a",
			coingeckoId: "polkadot",
			existentialDeposit: "10000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "polkadot"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "polymesh-substrate-native-polyx",
		data: {
			id: "polymesh-substrate-native-polyx",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "polymesh"
			},
			symbol: "POLYX",
			decimals: 6,
			isTestnet: false,
			themeColor: "#ffffff",
			coingeckoId: "polymesh",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "polymesh"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "polymesh-testnet-substrate-native-polyx",
		data: {
			id: "polymesh-testnet-substrate-native-polyx",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "polymesh-testnet"
			},
			symbol: "POLYX",
			decimals: 6,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "polymesh-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "quartz-substrate-native-qtz",
		data: {
			id: "quartz-substrate-native-qtz",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/quartz.svg",
			type: "substrate-native",
			chain: {
				id: "quartz"
			},
			symbol: "QTZ",
			decimals: 18,
			isTestnet: false,
			themeColor: "#ff4d6a",
			coingeckoId: "quartz",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "quartz"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "robonomics-kusama-substrate-native-xrt",
		data: {
			id: "robonomics-kusama-substrate-native-xrt",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/robonomics-kusama.svg",
			type: "substrate-native",
			chain: {
				id: "robonomics-kusama"
			},
			symbol: "XRT",
			decimals: 9,
			isTestnet: false,
			themeColor: "#03a5ed",
			coingeckoId: "robonomics-network",
			existentialDeposit: "1000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "robonomics-kusama"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-amplitude-testnet-substrate-native-ampe",
		data: {
			id: "rococo-amplitude-testnet-substrate-native-ampe",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "rococo-amplitude-testnet"
			},
			symbol: "AMPE",
			decimals: 12,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "1000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "rococo-amplitude-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-asset-hub-testnet-substrate-native-roc",
		data: {
			id: "rococo-asset-hub-testnet-substrate-native-roc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "rococo-asset-hub-testnet"
			},
			symbol: "ROC",
			decimals: 12,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "33333333"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "rococo-asset-hub-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-aventus-testnet-substrate-native-avt",
		data: {
			id: "rococo-aventus-testnet-substrate-native-avt",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "rococo-aventus-testnet"
			},
			symbol: "AVT",
			decimals: 18,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "rococo-aventus-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-bajun-testnet-substrate-native-baju",
		data: {
			id: "rococo-bajun-testnet-substrate-native-baju",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "rococo-bajun-testnet"
			},
			symbol: "BAJU",
			decimals: 12,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "1000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "rococo-bajun-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-basilisk-testnet-substrate-native-bsx",
		data: {
			id: "rococo-basilisk-testnet-substrate-native-bsx",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/rococo-basilisk-testnet.svg",
			type: "substrate-native",
			chain: {
				id: "rococo-basilisk-testnet"
			},
			symbol: "BSX",
			decimals: 12,
			isTestnet: true,
			themeColor: "#4cffaf",
			existentialDeposit: "1000000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "rococo-basilisk-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-bifrost-testnet-substrate-native-bnc",
		data: {
			id: "rococo-bifrost-testnet-substrate-native-bnc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/bnc.svg",
			type: "substrate-native",
			chain: {
				id: "rococo-bifrost-testnet"
			},
			symbol: "BNC",
			decimals: 12,
			isTestnet: true,
			themeColor: "#68baf9",
			existentialDeposit: "10000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "rococo-bifrost-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-bifrost-testnet-substrate-orml-bnc",
		data: {
			id: "rococo-bifrost-testnet-substrate-orml-bnc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/bnc.svg",
			type: "substrate-orml",
			chain: {
				id: "rococo-bifrost-testnet"
			},
			symbol: "BNC",
			decimals: 12,
			stateKey: "0x4a6fdeede9332ffc0201",
			isTestnet: true,
			themeColor: "#68baf9",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-bifrost-testnet-substrate-orml-dot",
		data: {
			id: "rococo-bifrost-testnet-substrate-orml-dot",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/dot.svg",
			type: "substrate-orml",
			chain: {
				id: "rococo-bifrost-testnet"
			},
			symbol: "DOT",
			decimals: 10,
			stateKey: "0x40c8bff02912d7a00203",
			isTestnet: true,
			themeColor: "#e6007a",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-bifrost-testnet-substrate-orml-kar",
		data: {
			id: "rococo-bifrost-testnet-substrate-orml-kar",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/kar.svg",
			type: "substrate-orml",
			chain: {
				id: "rococo-bifrost-testnet"
			},
			symbol: "KAR",
			decimals: 12,
			stateKey: "0xca82739c8129d4d20206",
			isTestnet: true,
			themeColor: "#f93d43",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-bifrost-testnet-substrate-orml-ksm",
		data: {
			id: "rococo-bifrost-testnet-substrate-orml-ksm",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ksm.svg",
			type: "substrate-orml",
			chain: {
				id: "rococo-bifrost-testnet"
			},
			symbol: "KSM",
			decimals: 12,
			stateKey: "0x1dab0d33717892710204",
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-bifrost-testnet-substrate-orml-kusd",
		data: {
			id: "rococo-bifrost-testnet-substrate-orml-kusd",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/kusd.svg",
			type: "substrate-orml",
			chain: {
				id: "rococo-bifrost-testnet"
			},
			symbol: "KUSD",
			decimals: 12,
			stateKey: "0xfb747b895a9033f80202",
			isTestnet: true,
			themeColor: "#e40c5b",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-bifrost-testnet-substrate-orml-movr",
		data: {
			id: "rococo-bifrost-testnet-substrate-orml-movr",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-orml",
			chain: {
				id: "rococo-bifrost-testnet"
			},
			symbol: "MOVR",
			decimals: 18,
			stateKey: "0xac435ba151a0ded6020a",
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-bifrost-testnet-substrate-orml-pha",
		data: {
			id: "rococo-bifrost-testnet-substrate-orml-pha",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-orml",
			chain: {
				id: "rococo-bifrost-testnet"
			},
			symbol: "PHA",
			decimals: 12,
			stateKey: "0xc3413250cf88fd430208",
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-bifrost-testnet-substrate-orml-rmrk",
		data: {
			id: "rococo-bifrost-testnet-substrate-orml-rmrk",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/rmrk.svg",
			type: "substrate-orml",
			chain: {
				id: "rococo-bifrost-testnet"
			},
			symbol: "RMRK",
			decimals: 10,
			stateKey: "0x3aabf5b1eec116df0209",
			isTestnet: true,
			themeColor: "#3d2a76",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-bifrost-testnet-substrate-orml-zlk",
		data: {
			id: "rococo-bifrost-testnet-substrate-orml-zlk",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/zlk.svg",
			type: "substrate-orml",
			chain: {
				id: "rococo-bifrost-testnet"
			},
			symbol: "ZLK",
			decimals: 18,
			stateKey: "0xb682815e8b9cd45d0207",
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-bridgehub-testnet-substrate-native-roc",
		data: {
			id: "rococo-bridgehub-testnet-substrate-native-roc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "rococo-bridgehub-testnet"
			},
			symbol: "ROC",
			decimals: 12,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "3333333"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "rococo-bridgehub-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-catalyst-testnet-substrate-native-ncfg",
		data: {
			id: "rococo-catalyst-testnet-substrate-native-ncfg",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "rococo-catalyst-testnet"
			},
			symbol: "NCFG",
			decimals: 18,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "1000000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "rococo-catalyst-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-contracts-testnet-substrate-native-roc",
		data: {
			id: "rococo-contracts-testnet-substrate-native-roc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "rococo-contracts-testnet"
			},
			symbol: "ROC",
			decimals: 12,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "33333333"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "rococo-contracts-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-ethos-testnet-substrate-native-jur",
		data: {
			id: "rococo-ethos-testnet-substrate-native-jur",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "rococo-ethos-testnet"
			},
			symbol: "JUR",
			decimals: 18,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "1000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "rococo-ethos-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-frequency-testnet-substrate-native-xrqcy",
		data: {
			id: "rococo-frequency-testnet-substrate-native-xrqcy",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "rococo-frequency-testnet"
			},
			symbol: "XRQCY",
			decimals: 8,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "1000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "rococo-frequency-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-hydra-dx-testnet-substrate-native-hdx",
		data: {
			id: "rococo-hydra-dx-testnet-substrate-native-hdx",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "rococo-hydra-dx-testnet"
			},
			symbol: "HDX",
			decimals: 12,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "1000000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "rococo-hydra-dx-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-integritee-testnet-substrate-native-teer",
		data: {
			id: "rococo-integritee-testnet-substrate-native-teer",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/rococo-integritee-testnet.svg",
			type: "substrate-native",
			chain: {
				id: "rococo-integritee-testnet"
			},
			symbol: "TEER",
			decimals: 12,
			isTestnet: true,
			themeColor: "#777aac",
			existentialDeposit: "1000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "rococo-integritee-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-litentry-testnet-substrate-native-lit",
		data: {
			id: "rococo-litentry-testnet-substrate-native-lit",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/rococo-litentry-testnet.svg",
			type: "substrate-native",
			chain: {
				id: "rococo-litentry-testnet"
			},
			symbol: "LIT",
			decimals: 12,
			isTestnet: true,
			themeColor: "#15ea85",
			existentialDeposit: "100000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "rococo-litentry-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-mangata-testnet-substrate-native-mgat",
		data: {
			id: "rococo-mangata-testnet-substrate-native-mgat",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/rococo-mangata-testnet.svg",
			type: "substrate-native",
			chain: {
				id: "rococo-mangata-testnet"
			},
			symbol: "MGAT",
			decimals: 18,
			isTestnet: true,
			themeColor: "#00457a",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "rococo-mangata-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-md-5-testnet-substrate-native-md5",
		data: {
			id: "rococo-md-5-testnet-substrate-native-md5",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "rococo-md-5-testnet"
			},
			symbol: "MD5",
			decimals: 18,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "1000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "rococo-md-5-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-nodle-testnet-substrate-native-notnodl",
		data: {
			id: "rococo-nodle-testnet-substrate-native-notnodl",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/rococo-nodle-testnet.svg",
			type: "substrate-native",
			chain: {
				id: "rococo-nodle-testnet"
			},
			symbol: "notNODL",
			decimals: 11,
			isTestnet: true,
			themeColor: "#010717",
			existentialDeposit: "10000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "rococo-nodle-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-origin-trail-parachain-testnet-substrate-native-otp",
		data: {
			id: "rococo-origin-trail-parachain-testnet-substrate-native-otp",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "rococo-origin-trail-parachain-testnet"
			},
			symbol: "OTP",
			decimals: 12,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "1000000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "rococo-origin-trail-parachain-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-pangolin-testnet-substrate-native-pring",
		data: {
			id: "rococo-pangolin-testnet-substrate-native-pring",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "rococo-pangolin-testnet"
			},
			symbol: "PRING",
			decimals: 18,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "rococo-pangolin-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-phala-testnet-substrate-native-pha",
		data: {
			id: "rococo-phala-testnet-substrate-native-pha",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "rococo-phala-testnet"
			},
			symbol: "PHA",
			decimals: 12,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "10000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "rococo-phala-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-picasso-testnet-substrate-native-pica",
		data: {
			id: "rococo-picasso-testnet-substrate-native-pica",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "rococo-picasso-testnet"
			},
			symbol: "PICA",
			decimals: 12,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "100000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "rococo-picasso-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-societal-testnet-substrate-native-sctl",
		data: {
			id: "rococo-societal-testnet-substrate-native-sctl",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "rococo-societal-testnet"
			},
			symbol: "SCTL",
			decimals: 12,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "rococo-societal-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-sora-testnet-substrate-native-rxor",
		data: {
			id: "rococo-sora-testnet-substrate-native-rxor",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/rococo-sora-testnet.svg",
			type: "substrate-native",
			chain: {
				id: "rococo-sora-testnet"
			},
			symbol: "RXOR",
			decimals: 12,
			isTestnet: true,
			themeColor: "#fd0100",
			existentialDeposit: "1000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "rococo-sora-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-statemint-testnet-substrate-native-roc",
		data: {
			id: "rococo-statemint-testnet-substrate-native-roc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/rococo-statemint-testnet.svg",
			type: "substrate-native",
			chain: {
				id: "rococo-statemint-testnet"
			},
			symbol: "ROC",
			decimals: 12,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "33333333"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "rococo-statemint-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-subsocial-testnet-substrate-native-soon",
		data: {
			id: "rococo-subsocial-testnet-substrate-native-soon",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/rococo-subsocial-testnet.svg",
			type: "substrate-native",
			chain: {
				id: "rococo-subsocial-testnet"
			},
			symbol: "SOON",
			decimals: 10,
			isTestnet: true,
			themeColor: "#4d0366",
			existentialDeposit: "100000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "rococo-subsocial-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-testnet-substrate-native-roc",
		data: {
			id: "rococo-testnet-substrate-native-roc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/rococo-testnet.svg",
			type: "substrate-native",
			chain: {
				id: "rococo-testnet"
			},
			symbol: "ROC",
			decimals: 12,
			isTestnet: true,
			themeColor: "#2291fc",
			existentialDeposit: "33333333"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "rococo-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-turing-testnet-substrate-native-tur",
		data: {
			id: "rococo-turing-testnet-substrate-native-tur",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "rococo-turing-testnet"
			},
			symbol: "TUR",
			decimals: 10,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "100000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "rococo-turing-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-watr-testnet-substrate-native-watrd",
		data: {
			id: "rococo-watr-testnet-substrate-native-watrd",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/rococo-watr-testnet.svg",
			type: "substrate-native",
			chain: {
				id: "rococo-watr-testnet"
			},
			symbol: "WATRD",
			decimals: 18,
			isTestnet: true,
			themeColor: "#f5f5f3",
			existentialDeposit: "10000000000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "rococo-watr-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "rococo-zeitgeist-testnet-substrate-native-zbs",
		data: {
			id: "rococo-zeitgeist-testnet-substrate-native-zbs",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/rococo-zeitgeist-testnet.svg",
			type: "substrate-native",
			chain: {
				id: "rococo-zeitgeist-testnet"
			},
			symbol: "ZBS",
			decimals: 10,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "50000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "rococo-zeitgeist-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "shadow-kusama-substrate-native-csm",
		data: {
			id: "shadow-kusama-substrate-native-csm",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/shadow-kusama.svg",
			type: "substrate-native",
			chain: {
				id: "shadow-kusama"
			},
			symbol: "CSM",
			decimals: 12,
			isTestnet: false,
			themeColor: "#ffffff",
			coingeckoId: "crust-storage-market",
			existentialDeposit: "100000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "shadow-kusama"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "sherpax-substrate-native-ksx",
		data: {
			id: "sherpax-substrate-native-ksx",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/sherpax.svg",
			type: "substrate-native",
			chain: {
				id: "sherpax"
			},
			symbol: "KSX",
			decimals: 18,
			isTestnet: false,
			themeColor: "#34c69a",
			existentialDeposit: "10000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "sherpax"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "sherpax-testnet-substrate-native-ksx",
		data: {
			id: "sherpax-testnet-substrate-native-ksx",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/sherpax-testnet.svg",
			type: "substrate-native",
			chain: {
				id: "sherpax-testnet"
			},
			symbol: "KSX",
			decimals: 18,
			isTestnet: true,
			themeColor: "#34c69a",
			existentialDeposit: "10000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "sherpax-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "shibuya-testnet-substrate-native-sby",
		data: {
			id: "shibuya-testnet-substrate-native-sby",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/shibuya-testnet.svg",
			type: "substrate-native",
			chain: {
				id: "shibuya-testnet"
			},
			symbol: "SBY",
			decimals: 18,
			isTestnet: true,
			themeColor: "#bba5e1",
			existentialDeposit: "1000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "shibuya-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "shiden-kusama-substrate-native-sdn",
		data: {
			id: "shiden-kusama-substrate-native-sdn",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/shiden-kusama.svg",
			type: "substrate-native",
			chain: {
				id: "shiden-kusama"
			},
			symbol: "SDN",
			decimals: 18,
			isTestnet: false,
			themeColor: "#bba5e1",
			coingeckoId: "shiden",
			existentialDeposit: "1000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "shiden-kusama"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "skyekiwi-testnet-substrate-native-unknown",
		data: {
			id: "skyekiwi-testnet-substrate-native-unknown",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "skyekiwi-testnet"
			},
			symbol: "Unknown",
			decimals: 0,
			isTestnet: true,
			themeColor: "#505050",
			existentialDeposit: "500"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "skyekiwi-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "sora-kusama-substrate-native-unknown",
		data: {
			id: "sora-kusama-substrate-native-unknown",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "sora-kusama"
			},
			symbol: "Unknown",
			decimals: 0,
			isTestnet: false,
			themeColor: "#505050",
			existentialDeposit: "1000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "sora-kusama"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "sora-standalone-substrate-native-xor",
		data: {
			id: "sora-standalone-substrate-native-xor",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/sora-standalone.svg",
			type: "substrate-native",
			chain: {
				id: "sora-standalone"
			},
			symbol: "XOR",
			decimals: 18,
			isTestnet: false,
			themeColor: "#fd0100",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "sora-standalone"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "sora-substrate-testnet-substrate-native-xor",
		data: {
			id: "sora-substrate-testnet-substrate-native-xor",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "sora-substrate-testnet"
			},
			symbol: "XOR",
			decimals: 18,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "sora-substrate-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "statemine-substrate-assets-16-aris",
		data: {
			id: "statemine-substrate-assets-16-aris",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/aris.svg",
			type: "substrate-assets",
			chain: {
				id: "statemine"
			},
			symbol: "ARIS",
			assetId: "16",
			decimals: 8,
			isFrozen: false,
			isTestnet: false,
			themeColor: "#fa8297",
			existentialDeposit: "10000000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "statemine-substrate-assets-1984-usdt",
		data: {
			id: "statemine-substrate-assets-1984-usdt",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/usdt.svg",
			type: "substrate-assets",
			chain: {
				id: "statemine"
			},
			symbol: "USDT",
			assetId: "1984",
			decimals: 6,
			isFrozen: false,
			isTestnet: false,
			themeColor: "#53ae94",
			coingeckoId: "tether",
			existentialDeposit: "1000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "statemine-substrate-assets-8-rmrk",
		data: {
			id: "statemine-substrate-assets-8-rmrk",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/rmrk.svg",
			type: "substrate-assets",
			chain: {
				id: "statemine"
			},
			symbol: "RMRK",
			assetId: "8",
			decimals: 10,
			isFrozen: false,
			isTestnet: false,
			themeColor: "#3d2a76",
			coingeckoId: "rmrk",
			existentialDeposit: "100000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "statemine-substrate-native-ksm",
		data: {
			id: "statemine-substrate-native-ksm",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/ksm.svg",
			type: "substrate-native",
			chain: {
				id: "statemine"
			},
			symbol: "KSM",
			decimals: 12,
			isTestnet: false,
			themeColor: "#ffffff",
			coingeckoId: "kusama",
			existentialDeposit: "33333333"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "statemine"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "statemint-substrate-assets-1984-usdt",
		data: {
			id: "statemint-substrate-assets-1984-usdt",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/usdt.svg",
			type: "substrate-assets",
			chain: {
				id: "statemint"
			},
			symbol: "USDT",
			assetId: "1984",
			decimals: 6,
			isFrozen: false,
			isTestnet: false,
			themeColor: "#53ae94",
			coingeckoId: "tether",
			existentialDeposit: "700000"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "statemint-substrate-native-dot",
		data: {
			id: "statemint-substrate-native-dot",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/dot.svg",
			type: "substrate-native",
			chain: {
				id: "statemint"
			},
			symbol: "DOT",
			decimals: 10,
			isTestnet: false,
			themeColor: "#e6007a",
			coingeckoId: "polkadot",
			existentialDeposit: "1000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "statemint"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "subsocial-polkadot-substrate-native-sub",
		data: {
			id: "subsocial-polkadot-substrate-native-sub",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/subsocial-polkadot.svg",
			type: "substrate-native",
			chain: {
				id: "subsocial-polkadot"
			},
			symbol: "SUB",
			decimals: 10,
			isTestnet: false,
			themeColor: "#a4028f",
			existentialDeposit: "100000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "subsocial-polkadot"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "subspace-gemini-1-testnet-substrate-native-tssc",
		data: {
			id: "subspace-gemini-1-testnet-substrate-native-tssc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "subspace-gemini-1-testnet"
			},
			symbol: "tSSC",
			decimals: 18,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "500"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "subspace-gemini-1-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "subspace-gemini-2-a-testnet-substrate-native-tssc",
		data: {
			id: "subspace-gemini-2-a-testnet-substrate-native-tssc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "subspace-gemini-2-a-testnet"
			},
			symbol: "tSSC",
			decimals: 18,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "500"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "subspace-gemini-2-a-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "sumi-testnet-substrate-native-sumi",
		data: {
			id: "sumi-testnet-substrate-native-sumi",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "sumi-testnet"
			},
			symbol: "SUMI",
			decimals: 12,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "100000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "sumi-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "swapdex-substrate-native-sdx",
		data: {
			id: "swapdex-substrate-native-sdx",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "swapdex"
			},
			symbol: "SDX",
			decimals: 18,
			isTestnet: false,
			themeColor: "#ffffff",
			coingeckoId: "swapdex",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "swapdex"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "t-0-rn-testnet-substrate-native-t0rn",
		data: {
			id: "t-0-rn-testnet-substrate-native-t0rn",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "t-0-rn-testnet"
			},
			symbol: "T0RN",
			decimals: 12,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "1"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "t-0-rn-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "t-3-rn-substrate-native-trn",
		data: {
			id: "t-3-rn-substrate-native-trn",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "t-3-rn"
			},
			symbol: "TRN",
			decimals: 12,
			isTestnet: false,
			themeColor: "#ffffff",
			existentialDeposit: "1000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "t-3-rn"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "ternoa-alphanet-testnet-substrate-native-caps",
		data: {
			id: "ternoa-alphanet-testnet-substrate-native-caps",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/ternoa-alphanet-testnet.svg",
			type: "substrate-native",
			chain: {
				id: "ternoa-alphanet-testnet"
			},
			symbol: "CAPS",
			decimals: 18,
			isTestnet: true,
			themeColor: "#ff8500",
			existentialDeposit: "150000000000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "ternoa-alphanet-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "ternoa-substrate-native-caps",
		data: {
			id: "ternoa-substrate-native-caps",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/ternoa.svg",
			type: "substrate-native",
			chain: {
				id: "ternoa"
			},
			symbol: "CAPS",
			decimals: 18,
			isTestnet: false,
			themeColor: "#ff8500",
			existentialDeposit: "150000000000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "ternoa"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "thebifrost-mainnet-substrate-native-bfc",
		data: {
			id: "thebifrost-mainnet-substrate-native-bfc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "thebifrost-mainnet"
			},
			symbol: "BFC",
			decimals: 18,
			isTestnet: false,
			themeColor: "#ffffff",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "thebifrost-mainnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "thebifrost-testnet-substrate-native-bfc",
		data: {
			id: "thebifrost-testnet-substrate-native-bfc",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "thebifrost-testnet"
			},
			symbol: "BFC",
			decimals: 18,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "thebifrost-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "tinker-substrate-native-tnkr",
		data: {
			id: "tinker-substrate-native-tnkr",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/tinker.svg",
			type: "substrate-native",
			chain: {
				id: "tinker"
			},
			symbol: "TNKR",
			decimals: 12,
			isTestnet: false,
			themeColor: "#30bcd0",
			existentialDeposit: "1000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "tinker"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "turing-substrate-native-tur",
		data: {
			id: "turing-substrate-native-tur",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/turing.svg",
			type: "substrate-native",
			chain: {
				id: "turing"
			},
			symbol: "TUR",
			decimals: 10,
			isTestnet: false,
			themeColor: "#1db5cf",
			existentialDeposit: "100000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "turing"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "unique-substrate-native-unq",
		data: {
			id: "unique-substrate-native-unq",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unique.svg",
			type: "substrate-native",
			chain: {
				id: "unique"
			},
			symbol: "UNQ",
			decimals: 18,
			isTestnet: false,
			themeColor: "#00bfff",
			coingeckoId: "unique-network",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "unique"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "vara-substrate-native-vara",
		data: {
			id: "vara-substrate-native-vara",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/vara.svg",
			type: "substrate-native",
			chain: {
				id: "vara"
			},
			symbol: "VARA",
			decimals: 12,
			isTestnet: false,
			themeColor: "#03ffc4",
			existentialDeposit: "10000000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "vara"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "web-3-games-testnet-substrate-native-w3g",
		data: {
			id: "web-3-games-testnet-substrate-native-w3g",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "web-3-games-testnet"
			},
			symbol: "W3G",
			decimals: 18,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "web-3-games-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "westend-asset-hub-testnet-substrate-native-wnd",
		data: {
			id: "westend-asset-hub-testnet-substrate-native-wnd",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "westend-asset-hub-testnet"
			},
			symbol: "WND",
			decimals: 12,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "1000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "westend-asset-hub-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "westend-collectives-testnet-substrate-native-wnd",
		data: {
			id: "westend-collectives-testnet-substrate-native-wnd",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "westend-collectives-testnet"
			},
			symbol: "WND",
			decimals: 12,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "1000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "westend-collectives-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "westend-testnet-substrate-native-wnd",
		data: {
			id: "westend-testnet-substrate-native-wnd",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/westend-testnet.svg",
			type: "substrate-native",
			chain: {
				id: "westend-testnet"
			},
			symbol: "WND",
			decimals: 12,
			isTestnet: true,
			themeColor: "#e24a79",
			existentialDeposit: "10000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "westend-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "westmint-testnet-substrate-native-wnd",
		data: {
			id: "westmint-testnet-substrate-native-wnd",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "westmint-testnet"
			},
			symbol: "WND",
			decimals: 12,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "1000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "westmint-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "xsocial-testnet-substrate-native-sub",
		data: {
			id: "xsocial-testnet-substrate-native-sub",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/unknown.svg",
			type: "substrate-native",
			chain: {
				id: "xsocial-testnet"
			},
			symbol: "SUB",
			decimals: 10,
			isTestnet: true,
			themeColor: "#ffffff",
			existentialDeposit: "100000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "xsocial-testnet"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "zeitgeist-substrate-native-ztg",
		data: {
			id: "zeitgeist-substrate-native-ztg",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/zeitgeist.svg",
			type: "substrate-native",
			chain: {
				id: "zeitgeist"
			},
			symbol: "ZTG",
			decimals: 10,
			isTestnet: false,
			themeColor: "#ffffff",
			coingeckoId: "zeitgeist",
			existentialDeposit: "50000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "zeitgeist"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "zero-substrate-native-zero",
		data: {
			id: "zero-substrate-native-zero",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/zero.svg",
			type: "substrate-native",
			chain: {
				id: "zero"
			},
			symbol: "ZERO",
			decimals: 18,
			isTestnet: false,
			themeColor: "#f6921e",
			existentialDeposit: "10000000000000000"
		},
		squidImplementationDetailNativeToChains: [
			{
				id: "zero"
			}
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "zero-substrate-orml-dot",
		data: {
			id: "zero-substrate-orml-dot",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/tokens/dot.svg",
			type: "substrate-orml",
			chain: {
				id: "zero"
			},
			symbol: "DOT",
			decimals: 10,
			stateKey: "0x56a60a12d72ef524000c",
			isTestnet: false,
			themeColor: "#e6007a",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "zero-substrate-orml-game",
		data: {
			id: "zero-substrate-orml-game",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/zero.svg",
			type: "substrate-orml",
			chain: {
				id: "zero"
			},
			symbol: "GAME",
			decimals: 10,
			stateKey: "0xc483de2de1246ea70002",
			isTestnet: false,
			themeColor: "#f6921e",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "zero-substrate-orml-play",
		data: {
			id: "zero-substrate-orml-play",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/zero.svg",
			type: "substrate-orml",
			chain: {
				id: "zero"
			},
			symbol: "PLAY",
			decimals: 10,
			stateKey: "0xd67c5ba80ba065480001",
			isTestnet: false,
			themeColor: "#f6921e",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	},
	{
		id: "zero-substrate-orml-zero",
		data: {
			id: "zero-substrate-orml-zero",
			logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/v3/assets/chains/zero.svg",
			type: "substrate-orml",
			chain: {
				id: "zero"
			},
			symbol: "ZERO",
			decimals: 18,
			stateKey: "0x01a12dfa1fa4ab9a0000",
			isTestnet: false,
			themeColor: "#f6921e",
			existentialDeposit: "0"
		},
		squidImplementationDetailNativeToChains: [
		],
		squidImplementationDetailNativeToEvmNetworks: [
		]
	}
];

// These json files are generated by a script.
const fetchInitChains = async () => initChainsResponse;
const fetchInitEvmNetworks = async () => initEvmNetworksResponse;
const fetchInitTokens = async () => initTokensResponse;

var packageJson = {
	name: "@talismn/chaindata-provider-extension",
	version: "0.0.0-pr1020-20230901052420",
	author: "Talisman",
	homepage: "https://talisman.xyz",
	license: "GPL-3.0-or-later",
	publishConfig: {
		access: "public"
	},
	repository: {
		directory: "packages/chaindata-provider-extension",
		type: "git",
		url: "https://github.com/talismansociety/talisman.git"
	},
	main: "dist/talismn-chaindata-provider-extension.cjs.js",
	module: "dist/talismn-chaindata-provider-extension.esm.js",
	files: [
		"/dist"
	],
	engines: {
		node: ">=18"
	},
	scripts: {
		test: "jest",
		lint: "eslint src --max-warnings 0",
		"graphql-codegen": "graphql-codegen -c src/codegen.ts",
		"generate-init-data": "ts-node scripts/generateInitData.ts",
		clean: "rm -rf dist && rm -rf .turbo rm -rf node_modules"
	},
	dependencies: {
		"@talismn/chaindata-provider": "workspace:*",
		anylogger: "^1.0.11",
		dexie: "^3.2.4",
		graphql: "^16.7.1",
		"graphql-request": "^6.1.0",
		rxjs: "^7.8.1"
	},
	devDependencies: {
		"@graphql-codegen/cli": "^3.3.0",
		"@graphql-codegen/client-preset": "^3.0.0",
		"@talismn/eslint-config": "workspace:*",
		"@talismn/tsconfig": "workspace:*",
		"@types/jest": "^27.5.1",
		eslint: "^8.4.0",
		jest: "^28.1.0",
		"ts-jest": "^28.0.2",
		"ts-node": "^10.9.1",
		typescript: "^4.6.4"
	},
	eslintConfig: {
		root: true,
		"extends": [
			"@talismn/eslint-config/base"
		]
	}
};

var log = anylogger(packageJson.name);

// TODO: Fix `token` type after https://github.com/subsquid/squid/issues/41 is merged
const parseTokensResponse = tokens => tokens.map(token => token?.data).filter(isITokenPartial).filter(isToken);
const isITokenPartial = token => typeof token === "object" && token !== null;
const isToken = token => {
  const id = token.id;
  if (typeof id !== "string") return false;
  const type = token.type;
  if (typeof type !== "string") return false;
  const isTestnet = token.isTestnet;
  if (typeof isTestnet !== "boolean") return false;
  const symbol = token.symbol;
  if (typeof symbol !== "string") return false;
  const decimals = token.decimals;
  if (typeof decimals !== "number") return false;
  const logo = token.logo;
  if (typeof logo !== "string") return false;

  // coingeckoId can be undefined
  // const coingeckoId = token.coingeckoId
  // if (typeof coingeckoId !== "string") return false

  return true;
};

class TalismanChaindataDatabase extends Dexie {
  constructor() {
    super("TalismanChaindata");

    // https://dexie.org/docs/Tutorial/Design#database-versioning
    this.version(1).stores({
      // You only need to specify properties that you wish to index.
      // The object store will allow any properties on your stored objects but you can only query them by indexed properties
      // https://dexie.org/docs/API-Reference#declare-database
      //
      // Never index properties containing images, movies or large (huge) strings. Store them in IndexedDB, yes! but just don’t index them!
      // https://dexie.org/docs/Version/Version.stores()#warning
      chains: "id, genesisHash, name, nativeToken, tokens, evmNetworks",
      evmNetworks: "id, name, nativeToken, tokens, substrateChain",
      tokens: "id, type, symbol, coingeckoId, dcentName, contractAddress, chain, evmNetwork"
    });

    // this.on("ready", async () => {})
  }
}

new TalismanChaindataDatabase();

const minimumHydrationInterval = 300_000; // 300_000ms = 300s = 5 minutes

class ChaindataProviderExtension {
  #db;
  #lastHydratedChainsAt = 0;
  #lastHydratedEvmNetworksAt = 0;
  #lastHydratedTokensAt = 0;
  #onfinalityApiKey;
  constructor(options) {
    this.#db = new TalismanChaindataDatabase();
    this.#onfinalityApiKey = options?.onfinalityApiKey ?? undefined;
  }
  setOnfinalityApiKey(apiKey) {
    this.#onfinalityApiKey = apiKey;
  }
  async chainIds() {
    try {
      return await this.#db.chains.toCollection().primaryKeys();
    } catch (cause) {
      throw new Error("Failed to get chainIds", {
        cause
      });
    }
  }
  async chains() {
    try {
      const chains = await this.#db.chains.toArray();
      return Object.fromEntries(chains.map(chain => [chain.id, chain]));
    } catch (cause) {
      throw new Error("Failed to get chains", {
        cause
      });
    }
  }
  async chainsArray() {
    try {
      return await this.#db.chains.toArray();
    } catch (cause) {
      throw new Error("Failed to get chains", {
        cause
      });
    }
  }
  async getChain(chainIdOrQuery) {
    const [chainId, chainQuery] = typeof chainIdOrQuery === "string" ?
    // chainId (ChainId)
    [chainIdOrQuery, undefined] :
    // chainQuery (Partial<Chain>)
    [undefined, chainIdOrQuery];
    try {
      return chainId !== undefined ? (await this.#db.chains.get(chainId)) || null : (await this.#db.chains.get(chainQuery)) || null;
    } catch (cause) {
      throw new Error("Failed to get chain", {
        cause
      });
    }
  }
  async evmNetworkIds() {
    try {
      return await this.#db.evmNetworks.toCollection().primaryKeys();
    } catch (cause) {
      throw new Error("Failed to get evmNetworkIds", {
        cause
      });
    }
  }
  async evmNetworks() {
    try {
      const evmNetworks = await this.#db.evmNetworks.toArray();
      return Object.fromEntries(evmNetworks.map(evmNetwork => [evmNetwork.id, evmNetwork]));
    } catch (cause) {
      throw new Error("Failed to get evmNetworks", {
        cause
      });
    }
  }
  async evmNetworksArray() {
    try {
      return await this.#db.evmNetworks.toArray();
    } catch (cause) {
      throw new Error("Failed to get evmNetworks", {
        cause
      });
    }
  }
  async getEvmNetwork(evmNetworkIdOrQuery) {
    const [evmNetworkId, evmNetworkQuery] = typeof evmNetworkIdOrQuery === "string" ?
    // evmNetworkId (EvmNetworkId)
    [evmNetworkIdOrQuery, undefined] :
    // evmNetworkQuery (Partial<EvmNetwork>)
    [undefined, evmNetworkIdOrQuery];
    try {
      return evmNetworkId !== undefined ? (await this.#db.evmNetworks.get(evmNetworkId)) || null : (await this.#db.evmNetworks.get(evmNetworkQuery)) || null;
    } catch (cause) {
      throw new Error("Failed to get evmNetwork", {
        cause
      });
    }
  }
  async tokenIds() {
    try {
      return await this.#db.tokens.toCollection().primaryKeys();
    } catch (cause) {
      throw new Error("Failed to get tokenIds", {
        cause
      });
    }
  }
  async tokens() {
    try {
      const tokens = await this.#db.tokens.toArray();
      return Object.fromEntries(tokens.map(token => [token.id, token]));
    } catch (cause) {
      throw new Error("Failed to get tokens", {
        cause
      });
    }
  }
  async tokensArray() {
    try {
      return await this.#db.tokens.toArray();
    } catch (cause) {
      throw new Error("Failed to get tokens", {
        cause
      });
    }
  }
  async getToken(tokenIdOrQuery) {
    const [tokenId, tokenQuery] = typeof tokenIdOrQuery === "string" ?
    // tokenId (TokenId)
    [tokenIdOrQuery, undefined] :
    // tokenQuery (Partial<Token>)
    [undefined, tokenIdOrQuery];
    try {
      return tokenId !== undefined ? (await this.#db.tokens.get(tokenId)) || null : (await this.#db.tokens.get(tokenQuery)) || null;
    } catch (cause) {
      throw new Error("Failed to get token", {
        cause
      });
    }
  }
  async addCustomChain(customChain) {
    try {
      if (!("isCustom" in customChain)) return;
      return this.#db.chains.put(customChain);
    } catch (cause) {
      throw new Error("Failed to add custom chain", {
        cause
      });
    }
  }
  async removeCustomChain(chainId) {
    try {
      return this.#db.chains
      // only affect custom chains
      .filter(chain => "isCustom" in chain && chain.isCustom === true)
      // only affect the provided chainId
      .filter(chain => chain.id === chainId)
      // delete the chain (if exists)
      .delete();
    } catch (cause) {
      throw new Error("Failed to remove custom chain", {
        cause
      });
    }
  }
  subscribeCustomChains() {
    return from(liveQuery(() => this.#db.chains.filter(chain => "isCustom" in chain && chain.isCustom)
    // @ts-expect-error Dexie can't do type assertion on filter
    .toArray(chains => chains)));
  }
  setCustomChains(chains) {
    return this.#db.transaction("rw", this.#db.chains, async () => {
      const keys = await this.#db.chains.filter(chains => "isCustom" in chains && Boolean(chains.isCustom)).primaryKeys();
      await this.#db.chains.bulkDelete(keys);
      await this.#db.chains.bulkPut(chains.filter(network => network.isCustom));
    });
  }
  async addCustomEvmNetwork(customEvmNetwork) {
    try {
      if (!("isCustom" in customEvmNetwork)) return;
      return this.#db.evmNetworks.put(customEvmNetwork);
    } catch (cause) {
      throw new Error("Failed to add custom evm network", {
        cause
      });
    }
  }
  async removeCustomEvmNetwork(evmNetworkId) {
    if (await this.getIsBuiltInEvmNetwork(evmNetworkId)) throw new Error("Cannot remove built-in EVM network");
    try {
      return this.#db.transaction("rw", [this.#db.evmNetworks, this.#db.tokens], async () => {
        await this.#db.evmNetworks.delete(evmNetworkId);
        await this.#db.tokens.filter(token => token.evmNetwork?.id === evmNetworkId).delete();
      });
    } catch (cause) {
      throw new Error("Failed to remove custom evm network", {
        cause
      });
    }
  }
  subscribeCustomEvmNetworks() {
    return from(liveQuery(() => this.#db.evmNetworks.filter(network => "isCustom" in network && network.isCustom)
    // @ts-expect-error Dexie can't do type assertion on filter
    .toArray(networks => networks)));
  }
  setCustomEvmNetworks(networks) {
    return this.#db.transaction("rw", this.#db.evmNetworks, async () => {
      const keys = await this.#db.evmNetworks.filter(network => "isCustom" in network && Boolean(network.isCustom)).primaryKeys();
      await this.#db.evmNetworks.bulkDelete(keys);
      await this.#db.evmNetworks.bulkPut(networks.filter(network => network.isCustom));
    });
  }
  async resetEvmNetwork(evmNetworkId) {
    const builtInEvmNetwork = await fetchEvmNetwork(evmNetworkId);
    if (!builtInEvmNetwork) throw new Error("Cannot reset non-built-in EVM network");
    if (!builtInEvmNetwork.nativeToken?.id) throw new Error("Failed to lookup native token (no token exists for network)");
    const builtInNativeToken = await fetchToken(builtInEvmNetwork.nativeToken.id);
    if (!isITokenPartial(builtInNativeToken)) throw new Error("Failed to lookup native token");
    if (!isToken(builtInNativeToken)) throw new Error("Failed to lookup native token (isToken test failed)");
    try {
      return await this.#db.transaction("rw", this.#db.evmNetworks, this.#db.tokens, async () => {
        // delete network and it's native token
        const networkToDelete = await this.#db.evmNetworks.get(evmNetworkId);
        if (networkToDelete?.nativeToken?.id) await this.#db.tokens.delete(networkToDelete.nativeToken.id);
        await this.#db.evmNetworks.delete(evmNetworkId);

        // reprovision them from subsquid data
        await this.#db.tokens.put(builtInNativeToken);
        await this.#db.evmNetworks.put(builtInEvmNetwork);
      });
    } catch (cause) {
      throw new Error("Failed to reset evm network", {
        cause
      });
    }
  }
  async addCustomToken(customToken) {
    try {
      if (!("isCustom" in customToken)) return;
      return this.#db.tokens.put(customToken);
    } catch (cause) {
      throw new Error("Failed to add custom token", {
        cause
      });
    }
  }
  async removeCustomToken(tokenId) {
    try {
      return this.#db.tokens
      // only affect custom tokens
      .filter(token => "isCustom" in token && token.isCustom === true)
      // only affect the provided token
      .filter(token => token.id === tokenId)
      // delete the token (if exists)
      .delete();
    } catch (cause) {
      throw new Error("Failed to remove custom token", {
        cause
      });
    }
  }

  // Need to explicitly type the return type
  // else TypeScript will resolve it to `IToken` instead
  subscribeCustomTokens() {
    return from(liveQuery(() => this.#db.tokens.filter(token => "isCustom" in token)
    // Dexie can't do type assertion on filter
    .toArray(tokens => tokens)));
  }
  setCustomTokens(tokens) {
    return this.#db.transaction("rw", this.#db.tokens, async () => {
      const keys = await this.#db.tokens.filter(token => "isCustom" in token && Boolean(token.isCustom)).primaryKeys();
      await this.#db.tokens.bulkDelete(keys);
      await this.#db.tokens.bulkPut(tokens.filter(token => "isCustom" in token && token.isCustom));
    });
  }
  async removeToken(tokenId) {
    try {
      return await this.#db.tokens.delete(tokenId);
    } catch (cause) {
      throw new Error("Failed to remove token", {
        cause
      });
    }
  }

  /**
   * Hydrate the db with the latest chaindata from subsquid.
   *
   * @returns A promise which resolves to true if any db table has been hydrated, or false if all hydration has been skipped.
   */
  async hydrate() {
    return (await Promise.all([
    // call inner hydration methods
    this.hydrateChains(), this.hydrateEvmNetworks(), this.hydrateTokens()])

    // return true if any hydration occurred
    ).some(Boolean);
  }

  /**
   * Hydrate the db with the latest chains from subsquid.
   * Hydration is skipped when the last successful hydration was less than minimumHydrationInterval ms ago.
   *
   * @returns A promise which resolves to true if the db has been hydrated, or false if the hydration was skipped.
   */
  async hydrateChains() {
    const now = Date.now();
    if (now - this.#lastHydratedChainsAt < minimumHydrationInterval) return false;
    const dbHasChains = (await this.#db.chains.count()) > 0;
    try {
      try {
        var chains = addCustomChainRpcs(await fetchChains(), this.#onfinalityApiKey); // eslint-disable-line no-var
        if (chains.length <= 0) throw new Error("Ignoring empty chaindata chains response");
      } catch (error) {
        if (dbHasChains) throw error;

        // On first start-up (db is empty), if we fail to fetch chains then we should
        // initialize the DB with the list of chains inside our init/chains.json file.
        // This data will represent a relatively recent copy of what's in the squid,
        // which will be better for our users than to have nothing at all.
        var chains = addCustomChainRpcs(await fetchInitChains(), this.#onfinalityApiKey); // eslint-disable-line no-var
      }

      await this.#db.transaction("rw", this.#db.chains, () => {
        this.#db.chains.filter(chain => !("isCustom" in chain)).delete();
        this.#db.chains.bulkPut(chains);
      });
      this.#lastHydratedChainsAt = now;
      return true;
    } catch (error) {
      log.warn(`Failed to hydrate chains from chaindata`, error);
      return false;
    }
  }

  /**
   * Hydrate the db with the latest evmNetworks from subsquid.
   * Hydration is skipped when the last successful hydration was less than minimumHydrationInterval ms ago.
   *
   * @returns A promise which resolves to true if the db has been hydrated, or false if the hydration was skipped.
   */
  async hydrateEvmNetworks() {
    const now = Date.now();
    if (now - this.#lastHydratedEvmNetworksAt < minimumHydrationInterval) return false;
    const dbHasEvmNetworks = (await this.#db.evmNetworks.count()) > 0;
    try {
      try {
        var evmNetworks = await fetchEvmNetworks(); // eslint-disable-line no-var
        if (evmNetworks.length <= 0) throw new Error("Ignoring empty chaindata evmNetworks response");
      } catch (error) {
        if (dbHasEvmNetworks) throw error;

        // On first start-up (db is empty), if we fail to fetch evmNetworks then we should
        // initialize the DB with the list of evmNetworks inside our init/evm-networks.json file.
        // This data will represent a relatively recent copy of what's in the squid,
        // which will be better for our users than to have nothing at all.
        var evmNetworks = await fetchInitEvmNetworks(); // eslint-disable-line no-var
      }

      await this.#db.transaction("rw", this.#db.evmNetworks, async () => {
        await this.#db.evmNetworks.filter(network => !("isCustom" in network)).delete();
        // add all except ones matching custom existing ones (user may customize built-in networks)
        const customNetworks = await this.#db.evmNetworks.toArray();
        const newNetworks = evmNetworks.filter(network => customNetworks.every(existing => existing.id !== network.id));
        await this.#db.evmNetworks.bulkPut(newNetworks);
      });
      this.#lastHydratedEvmNetworksAt = now;
      return true;
    } catch (error) {
      log.warn(`Failed to hydrate evmNetworks from chaindata`, error);
      return false;
    }
  }

  /**
   * Hydrate the db with the latest tokens from subsquid.
   * Hydration is skipped when the last successful hydration was less than minimumHydrationInterval ms ago.
   *
   * @returns A promise which resolves to true if the db has been hydrated, or false if the hydration was skipped.
   */
  async hydrateTokens() {
    const now = Date.now();
    if (now - this.#lastHydratedTokensAt < minimumHydrationInterval) return false;
    const dbHasTokens = (await this.#db.tokens.count()) > 0;
    try {
      try {
        var tokens = parseTokensResponse(await fetchTokens()); // eslint-disable-line no-var
        if (tokens.length <= 0) throw new Error("Ignoring empty chaindata tokens response");
      } catch (error) {
        if (dbHasTokens) throw error;

        // On first start-up (db is empty), if we fail to fetch tokens then we should
        // initialize the DB with the list of tokens inside our init/tokens.json file.
        // This data will represent a relatively recent copy of what's in the squid,
        // which will be better for our users than to have nothing at all.
        var tokens = parseTokensResponse(await fetchInitTokens()); // eslint-disable-line no-var
      }

      await this.#db.transaction("rw", this.#db.tokens, async () => {
        await this.#db.tokens.filter(token => !("isCustom" in token)).delete();
        // add all except ones matching custom existing ones (user may customize built-in tokens)
        const customTokens = await this.#db.tokens.toArray();
        const newTokens = tokens.filter(token => customTokens.every(existing => existing.id !== token.id));
        await this.#db.tokens.bulkPut(newTokens);
      });
      this.#lastHydratedTokensAt = now;
      return true;
    } catch (error) {
      log.warn(`Failed to hydrate tokens from chaindata`, error);
      return false;
    }
  }
  async getIsBuiltInEvmNetwork(evmNetworkId) {
    const evmNetwork = await fetchEvmNetwork(evmNetworkId);
    return !!evmNetwork;
  }
  transaction(mode, tables, scope) {
    return this.#db.transaction(mode, tables, scope);
  }
}

export { ChaindataProviderExtension, graphqlUrl };
